import { cifAe, cifEg } from "@coreui/icons";
import { colors } from "../src/utils/const";
import { userAgent } from "@/utils/generalUrils";
import { Box } from "@mui/material";

export default {
  terms: "https://contact.eg/terms-and-conditions-ar.pdf",
  offer_expiry_date: "الصلاحية حتى",
  offer_details: "التفاصيل",
  contact: "كونتكت",
  offers: "العروض",
  // ** CONTACT
  brand_description:
    "كونتكت المالية القابضة ش.م.م  كود البورصة المصرية( CNFN.CA)  هي أكبر مقدم للخدمات المالية غير المصرفية في مصر، حيث تقود التحول في وسائل تقديم خدمات التمويل والتأمين للأفراد والشركات. ومنذ تأسيسها عام 2001، تتبنى كونتكت منهجًا مبتكرًا لضمان تقديم خدماتها بأعلى جودة في مجالات التمويل والتأمين، وذلك بأسهل إجراءات وصولاً إلى قطاع عريض من السوق من خلال شركاتها التابعة وشركائها الاستراتيجيين. فعن طريق شركة كونتكت للتمويل، تقدم باقة من البرامج التمويلية المتنوعة لتمويل شراء السيارات والمركبات الجديدة والمستعملة وبرامج تمويل السلع المعمرة عن طريق كونتكت كريدي تك، إضافة إلى برامج التمويل العقاري من خلال كونتكت للتمويل العقاري، وبرامج التمويل التجاري من خلال شركاتها كونتكت التأجير التمويلي وكونتكت التخصيم. كما تقدم كونتكت خدمات التأمين من خلال شركتي ثروة للتأمين وثروة لتأمينات الحياة. كما تقدم الشركة باقة واسعة من خدمات التمويل للشركات بما في ذلك إصدار سندات التوريق وإدارة الديون المهيكلة وإدارة استثمار الديون. شركة كونتكت المالية القابضة ش.م.م. مرخصة وخاضعة للهيئة العامة للرقابة المالية. ",
  contact_supervision:
    "ترخيص الهيئة العامة للرقابة المالية رقم 756 بتاريخ 2018/04/18",
  // ** form page
  CategoriesForm1: [
    "اجهزاة منزلية و أليكترونيات",
    "وسائل الترفيه و السياحة",
    "سيارات و درجات",
    "اجهزاة منزلية",
    "أجهزة محمول",
    "أثاثات و البيت",
    "ملابس",
    // "الجمال",
    "مجوهرات",
    "الصحة",
    "الجمال",
    "العائلة و الحيونات الاليفة",
    "تعليم",
    "خدمات",
    "الرياضة و العافية",
    "سوبر ماركت",
    "مأكولات و مشروبات",
    "البيت",
    "متاجر و الأسواق",
    "الهدايا",
    "الاعمال",
  ],
  POSform1: ["باي موب", "باي تابس", "فوري", "جيديا", "كاشير", "نتورك", "اخري"],
  partner_types: [
    { id: "1", title: "شبكة تجار ContactNow" },
    { id: "2", title: " التوريدات الطبية" },
    { id: "3", title: "السيارات و وسائل النقل" },
    { id: "4", title: " مؤسسات اخرى" },
  ],

  form_title1: "شبكة تجار ContactNow",
  form_sub1: "عملاء أكثر ونجاح أكبر",
  form_des1:
    "من خلال خبراتنا التمويلية الطويلة بالسوق المصري وفريق عملنا المتخصص سنمكنك من إطلاق العنان لمجال أعمالك. ستساعدك اجراءاتنا البسيطة وحلولنا التمويلية المختلفة في تحقيق المزيد من المبيعات والوصول إلى شرائح مختلفة من العملاء. انضم الينا الآن من خلال تسجيل متجرك مع ContactNow",
  form_title2: "التوريدات الطبية",
  form_sub2: "",
  form_des2:
    "انضم إلى شبكة موردي المعدات الطبية لدينا ووفر لعملائك  الحاليين والجدد من الأطباء والصيادلة والمؤسسات الطبية في جميع أنحاء مصر مرونة في السداد من خلال أسهل وأسرع خطط التمويل من كونتكت. ",
  form_title3: "السيارات و وسائل النقل",
  form_sub3: "",
  form_des3:
    "انضم إلى شبكة موردينا في قطاع النقل والسيارات ومعدات النقل الثقيل والتجاري (الخفيف والمتوسط والثقيل)، والحافلات والشاحنات. احصل على انتشار أكبر وقدم لعملائك أنظمة دفع أكثر مرونة مع كونتكت. ",
  form_title4: "مؤسسات أخرى",
  form_sub4: "",
  form_des4:
    "إذا كنت تقدم أي منتجات أو خدمات آخرى وترغب في توفير المزيد من خطط السداد لعملائك مع كونتكت، يرجى تسجيل بياناتك وسوف يقوم أحد مندوبينا بالتواصل معك.",
  yes: "نعم",
  no: "لا",
  have_record: "هل لديك سجل تجاري و بطاقة ضريبية؟",
  company_nameForm1: "اسم الشركه",
  company_nameForm2: "اسم الشركة التجارية ",
  company_nameForm3: "اسم الشركة  ",
  full_name: "الإسم الكامل للشخص الذي يمكن الاتصال به",
  // client_name: "اسم العميل",
  business_name: "اسم العمل",
  specialist_name: "اسم الشخص المختص",
  phone: "رقم الموبايل",
  email: "البريد الالكتروني",
  categories: "الفئات",
  url: "رابط الموقع او الفيسبوك",
  address: "العنوان بالتفصيل",
  governorate: "المحافظة",
  branchesNumber: "عدد الفروع",
  employees_number: "عدد الموظفين",
  field: "مجال العمل",
  digital: "منصة الاكترونية",
  POS: "هل لديك أي من ألات نقاط البيع المذكورة  أدناه ؟",
  send: "ارسال",
  // ** ----- extra -----
  plans: "خطط التقسيط",
  // \u202B.\u202C
  popup: (
    <>
      <p style={{ marginBottom: "6px" }}>
        <span dir="rtl">تمويل من غير حدود مع كونتكت!</span>
      </p>{" "}
      <p>اشتري في مصر، وقسط من الإمارات</p>
    </>
  ),
  popup_img: "/ar-popup.png",
  popup_btn_text: "استفسر عن تمويل عربيتك",
  contact_now_btn: "أقساطك & نقاطك",
  last_offers: "اخر العروض",
  exclusive: "حصرياً لك",
  // ** ---------
  join_us: "عملاء أكثر ونجاح أكبر",
  // more_clients: "المزيد من العملاء ، تحولات أسرع",
  join_us_des:
    "من خلال خبراتنا التمويلية الطويلة بالسوق المصري وفريق عملنا المتخصص سنمكنك من إطلاق العنان لمجال أعمالك. ستساعدك اجراءاتنا البسيطة وحلولنا التمويلية المختلفة في تحقيق المزيد من المبيعات والوصول إلى شرائح مختلفة من العملاء. انضم الينا الآن من خلال تسجيل متجرك مع ContactNow",
  join_us_btn: "انضم إلينا الآن",
  // ** ---------
  fatorty_title: "فاتورتي",
  fatorty_des:
    "قسط أي فاتورة حديثة عندك، كل إللي هتحتاجه هو إنك تقوم بتحميل التطبيق وتختار بعدها فترات السداد المناسبة ليك لإن فاتورتي بتقدملك أفضل طرق تسديد مرنة لفواتيرك",
  fatorty_btn: "احصل على الحد الفوري !",
  // ** ---------
  //^ income management
  incomeManagement: {
    fisrt_section: {
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/cash-mangement.png",
      title: "إدارة المحافظ",
      subTitle: "شريكك الموثوق به في سوق رأس مال الدين بمصر!",
      pg: `تتمتع كونتكت بتاريخ طويل وناجح في سوق رأس مال الدين (DCM) بمصر، مما يجعلنا الشريك الرائد في هذا المجال. نحن نستفيد من خبراتنا الواسعة لتقديم مجموعة شاملة من حلول التمويل، مما يساعد الشركات على الازدهار وتحقيق أهدافها المالية في الوقت المطلوب.   
      
      خدماتنا في ادارة رأس مال الدين عديدة وتشمل التوريق، وإصدار الصكوك، و ادارة الاكتتاب، والترويج للأدوات المالية. نضع في أولوياتنا حماية قيمة المحفظة الخاصة بعملائنا من التقلبات السوقية الشديدة، وضمان مستويات سيولة كافية معظم الوقت، وتنويع الأدوات المالية، ومصدر الدين، والمدة، وتحقيق عوائد تنافسية من خلال استراتيجيات مختلفة تحت إدارة مجموعة من المتخصصين في كونتكت.`,
    },
    second_section: {
      img: "/images/benefits.png",
      title: "أهم الإنجازات",
      pg: `كونتكت كانت ولازالت رائدةً في مجال ادارة رأس مال الدين في مصر منذ عام 2005. لقد قمنا بترتيب وإصدار أكثر من 26 مليار جنيه مصري كأدوات دين، بما في ذلك أول إصدار للتوريق بالسوق المصري. كما أننا أول جهة مُرخصة مُصدرة للصكوك في السوق المصرية، حيث نقدم حلول تمويل متوافقة مع أحكام الشريعة الإسلامية.
     
      كما قامت كونتكت بإصدار أول سند توريق عقاري في السوق عام 2015، وتمكنت من أن تكون الجهة الرائدة في إصدار صكوك المضاربة في عام 2021. كما أصدرت "كونتكت" أول سند تمويل استهلاكي في عام 2022 بأعلى تصنيف في السوق.`,
    },
    third_section: {
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/3.png",
      title: "باختيارك كونتكت كشريك استراتيجي في سوق رأس مال الدين، ستستفيد من",
      list: [
        "خبرتنا الواسعة والعميقة في مجال سوق رأس مال الدين",
        "علاقاتنا القوية مع الجهات التنظيمية ووكالات التصنيف والمستثمرين وغيرهم من المشاركين في السوق وصُناعه",
        "حلولنا المبتكرة والمخصصة التي تلبي احتياجاتك المالية الخاصة بشركتك",
        "أسعارنا التنافسية وخيارات الدفع المرنة",
        "فريقنا المحترف الذي يقدم الاستشارات والتوجيهات عندما تحتاج",
      ],
    },
    outro:
      "تواصل معنا اليوم لنتمكن من مساعدتك والرد على استفساراتك فيما يخص خدمات إدارة سوق رأس مال الدين.",
  },
  //^ income trading
  incomeTrading: {
    fisrt_section: {
      title: "أدوات الدخل الثابت",
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/1.png",
    },
    second_section: {
      first_title: "التوريق",
      fisrt_subtitle: "خبرة تصنع الفارق",
      fisrt_pg: `يعتبر التوريق هو أحد أبرز أدوات إدارة وهيكلة الدين شيوعاً حيث يهدف الي تحويل التحصيلات و الإيرادات الى استثمارات. 
      
      إن اختيار التوريق كهيكلة للدين له مزايا متعددة مثل تعزيز التصنيف الائتماني للأصول الأساسية ، الادخار الضريبي، وانخفاض تكلفة الاستثمار ، والتمويل الإضافي خارج الميزانية العمومية ، ومصدر السيولة النقدية
      
      منذ عام 2005، أصبحت كونتكت شريكًا موثوقًا به في مجال التوريق، حيث نقدم الدعم لشركائنا وعملائنا طوال الوقت. بفضل خبرتنا الواسعة وفهمنا للسوق المصري، نقوم بتخصيص وإيجاد حلول تناسب احتياجات شركتك، ونساعدك على تجاوز تعقيدات التوريق لتحقيق أهدافك المالية في الوقت المطلوب.`,
      second_title: "الصكوك",
      second_subtitle: "متوافقة مع مبادئ الشريعة",
      second_pg: `الصكوك هي أوراق مالية قائمة على الأصول تمثل حصصاً مجمعة وغير مجزأة من الملكية و / أو الحقوق في أصل ملموس من حيث صلتها بمشروع معين أو نشاط استثماري محدد خارج الميزانية العمومية عبر منشآت أعمال ذات غرض واحد  SPV وطويلة الأجل. 

      إمكانية وجود قاعدة عريضة ومتنوعة من الاستثمارات لتكوين هيكل مرن و تشمل على المضاربة والمشاركة والإجارة والمرابحة.

      نحن نقدم خدمات شاملة لإصدار الصكوك في مصر، مما يضمن تلبية احتياجاتك من البداية إلى النهاية.`,
    },
  },
  second_pg: `الصكوك هي أوراق مالية قائمة على الأصول تمثل حصصاً مجمعة وغير مجزأة من الملكية و / أو الحقوق في أصل ملموس من حيث صلتها بمشروع معين أو نشاط استثماري محدد خارج الميزانية العمومية عبر منشآت أعمال ذات غرض واحد  SPV وطويلة الأجل. 

  

  إمكانية وجود قاعدة عريضة ومتنوعة من الاستثمارات لتكوين هيكل مرن  وتشمل على: ( المضاربة والمشاركة والإجارة والمرابحة).

  نحن نقدم خدمات شاملة لإصدار الصكوك في مصر، مما يضمن تلبية احتياجاتك من البداية إلى النهاية.`,

  //^ investment fund
  KolYom: {
    fisrt_section: {
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/investment-fund.png",
      title: "كونتكت كل يوم",
      subtitle: "أستثمر بكل حرية",
      pg: `كونتكت كل يوم هو صندوق ادخار ذو عائد يومي تراكمي يوفر لشركتك فرصة لتحقيق نمو مالي ثابت. نحن نقدم فرصة استثمار بسيطة وثابتة، تقدم عائد يومي على استثمارك. صندوق كونتكت كل يوم للاستثمار والادخار هو فرصة للشركات التي تريد نموا ثابت خصوصًا في أوقت التحركات الاقتصادية السريعة  التي قد تؤثر على وتيرة الأعمال اليومية.

      يستفيد "كل يوم" من محفظة متنوعة من الأصول، مما يضمن عوائد ثابتة مع حماية رأس مالك. نقدم حلاً شاملاً يجمع بين سهولة فتح الحساب بدون رسوم، ومرونة لا مثيل لها للإيداع والسحب. بالإضافة إلى ذلك، يظل فريق دعمنا المخصص متاحًا لمساعدتك في أي أسئلة، مما يضمن تجربة استثمار ناجحة.`,
    },
    second_section: {
      title: "المميزات",
      list: [
        "عائد تراكمي متميز",
        "استثمار سهل ومضمون",
        "بدون مصاريف ",
        "صندوق يومي للسحب والإيداع",
        "لا يشترط وجود حساب بنكي",
        "أسهل وأسرع إجراءات بالبطاقة الشخصية فقط",
        "سهولة وتنوع في طرق إجراء المعاملات ",
        "فريق خدمة عملاء متخصص للمساعدة التليفونية",
      ],
    },
    outro: `من خلال "كل يوم"، فإنك تستثمر في نمو واستقرار أعمالك. لتستفيد من الاستثمار اليومي تواصل معنا وابدأ رحلتك نحو المزيد من النجاح المالي اليوم.`,
  },

  // ** ---------
  download: "حمل التطبيق",
  direction: "rtl",
  textAlign: "right",
  contact_us_title: "نود أن نستمع إليك!",
  formMsg: "تم ارسال الطلب بنجاح",
  formMsgFail: "فشل ارسال الطلب",
  clipboardMsg: "تم نسخ الرابط بنجاح",
  subscribeMsg: "تم الاشتراك بنجاح",
  subscribeFailMsg: "فشل الاشتراك",
  insurance_companies_title: "خدمات التأمين للشركات",
  insurance_individuals_title: "خدمات التأمين للأفراد",
  insuranceFeatures_companies: [
    "تأمين السيارات للأفراد والشركات",
    " تأمين الحوادث المتنوعة والمسئوليات",
    " تأمين الممتلكات",
    " التأمينات الهندسية",
    "التأمين البحري والداخلي للبضائع",
    "تأمين طبي",
    "استثمار وادخار",
  ],
  insuranceFeatures_individual: [
    "مخاطر عدم السداد",
    "الحوادث الشخصية",
    "نقل النقدية (السرقة بالإكراه)",
    "جميع أخطار المقاولين",
    "أجسام السفن",
    "معدات المقاولين – برية",
    "جميع أخطار التركيب",
    "فساد المحتويات أو المخزون",
    "كسر الزجاج",
    "فقد الإيراد",
    "المسؤوليات",
    "النقل",
    "النفوق (ماشية – دواجن)",
    "الضمان التجاري",
    "خيانة الأمانة",
    "ضمان مستحقات الجمارك",
    "الحريق والأخطار الإضافية",
    "عطل الآلات أو الأجهزة الكهربائية",
    "برامج تأمينية تناسب نشاطك",
  ],
  calcTitle: "احسب قسطك",
  purpose: "غرض التمويل",

  calc: {
    monthlyAmount: " قيمة القسط الشهري",
    priceCar: "السعر ",
    preAmount: "المقدم",
    plan: "الخطة",
    plan: "الخطة",
    purpose: "غرض التمويل",
    egyptianPound: "جنية مصري",
    duration: "المدة",
    year1: "1 سنة",
    year2: "2 سنة",
    year3: "3 سنة",
    year4: "4 سنة",
    year5: "5 سنة",
    year6: "6 سنة",
    plan1: "البرنامج الإقتصادي",
    plan2: "البرنامج المرن",
  },
  calc_packages: {
    auto: [
      { packageId: 268, title: "المرن بلس" },
      { packageId: 114, title: "الاقتصادي" },
      { packageId: 262, title: "الاقتصادي بلس" },
      { packageId: 144, title: "السيارات المستعملة" },
    ],
    trucks: [
      { packageId: 247, title: "النظام المرن" },
      { packageId: 234, title: "النظام العادي" },
    ],
    consumer_finance: [{ packageId: 408, title: "كريدي تيك" }],
    mortgage: [
      { packageId: 179, title: "إعادة تمويل بيتك - البرنامج الاقتصادي" },
      { packageId: 180, title: "إعادة تمويل بيتك - البرنامج المرن" },
      { packageId: 336, title: "تمويل بيتك" },
    ],
    clubs: [{ packageId: 452, title: "عضوية الأندية" }],
    education: [{ packageId: 363, title: "التعليم" }],
    insurance: [{ packageId: 402, title: "تأمين" }],
    wedding: [{ packageId: 437, title: "أفراح" }],
    maintenance: [{ packageId: 439, title: "صيانة البيت" }],
    green_finance: [
      {
        packageId: 459,
        title: "التمويل الأخضر أ (ربع سنوي)",
        packageId: 458,
        title: "التمويل الأخضر ب (شهري)",
      },
    ],
    home_interior: [{ packageId: 354, title: "تصميم وتشطيب بيتك" }],
    watercrafts: [{ packageId: 465, title: "المركبات المائية" }],
    motorcycles: [{ packageId: 469, title: "المركبات المائية" }],
    home_furniture: [{ packageId: 460, title: " فرش البيت" }],
    manasik: [
      {
        packageId: process.env.NEXT_PUBLIC_MODE == "STAGING" ? 501 : 526,
        title: "عمره",
      },
      {
        packageId: process.env.NEXT_PUBLIC_MODE == "STAGING" ? 500 : 525,
        title: "حج",
      },
    ],
  },
  general: {
    gifs: { hi: "/gif/hi-ar.gif", calculationg: "/gif/calculating-ar.gif" },
    popup: "/popup-ar.png",
    menu: {
      about_us: "نبذة عنا",
      media: "أخبارنا",
      careers: "وظائف",
      our_brand: "شركات المجموعة",
      contact_us: "اتصل بنا",
      contact_uae: "كونتكت الامارات",
      investor_relations: "علاقات المستثمرين",
      sustainability: "الاستدامة",
      why_contact: "ليه كونتكت ؟",
    },
    reviewTitle: "آراء العملاء",
    reviewSubTitle: "ماذا يقول العملاء عننا؟",
    reviews_individuals: [
      {
        id: "1",
        name: "محمد دياب",
        role: "30 مارس 2022",
        avatar: "/male-avatar.svg",
        rating: "تطبيق ممتاز ومفيد جدا وسهل الاستخدام.",
        review: "تطبيق ممتاز ومفيد جدا وسهل الاستخدام.",
      },
      {
        id: "2",
        name: "مارتينا ابراهيم",
        role: "3 يناير 2023",
        avatar: "/female-avatar.png",
        rating: "تطبيق ممتاز وسهل الاستخدام للغاية.",
        review: "تطبيق ممتاز وسهل الاستخدام للغاية.",
      },
      {
        id: "3",
        name: "مينا البر",
        role: "15 يناير 2023",
        avatar: "/male-avatar.svg",
        rating: "تطبيق مفيد وسهل وسريع.",
        review: "تطبيق مفيد وسهل وسريع.",
      },
      {
        id: "4",
        name: "عزيز محمد صلاح",
        role: "31 ديسمبر 2022",
        avatar: "/male-avatar.svg",
        rating:
          "تطبيق جديد كليًا ، وكل الميزات الجديدة ، وسهل الاستخدام ، شكرًا على المجهود الكبير.",
        review:
          "تطبيق جديد كليًا ، وكل الميزات الجديدة ، وسهل الاستخدام ، شكرًا على المجهود الكبير.",
      },
      {
        id: "5",
        name: "مو عبد الوهاب",
        role: "30 ديسمبر 2022",
        avatar: "/male-avatar.svg",
        rating: "مفيد. يعطينا تجربة رائعة. شكرا على الميزات الجديدة.",
        review: "مفيد. يعطينا تجربة رائعة. شكرا على الميزات الجديدة.",
      },
    ],
    directors: [
      {
        id: 1,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Mr.Hazem-Mousa.jpg",
        name: "حازم موسى",
        nameWithMr: "السيد/ حازم موسى",
        role: "رئيس مجلس إدارة الشركة القابضة",
        details: `حازم موسى هو المؤسس المشارك ورئيس مجلس إدارة شركة كونتكت المالية القابضة، الشركة الرائدة في تقديم الخدمات المالية غير المصرفية في مصر.
       
        وبفضل رؤيته القوية والقيادة المتفانية، لعب حازم دورًا فعالًا في بناء الشركة منذ بداياتها في عام 2001 كشركة إقراض استهلاكية ذات منتج واحد إلى شركة مزدهرة تشمل مجموعة من الخدمات المالية الاستهلاكية والتجارية المقدمة ماديًا ورقميًا إلى العملاء وإلى شريحة واسعة من المصريين.

        بالإضافة إلى كونها أكبر شركة تمويل استهلاكي في مصر، تمتلك شركة كونتكت أيضًا أعمالًا رائدة في مجال التأمين والتكنولوجيا وأسواق رأس المال. يقود حازم فريقًا قويًا من الكوادر المصريين المتفانين الذين يتمتعون بمجموعة من الخبرات، وقد قاد الأعمال كمدير عام ثم الرئيس التنفيذي لمدة 18 عامًا قبل التركيز على الإستراتيجية والتطوير كرئيس مجلس الإدارة. حصل حازم على درجة البكالوريوس في الاقتصاد من جامعة هاميلتون بنيويورك
        `,
      },
      {
        id: 2,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Mr.Said-Zater.jpg",
        name: "سعيد زعتر",
        nameWithMr: "السيد/ سعيد زعتر",
        role: "العضو المنتدب للشركة القابضة والرئيس التنفيذي",
        details: `سعيد زعتر هو رجل أعمال متميز يتمتع برحلة مؤسسية مهمة في مجال الخدمات المالية غير المصرفية منذ عام 2001.
        
        يشغل حاليًا منصب العضو المنتدب والرئيس التنفيذي لشركة كونتكت المالية القابضة، ويتولى في الوقت نفسه منصب رئيس الإتحاد المصري للتمويل الاستهلاكي.

        مع خلفية لامعة تشمل مناصب قيادية استراتيجية في وزارة الداخلية، بدأت مسيرة زعتر المهنية في مجال الخدمات المالية غير المصرفية في شركة كونتكت، حيث تشمل مساهماته المؤثرة التخطيط الاستراتيجي والعمليات وتحليل التكاليف وتنفيذ أساليب الاستشارات الإدارية لتعزيز أداء الشركة والوصول إلى العملاء وتحقيق الأرباح.

        ومن الجدير بالذكر أن زعتر نجح في توجيه الشركة نحو زيادة الكفاءة التشغيلية وتوسيع إنتشار العلامة التجارية من خلال الاكتتاب العام. وما يضيف بعدًا رائعًا لقيادة زعتر هو التقدير الجدير بالملاحظة الذي تلقاه كونتكت تحت إشرافه من فوربس الشرق الأوسط نفسها.

        وقد حصلت الشركة على مكانتها وتميزها من خلال إدراجها ضمن أفضل 50 شركة مدرجة في مصر لمدة عامين متتاليين، وهو دليل على نموها المستمر وحضورها الكبير في الصناعة.

        كما تم تكريم الإنجازات المتميزة التي حققتها الشركة تحت قيادته من قبل مجلة جلوبال إكونومكس، ومنحت الجوائز بناءاً على كونها شركة التمويل الأسرع نموًا وأفضل شركة شركة تكنولوجيا مالية في مجال التحول الرقمي. ايضاً تشمل الخبرة الواسعة للسيد سعيد زعتر، الإدارة الإستراتيجية وإدارة المخاطر، واستراتيجيات النمو، والتعامل مع الأزمات، والعلاقات الحكومية.`,
      },
      {
        id: 3,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Mr-Amr-Lamei.jpg",
        name: "عمرو لمعي",
        role: "نائب رئيس مجلس الإدارة",
      },
      {
        id: 4,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Ashraf-Zaki.jpg",
        name: "أشرف زكي",
        role: "عضو مجلس الإدارة",
      },
      {
        id: 5,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Mohamed-Abdel-Halim.jpg",
        name: "محمد عبد الحليم",
        role: "عضو مجلس الإدارة",
      },
      {
        id: 6,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Mohamed-Sadek.jpg",
        name: "محمد صادق",
        role: "عضو مجلس الإدارة",
      },
      {
        id: 7,
        img: "/directors/man.jpeg",
        name: " نيلز باختلر",
        role: "عضو مجلس الإدارة",
      },
      {
        id: 8,
        img: "/directors/man.jpeg",
        name: " عمرو عصمت أباضة",
        role: "عضو مجلس الإدارة",
      },
      {
        id: 9,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Karim-Hussein.jpg",
        name: "كريم حسين",
        role: "عضو مجلس إدارة مستقل",
      },
      {
        id: 10,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Karim-Zein.jpg",
        name: "كريم زين",
        role: "عضو مجلس إدارة مستقل",
      },
      {
        id: 11,
        img: "/managers/safaya.jpg",
        name: "صفية برهان",
        role: "عضو مجلس الإدارة",
        details: `صفية برهان شخصية متميزة في ميدان أسواق رأس المال، متخصصة في شؤون الشركات والحوكمة. بفضل خبرتها الواسعة وأساسها القوي في مبادئ الحوكمة الجيدة التي تمتد عبر قطاعات متنوعة، اكتسبت صفية أكثر من 17 عامًا من الخبرة في صناعة الخدمات المالية غير المصرفية. حاليًا، تتولى منصب مدير شؤون الشركات والحوكمة والاستدامة في كونتكت المالية القابضة، حيث تشغل أيضًا منصب رئيس لجنة تطوير الاستدامة.

        في عام 2021، حققت صفية إنجازًا هامًا بترقيتها إلى منصب عضو مجلس الإدارة في شركات كونتكت المالية القابضة، وشركات ثروة للتأمين وثروة للحياة. تمتد إسهاماتها الفعّالة إلى دورها كمبادر رئيسي لقانون التمويل الاستهلاكي المصري الذي قُدم إلى هيئة الرقابة المالية في مصر من 2018 إلى 2020. خلال هذا الوقت، لعبت دورًا حيويًا في إنشاء اتحاد التمويل الاستهلاكي المصري، حيث شغلت منصب الأمين العام للاتحاد.

        إن إنجازات صفية تشمل أيضًا تأمين وإدارة تراخيص لأكثر من 20 كيانًا تجارياً، بما في ذلك كونتكت للتمويل (2020)، وثروة للصكوك (2019)، وثروة كابيتال القابضة(2018)، وثروة للتأمين (2018)، وثروة لتأمينات الحياة (2018)، وكونتكت للتخصيم (2016)، وكونتكت للتمويل العقاري (2015)، وكونتكت للوساطة التأمينية (2015)، وثروة للترويج والإكتتاب(2015)، وثروة لإدارة الأصول (2013).

        من بين إنجازاتها الملحوظة، تنظيم إطلاق العرض العام الأولي لسهم ثروة كابيتال بتخطيط استراتيجي دقيق وتنفيذ في عام 2018. تتمتع صفية بمجموعة متنوعة من المهارات الشخصية، تتضمن التطوير الذاتي، والوعي الذاتي، والقدرة على التكيف. لديها سجل حافل في تنمية مهنية أفراد الفريق من خلال تقديم دعم شامل وقيادة ملهمة في بيئة عمل مفتوحة ومحفزة.

        تحمل صفية درجة الدكتوراه في إدارة الأعمال (DBA) ودرجة الماجستير في إدارة الأعمال (MBA) من جامعة ESLSCA في مصر، بالإضافة إلى شهادات أخرى في مجال حوكمة الشركات.`,
      },
      {
        id: 12,
        img: "/directors/woman.png",
        name: "زينب هشام",
        role: "عضو مجلس إدارة مستقل",
      },
    ],
    mangers: [
      {
        id: 13,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Mr.Hazem-Mousa.jpg",
        name: "حازم موسى",
        nameWithMr: "السيد/ حازم موسى",
        role: "رئيس مجلس إدارة الشركة القابضة",
        details: `حازم موسى هو المؤسس المشارك ورئيس مجلس إدارة شركة كونتكت المالية القابضة، الشركة الرائدة في تقديم الخدمات المالية غير المصرفية في مصر.
       
        وبفضل رؤيته القوية والقيادة المتفانية، لعب حازم دورًا فعالًا في بناء الشركة منذ بداياتها في عام 2001 كشركة إقراض استهلاكية ذات منتج واحد إلى شركة مزدهرة تشمل مجموعة من الخدمات المالية الاستهلاكية والتجارية المقدمة ماديًا ورقميًا إلى العملاء وإلى شريحة واسعة من المصريين.

        بالإضافة إلى كونها أكبر شركة تمويل استهلاكي في مصر، تمتلك شركة كونتكت أيضًا أعمالًا رائدة في مجال التأمين والتكنولوجيا وأسواق رأس المال. يقود حازم فريقًا قويًا من الكوادر المصريين المتفانين الذين يتمتعون بمجموعة من الخبرات، وقد قاد الأعمال كمدير عام ثم الرئيس التنفيذي لمدة 18 عامًا قبل التركيز على الإستراتيجية والتطوير كرئيس مجلس الإدارة. حصل حازم على درجة البكالوريوس في الاقتصاد من جامعة هاميلتون بنيويورك
        `,
      },
      {
        id: 14,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Mr.Said-Zater.jpg",
        name: "سعيد زعتر",
        nameWithMr: "السيد/ سعيد زعتر",
        role: "العضو المنتدب للشركة القابضة والرئيس التنفيذي",
        details: `سعيد زعتر هو رجل أعمال متميز يتمتع برحلة مؤسسية مهمة في مجال الخدمات المالية غير المصرفية منذ عام 2001.
        
        يشغل حاليًا منصب العضو المنتدب والرئيس التنفيذي لشركة كونتكت المالية القابضة، ويتولى في الوقت نفسه منصب رئيس الإتحاد المصري للتمويل الاستهلاكي.

        مع خلفية لامعة تشمل مناصب قيادية استراتيجية في وزارة الداخلية، بدأت مسيرة زعتر المهنية في مجال الخدمات المالية غير المصرفية في شركة كونتكت، حيث تشمل مساهماته المؤثرة التخطيط الاستراتيجي والعمليات وتحليل التكاليف وتنفيذ أساليب الاستشارات الإدارية لتعزيز أداء الشركة والوصول إلى العملاء وتحقيق الأرباح.

        ومن الجدير بالذكر أن زعتر نجح في توجيه الشركة نحو زيادة الكفاءة التشغيلية وتوسيع إنتشار العلامة التجارية من خلال الاكتتاب العام. وما يضيف بعدًا رائعًا لقيادة زعتر هو التقدير الجدير بالملاحظة الذي تلقاه كونتكت تحت إشرافه من فوربس الشرق الأوسط نفسها.

        وقد حصلت الشركة على مكانتها وتميزها من خلال إدراجها ضمن أفضل 50 شركة مدرجة في مصر لمدة عامين متتاليين، وهو دليل على نموها المستمر وحضورها الكبير في الصناعة.

        كما تم تكريم الإنجازات المتميزة التي حققتها الشركة تحت قيادته من قبل مجلة جلوبال إكونومكس، ومنحت الجوائز بناءاً على كونها شركة التمويل الأسرع نموًا وأفضل شركة شركة تكنولوجيا مالية في مجال التحول الرقمي. ايضاً تشمل الخبرة الواسعة للسيد سعيد زعتر، الإدارة الإستراتيجية وإدارة المخاطر، واستراتيجيات النمو، والتعامل مع الأزمات، والعلاقات الحكومية.`,
      },
      // {
      //   id: 15,
      //   img: "/managers/03.jpg",
      //   name: "أيمن الصاوي",
      //   role: "المستشار المالي للمجموعة",
      // },
      {
        id: 15,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Seif-ElBassiouni.jpg",
        name: " سيف البسيوني",
        role: "رئيس القطاعات المالية",
      },
      {
        id: 16,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Amr-Refaat.jpg",
        name: "عمرو رفعت",
        role: "نائب رئيس مجلس الإدارة لكونتكت للتمويل",
      },
      {
        id: 17,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Dr.%20Alaa-Awad.jpg",
        name: "علاء عوض",
        role: "رئيس قطاعات الموارد البشرية والحوكمة والتطوير المؤسسي",
      },
      {
        id: 18,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Tamer-Samir.jpg",
        name: "تامر سمير",
        role: "العضو المنتدب لكونتكت للتمويل",
      },
      {
        id: 19,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Mohamed-Salama.jpg",
        name: "محمد سلامة",
        role: "رئيس القطاع القانوني",
      },
      {
        id: 20,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Dr-Haidy.jpg",
        name: "هايدي المصري",
        role: "مدير عام الموارد البشرية والتطوير التنظيمي بالمجموعة",
      },

      {
        id: 21,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Ismail-Samir.jpg",
        name: "إسماعيل سمير",
        role: "العضو المنتدب لشركة كونتكت للتأجير التمويلي",
      },
      {
        id: 22,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Ahmed-Khalifa.jpg",
        name: "أحمد خليفة",
        role: "العضو المنتدب لشركة ثروة للتأمين",
      },
      {
        id: 23,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Rimah-Asaad.jpg",
        name: "رماح أسعد",
        role: "العضو المنتدب لشركة ثروة لتأمينات الحياة",
      },
      {
        id: 24,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/_91A0073.jpg",
        name: "أحمد حسنين",
        role: "رئيس قطاعات الائتمان وإدارة المخاطر",
      },
      {
        id: 25,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Ahmed-Ezz.jpg",
        name: "أحمد عز",
        role: "مدير عام المخاطر بالمجموعة",
      },
      {
        id: 26,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Sherif-Galal.jpg",
        name: "شريف جلال",
        role: "رئيس قطاع التفتيش والمتابعة",
      },

      // {
      //   id: 27,
      //   img: "/managers/safaya.jpg",
      //   name: "صفية برهان",
      //   role: "مدير عام شئون الشركات والحوكمة",
      //   details: `صفية برهان شخصية متميزة في ميدان أسواق رأس المال، متخصصة في شؤون الشركات والحوكمة. بفضل خبرتها الواسعة وأساسها القوي في مبادئ الحوكمة الجيدة التي تمتد عبر قطاعات متنوعة، اكتسبت صفية أكثر من 17 عامًا من الخبرة في صناعة الخدمات المالية غير المصرفية. حاليًا، تتولى منصب مدير شؤون الشركات والحوكمة والاستدامة في كونتكت المالية القابضة، حيث تشغل أيضًا منصب رئيس لجنة تطوير الاستدامة.

      //   في عام 2021، حققت صفية إنجازًا هامًا بترقيتها إلى منصب عضو مجلس الإدارة في شركات كونتكت المالية القابضة، وشركات ثروة للتأمين وثروة للحياة. تمتد إسهاماتها الفعّالة إلى دورها كمبادر رئيسي لقانون التمويل الاستهلاكي المصري الذي قُدم إلى هيئة الرقابة المالية في مصر من 2018 إلى 2020. خلال هذا الوقت، لعبت دورًا حيويًا في إنشاء اتحاد التمويل الاستهلاكي المصري، حيث شغلت منصب الأمين العام للاتحاد.

      //   إن إنجازات صفية تشمل أيضًا تأمين وإدارة تراخيص لأكثر من 20 كيانًا تجارياً، بما في ذلك كونتكت للتمويل (2020)، وثروة للصكوك (2019)، وثروة كابيتال القابضة(2018)، وثروة للتأمين (2018)، وثروة لتأمينات الحياة (2018)، وكونتكت للتخصيم (2016)، وكونتكت للتمويل العقاري (2015)، وكونتكت للوساطة التأمينية (2015)، وثروة للترويج والإكتتاب(2015)، وثروة لإدارة الأصول (2013).

      //   من بين إنجازاتها الملحوظة، تنظيم إطلاق العرض العام الأولي لسهم ثروة كابيتال بتخطيط استراتيجي دقيق وتنفيذ في عام 2018. تتمتع صفية بمجموعة متنوعة من المهارات الشخصية، تتضمن التطوير الذاتي، والوعي الذاتي، والقدرة على التكيف. لديها سجل حافل في تنمية مهنية أفراد الفريق من خلال تقديم دعم شامل وقيادة ملهمة في بيئة عمل مفتوحة ومحفزة.

      //   تحمل صفية درجة الدكتوراه في إدارة الأعمال (DBA) ودرجة الماجستير في إدارة الأعمال (MBA) من جامعة ESLSCA في مصر، بالإضافة إلى شهادات أخرى في مجال حوكمة الشركات.`,
      // },
      {
        id: 28,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Nehal-Break.jpg",
        name: "نيهال بريك",
        role: "العضو المنتدب لشركة كونتكت للوساطة التأمينية",
      },
      {
        id: 29,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Waleed-Kamel.jpg",
        name: "وليد كامل",
        role: "المدير التنفيذي لشركة كونتكت كارز دوت كوم",
      },
      {
        id: 30,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Ahmed-A.%20Hakim.jpg",
        name: "أحمد عبد الحكيم",
        role: "مدير عام تكنولوجيا المعلومات",
      },
      {
        id: 31,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Omar-ElFiky.jpg",
        name: "عمر الفقي",
        role: "العضو المنتدب لكونتكت كريدي تك",
      },
      {
        id: 32,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Hany-Omar.jpg",
        name: "هاني عمر",
        role: "العضو المنتدب لشركة كونتكت للتخصيم",
      },
      {
        id: 33,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Ayman-Halim.jpg",
        name: "أيمن حليم",
        role: "العضو المنتدب لشركة كونتكت للتمويل العقاري",
      },
      {
        id: 34,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Marwan-Adel.jpg",
        name: "مروان عادل",
        role: "مدير عام التسويق",
      },
      {
        id: 35,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Ghada-Tayel.jpg",
        name: "غادة طايل",
        role: "مدير تطوير الأعمال بالمجموعة",
      },
      {
        id: 36,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Mohamed-Samir.jpg",
        name: "محمد سمير",
        role: "رئيس قطاع الشئون الإدارية",
      },

      {
        id: 37,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Moursy-Mansour.jpg",
        name: "مرسي منصور",
        role: "المراجع الداخلي للمجموعة",
      },
      {
        id: 38,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Ahmed-Ewiess.jpg",
        name: "أحمد عويس",
        role: "مدير تحليل السوق والأعمال بالمجموعة",
      },
    ],
    icon_title: {
      products_auto_page: [
        {
          id: 1,
          img: "/calender.png",
          title: "5 سنين",
          sub_title: "فترات سداد تصل إلى 5 سنوات",
        },
        {
          id: 2,
          img: "/cash1.png",
          title: "10 مليون",
          sub_title: "تمويل يصل إلى 10 مليون جنيه",
        },
        {
          id: 3,
          img: "/payment1.png",
          title: "٪10 مقدم",
          sub_title: " مقدم يبدأ من 10 ٪ ",
        },
        {
          id: 4,
          img: "/speed1.png",
          title: "سرعة",
          sub_title: "سهولة وسرعة في إجراءات التمويل",
        },
        {
          id: 5,
          img: "/approve.svg",
          title: "تسهيلات للتقسيط",
          sub_title:
            "خدمات إضافية مع باقات التقسيط كتسهيلات التراخيص والتأمين والتجديد",
        },
        {
          id: 6,
          img: "/no-insurance.png",
          title: "بدون تأمين",
          sub_title: "إمكانية التقسيط بدون تأمين.",
        },
      ],
      products_trucks_page: [
        {
          id: 1,
          img: "/calender.png",
          title: "5 سنين",
          sub_title: "فترات سداد تصل إلى 5 سنوات.",
        },
        {
          id: 2,
          img: "/cash1.png",
          title: "8 مليون",
          sub_title: "تمويل يصل إلى 8 مليون جنيه.",
        },
        {
          id: 3,
          img: "/payment1.png",
          title: "٪20 مقدم",
          sub_title: " مقدم يبدأ من ٢٠ ٪ .",
        },
        {
          id: 4,
          img: "/speed1.png",
          title: "سرعة",
          sub_title: "سهولة وسرعة في إجراءات التمويل.",
        },
      ],
      products_maintainance_page: [
        {
          id: 1,
          img: "/calender.png",
          title: "24 شهر",
          sub_title: "فترات سداد تصل إلى 24 شهر .",
        },
        {
          id: 2,
          img: "/cash1.png",
          title: " 1.5 مليون",
          sub_title: "تمويل يصل إلى 1.5 مليون جنيه.",
        },
        {
          id: 3,
          img: "/payment1.png",
          title: "٪20 مقدم",
          sub_title: " مقدم يبدأ من ٢٠ ٪ .",
        },
        {
          id: 4,
          img: "/speed1.png",
          title: "سرعة",
          sub_title: "سهولة وسرعة في إجراءات التمويل.",
        },
      ],
      products_shopping_page: [
        {
          id: 1,
          img: "/calender.png",
          title: "5 سنوات",
          sub_title: "فترات سداد تصل إلى 5 سنوات.",
        },
        {
          id: 2,
          img: "/cash1.png",
          title: "1 مليون",
          sub_title: "تمويل يصل إلى مليون جنيه.",
        },
        {
          id: 3,
          img: "/payment.png",
          title: "بدون مقدم ",
          // sub_title:""
        },
        {
          id: 4,
          img: "/speed1.png",
          title: " سرعة",
          sub_title:
            "سهولة وسرعة في الشراء عن طريق رقم بطاقتك و رقم موبايلك فقط.",
        },
        {
          id: 5,
          img: "/bank.png",
          title: "شبكة تجار واسعة ",
          sub_title: "أكبر عدد من المحلات والمعارض ومنافذ البيع والتحصيل.",
        },
        {
          id: 6,
          img: "/without-complications.svg",
          title: "بدون رسوم ",
          sub_title: "مفيش مصاريف مخفية ولا رسوم مفاجئة.",
        },
        {
          id: 7,
          img: "/approve.svg",
          title: "مرنة ",
          sub_title: "خيارات دفع مرنة ومريحة.",
        },
        {
          id: 8,
          img: "/customer-services.svg",
          title: "على مدار الساعة",
          sub_title: "خدمة عملاء محترفة في خدمتك على مدار الساعة.",
        },
      ],
      products_clubs_page: [
        {
          id: 1,
          img: "/calender.png",
          title: "5 سنين",
          sub_title: "فترات سداد تصل إلى 5 سنوات.",
        },
        {
          id: 2,
          img: "/cash1.png",
          title: " 1.5 مليون",
          sub_title: "تمويل يصل إلى 1.5 مليون جنيه.",
        },
        {
          id: 3,
          img: "/payment1.png",
          title: "بدون مقدم",
          // sub_title: " مقدم يبدأ من 0 ٪ .",
        },
        {
          id: 4,
          img: "/speed1.png",
          title: "سرعة",
          sub_title: "سهولة وسرعة في إجراءات التمويل.",
        },
        {
          id: 5,
          img: "/membership.svg",
          title: "تفعيل فوري للعضوية ",
        },
      ],
      products_events_page: [
        {
          id: 1,
          img: "/calender.png",
          title: "3 سنين",
          sub_title: "فترات سداد تصل إلى 3 سنوات.",
        },
        {
          id: 2,
          img: "/cash1.png",
          title: "2 مليون",
          sub_title: "تمويل يصل إلى 2 مليون جنيه.",
        },
        {
          id: 3,
          img: "/payment1.png",
          title: "٪20 مقدم",
          sub_title: " مقدم يبدأ من ٢٠ ٪. ",
        },
        {
          id: 4,
          img: "/speed1.png",
          title: "سرعة",
          sub_title: "سهولة وسرعة في إجراءات التمويل.",
        },
        // {
        //   id: 4,
        //   img: "/rate.svg",
        //   title: "فوائد تنافسية",
        //   sub_title: "",
        // },
        // {
        //   id: 5,
        //   img: "/approve.svg",
        //   title: "شروط بسيطة للموافقة",
        //   sub_title: "",
        // },
        // {
        //   id: 6,
        //   img: "/bank.png",
        //   title: "شبكة واسعة من التجار الشركاء",
        //   sub_title: "",
        // },
      ],
      products_green_finance_page: [
        {
          id: 1,
          img: "/calender.png",
          title: "5 سنين",
          sub_title: "خطط سداد تصل لـ 5 سنين.",
        },
        {
          id: 2,
          img: "/cash1.png",
          title: "3 مليون",
          sub_title: "تمويل يصل لـ 3 مليون جنيه .",
        },
        {
          id: 3,
          img: "/payment1.png",
          title: "٪30 مقدم",
          sub_title: " مقدم يبدأ من 30 ٪. ",
        },
        {
          id: 4,
          img: "/speed1.png",
          title: "سرعة",
          sub_title: "إجراءات أسرع وأسهل.",
        },
      ],
      products_education_page: [
        {
          id: 1,
          img: "/calender.png",
          title: "12 شهر",
          sub_title: "فترات سداد تصل إلى 12 شهر للمدارس والجامعات والكورسات.",
        },
        {
          id: 2,
          img: "/cash1.png",
          title: "2 مليون",
          sub_title: "تمويل يصل إلى 2 مليون جنيه.",
        },
        {
          id: 3,
          img: "/payment1.png",
          title: "بدون مقدم",
          sub_title: "",
        },
        // {
        //   id: 4,
        //   img: "/speed1.png",
        //   title: "سرعة",
        //   sub_title: "سهولة وسرعة في إجراءات التمويل",
        // },
        {
          id: 4,
          img: "/graduation.png",
          title: "فترات سداد تصل إلى 3 سنوات للماجستير",
        },
        {
          id: 5,
          img: "/PhD.svg",
          title: "فترات سداد تصل إلى 5 سنوات للدكتوراه  ",
        },
      ],
      products_factoring_page: [
        {
          id: 1,
          img: "/speed1.png",
          title: "موافقة سهلة وسريعة",
        },
        {
          id: 2,
          img: "/cash1.png",
          title: "سيوله نقدية فورية لمشروعك",
        },
        {
          id: 3,
          img: "/approve.svg",
          title: "حلول مناسبة لمختلف القطاعات",
        },
        {
          id: 4,
          img: "/payment1.png",
          title: "خدمة احترافية ودعم مستمر",
        },
      ],
      products_leasing_page: [
        {
          id: 1,
          img: "/coins.png",
          title: "دفعة مقدمة",
          sub_title: "دفعة مقدمة تبدأ من 10% طبقاً لنوع الأصل",
        },
        {
          id: 2,
          img: "/calender.png",
          title: " 5 سنين",
          sub_title: "فترات سداد تصل إلى 5 سنوات.",
        },
        {
          id: 3,
          img: "/suppliers.png",
          title: "شبكة من الموردين",
          sub_title:
            "شبكة واسعة من الموردين المعتمدين لأفضل المصنعين والماركات العالمية.",
        },
        {
          id: 4,
          img: "/payment.png",
          title: "خطط سداد متنوعة",
          sub_title: "خطط سداد متنوعة مصممة لتناسب احتياجاتك.",
        },
        // {
        //   id: 5,
        //   img: "/without-complications.svg",
        //   title: "بدون تعقيدات",
        //   sub_title: "إجراءات واضحة بدون تعقيدات",
        // },
        {
          id: 6,
          img: "/furniture.png",
          title: "يشمل التجهيزات",
          sub_title:
            "التمويل يشمل تجهيزات العيادات والمنشآت الطبية وسيارات الإسعاف بأحدث أجهزة الرعاية الصحية.",
        },
        {
          id: 7,
          img: "/transport.png",
          title: "يشمل وسائل النقل",
          sub_title:
            "التمويل يشمل وسائل النقل من السيارات الشخصية إلى السيارات التجارية (نقل خفيف، متوسط وثقيل) بالإضافة إلى الحافلات والڤان.",
        },
        // {
        //   id: null,
        // },
      ],
      products_watercraft_page: [
        {
          id: 1,
          img: "/calender.png",
          title: "5 سنين",
          sub_title: "فترات سداد تصل إلى 5 سنوات.",
        },
        {
          id: 2,
          img: "/cash1.png",
          title: "4 مليون",
          sub_title: "تمويل يصل إلى 4 مليون جنيه.",
        },
        {
          id: 3,
          img: "/payment1.png",
          title: "٪20 مقدم",
          sub_title: " مقدم يبدأ من ٢٠ ٪. ",
        },
        {
          id: 4,
          img: "/speed1.png",
          title: "سرعة",
          sub_title: "سهولة وسرعة في إجراءات التمويل.",
        },
        {
          id: 5,
          img: "/financing-maintenance.svg",
          title: "إمكانية تمويل مصاريف الصيانة والإصلاح",
        },
      ],
      products_motorcycle_page: [
        {
          id: 1,
          img: "/calender.png",
          title: "5 سنين",
          sub_title: "فترات سداد تصل إلى 5 سنوات.",
        },
        {
          id: 2,
          img: "/cash1.png",
          title: "3 مليون",
          sub_title: "تمويل يصل إلى 3 مليون جنيه.",
        },
        {
          id: 3,
          img: "/payment1.png",
          title: "٪20 مقدم",
          sub_title: " مقدم يبدأ من ٢٠ ٪. ",
        },
        {
          id: 4,
          img: "/speed1.png",
          title: "سرعة",
          sub_title: "سهولة وسرعة في إجراءات التمويل.",
        },
        // {
        //   id: 5,
        //   img: "/bank.png",
        //   title: "تأمين اختياري",
        // },
        {
          id: 5,
          img: "/motor.svg",
          title:
            "تمويل كل أنواع الدراجات النارية (عجلتين – ثلاث عجلات – أربع عجلات)",
        },
      ],
      products_furniture_page: [
        {
          id: 1,
          img: "/calender.png",
          title: "5 سنين",
          sub_title: "فترات سداد تصل إلى 5 سنوات.",
        },
        {
          id: 2,
          img: "/cash1.png",
          title: "3 مليون",
          sub_title: "تمويل يصل إلى 3 مليون جنيه.",
        },
        {
          id: 3,
          img: "/payment.png",
          title: "٪20 مقدم",
          sub_title: " مقدم يبدأ من ٢٠ ٪ .",
        },
        {
          id: 4,
          img: "/speed1.png",
          title: "سرعة",
          sub_title: "سهولة وسرعة في إجراءات التمويل .",
        },
        {
          id: 5,
          img: "/offers.svg",
          title: "إمكانية دمج عروض سعر مختلفة في نفس الطلب",
        },
      ],
      products_home_interior_page: [
        {
          id: 1,
          img: "/calender.png",
          title: "5 سنين",
          sub_title: "خطط تقسيط تصل إلى 5 سنوات.",
        },
        {
          id: 2,
          img: "/cash1.png",
          title: "4 مليون",
          sub_title: "تمويل يصل إلى 4 مليون جنيه .",
        },
        {
          id: 3,
          img: "/payment1.png",
          title: "٪20 مقدم",
          sub_title: " مقدم بيبدأ من ٢٠ ٪ .",
        },
        {
          id: 4,
          img: "/speed1.png",
          title: "سرعة",
          sub_title: "سهولة وسرعة في إجراءات التمويل.",
        },
      ],
      mortgage_page: [
        {
          id: 1,
          img: "/calender.png",
          title: "10 سنين",
          sub_title: "فترات سداد تصل إلى 10 سنوات.",
        },
        {
          id: 2,
          img: "/cash1.png",
          title: "10 مليون",
          sub_title: "تمويل يصل إلى 10 مليون جنيه.",
        },
        {
          id: 3,
          img: "/payment1.png",
          title: "٪25 مقدم",
          sub_title: "مقدم 25% من قيمة الوحدة.",
        },
        {
          id: 4,
          img: "/speed1.png",
          title: "سرعة",
          sub_title: "إجراءات بسيطة وسريعة من غير مشاوير كتيرة.",
        },
        {
          id: 5,
          img: "/repayment-periods.svg",
          title: "تشمل جميع الوحدات السكنية بجميع أنواعها",
          sub_title: "سواء كانت داخل كومباوند أو خارجه.",
        },
      ],
      home_equity: [
        {
          id: 1,
          img: "/calender.png",
          title: "5 سنين",
          sub_title: "فترات سداد تصل إلى 5 سنوات.",
        },
        {
          id: 2,
          img: "/cash1.png",
          title: "10 مليون",
          sub_title: "تمويل نقدي يصل إلى 10 مليون جنيه.",
        },
        {
          id: 3,
          img: "/payment1.png",
          title: "بدون مقدم",
          sub_title: "",
        },
        {
          id: 4,
          img: "/repayment-periods.svg",
          title: "التمويل يشمل جميع الوحدات السكنية بجميع أنواعها ",
          sub_title: "سواء كانت داخل كومباوند أو خارجه.",
        },
      ],
      products_manasik_page: [
        {
          id: 1,
          img: "/calender.png",
          title: "5 سنين",
          sub_title: "فترات سداد تصل إلى 5 سنوات للحج و 12 شهر للعمرة",
        },
        {
          id: 2,
          img: "/cash1.png",
          title: " 3 مليون",
          sub_title: "تمويل يصل إلى 3 مليون جنيه",
        },
        {
          id: 3,
          img: "/payment1.png",
          title: "٪20 مقدم",
          sub_title: " مقدم يبدأ من ٢٠ ٪",
        },
        {
          id: 4,
          img: "/speed1.png",
          title: "سرعة",
          sub_title: "سهولة وسرعة في إجراءات التمويل",
        },
        {
          id: 5,
          img: "/sharia_islamia.svg",
          title: "متوافق مع أحكام الشريعة الإسلامية",
        },
      ],
    },
  },
  logo: "/logo-ar.png",

  main_nav: {
    individuals: "أفراد",
    companies: "شركات",
    investors: "مستثمرين",
    lang: "En",
  },
  secondary_nav: {
    financial_services: "خدمات تمويلية",
    insurance_services: "خدمات تأمينية",
    contact_uae: "كونتكت الامارات",
    contact_now: "كونتكت تسوق",
    insurance_services_dropdown:
      // motor: "تأمين السيارات",
      // home: "تأمين المنزل",
      // personal: "تأمين الحوادث الشخصية ونمط الحياة",
      // property: "تأمين الممتلكات",
      // engineering: "التأمينات الهندسية",
      // motor_fleet: "تأمين أساطيل السيارات",
      // marine: "التأمين البحري والبري بضائع",
      // liability: "تأمين المسؤوليات والتأمينات المالية",
      // medical: "تأمين طبي",
      // brokerge: "الوساطة التأمينية",
      [
        {
          url: "/products/insurance",
          color: colors.ratty,
          img: "/services/bro-ar.svg",
          title: "وساطة تأمينية",
        },
        {
          url: "/sarwa-life",
          color: colors.ratty,
          img: "/images/life-logo-ar.svg",
          title: "ثروة لتأمينات الحياة",
        },
        {
          url: "/sarwa-insurance",
          color: colors.ratty,
          img: "/images/insurance-logo-ar.svg",
          title: "ثروة للتأمين",
        },
      ],

    e_payments: "مدفوعات الكترونية",
    why_contact: "ليه كونتكت ؟",
    clients_program: "برامج كونتكت",
    // investment_and_savings: "استثمار وادخار",
    branches_location: "أماكن الفروع",
    login: "تسجيل الدخول",
    download_app: "حمل التطبيق",
  },
  footer: {
    section_a: {
      subscribe_now: "اشترك الآن ",
      in_email_service: "في خدمة البريد الالكتروني",
      // enter_email: "أدخل بريدك الالكتروني",
      enter_email: "اشترك في خدمة البريد الالكتروني",
      button: "اشترك",
    },
    section_b: {
      financial_services: "خدمات تمويلية",
      insurance_services: "خدمات تأمينية",
      for_individuals: "للأفراد",
      Terms_and_Conditions: "الشروط و الأحكام",

      list1: [
        { id: "1", name: "تمويل السيارات", url: "/products/auto" },
        { id: "2", name: "تمويل النقل", url: "/products/trucks" },
        { id: "3", name: "تسوق", url: "/products/contact-now" },
        { id: "4", name: "تمويل التعليم", url: "/products/education" },
        { id: "5", name: "تمويل اشتراكات الاندية", url: "/products/clubs" },
        { id: "6", name: "تمويل الصيانة", url: "/products/maintainance" },
        { id: "7", name: "تمويل أفراح و مناسبات", url: "/products/events" },
        { id: "8", name: "تمويل عقاري", url: "/products/mortgage" },
        {
          id: "9",
          name: "تمويل الدراجات النارية",
          url: "/products/motorcycles",
        },
        { id: "10", name: "التمويل الأخضر", url: "/products/green-finance" },
        { id: "11", name: "تخصيم", url: "/products-bussiness/factoring" },
        { id: "12", name: "تأجير تمويلي", url: "/products-bussiness/leasing" },
        {
          id: "13",
          name: "تمويل التصميم و التشطيب",
          url: "/products/home-interior",
        },
        { id: "14", name: "تمويل فرش البيت", url: "/products/home-furniture" },
        {
          id: "15",
          name: "تمويل مركبات ومعدات الرياضات المائية",
          url: "/products/watercraft",
        },
      ],
      list2: [
        { name: "وساطة تأمينية", url: "/products/insurance" },
        {
          name: "ثروة لتأمينات الحياة",
          url: "/sarwa-life",
          // url: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar#reqP",
        },
        {
          name: "ثروة للتأمين",
          url: "/sarwa-insurance",
          // url: "https://sarwa.insurance/sarwa-insurance/product/retail?lang=ar",
        },
      ],
      list3: [
        { name: "مدفوعات الكترونية", url: "/e-payment" },
        // { name: "استثمار و ادخار", url: "/investment" },
      ],
      for_business: "للشركات",
      for_business_list: [{ name: "برامج كونتكت", url: "/referral-program" }],
      contact: "عن كونتكت",
      contact_list: [
        { name: "عنا", url: "/about" },
        { name: "شركاتنا", url: "/our-brands" },
        { name: "ليه كونتكت ؟", url: "/why-contact" },
        { name: "وظائفنا", url: "/careers" },
        { name: "كونتكت الإمارات", url: "/contact-uae" },

        {
          name: " علاقات المستثمرين",
          url: "https://investorrelations.contact.eg/ar",
        },
        { name: "الاستدامة", url: "/sustainability" },
        { name: "المدونات", url: "/blogs" },
        { name: "أخبارنا", url: "/media" },
      ],
      contact_us: "تواصل معنا",
      contact_us_list: [
        // { name: "تواصل معنا", url: "/contact-us" },
        {
          name: "كتالوج منتجات كونتكت",
          url: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Contact-Brochure.pdf",
        },
        { name: "فروعنا", url: "/our-branches" },
        { name: "الخط الساخن: 16177", url: "" },
      ],
      privacy: "السياسات",
      privacy_list: [{ name: "سياسة الخصوصية", url: "/privacy-policy.pdf" }],
      protection_guide: "دليل حماية المستهلك",
      protection_guide_list: [
        {
          name: "دليل 1",
          url: "https://fra.gov.eg/%D8%AF%D9%84%D9%8A%D9%84-%D8%AD%D9%85%D8%A7%D9%8A%D8%A9-%D8%A7%D9%84%D9%85%D8%AA%D8%B9%D8%A7%D9%85%D9%84%D9%8A%D9%86-%D9%81%D9%8A-%D8%A7%D9%84%D9%82%D8%B7%D8%A7%D8%B9-%D8%A7%D9%84%D9%85%D8%A7%D9%84/",
        },
        {
          name: "دليل 2",
          url: `${process.env.NEXT_PUBLIC_SITE_URL}كتاب دورى رقم (4) .pdf`,
        },
      ],
    },
    section_c: {
      download_app: "حمل تطبيق كونتكت",
      img1: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/google-play-ar.png",
      img2: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/app-store-ar.png",
      img3: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/huawei-store-ar.png",
    },
    section_d: {
      copy_right: "جميع الحقوق محفوظة لكونتكت ",
    },
  },
  bottom_card: {
    placeholder: "ادخل البريد الالكتروني",
    send: "ارسل",
  },
  form_labels: {
    title: "شبكة التجار",
    full_name: "الإسم بالكامل",
    last_name: "اسم العائلة",
    email_adress: "البريد الالكتروني",
    phone_number: "رقم الموبايل",
    national_id: "رقم البطاقة",
    governorate: "المحافظة",
    g_placeholder: "اختر المحافظة",
    city: "المدينة",
    category: "الفئة",
    area: "المنطقة",
    country: "الدولة",
    country_placeholder: "اختر الدولة ",
    case1: "من فضلك اختر على الأقل فئة ومدينة",
    case2: "لا يوجد تجار",
    cat_placeholder: "اختر الفئة",
    city_placeholder: "اختر المدينة",
    area_placeholder: "اختر المنطقة",
    a_placeholder: "اختر المنطقة",
    car_type: "حالة السيارة",
    car_placeholder: "اختر حالة السيارة",
    car_price: "ثمن السيارة",
    products: "المنتجات",
    products_placeholder: "اختر منتج",
    mortgage_type: "نوع التمويل",
    POS_Placeholder: "اختر نقاط البيع",
    submit: "ارسل طلبك",
    // =======
    subject: "الموضوع",
    message: "كيف يمكننا مساعدتك؟",
    job: "الوظيفة المقدم عليها",
    resume: "السيرة الذاتية",
    resume_des: "برجاء رفع الرابط الخاص بالسيرة الذاتية",
    passport_copy: "صورة من جواز السفر سارى",
    work_permit: "صورة من اقامة العمل",
    hr_letter: "خطاب HR من جهة العمل",
    bank_statement: "كشف حساب بنكي",
    EgyptAddress: "  عنوان إقامة داخل مصر",
    noFileChosen: "لا يوجد ملف مختار",
    chooseFile: "حدد الملف",
    terms:
      "بالضغط على هذا المربع، أوافق على منح شركة كونتكت للتمويل الحق والموافقة على الكشف عن البيانات والمعلومات المتعلقة بى او التسهيل الائتماني والالتزامات المتعلقة بذلك وأى تقصير إن وجد الى الشركة المصرية للإستعلام الائتمانى (I-Score)، ويتضمن ذلك إستخراج تقرير الإستعلام الائتمانى الخاص بى والمُطلوب للموافقة على الطلب المُقدم. بالاضافة الى ذلك، أقر بأننى أقبل اجراءات الاستعلام عنى من جانب موظفى شركة كونتكت للتمويل دون اعتراض مني\u202B.\u202C",
    enterPhoneFirst: "الرجاء إدخال رقم هاتفك اولا",
    Disclaimer:
      " للحصول على عملية موافقة اسرع , يرجى تحميل جميع المستندات ذات الصلة",
    apply: "قدم للوظيفة",
    showmore: "عرض المزيد",
    optinol: "اختياري",
  },
  governorates: [
    {
      id: "1",
      governorate_name: "القاهرة",
    },
    { id: "2", governorate_name: "الجيزة" },
    {
      id: "3",
      governorate_name: "الأسكندرية",
    },
    {
      id: "4",
      governorate_name: "الدقهلية",
    },
    {
      id: "5",
      governorate_name: "البحر الأحمر",
    },
    {
      id: "6",
      governorate_name: "البحيرة",
    },
    {
      id: "7",
      governorate_name: "الفيوم",
    },
    {
      id: "8",
      governorate_name: "الغربية",
    },
    {
      id: "9",
      governorate_name: "الإسماعلية",
    },
    {
      id: "10",
      governorate_name: "المنوفية",
    },
    {
      id: "11",
      governorate_name: "المنيا",
    },
    {
      id: "12",
      governorate_name: "القليوبية",
    },
    {
      id: "13",
      governorate_name: "الوادي الجديد",
    },
    {
      id: "14",
      governorate_name: "السويس",
    },
    {
      id: "15",
      governorate_name: "اسوان",
    },
    {
      id: "16",
      governorate_name: "اسيوط",
    },
    {
      id: "17",
      governorate_name: "بني سويف",
    },
    {
      id: "18",
      governorate_name: "بورسعيد",
    },
    {
      id: "19",
      governorate_name: "دمياط",
    },
    {
      id: "20",
      governorate_name: "الشرقية",
    },
    {
      id: "21",
      governorate_name: "جنوب سيناء",
    },
    {
      id: "22",
      governorate_name: "كفر الشيخ",
    },
    {
      id: "23",
      governorate_name: "مطروح",
    },
    {
      id: "24",
      governorate_name: "الأقصر",
    },
    { id: "25", governorate_name: "قنا" },
    {
      id: "26",
      governorate_name: "شمال سيناء",
    },
    {
      id: "27",
      governorate_name: "سوهاج",
    },
  ],
  country: [
    {
      id: "مصر",
      country_name: "مصر",
      phoneCode: "+٢٠",
      flag: "EG",
      icon: cifEg,
    },
    {
      id: "الامارات",
      country_name: "الامارات",
      phoneCode: "+٩٧١",
      flag: "AE",
      icon: cifAe,
    },
  ],
  car_type: [
    {
      id: "1",
      value: "جديد",
    },
    { id: "2", value: "مستعمل" },
  ],
  mortgage_type: [
    {
      id: "1",
      value: "تمويل المنزل",
    },
    { id: "2", value: "إعادة تمويل المنزل" },
  ],
  home_page: {
    slides: [
      {
        bgImage: "/orange-video-bg.jpeg",
        banner_type: "video",
        desktopSrc:"https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Copy+of+Helping+You+Achieve+Your+Dreams+(1920+x+1080+px)+(2000+x+700+px).mp4",
        mobileSrc: "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Copy+of+Helping+You+Achieve+Your+Dreams+(1920+x+1080+px)+(420+x+700+px).mp4",
      },
      {
        bgColor: "#EAEAEA",
        bgImage: "/bgs/02-ar.svg",
        logo: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/contact-ar-white.png",
        alt: "قسط مع كونتكت",
        text: "تمويل وتأمين في مكان واحد",
        textColor: colors.white,
        button: "تصفح المنتجات",
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/cover_img_55.png",
        link: "/#all-products",
      },
      {
        // bgImage:"/lg-ar-banner-auto.png",
        banner_type: "img",
        desktopSrc: "/lg-ar-banner-auto.png",
        mobileSrc: "/sm-ar-banner-auto.png",
      },
      {
        bgColor: "#2D317F",
        bgImage: "/bgs/02-en.svg",
        logo: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/contact-logo-ar.png",
        text: "حلم الحج والعمرة بتمويل من كونتكت أسرع من أي وقت",
        textColor: colors.white,
        button: "أعرف المزيد",
        img: "/bgs/manasik-home-banner.png",
        alt: "manasik",
        link: "/products/manasik",
      },

      {
        bgColor: "#EAEAEA",
        // bgImage: "/bgs/03-ar.svg",
        bgImage: "/bgs/02-ar.svg",

        logo: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/contact-brokerage-ar-light.png",

        text: "حمل التطبيق واستمتع بكل مزايا التأمين وانت في مكانك",
        // textColor: colors.ratty,
        textColor: colors.white,

        button: "اطلب الخدمة",
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/cover_img_33.png        ",
        alt: "الوساطة التأمينيه",
        link: "/products/insurance",
        app: {
          google_play_link:
            "https://play.google.com/store/apps/details?id=com.insuranceBrokerage&hl=ar",
          app_store_link:
            "https://apps.apple.com/eg/app/insurance-brokerage/id6445921286",
          qr_code: "/insurance_brokerage_qr_code.svg",
        },
      },
      {
        bgColor: "#2D317F",
        bgImage: "/bgs/02-en.svg",
        logo: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/contact-pay-logo.png",
        text: "أسهل طريقة دفع, لكل احتياجاتك",
        textColor: colors.white,
        button: "اقرأ المزيد",
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/contact-pay-banner-orange.png",
        alt: "دفع الفواتير",
        link: "/e-payment",
        app: {
          google_play_link:
            "https://play.google.com/store/apps/details?id=eg.contact",
          app_store_link:
            "https://apps.apple.com/us/app/contactnow-%D9%83%D9%88%D9%86%D8%AA%D9%83%D8%AA/id1544159088",
          // qr_code:
          //   "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/qr-code-light.png",
        },
      },
      {
        bgColor: "#EAEAEA",
        bgImage: "/bgs/02-ar.svg",
        textColor: colors.white,
        logo: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/contact-logo-ar.png",
        text: "بنقربلك في كل محافظة في مصر",
        button: "ابحث عن أقرب فرع",
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/cover_img_22-ar.png",
        alt: "فروع كونتكت",
        link: "/our-branches",
      },
    ],
    services_title: "خدماتنا",
    products_title: "منتجاتنا",

    products_options: [
      { id: "1", title: "بيتك" },
      { id: "2", title: "المركبات" },
      { id: "3", title: "التأمين" },
      { id: "4", title: "تفاصيل حياتك" },
      { id: "5", title: "التعليم" },
      { id: "6", title: "التمويل الأخضر" },
      { id: "7", title: "مناسك" },
    ],

    products: [
      {
        optionId: "1",
        title1: "",
        title2: "تمويل فرش البيت",
        img: "/pages/furniture-cover.png",
        small_img: "/pages/furniture-cover-small.png",
        bgcolor: "#fff",
        url: "/products/home-furniture",
        value: "HomeFurniture",
        alt: "furniture background",
      },
      {
        optionId: "1",
        title1: "",
        title2: "تمويل التشطيب",
        img: "/pages/finishing-cover.png",
        small_img: "/pages/finishing-cover-small.png",
        bgcolor: "#fff",
        url: "/products/home-interior",
        value: "Homes",
        alt: "home interior background",
      },
      {
        optionId: "1",
        title1: "",
        title2: "تمويل الصيانة",
        img: "/pages/maintainance-cover.png",
        small_img: "/pages/maintainance-cover-small.png",
        bgcolor: "#fff",
        url: "/products/maintainance",
        value: "Maintenance",
        alt: "maintenance background",
      },
      {
        optionId: "1",
        title1: "",
        title2: "تمويل عقاري",
        img: "/pages/home-cover.png",
        small_img: "/pages/home-cover-small.png",
        bgcolor: "#fff",
        url: "/products/mortgage",
        value: "Mortgage",
        alt: "mortgage background",
      },
      {
        optionId: "2",
        title1: "",
        title2: "تمويل السيارات",
        img: "/pages/cars-cover.png",
        small_img: "/pages/cars-cover-small.png",
        bgcolor: "#fff",
        url: "/products/auto",
        value: "Auto",
        alt: "auto background",
      },
      {
        optionId: "2",
        title1: "",
        title2: "تمويل النقل",
        img: "/pages/trucks-cover.png",
        small_img: "/pages/trucks-cover-small.png",
        bgcolor: "#fff",
        url: "/products/trucks",
        value: "Trucks",
        alt: "trucks background",
      },
      {
        optionId: "2",
        title1: "",
        title2: "تمويل المركبات المائية",
        img: "/pages/watercraft-cover.png",
        small_img: "/pages/watercraft-cover-small.png",
        bgcolor: "#fff",
        url: "/products/watercraft",
        value: "Watercrafts",
        alt: "watercraft background",
      },
      {
        optionId: "2",
        title1: "",
        title2: "تمويل الدراجات النارية",
        img: "/pages/motorcycle-cover.png",
        small_img: "/pages/motorcycle-cover-small.png",
        bgcolor: "#fff",
        url: "/products/motorcycles",
        value: "Motorcycles",
        alt: "mortgage background",
      },
      {
        optionId: "3",
        title1: "",
        title2: "وساطة تامينية",
        img: "/pages/insurance-cover.png",
        small_img: "/pages/insurance-cover-small-ar.png",
        bgcolor: "#fff",
        url: "/products/insurance",
        value: "Brokerage",
        alt: "insurance background",
      },
      {
        optionId: "3",
        title2: "ثروة لتأمينات الحياة",
        img: "/our-brands/sarwa-life.png",
        small_img: "/pages/sarwa-life-small-ar.png",
        bgcolor: "#fff",
        url: "/sarwa-life",
        value: "Life",
        alt: "insurance background",
      },
      {
        optionId: "3",
        title2: "ثروة للتأمين",
        img: "/our-brands/sarwa-insurance.png",
        small_img: "/pages/sarwa-insurance-small-ar.png",
        bgcolor: "#fff",
        url: "/sarwa-insurance",
        value: "Insurance",
        alt: "insurance background",
      },
      {
        optionId: "4",
        title1: "",
        title2: "تمويل تسوق",
        img: "/pages/cart.png",
        small_img: "/pages/cart-small.png",
        bgcolor: "#fff",
        url: "/products/contact-now",
        value: "shopping",
        alt: "shopping background",
      },
      {
        optionId: "4",
        title1: "",
        title2: "تمويل افراح",
        img: "/pages/event-cover-ar.png",
        small_img: "/pages/events-cover-small.png",
        bgcolor: "#fff",
        url: "/products/events",
        value: "Wedding",
        alt: "wedding and events background",
      },
      {
        optionId: "4",
        title1: "",
        title2: "اشتراكات الاندية",
        img: "/pages/clubs-cover.png",
        small_img: "/pages/clubs-cover-small.png",
        bgcolor: "#fff",
        url: "/products/clubs",
        value: "Clubs",
        alt: "clubs background",
      },
      {
        optionId: "4",
        title1: "",
        title2: "تمويل التعليم",
        img: "/pages/schools.png",
        small_img: "/pages/schools-small.png",
        bgcolor: "#fff",
        url: "/products/education",
        value: "Education",
        alt: "education background",
      },
      {
        optionId: "5",
        title1: "",
        title2: "حضانة",
        img: "/pages/nursery.png",
        small_img: "/pages/nursery-small.png",
        bgcolor: "#fff",
        url: "/products/education",
        value: "Education",
        alt: "education background",
      },
      {
        optionId: "5",
        title1: "",
        title2: "مدارس",
        img: "/pages/schools.png",
        small_img: "/pages/schools-small.png",
        bgcolor: "#fff",
        url: "/products/education",
        value: "Education",
        alt: "education background",
      },
      {
        optionId: "5",
        title1: "",
        title2: "جامعات",
        img: "/pages/universities.png",
        small_img: "/pages/universities-small.png",
        bgcolor: "#fff",
        url: "/products/education",
        value: "Education",
        alt: "education background",
      },
      {
        optionId: "5",
        title1: "",
        title2: "دراسات عليا وكورسات",
        img: "/pages/postgraduate.png",
        small_img: "/pages/postgraduate-small.png",
        bgcolor: "#fff",
        url: "/products/education",
        value: "Education",
        alt: "education background",
      },
      {
        optionId: "6",
        title2: "السيارات الكهربائية",
        img: "/pages/green-finance-cover.png",
        small_img: "/pages/green-car-small.png",
        bgcolor: "#fff",
        url: "/products/auto",
        value: "GreenFinance",
        alt: "green finance background",
      },
      {
        optionId: "6",
        title2: "ألواح الطاقة الشمسية",
        img: "/pages/green-finance-cover.png",
        small_img: "/pages/green-energy-small.png",
        bgcolor: "#fff",
        url: "/products/green-finance",
        value: "GreenFinance",
        alt: "green finance background",
      },
      {
        optionId: "6",
        title2: "الصوب الزراعية",
        img: "/pages/green-finance-cover.png",
        small_img: "/pages/green-house-small.png",
        bgcolor: "#fff",
        url: "/products/green-finance",
        value: "GreenFinance",
        alt: "green finance background",
      },
      {
        optionId: "7",
        title2: "مناسك",
        img: "/pages/manasik-card.png",
        small_img: "/pages/manasik-card.png",
        bgcolor: "#fff",
        url: "/products/manasik",
        value: "Manasik",
        alt: "manasik",
      },

      // *********
      {
        title1: "",
        title2: "تمويل التخصيم",
        img: "/pages/factoring-cover.png",
        bgcolor: "#bf6340",
        url: "/products-bussiness/factoring",
        value: "Factoring",
        alt: "factoring background",
      },
      {
        title1: "",
        title2: "تأجير تمويلي",
        img: "/pages/leasing-cover.png",
        bgcolor: "#4aa2a6",
        url: "/products-bussiness/leasing",
        value: "Leasing",
        alt: "leasing background",
      },
      // *******
    ],
    bos: {
      title1: "دفع الفواتير",
      // title2: "فواتيرك",
      subtitle: "حل الدفع الشامل!",
      body1:
        "اتخلص من مشاكل الفواتير الكتير والطوابير الطويلة مع كونتكت باي، حل الدفع المُبتكر من كونتكت!",
      body2: [
        "مصاريف المدارس والجامعات",
        "فواتير الكهرباء",
        "فواتير الغاز",
        "فواتير التليفون الأرضي",
        "فواتير المياه",
        "فواتير وشحن المحمول",
        "تذاكر وسائل النقل",
        "اشتراك الإنترنت",
        "اشتراك القنوات التلفزيونية",
        "الأقساط التأمينية",
        "التبرعات الخيرية",
        "اشتراكات الأندية",
      ],
      WithContactPay_list: {
        title: "إيه اللي تقدر تدفعه مع كونتكت باي؟",
        list: [
          "فواتير الكهرباء",
          "فواتير الغاز ",
          "فواتير المياه ",
          "فواتير التليفون الأرضي",
          "فواتير وشحن المحمول ",
          "اشتراك الإنترنت",
          "تذاكر وسائل النقل ",
          "الأقساط التأمينية",
          "التبرعات الخيرية",
          "اشتراكات الأندية",
          "مصاريف المدارس والجامعات",
        ],
      },
      benefits: {
        title: "المميزات",
        list: [
          "سرعة وسهولة: كونتكت باي بتخليك تدفع كل مصاريفك بسرعة وسهولة.",
          "معاملات مالية آمنة يمكنك الاعتماد عليها: اطمن لأن معاملاتك محمية بإجراءات الأمان المتقدمة من كونتكت.",
          "حل شامل: متلخبط بين منصات مدفوعات كتير، مع كونتكت باي هتدفع كل فواتيرك بسهولة وفي مكان واحد.",
        ],
      },
      outro: (
        <p>
          كونتكت باي طريقة الكترونية سهلة وأكتر كفاءة لإدارة مدفوعاتك. اتصل بنا
          أو زور أي فرع من فروعنا عشان تعرف أكتر وتدفع اى مصاريف أو فواتير عن
          طريق كونتكت باي حل الدفع الذكى.
          <p style={{ paddingTop: "16px" }}>
            {" "}
            <a
              target="_blank"
              style={{ color: "#F18222", fontWeight: "600" }}
              href={userAgent(
                "https://apps.apple.com/us/app/contactnow-%D9%83%D9%88%D9%86%D8%AA%D9%83%D8%AA/id1544159088",
                "https://play.google.com/store/apps/details?id=eg.contact"
              )}
            >
              حمل التطبيق دلوقتي!{" "}
            </a>{" "}
          </p>
        </p>
      ),
    },
    services: {
      A: [
        {
          id: "1",
          url: "/products/auto",
          color: colors.blue,
          img: "/services/car.svg",
          title: "تمويل السيارات",
          description:
            "لو عايز تشتري عربية جديدة أو مستعملة، كونتكت بتوفرلك حلول تمويلية متميزة لجميع الماركات ",
        },
        {
          id: "7",
          url: "/products/motorcycles",
          color: "#DD6F5A",
          img: "/services/motorcycle.svg",
          title: "تمويل الدراجات النارية",
        },
        {
          url: "/products/trucks",
          id: "2",
          color: colors.dark_red,
          img: "/services/lorry.svg",
          title: "تمويل النقل",
          description:
            "سواء محتاج نقل تقيل أو خفيف كونتكت هتقسطلك جميع أنواع الشاحنات الجديدة والمستعملة والاستيراد",
        },
        {
          url: "/products/contact-now",
          id: "3",

          color: colors.dark_violet,
          img: "/services/cart.svg",
          title: "تسوق",
          description: "لو نفسك تشتري في أي وقت براحتك، كونتكت هتسهل حياتك",
        },
        {
          url: "/products/education",
          id: "4",
          color: colors.green,
          img: "/services/education.svg",
          title: "تمويل التعليم",
          description:
            "نفسك في مستقبل أفضل ليك ولأولادك، كونتكت هتساعدك وهتكون معاك طول مشوار التعليم",
        },
        {
          url: "/products/clubs",
          id: "5",
          color: colors.dark_petroli,
          img: "/services/clubs.svg",
          title: "تمويل اشتراكات الاندية",
          description:
            "نفسك تُنمى مهارات أولادك وتساعدهم يمارسوا الرياضة اللي بيحبوها، كونتكت هتقسطلك اشتراك ",
        },
        {
          id: "6",
          url: "/products/maintainance",
          color: "#DB8539",
          img: "/services/maintainance.svg",
          title: "تمويل الصيانة",
          description:
            "سواء كنت عايز تصّلّح عربيتك، تجدد بيتك، أو تعمل صيانة لأي حاجة، احنا عارفين إن الصيانة ممكن تكلّف كتير وتاخُد وقت. عشان كده كونتكت موجودة عشان تساعدك في كل احتياجات الصيانة بتاعتك. كونتكت بتقدملك حلول تمويل مبتكرة لأي صيانة، من خلال تمويل الصيانة هتقدر تستعين بأحسن عمال الصيانة في مصر، وتقسط بعدين بأقساط مريحة وسهلة.",
        },
      ],
      B: [
        {
          id: "16",
          url: "/products/manasik",
          color: "#27A9E1",
          img: "/services/manasik.svg",
          title: "مناسك",
        },
        {
          url: "/products/events",
          id: "8",
          color: colors.dark_green,
          img: "/services/ring.svg",
          title: "تمويل أفراح و مناسبات",
          description:
            "افرح وريح بالك، كونتكت حلتهالك وهتغطي تكاليف فرحك بأكبر قيمة تمويل وبتقسيط سهل ومريح",
        },
        {
          id: "9",
          url: "/products/mortgage",
          color: colors.dark_petroli,
          img: "/services/house.svg",
          title: "تمويل عقاري",
          description:
            'احصل على تمويل بيت أحلامك بأسهل وأسرع الإجراءات من خلال نظام "تمويل بيتك"',
        },
        {
          url: "/products-bussiness/factoring",
          id: "10",
          color: colors.dark_brown,
          img: "/services/discount.svg",
          title: "تخصيم",
          description:
            "لو محتاج سيولة نقدية، كونتكت هتدعمك وهتضمنلك تعزيز رأس المال الخاص بشركتك ",
        },
        {
          url: "/products-bussiness/leasing",
          id: "11",
          color: colors.light_petroli,
          img: "/services/rent.svg",
          title: "تأجير تمويلي",
          description:
            "لو عايز تجهز عيادتك الطبية أو تطور أسطول النقل الخاص بشركتك",
        },

        {
          id: "12",
          url: "/products/green-finance",
          color: colors.light_green,
          img: "/services/green-finance.svg",
          title: "التمويل الأخضر",
          description:
            "لو محتاج تُنمي استثمارك الزراعي، كونتكت بتقدملك التمويل اللازم اللي هيساعدك في تحقيق التنمية ",
        },
        {
          id: "13",
          url: "/products/home-furniture",
          color: "#5E7EB5",
          img: "/services/home-furniture.svg",
          title: "تمويل فرش البيت",
          description:
            "لو عايز تفرش وتجهز بيتك على مزاجك ومن أي مكان نفسك فيه، كونتكت هتسهلك المشوار",
        },
        {
          url: "/products/home-interior",
          id: "14",
          color: colors.dark_brown,
          img: "/services/design.svg",
          title: "تمويل التصميم و التشطيب",
          description:
            "لو عايز تصمم وتشطب بيتك على مزاجك من خلال أفضل شركات التصميم الداخلي والديكور في مصر، ",
        },
        {
          id: "15",
          url: "/products/watercraft",
          color: "#27A9E1",
          img: "/services/watercraft.svg",
          title: "تمويل مركبات ومعدات الرياضات المائية",
          description:
            "لو عايز تفرش وتجهز بيتك على مزاجك ومن أي مكان نفسك فيه، كونتكت هتسهلك المشوار",
        },
      ],
      All: [
        {
          url: "/products/auto",
          id: "1",
          color: colors.blue,
          img: "/services/car.svg",
          title: "تمويل السيارات",
          description:
            "لو عايز تشتري عربية جديدة أو مستعملة، كونتكت بتوفرلك حلول تمويلية متميزة لجميع الماركات ",
        },
        {
          id: "2",

          url: "/products/trucks",

          color: colors.dark_red,
          img: "/services/lorry.svg",
          title: "تمويل النقل",
          description:
            "سواء محتاج نقل تقيل أو خفيف كونتكت هتقسطلك جميع أنواع الشاحنات الجديدة والمستعملة والاستيراد",
        },
        {
          url: "/products/contact-now",
          id: "3",
          color: colors.dark_violet,
          img: "/services/cart.svg",
          title: "تسوق",
          description: "لو نفسك تشتري في أي وقت براحتك، كونتكت هتسهل حياتك",
        },
        {
          url: "/products/education",
          id: "4",

          color: colors.green,
          img: "/services/education.svg",
          title: "تمويل التعليم",
          description:
            "نفسك في مستقبل أفضل ليك ولأولادك، كونتكت هتساعدك وهتكون معاك طول مشوار التعليم",
        },
        {
          url: "/products/clubs",
          id: "5",

          color: colors.dark_petroli,
          img: "/services/clubs.svg",
          title: "تمويل اشتراكات الاندية",
          description:
            "نفسك تُنمى مهارات أولادك وتساعدهم يمارسوا الرياضة اللي بيحبوها، كونتكت هتقسطلك اشتراك ",
        },
        {
          id: "6",

          url: "/products/maintainance",
          color: "#DB8539",
          img: "/services/maintainance.svg",
          title: "تمويل الصيانة",
          description:
            "سواء كنت عايز تصّلّح عربيتك، تجدد بيتك، أو تعمل صيانة لأي حاجة، احنا عارفين إن الصيانة ممكن تكلّف كتير وتاخُد وقت. عشان كده كونتكت موجودة عشان تساعدك في كل احتياجات الصيانة بتاعتك. كونتكت بتقدملك حلول تمويل مبتكرة لأي صيانة، من خلال تمويل الصيانة هتقدر تستعين بأحسن عمال الصيانة في مصر، وتقسط بعدين بأقساط مريحة وسهلة.",
        },
        {
          id: "7",

          url: "/products/motorcycles",
          color: "#DD6F5A",
          img: "/services/motorcycle.svg",
          title: "تمويل الدراجات النارية",
        },
        {
          url: "/products/events",
          id: "8",

          color: colors.dark_green,
          img: "/services/ring.svg",
          title: "تمويل أفراح و مناسبات",
          description:
            "افرح وريح بالك، كونتكت حلتهالك وهتغطي تكاليف فرحك بأكبر قيمة تمويل وبتقسيط سهل ومريح",
        },
        {
          url: "/products/mortgage",
          id: "9",

          color: colors.dark_petroli,
          img: "/services/house.svg",
          title: "تمويل عقاري",
          description:
            'احصل على تمويل بيت أحلامك بأسهل وأسرع الإجراءات من خلال نظام "تمويل بيتك"',
        },
        {
          url: "/products-bussiness/factoring",
          id: "10",

          color: colors.dark_brown,
          img: "/services/discount.svg",
          title: "تخصيم",
          description:
            "لو محتاج سيولة نقدية، كونتكت هتدعمك وهتضمنلك تعزيز رأس المال الخاص بشركتك ",
        },
        {
          url: "/products-bussiness/leasing",
          id: "11",

          color: colors.light_petroli,
          img: "/services/rent.svg",
          title: "تأجير تمويلي",
          description:
            "لو عايز تجهز عيادتك الطبية أو تطور أسطول النقل الخاص بشركتك",
        },
        {
          url: "/products/green-finance",
          id: "12",

          color: colors.light_green,
          img: "/services/green-finance.svg",
          title: "التمويل الأخضر",
          description:
            "لو محتاج تُنمي استثمارك الزراعي، كونتكت بتقدملك التمويل اللازم اللي هيساعدك في تحقيق التنمية ",
        },
        {
          id: "13",

          url: "/products/home-furniture",
          color: "#5E7EB5",
          img: "/services/home-furniture.svg",
          title: "تمويل فرش البيت",
          description:
            "لو عايز تفرش وتجهز بيتك على مزاجك ومن أي مكان نفسك فيه، كونتكت هتسهلك المشوار",
        },
        {
          id: "14",
          url: "/products/home-interior",
          color: colors.dark_brown,
          img: "/services/design.svg",
          title: "تمويل التصميم و التشطيب",
          description:
            "لو عايز تصمم وتشطب بيتك على مزاجك من خلال أفضل شركات التصميم الداخلي والديكور في مصر، ",
        },
        {
          id: "15",

          url: "/products/watercraft",
          color: "#27A9E1",
          img: "/services/watercraft.svg",
          title: "تمويل مركبات ومعدات الرياضات المائية",
          description:
            "لو عايز تفرش وتجهز بيتك على مزاجك ومن أي مكان نفسك فيه، كونتكت هتسهلك المشوار",
        },
        {
          id: "16",
          url: "/products/manasik",
          color: "#27A9E1",
          img: "/services/manasik.svg",
          title: "مناسك",
        },
      ],
      C: [
        {
          url: "/referral-program",

          color: colors.blue,
          img: "/services/clients.svg",
          title: "برنامج ترشيح العملاء",
          description:
            "يمكنك ترشيح أصدقاءك والحصول على نقاط مجانية وخصومات حصرية",
          full_description:
            "الان من خلال الشراكة بين شركة كونتكت, شركة التمويل الأولى في مصر، و شركة كولدويل بانكر",
        },
        // {
        //   url: "/contact-homes",
        //   color: colors.blue,
        //   img: "/services/homes.svg",
        //   title: "كونتكت هومز",
        //   description:
        //     "الان من خلال الشراكة بين شركة كونتكت, شركة التمويل الأولى في مصر، و شركة كولدويل بانكر",
        //   full_description:
        //     "الان من خلال الشراكة بين شركة كونتكت, شركة التمويل الأولى في مصر، و شركة كولدويل بانكر",
        // },
        {
          url: "/rewards",
          color: colors.blue,
          img: "/services/loyalty.svg",
          title: "برنامج المكافآت",
          description:
            "يمكنك ترشيح أصدقاءك والحصول على نقاط مجانية وخصومات حصرية",
          full_description:
            "الان من خلال الشراكة بين شركة كونتكت, شركة التمويل الأولى في مصر، و شركة كولدويل بانكر",
        },
      ],
      D: [
        {
          url: "/referral-program",

          color: colors.blue,
          img: "/services/clients.svg",
          title: "برنامج ترشيح العملاء",
          description:
            "يمكنك ترشيح أصدقاءك والحصول على نقاط مجانية وخصومات حصرية",
          full_description:
            "الان من خلال الشراكة بين شركة كونتكت, شركة التمويل الأولى في مصر، و شركة كولدويل بانكر",
        },
      ],
    },
    news_title: "أخبارنا",
    news_button1: "اقرأ المزيد",
    news_button2: "المزيد",
    news: [
      {
        id: "1",
        img: "/news/news1.png",
        title: "كونتكت تطلق منتج رقمي لتأمين السيارات",
        description:
          "كونتكت المالية القابضة تعلن اليوم عن إطلاق منتج رقمي بالكامل للتأمين التكميلى للسيارات في مصر. يتوفر المنتج من خلال منصة كونتكت كارز دوت كوم وشركة ثروة للتأمين وشركة كونتكت ...",
      },
      {
        id: "2",
        img: "/news/news2.png",
        title:
          "«شطبلي» توقع اتفاقية شراكة مع «كونتكت» لإتاحة برامج تمويل مبتكرة",
        description:
          "وقّعت شركة «شطبلي»، صاحبة أول منصة إلكترونية متخصصة في أعمال تصميم وتنفيذ أعمال الديكورات والتشطيبات، اتفاقية شراكة مع شركة كونتكت للتمويل ...",
      },
      {
        id: "3",
        img: "/news/news3.png",
        title: "كونتكت توقع برنامج تمويل فريد من نوعه في مصر مع كابيتر",
        description:
          "وقعت كونتكت المالية القابضة (CNFN)، الشركة الرائدة في مجال الخدمات المالية غير مصرفية في مصر، من خلال شركة كونتكت للتخصيم، أحد ...",
      },
    ],
  },

  products_shopiing_page: {
    cover: {
      title1: "تمويل استهلاكي",
      title2: "بنسهّل حياتك",
      description: `لو نفسك تشتري في أي وقت براحتك، كونتكت هتسهل حياتك من خلال حلول
      تمويلية خالية من المتاعب وبأسهل وأسرع موافقة وأوسع شبكة تجار تغطي جميع
      المنتجات والخدمات ومنتشرة في جميع أنحاء الجمهورية.`,
    },
    outro:
      "كونتكت مش بس شركة تمويل، احنا شريكك اللي بيساعدك في تحقيق متطلباتك. بنساعدك تمتلك اللي بتحلم بيه من غير أي تعقيدات. اتصل بينا النهاردة، افتح حسابك، واستمتع بأسهل تجربة تسوق!",
    section_a: {
      title1: "فترة سداد",
      title2: "36 شهر",
      body: `إشتري كل إحتياجاتك بدون عمليات معقدة فقط برقم البطاقة و برقم موبايلك, من خلال نظام كنتكت الإلكتروني للتس الشراء و التقسيط من أكثر من 1000 منفذ بيع في جميع محافاظات الجمهورية. نظام التقسيط من كونتكت تسوق هو أفضل و أسرع طريقة لتمويل جميع مشترياتك من خلال شبكة ضخمة من المنافذ التجارية و معارض التجزئة و المتاجر الكبري و توكيلات الماركات العالمية. والذي يتيح لك حرية تحديد مبلغ الدفعة المقدمة و يقدم أنظمة التقسيط بفترات سداد تتراوح من 6 أشهر إلي 36 شهر.`,
    },
    section_b: {
      title: "ازاي تشتري وتقسط مع كونتكت؟",
      description: "لما يكون عندك حساب مفتوح مع كونتكت:",
      list: [
        "إختار التاجر من خلال شبكتنا",
        "توجه إلى المتجر مع بطاقة الرقم القومي والموبايل المسجل في الخدمة",
        "حدد مبلغ القسط وفترة السداد ",
        "هيوصلك رمز العملية من خلال رسالة نصية على موبايلك لتقديمها للتاجر",
        "هيوصلك فاتورة إلكترونية من خلال رسالة نصية على موبايلك",
      ],
    },
  },
  products_contact_now_page: {
    cover: {
      title1: `اشترى اللي نفسك فيه`,
      title2: "",
      description: `عايز تشتري لاب توب جديد، موبايل جديد، تليفزيون جديد، أو أي منتج استهلاكي؟ إحنا عندنا الحل المثالي ليك، مع كونتكت، تقدر تشتري كل اللي نفسك فيه النهاردة، وتدفع بعدين على أقساط مرنة وبأسرع موافقة من خلال أوسع شبكة تجار بتغطي كل المنتجات والخدمات في كل أنحاء مصر.`,
    },
    section_a: {
      title1: "فترة سداد",
      title2: "36 شهر",
      body: `إشتري كل إحتياجاتك بدون عمليات معقدة فقط برقم البطاقة و برقم موبايلك, من خلال نظام كنتكت الإلكتروني للتس الشراء و التقسيط من أكثر من 1000 منفذ بيع في جميع محافاظات الجمهورية. نظام التقسيط من كونتكت تسوق هو أفضل و أسرع طريقة لتمويل جميع مشترياتك من خلال شبكة ضخمة من المنافذ التجارية و معارض التجزئة و المتاجر الكبري و توكيلات الماركات العالمية. والذي يتيح لك حرية تحديد مبلغ الدفعة المقدمة و يقدم أنظمة التقسيط بفترات سداد تتراوح من 6 أشهر إلي 36 شهر.`,
    },
    section_b: [
      "إختار التاجر من خلال شبكتنا",
      "توجه إلى المتجر مع بطاقة الرقم القومي والموبايل المسجل في الخدمة",
      "حدد مبلغ القسط وفترة السداد التي تتراوح ما بين 6 إلى 60 شهر",
      "هيوصلك رمز العملية من خلال رسالة نصية على موبايلك لتقديمها للتاجر",
      "هيوصلك فاتورة إلكترونية من خلال رسالة نصية على موبايلك",
    ],
  },

  // our_platforms: "منصاتنا الرقمية",
  about: {
    members: {
      directors: "مجلس الادارة",
      mangers: "الادارة التنفيذية",
      title: "مجلس الإدارة ",
      subtitle:
        "نحن نبحث دائمًا عن الأفراد المتحمسين والديناميكيين والموهوبين.",
    },
    aboutTitle: "نبذه عن",
    aboutText:
      "كونتكت المالية القابضة هي شركة رائدة تتميز بتقديم باقة متنوعة من الحلول والخدمات التمويلية تشمل تمويل السيارات والتمويل الاستهلاكي والتمويل العقاري والتأمين وغيرها من الخدمات لقاعدة عريضة من العملاء، فضلاً عن أنها اللاعب الرئيسي في أسواق أدوات الدين الناشئة في مصر، حيث تقوم بهيكلة وتنظيم وتغطية الاكتتاب في عمليات إصدار الدين للشركات الراغبة في تمويل خطط النمو وإدارة المخاطر وتحسين أوضاعها المالية وزيادة مستويات السيولة.",

    aboutCard: {
      heading1: "خبراتنا",
      text1:
        "نسعى دائما إلى توظيف خبرتنا الواسعة بمجال إدارة الاستثمارات المالية وتوفير التمويل في استحداث حلول مالية متطورة تناسب احتياجات عملائنا؛ كما نعمل على تطويع الفرص المتاحة في القطاعات المالية الواعدة مما يساهم في زيادة معدلات الإدماج المالي في السوق.وتتباين الحلول التمويلية المقدمة لتشمل نطاقا عريضًا من الخدمات والمنتجات لعملائنا من الأفراد والشركات سواء قدمت تحت إحدى العلامات التجارية الخاصة بكونتكت المالية القابضة أو ضمن برامج العلامات المتخصصة التي نقدم من خلالها مجموعة من المنتجات والحلول التمويلية التي صممت خصيصا لتتناسب مع احتياجات كبرى الشركات من شركاء الأعمال.",
      heading2: "فريق العمل",
      text2:
        "ويمثل حجر الأساس في نجاح كونتكت المالية القابضة فريق العمل الذي يضم أكثر من 2,500 محترف من أبرز الكوادر في الصناعة. وإيمانًا من الشركة بالدور الذي يلعبه فريق العمل في الحفاظ على ريادة الشركة وتميزها، فإنها تحرص دائمًا على الاستثمار في موظفيها ولا تدخر جهدًا في دعمهم حيث إنها تثق أن نجاح الشركة لا يولد إلا بنجاح موظفيها.",
      heading3: "الحلول التمويلية",
      text3:
        "وتنفرد شركة كونتكت بتبني نموذج أعمال تكاملي محوره الاندماج والتكامل بين شركاء العمل وجميع الأطراف ذات العلاقة من أجل استحداث وتقديم باقة متميزة من الخدمات والمنتجات فائقة الجودة والتي تخاطب احتياجات السوق وتلبي تطلعات العملاء بتوفير حلول التمويل المتميزة بالكفاءة والبساطة والسهولة المتناهية. وتقوم شركة كونتكت بتقديم خدماتها المتنوعة من خلال أكثر من 75 فرع رئيسي يغطي أنحاء الجمهورية، إلى جانب تواجدها من خلال شبكة نقاط البيع التي تغطي أكثر من 10,000 مركز خدمة بمعارض السيارات وشركات التطوير العقاري وتجار السلع الاستهلاكية المعمرة والنوادى الرياضية.",
    },
    title: "أكد على ما هو مهم لشركتك",
    text: "نسعى دائما إلى توظيف خبرتنا الواسعة بمجال إدارة الاستثمارات المالية وتوفير التمويل في استحداث حلول مالية متطورة تناسب احتياجات عملائنا",
    card: {
      vision_mission: [
        {
          id: "1",
          title: "رؤيتنا",
          text: [
            "نسعى أن نكون الاختيار الأول في تقديم الخدمات المالية لعملائنا مستخدمين أحدث التقنيات التكنولوجية للتأكد من تمكين العملاء من الاستفادة من حلولنا المبتكرة وتعظيم إمكاناتهم المالية. كما نسعى جاهدين للتميز في كل ما نقوم به ونلتزم بتقديم تجربة عملاء متميزة.",
          ],
          img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/eye.png",
        },
        {
          id: "2",
          title: "هدفنا",
          text: [
            "نقوم بتقديم خدمات تمويلية رقمية مبتكرة تتمركز حول متطلبات العميل واحتياجاته، من خلال علاقتنا القوية والتزامنا تجاه عملائنا. حيث يقوم خبرائنا بتقديم تجربة فريدة عن طريق نافذة تمويلية متكاملة باستخدام أحدث التقنيات المتطورة وتقديم خدمة عملاء استثنائية. كما تتعدد برامجنا التمويلية لتشمل خدمة الأفراد والشركات بهدف تحقيق جميع أهدافهم المالية.",
          ],
          img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/mission.png",
        },
        {
          id: "3",
          title: "قيمنا",
          text: [
            "رضاء العملاء:علاقتنـا طويلـة الأمـد مـع عملائنـا تكمـن فـي قيمنـا الأساسـية. ونهجنا يضمـن تجربـة عمـلاء متميزة وسلسـة.",
            "النزاهة:نتصـرف بنزاهـة وصـدق لا تهـاون فيهمـا كأفـراد وفـرق وشـركات. كمـا نسـعى جاهديـن لكسـب مصداقيـة دائمـة مـع الأخريـن، والتـي نعتقـد أنهـا ضروريـة للأفـراد وعلاقـات العمـل علـى المـدى الطويـل.",
            "الانتماء:معـدل دوران العمالـة المنخفـض يعـود بشـكل كبيـر الـي شـعور افـراد المجموعـة بالانتماء الـى فريـق عمـل يقـدر القيـم الإنسـانية بيـن الأفراد. إلــى جانــب الدعــم المهنــي المتواصــل، فإننــا نبــذل قصــارى جهدنــا لمسـاعدة ودعـم بعضنـا البعـض علـي المسـتوى الشـخصي و المهني، كمـا أن شـعورنا بالانتماء الـي المجموعـة ينعكـس بـدوره علـي ترسـيخ الــولاء لــدي عملائنا. ",
            "تمكين الأحلام:نلهــم موظفينــا و عملائنا ليحلمــوا ويســعوا لتحقيــق أحلامهــم، و ندعمهــم لتطوير أنفسهم ليتمكنــوا مــن تغييــر العالــم.",
            "المسئولية:نــرى أن الــكل مســؤول عــن مصلحتــه ومصلحــة غيــره وكذلــك عــن المــوارد التــي تخــص الجميــع.",
          ],
          img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/value.png",
        },
      ],
    },
    statistic: [
      { id: "1", sufTheous: " ألف", text: "عميل", count: 150 },
      { id: "2", sufTheous: " ألف", text: "عملية", count: 360 },
      { id: "3", sufTheous: "", text: "موظف", count: 2500 },
    ],
  },
  sustainability: {
    sustainabilityTitle: "الاستدامة في",
    sustainabilityText:
      "تعد الاستدامة عنصراً هاماً في مواجهة التحديات البيئية والاجتماعية تعمل كونتكت على تعبئة الموارد المالية وتخصيصها لمبادرات التنمية المستدامة وحماية البيئة وتنمية الموارد الطبيعية بالإضافة إلى العدالة الاجتماعية والاقتصادية.  توفر كونتكت التمويل ورأس المال اللازم لمختلف المشاريع والمبادرات البيئية والحماية المجتمعية مثل مبادرات حماية محدودي الدخل وتمكين المرأة وذوى الهمم. وتأتي الحاجة إلى تمويل الاستدامة من خلال المسئولية المجتمعية للشركة حيث أن النظم المالية التقليدية غالبا ما تعطي الأولوية للمكاسب القصيرة الأجل على حساب مشاريع الاستدامة الطويلة الأجل. ونتيجة لذلك، كان هناك تركيز متزايد لدى كونتكت على دمج اعتبارات الاستدامة في عمليات صنع القرار المالي وتيسير التمويل الاخضر لدعم مشروعات الطاقة النظيفة، حماية البيئة، الحفاظ على الموارد والحرص الدائم على إتباع ومواكبة السياسات الحكومية التي تحفز الاستثمارات في هذا المجال.",
    sustainabilityList: [
      "بروتوكول تعاون لتقديم الدعم المادي والمعنوي لمحاربات مرض سرطان الثدي.",
      "احتفلت مجموعة شركات كونتكت بيوم الطفل وذلك بزيارة فرعين من دور رعاية الطفل التابعين لمؤسسة الأورمان.",
      "كونتكت تكرم طلاب الثانوية العامة.",
      "الاحتفال بيوم المرأة العالمي وتكريم السيدات الرائدات في إطار جهود الشركة لتمكين المرأة.",
      "تجهيز وإعداد كراتين رمضان مع مؤسسة مصر الخير ضمن فاعلية إفطار صائم.",
    ],
  },
  investments: {
    investmentsTitle1: "كونتكت كل",
    investmentsTitle2: "يوم للاستثمار والادخار",
    investmentsText: `استثمر بحرية
بتحلم باستثمار لمدخراتك بأسهل وأضمن الطرق، صندوق كونتكت كل يوم للاستثمار والادخار بيقدملك عائد يومي تراكمي باستحقاق قصير وعائد متميز وتنافسي.
`,
    investmentsList_title: "المميزات",
    investmentsList: [
      {
        pointTitle: "عوائد يومية: ",
        pointDetails: " فلوسك بتكتر من خلال فوائد يومية",
      },
      {
        pointTitle: "استثمار مريح: ",
        pointDetails:
          " ممكن تفتح حساب ببطاقة الرقم القومي ومَش شرط يكون عندك حساب في البنك!",
      },
      { pointTitle: "بدون مصاريف: ", pointDetails: "  مفيش أي مصاريف إضافية" },
      {
        pointTitle: "مرونة من غير حدود: ",
        pointDetails: " أودع واسحب فلوسك في أي وقت بدون قيود",
      },
      {
        pointTitle: "سرعة وسهولة: ",
        pointDetails: "  تقدر تدير استثماراتك بسهولة",
      },
      {
        pointTitle: "دعم الخبراء: ",
        pointDetails:
          " فريقنا المتخصص دايماً مستعد يساعدك في أي استفسار عن طريق رقم خدمة العملاء 16177 و 75 فرع في كل انحاء مصر",
      },
    ],
    //
  },
  calc: {
    monthlyAmount: " قيمة القسط الشهري",
    priceCar: "قيمة التمويل",
    preAmount: "المقدم",
    plan: "الخطة",
    plan: "الخطة",
    egyptianPound: "جنية مصري",
    duration: "المدة",
    month6: "6 شهور",
    year1: "1 سنة",
    year2: "2 سنة",
    year3: "3 سنة",
    year4: "4 سنة",
    year5: "5 سنة",
    year6: "6 سنة",
    year7: "7 سنة",
    year8: "8 سنة",
    year9: "9 سنة",
    year10: "10 سنة",
    plan1: "البرنامج الإقتصادي",
    plan2: "البرنامج المرن",
  },
  products_events: {
    cover: {
      img: "/pages/event-cover-ar.png",
      color: "#547865",
      title1: "تمويل أفراح ومناسبات",
      title2: "هنكمل فرحتك",
      description: `خطط لفرحتك واحنا نموّلها! - سواء كان فرح، كتب كتاب، تخرج، أو عيد ميلاد، خلينا نساعدك تخلّي المناسبة دي ذكرى حلوة من غير ما تقلق على المصاريف. كونتكت بتقدملك حلول تمويل مريحة وبسيطة لأكتر من نوع من المناسبات. سواء كنت عايز فرح كبير ولا حفلة تخرج صغيرة، كونتكت تقدر تسـاعدك تموّلها بإجراءات سريعة وسهلة.  `,
    },
  },
  products_manasik: {
    cover: {
      img: "/pages/manasik-cover.png",
      color: "#547865",
      title1: "مناسك: بوابتك لأداء الحج والعمرة",
      title2: "حقق حلمك وابدأ رحلتك الروحانية إلي بيت الله الحرام بكل سهولة",
      description: `دلوقتي حلمك بأداء مناسك الحج والعمرة أقرب مما تتخيل مع برنامج مناسك من كونتكت. عارفين أهمية الفريضة وعارفين أهمية الرحلة دي ليك ولحياتك, وكمان التحديات المالية اللي ممكن تواجهها. علشان كدا, خصصنا برنامج لتمويل وتقسيط الحج والعمرة علشان تخلي تجربتك أسهل.`,
    },
    section_2: {
      img: "/manasik_section_2.png",
      description:
        "مع مناسك بنقدملك حلول تمويلية متوافقة مع الشريعة الإسلامية ومصممة خصيصاُ علشان تدعم كل اللي بيخططوا للسفر لإداء الحج والعمرة. برامجنا تتيح لك خطط سداد مرنة علشان تقدر تركز علي أداء الفريضة بأمان وراحة, سواء كنت بتجهز لأول رحلة أو بتخطط للزيارة مرة تانية.",
    },
    section_3: {
      title: "مميزات برنامج مناسك من كونتكت",
      img: "/manasik_section_3.png",
      list: [
        "متوافق مع أحكام الشريعة الإسلامية",
        "خطط سداد مرنة:سدد تكاليف الرحلة بالتقسيط علي دفعات مريحة.",
        "سرعة الموافقة:ابدأ التخطيط دلوقتي لأن الإجراءات بسيطة.",
        "دعم مستمر:فريقنا جاهز لدعمك في كل خطوة من رحلتك.",
      ],
    },
    section_4: {
      description:
        "دلوقتي مفيش حاجة تمنعك من تحقيق حلمك بزيارة بيت الله الحرام. مع كونتكت, الحج والعمرة أقرب وأسهل من أي وقت فات. ابدأ رحلتك النهاردة مع مناسك من كونتكت",
    },
  },
  // products_finishing: {
  //   cover: {
  //     img: "/pages/finishing-cover.png",
  //     color: "#977859",
  //     title1: "تمويل التصميم والتشطيب",
  //     title2: "بيتك على ذوقك",
  //     description: `لو عايز تصمم وتشطب بيتك على مزاجك ويكون شيك وبيعكس شخصيتك وراحتك وتنفذه من خلال أفضل شركات التصميم الداخلي والديكور في مصر، كونتكت بتقدملك انسب حل ليك، مع تمويل تصميم وتشطيب بيتك من كونتكت اللي هيوفرلك أعلى قيمه تمويل وبفترات سداد مناسبة. سواء كنت بتشطب بيت جديد أو بتجدد بيتك القديم، هتقدر تنفذه بكل سهولة وسرعة ومن غير تفكير في التكاليف.`,
  //   },
  //   section_a: {
  //     title: "4 مليون جنية",
  //     body: `برامج تمويل النقل تصل بحد أقصي إلي 2 مليون جنية مصري لسيارات النقل الجديدة, بفترات سداد تصل إلي 5 سنوات بمقدم يبدأ من 20% بأسهل الإجراءات كونتكت توفر لك أسرع و أبسط نظام لتمويل و تقسيط معاملاتك الشرائية, فقط من خلال بطاقة الرقم القومي الخاصة بك تستطيع شراء منتجات التشطيب التي تحتاجها مثل الحوائط و الأرضيات, أبوب و شبابيك, دهانات  و ديكور, مستلزمات كهربائية, الأدوات الصحية و غيرها, من خلال شبكة سريعة النمو من المنافذ التجارية و معارض التجزئة و المتاجر الكبري, كما يتوفر لك حرية إختيار الدفعة المقدمة و القسط الشهري المناسب مع فترات تقيسط تتراوح من 6 إلي 60 شهراً.`,
  //   },
  //   section_b: {
  //     img: "/pages/without-advance.png",
  //     title: "بدون مقدم",
  //     body: `كونتكت توفر لك أسرع و أبسط نظام لتمويل و تقسيط معاملاتك الشرائية من خلال شبكة  سريعة النمو من المنافذ التجارية و معارض التجزئة و المتاجر الكبري. كما يتوفر لك حرية إختيار الدفعة المقدمة و القسط الشهري المناسب مع فترة تفسيط تتراوح بين 6 إلي 60 شهرا حد ائتماني يصل إلي 750,000 جنية بدون مقدم أو مصاريف إضافية. لا يتطلب ملكية الوحدة أو الرهن العقاري أسرع و أسهل إجراءات للإصدار`,
  //   },
  // },

  products_finishing: {
    cover: {
      img: "/pages/finishing-cover.png",
      color: "#95664B",
      title1: "تمويل التصميم والتشطيب",
      title2: "بيتك على ذوقك",
      description: `لو عايز تصمم وتشطب بيتك على مزاجك ويكون شيك وبيعكس شخصيتك وراحتك وتنفذه من خلال أفضل شركات التصميم الداخلي والديكور في مصر، كونتكت بتقدملك انسب حل ليك، مع تمويل تصميم وتشطيب بيتك من كونتكت اللي هيوفرلك أعلى قيمه تمويل وبفترات سداد مناسبة. سواء كنت بتشطب بيت جديد أو بتجدد بيتك القديم، هتقدر تنفذه بكل سهولة وسرعة ومن غير تفكير في التكاليف.`,
    },
    outro:
      "تمويل ديكورات وتشطيبات بيتك ده مشروع هدفنا فيه واحد وهو تحقيق أحلامك. أنت تختار شركة التصميم والتشطيب اللي تعجبك، وكونتكت هتموّل التكاليف. حلم تشطيب أو تجديد بيتك تقدر تحوله لحقيقة مع كونتكت. افتح حسابك مع كونتكت، واستعد للاستمتاع ببيتك الجديد باسلوب حياة مختلف.",
    section_a: {
      title: "4 مليون جنية",
      body: `برامج تمويل النقل تصل بحد أقصي إلي 2 مليون جنية مصري لسيارات النقل الجديدة, بفترات سداد تصل إلي 5 سنوات بمقدم يبدأ من 20% بأسهل الإجراءات كونتكت توفر لك أسرع و أبسط نظام لتمويل و تقسيط معاملاتك الشرائية, فقط من خلال بطاقة الرقم القومي الخاصة بك تستطيع شراء منتجات التشطيب التي تحتاجها مثل الحوائط و الأرضيات, أبوب و شبابيك, دهانات  و ديكور, مستلزمات كهربائية, الأدوات الصحية و غيرها, من خلال شبكة سريعة النمو من المنافذ التجارية و معارض التجزئة و المتاجر الكبري, كما يتوفر لك حرية إختيار الدفعة المقدمة و القسط الشهري المناسب مع فترات تقيسط تتراوح من 6 إلي 60 شهراً.`,
    },
    section_b: {
      img: "/pages/without-advance.png",
      title: "بدون مقدم",
      body: `كونتكت توفر لك أسرع و أبسط نظام لتمويل و تقسيط معاملاتك الشرائية من خلال شبكة  سريعة النمو من المنافذ التجارية و معارض التجزئة و المتاجر الكبري. كما يتوفر لك حرية إختيار الدفعة المقدمة و القسط الشهري المناسب مع فترة تفسيط تتراوح بين 6 إلي 60 شهرا حد ائتماني يصل إلي 750,000 جنية بدون مقدم أو مصاريف إضافية. لا يتطلب ملكية الوحدة أو الرهن العقاري أسرع و أسهل إجراءات للإصدار`,
    },
  },
  products_home_furniture: {
    cover: {
      img: "/pages/home-furniture.png",
      color: "#5E7EB5",
      title1: "تمويل فرش البيت",
      title2: "جدد شكل بيتك",
      description: `تخيل بيتك مليان بفرش وأثاث جديد وشيك يخليك تستمتع بالأناقة والراحة، وتختاره من أي مكان نفسك فيه. مع تمويل فرش البيت من كونتكت، الحلم ده هيقرب كتير وهتقدر تختار كل الفرش والديكور اللي بيتك محتاجه من خلال أكبر محلات الاثاث والديكور اللي بتناسب كل الأذواق.`,
    },
    outro:
      "لو عايز تشتري أثاث أو فرش لبيتك من أي مكان في مصر، كونتكت بتقدملك مجموعة متنوعة من خدمات وبرامج التمويل اللي تقدر تساعدك تحقق كل اللي تتمناه. مع خدمة تمويل الأثاث المنزلي من كونتكت، هتقدر تجدد بيتك بأسلوب جديد بسهولة وراحة من غير ما تقلق على الميزانية.",
  },
  products_events: {
    cover: {
      img: "/pages/event-cover-ar.png",
      color: "#547865",
      title1: "تمويل أفراح ومناسبات",
      title2: "هنكمل فرحتك",
      description: `خطط لفرحتك واحنا نموّلها! - سواء كان فرح، كتب كتاب، تخرج، أو عيد ميلاد، خلينا نساعدك تخلّي المناسبة دي ذكرى حلوة من غير ما تقلق على المصاريف. كونتكت بتقدملك حلول تمويل مريحة وبسيطة لأكتر من نوع من المناسبات. سواء كنت عايز فرح كبير ولا حفلة تخرج صغيرة، كونتكت تقدر تسـاعدك تموّلها بإجراءات سريعة وسهلة.  `,
    },
    outro:
      "كونتكت هي بوابتك للفرح. متخَلّيش المصاريف تقلل من احتفالك بأهم لحظات حياتك. قدّم النهاردة واستمتع بمناسبة حلوة مع كونتكت.",
  },
  products_factoring: {
    cover: {
      img: "/pages/factoring-cover.png",
      color: "#BF6340",
      title1: "التخصيم",
      title2: "سيولة بسهولة",
      description: `عايز توفر فلوس وسيولة لاحتياجاتك واحتياجات مشروعك؟ اتـعـرّف على خدمة التخصيم من كونتكت، الحل اللي بيـسـمـحلك تستبدل فواتير مبيعاتك وتاخد فلوسها فـوراً بدون انتظار.التخصيم طريقة سهلة ومريحة توفرلك فلوس تـشـغـل بيها مشروعك من غير ما تاخد قرض ولا تقلل من ملكيتك. تقدر تستعمل الفلوس دي تدفع لمورديك، وتصرف على مـرتـبـات الموظفين، تدفع ضرايب، أو تستثمر في مشاريع جديدة. `,
    },
    outro:
      'كونتكت هي شركة رائدة في مجال "التخصيم" بمصر، بخبره طويلة في دعم الشركات من كل المجالات. سواء كنت مشروع صغير أو متوسط، شركة كبيرة، أو شركة متعددة الجنسيات، كونتكت تقدر تقدم حلول مميزة ومرنة تناسب احتياجاتك وأهدافك. لو عايز تعرف أكتر عن إزاي كونتكت تقدر تساعدك تكبر مشروعك من خلال "التخصيـــم"، اتصل بينا دلوقتي.',
  },
  investment: {
    cover: {
      img: "/investement.png",
      color: "#5686A3",
      title1: "كونتكت كل يوم للاستثمار والادخار",
      title2: "شريك استثمارك اليومي ",
      description: `كونتكت "كل يوم" طريقة بسيطة وآمنة ومليانة بالمكاسب تقدر من خلالها تكتر فلوسك كل يوم. باستثمار سهل وفرصه لكل الناس عشان تحقق طموحاتها المالية. استفيد من محفظة متنوعة من الأصول ، وتضمنلك عوائد مستقرة مع الحفاظ على رأس مالك.`,
    },
    outro: `كونتكت "كل يوم" أكتر من مجرد استثمار، هو التزام لتأمين مستقبلك المالي، انضم لينا وابدأ رحلتك الاستثمارية مع العوائد اليومية.
    `,
    subOutro: `استثمر في بكرة مع كونتكت "كل يوم"!`,
  },
  products_clubs: {
    cover: {
      img: "/pages/clubs-cover.png",
      color: "#5686A3",
      title1: "تمويل اشتراكات الأندية",
      title2: "جدد نشاطك وشجع ولادك",
      description: `اشترك في النادي اللي بتحلم بيه مع كونتكت! عايز تنشط حياتك، تطور مواهب أولادك، وتساعدهم يمارسوا رياضتهم ويستمتعوا بأوقاتهم وسط أصحابهم ؟ مع كونتكت، شركة التمويل الرائدة في مصر، تقدر تموّل اشتراك النادي اللي تتمناه بأسهل إجراءات، وأسرع وقت وبفترات سداد مناسبة. سواء كنت عايز تشترك في نادي رياضي، نادي اجتماعي، أو نادي ثقافي، كونتكت دايما معاك.`,
    },
    outro:
      "تمويل اشتراك النادي مع كونتكت استثمار في مستقبلك وسعادة عيلتك. ماتفوتش الفرصة! قدم دلوقتي واحصل على الموافقة في دقايق. اتصل بينا النهاردة وخلينا نساعدك تحقق أحلامك.",
    clubs_title: "الاندية المشتركة",
    clubs: [
      ["نادي وادي دجلة", "/pages/club1.png"],
      ["نادي ماتركس", "/pages/club2.png"],
      ["نادي الزهور", "/pages/club3.png"],
      ["نادي جزيرة الورد الرياضي", "/pages/club4.png"],
      ["نادي الحوار", "/pages/club5.png"],
      ["نادي بلاتينم قطامية", "/pages/club6.png"],
    ],
  },
  products_maintainance: {
    cover: {
      img: "/pages/maintainance-cover.png",
      color: "#DB8539",
      title1: "تمويل الصيانة",
      title2: "معاك في كل تفصيله",
      description: `سواء كنت عايز تصّلّح عربيتك، تجدد بيتك، أو تعمل صيانة لأي حاجة، احنا عارفين إن الصيانة ممكن تكلّف كتير وتاخُد وقت. عشان كده كونتكت موجودة عشان تساعدك في كل احتياجات الصيانة بتاعتك. كونتكت بتقدملك حلول تمويل مبتكرة لأي صيانة، من خلال تمويل الصيانة هتقدر تستعين بأحسن عمال الصيانة في مصر، وتقسط بعدين بأقساط مريحة وسهلة.`,
    },
    outro:
      "لو بتدور على طريقة مضمونة ومريحة تموّل بيها الصيانة بتاعتك، اختار كونتكت. افتح حسابك النهاردة مع كونتكت واستمتع بمزايا وبرامج حصرية.",
  },
  products_trucks: {
    cover: {
      img: "/pages/trucks-cover.png",
      color: "#AA4445",
      title1: "تمويل النقل",
      title2: "سنَدك ومعاك طول الطريق",
      description: `عندنا في كونتكت خطط تمويل لكل أنواع سيارات النقل الثقيل والشاحنات، من الصغيرة للكبيرة، ومن النص نقل للمقطورة. إجراءاتنا سهلة وبسيطة، وبنقدم خطط سداد مرنة تتناسب مع احتياجاتك. نقدر نساعدك في شراء الشاحنات اللي محتاجها، سواء كنت صاحب مشروع صغير أو شركة كبيرة. عندنا حلول التمويل المناسبة ليك، بغض النظر عن حجم اعمالك أو استثماراتك.`,
    },
    outro:
      "لو شغال في مجال البناء أو التصنيع أوالشحن والخدمات اللوجستية في مصر، وبتنقل بضائع تقيلة، كونتكت بتقدملك تمويل لكل معداتك وشاحناتك، كلمنا دلوقتي عشان نساعدك من خلال خطط تمويل مختلفة لكل أنواع العربيات النقل الجديدة والمستعملة والمستوردة، بإجراءات سهلة ومرنة.",
    plans_title: "خطط التقسيط",
    plans: [
      {
        name: "النقل الجديد – النظام العادي",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 4 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهر ونصف",
        ],
      },
      {
        name: "النقل الجديد – النظام المرن",
        role: [
          "مقدم يبدأ من 20%",
          "فترات سداد تصل إلى 5 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهرين ونصف",
        ],
      },
      {
        name: "النقل الاستيراد  – النظام العادي",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 4 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهر ونصف",
        ],
      },
      {
        name: "النقل الاستيراد  – النظام الاقتصادي",
        role: [
          "مقدم يبدأ من 50%",
          "فترات سداد تصل إلى 4 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهر ونصف",
        ],
      },
      {
        name: "النقل الاستيراد – النظام الاقتصادي بلس",
        role: [
          "مقدم يبدأ من 50%",
          "فترات سداد تصل إلى 5 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهرين ونصف",
        ],
      },
      {
        name: "النقل الاستيراد – النظام المرن",
        role: [
          "مقدم يبدأ من 20%",
          "فترات سداد تصل إلى 5 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهرين ونصف",
        ],
      },
      {
        name: "النقل المستعمل – النظام الاقتصادي",
        role: [
          "مقدم يبدأ من 50%",
          "فترات سداد تصل إلى 4 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهر ونصف",
        ],
      },
      {
        name: "النقل المستعمل – النظام الاقتصادي بلس",
        role: [
          "مقدم يبدأ من 50%",
          "فترات سداد تصل إلى 5 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهرين ونصف",
        ],
      },
    ],
    business_plans_title:
      "خطط التقسيط لأصحاب المهن و الأنشطة التجارية (سجل تجاري و بطاقة ضريبية)",

    business_plans: [
      {
        name: "النقل الجديد – النظام العادي",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 4 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهر ونصف",
        ],
      },
      {
        name: "النقل الجديد – النظام المرن",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 5 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهرين ونصف",
        ],
      },
      {
        name: "النقل الاستيراد  – النظام العادي",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 4 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهر ونصف",
        ],
      },
      {
        name: "النقل الاستيراد  – النظام الاقتصادي",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 4 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهر ونصف",
        ],
      },
      {
        name: "النقل الاستيراد – النظام الاقتصادي بلس",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 5 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهرين ونصف",
        ],
      },
      {
        name: "النقل الاستيراد – النظام المرن",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 5 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهرين ونصف",
        ],
      },
      {
        name: "النقل المستعمل – النظام الاقتصادي",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 4 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهر ونصف",
        ],
      },
      {
        name: "النقل المستعمل – النظام الاقتصادي بلس",
        role: [
          "مقدم يبدأ من 30%",
          "فترات سداد تصل إلى 5 سنوات",
          "إمكانية السداد المبكر",
          "التأمين اختياري",
          "أول قسط بعد شهرين ونصف",
        ],
      },
    ],
  },
  products_cars: {
    cover: {
      img: "/pages/cars-cover.png",
      color: "#282780",
      title1: "تمويل السيارات",
      title2: "فرحة عربيتك الجديدة مستنياك",
      description: `عايز تشتري عربية جديدة أو مستعملة في مصر؟ كونتكت بتقدملك حلول تمويل سيارات متخصصة لاحتياجاتك، سواء كنت عايز عربية كهربائية أو بنزين. إجراءاتنا مرنة وبنقدم مجموعة واسعة من خطط التقسيط لكل الماركات والموديلات. كونتكت هي الاختيار الأول لتمويل السيارات في مصر، لأنها موجودة في كل مكان في مصر في غالبية صالات عرض السيارات. الشركة بتقدم حلول مالية خاصة لكل من السيارات الجديدة والمستعملة، بما في ذلك مجموعة واسعة من خطط التقسيط وإجراءات تمويل مرنة.`,
    },
    outro:
      "عايز تمتلك عربية أحلامك بسهولة؟ حلول تمويل السيارات عندنا صممت عشان تساعدك. إحنا عارفين إن شراء عربية ممكن يكون استثمار كبير، عشان كده بنقدملك حلول دفع وتمويل مرنة تتناسب مع ميزانيتك. سواء كنت عايز عربية جديدة أو مستعملة، عندنا الحل التمويلي المناسب ليك.",
    plans_title: "خطط التقسيط",
    plans: [
      {
        name: "السيارات الكهربائية",
        role: [
          "مقدم يبدأ من 20 ٪",
          "التأمين اختياري",
          "فترات سداد تصل الي 5 سنوات",
          "إمكانية السداد المبكر الكلي أو الجزئي",
        ],
      },
      {
        name: "نيو بلس",
        role: [
          "مقدم يبدأ من 20%",
          "التأمين إجباري",
          "فترات سداد تصل إلى 5 سنوات",
          "أول قسط بعد 3 أشهر",
        ],
      },
      {
        name: "الإقتصادي",
        role: [
          "مقدم يبدأ من 20 ٪",
          "التأمين إجباري",
          "فترات سداد تصل الي 3 سنوات",
        ],
      },
      {
        name: "الإقتصادي بلس",
        role: [
          "مقدم يبدأ من 20 ٪",
          "التأمين إجباري",
          "فترات سداد تصل الي 5 سنوات",
          "إمكانية السداد المبكر بعد سنة من التعاقد",
        ],
      },
      {
        name: "المرن",
        role: [
          "مقدم يبدأ من 20 ٪",
          "التأمين إجباري",
          "فترات سداد من 3 إلى 5 سنوات",
          "إمكانية السداد المبكر بعد سنة من التعاقد",
          "إمكانية تأجيل جزء من المقدم",
        ],
      },
      {
        name: "المرن بلس",
        role: [
          "مقدم يبدأ من 20 ٪",
          "التأمين اختياري",
          "فترات سداد تصل الي 5 سنوات",
          "إمكانية السداد المبكر الكلي أو الجزئي",
          "إمكانية تأجيل جزء من المقدم",
        ],
      },
      {
        name: "السيارات المستعملة",
        role: [
          "مقدم يبدأ من 20 ٪",
          "التأمين اختياري",
          "فترات سداد تصل الي 5 سنوات",
          // "إمكانية السداد المبكر بعد 6 أقساط",
        ],
      },
      {
        name: "الشركات",
        role: [
          "مقدم يبدأ من 10%",
          "التأمين إجباري",
          "فترات سداد من 2 إلى 5 سنوات",
          "إمكانية السداد المبكر بعد سنة من التعاقد",
        ],
      },
    ],
  },
  products_education: {
    cover: {
      img: "/pages/education-cover.png",
      color: "#72813B",
      title1: "تمويل التعليم",
      title2: "معاك وفي ضهرك طول مشوار التعليم",
      description: `التعليم هو أهم استثمار تقدر تعمله لنفسك ولـعيلتك. يـفـتحلك أبواب جديدة، يعـلّمـك مهارات جديدة، ويـسـاعدك تحقق نجاحات أكبر في حياتك. كونتكت بتقدملك حلول تمويلية مميزة عشان تقدر تستفيد من أحسن تعليم في مصر، في أي مرحلة دراسية. سواء كنت عايز تدخل أولادك في مدرسة أو جامعة كويسة، تأخد كورس عشان تتـقدّم في شغلك، أو تـعمل ماجستير أو دكتوراه أو دبلومه، تمويل التعليم افضل اختيار يناسب احتياجاتك وميزانيتك.`,
    },
    outro:
      "من غير ما تقلق على المصاريف أو الظروف تـمـنعـك تـكـمـل حلمك فى الوصول لأعلى الشهادات وتضمن أفضل مستوى تعليم لأولادك ، قدم على تمويل التعليم من كونتكت ومتعطلش مستقبلك.",
  },
  products_home: {
    cover: {
      img: "/pages/home-cover.png",
      color: "#53908A",
      title1: "تمويل عقاري",
      title2: "كونتكت معاك في خطواتك اللى جاية",

      description: `عايز تشتري شقة في مصر؟ كونتكت بتقدملك مجموعة متنوعة من برامج التمويل اللي تقدر تساعدك تحقق حلمك. مع تمويل بيتك هتستفيد من برامج مرنة لتمويل بيتك من غير قلق ولا إجراءات معقّدة. امتلاك بيت أحلامك بقى حقيقة. تمويل البيت من كونتكت بيقدملك أحسن طريقة  لتقسيط شقتك أو بيتك في مصر.`,
    },
    // plans_title: "خطط التقسيط",
    // plans: [
    // {
    //   title: "اقتصادي",
    //   bodyList: [
    //     "بدون مقدم",
    //     "تمويل يصل إلى 6 مليون جنية",
    //     "فترات سداد تصل الي 5 سنوات",
    //     "إمكانية السداد الكلي أو الجزئي بعد سنه",
    //   ],
    // },
    // {
    //   title: "المرن",
    //   bodyList: [
    //     "بدون مقدم",
    //     "تمويل يصل إلى 6 مليون جنية",
    //     "فترات سداد تصل الي 5 سنوات",
    //     "إمكانية السداد الكلي أو الجزئي بعد سنه",
    //   ],
    // },
    // ],
    section_a: {
      img: "/pages/without-advance.png",
      title: "مميزات نظام تمويل بيتك",
      body: [
        "مقدم 25% من قيمة الوحدة",
        "تمويل يصل إلى 6 مليون جنيه",
        "فترات سداد تصل إلى 10 سنوات",
        "شاملة جميع الوحدات السكنية بجميع أنواعها سواء كانت (داخل كومباوند أو خارجه بشكل منفرد)",
      ],
    },
    section_b: {
      img: "/pages/without-advance.png",
      title: `أو احصل على تمويل بضمان بيتك يصل إلى 50% من قيمته من خلال نظام "إعادة تمويل بيتك"`,
      body: [
        "بدون مقدم",
        " تمويل نقدي يصل إلى 6 مليون جنيه",
        "فترات سداد تصل إلى 5 سنوات",
        " التمويل يشمل جميع الوحدات السكنية بجميع أنواعها سواء كانت (داخل كومباوند أو خارجه بشكل منفرد)",
      ],
    },
    card_section_title: "البرامج",
    cards: [
      {
        name: "اقتصادي",
        role: [
          "بدون مقدم",
          "تمويل يصل إلى 6 مليون جنية",
          "فترات سداد تصل الي 5 سنوات",
          // "إمكانية السداد الكلي أو الجزئي بعد سنه",
        ],
      },
      {
        name: "المرن",
        role: [
          "بدون مقدم",
          "تمويل يصل إلى 6 مليون جنية",
          "فترات سداد تصل الي 5 سنوات",
          "إمكانية السداد الكلي أو الجزئي بعد سنه",
        ],
      },
    ],
    home_equity: {
      title: "إعادة تمويل بيتك",
      description:
        'لو محتاج سيولة وبتدور على طريقة مريحة ومضمونة؟ جرب "إعادة تمويل بيتك" من كونتكت عشان تحصل على تمويل لغاية 50% من قيمة بيتك الحالية، واستغـل الفلوس في انك تجدد بيتك، تسـدِّد ديونك، تـصـرف على تعليم أولادك، أو حتى تستثمرها.',
      outro: {
        img: "/pages/without-advance.png",
        content:
          'لو عايز توفر فلوس وتحقق اللي تتمناه من غير ما تبيع بيتك، "إعادة تمويل بيتك" من كونتكت هو الحل المناسب ليك. اتصل بينا النهاردة واستفسر أكتر.        ',
      },
    },
    home_finance: {
      title: "تمويل المنزل",
      description:
        "تمويل بيتك وسيلة تحقق بيها أحلامك. بنساعدك تعيش في المكان اللي تحبه، بكل وسائل الراحة اللي انت عايزها، وانت مطمن إنك عملت استثمار ذكي لمستقبلك.      ",
      outro: {
        img: "/images/mortgage.png",
        content: `الفرصة مش بتتكرر كتير، كونتكت بتقدملك أسهل وأسرع تمويل. اتصل بينا النهاردة واعرف إزاي تقدر تموّل شقة أحلامك مع "تمويل عقاري" من كونتكت.          `,
      },
    },
  },
  products_leasing: {
    cover: {
      img: "/pages/leasing-cover.png",
      color: "#4AA2A6",
      title1: "تأجير تمويلي",
      title2: "طوّر قدراتك ونجح أعمالك",
      description: `كونتكت هي شركة رائدة في تقديم خدمات التأجير التمويلي لمختلف القطاعات في مصر. لو عايز تجهز منشآة طبية، مركز أشعه أو تحاليل أو تطور أسطول النقل الخاص بشركتك، كونتكت هتساعدك في تنمية أعمالك بأسهل الحلول وأفضل الخدمات التمويلية اللي بتضمنلك السرعة والنجاح للوصول لأهدافك.`,
    },
    section_a: {
      img: "/pages/without-advance.png",
      title: "مزايا كونتكت تأجير تمويلي",
      body: [
        "دفعة مقدمة تبدأ من 10% طبقاً لنوع الأصل",
        "فترات سداد تصل إلى 5 سنوات",
        "شبكة واسعة من الموردين المعتمدين لأفضل المصنعين والماركات العالمية",
        "خطط سداد متنوعة مصممة لتناسب احتياجاتك",
        "إجراءات واضحة بدون تعقيدات",
        "التمويل يشمل تجهيزات العيادات والمنشآت الطبية وسيارات الإسعاف بأحدث أجهزة الرعاية الصحية",
        "التمويل يشمل وسائل النقل من السيارات الشخصية إلى السيارات التجارية (نقل خفيف، متوسط وثقيل) بالإضافة إلى الحافلات والڤان.",
      ],
    },
    section_b: {
      img: "/pages/without-advance.png",
      title: "كيف نعمل",
      description: `لتبسيط الإجراءات صممنا الحلول لترتكز علي القيمة السوقية للأصول التي تحتاجها الشركة. كما أن خبراتنا الطويلة ساعدتنا علي تقديم خدمات شاملة 
  و متخصصة بشكل أفضل و بأعلي إستفادة لك و لأنشتطتك التجارية.`,
      list: [
        [
          "إختار الأصول المناسبة لنشاطك",
          "من خلال شبكة الموردين والشركاء تغطى قطاعات الأدوات الطبية والنقل سواء كانت جديدة أو مستعملة لنضمن وصولك لأفضل المعدات التي تحتاجها لتنمية وتطوير نشاطك",
          "1",
        ],
        [
          "استكمال إجراءات التقديم",
          "فقد فمنا بتبسيط الإجراءات بشكل يسمح لك بمعرفة جميع الخطوات و المستندات المطلوبة بكل وضوح وشفافية. وكذلك الرد علي جميع استفساراتك بسرعة وفى المواعيد المحددة.",
          "2",
        ],
        [
          "اختيار خطة الدفع التي تناسب احتياجاتك",
          "اختيار خطة الدفع التي تناسبك مع مراعاة القيمة السوقية للأصل الذى تختاره مع وضوح وشفافية جميع المصاريف بداية من الدفعة الأولى والرسوم الإدارية المطلوبة منك ، وبدون أي رسوم أخرى غير معلنة",
          "3",
        ],
      ],
    },
    outro:
      "كونتكت هي شريك موثوق فيه بيفهم أهداف مشروعك ويساعدك تحققها. اتصل بينا النهاردة وخلينا نساعدك تطور قـدرة مشروعك.",
  },
  products_green_finance: {
    cover: {
      img: "/pages/green-finance-cover.png",
      color: "#92B338",
      title1: "التمويل الأخضر",
      title2: "أنطلاقة لمستقبل أفضل",
      description: `عايز تكبر استثمارك فى الزراعة أو الطاقة المتجددة؟ كونتكت بتقدملك التمويل اللازم اللي هيساعدك في تحقيق التنمية والاستدامة وبأنظمة سداد مختلفة تناسب إمكانياتك وتلبي جميع احتياجاتك. `,
    },
    outro:
      "الزراعة والطاقة النظيفة هما المستقبل اللي بنحلم بيه لينا ولأولادنا، وعشان كده كونتكت بتدعمهم من خلال منتجاتها التمويلية المبتكرة. لو كنت مهتم بالتمويل الأخضر، يبقى اتصل بينا النهاردة. لمعرفة المزيد من المعلومات والتفاصيل.",
    section_a: {
      img: "/pages/without-advance.png",
      title1: "من خلال التمويل الأخضر ممكن ",
      title2: "تمول :",
      body: [
        "وحدات الطاقة الشمسية",
        "تطوير نظم الري",
        "الصوب الزراعية ",
        "تطوير وتجهيز مشروعات الزراعات الخندقية والأغطية البلاستيكية للأنفاق والصوب الزراعية ",
        "أحواض ومعدات الثروة السمكية",
        "عنابر ومعدات الثروة الداجنة",
        "عنابر ومعدات الثروة الحيوانية",
      ],
    },
  },

  products_insurance_page: {
    cover: {
      img: "/pages/insurance-cover.png",
      color: "#282780",
      title1: "وساطة تأمينية",
      title2: "عيش مطّمن وأنت مأمن",
      description_indiv: ` كونتكت وساطة تأميــنيــة، مكان واحد يمكنك أن تجد فيه كل الخطط التأمينية المناسبة لشركتك. إذا كنت تختار خطط تأمين لمشروعك أو لشركتك فيمكنك الاعتماد على خدمات الوساطة التأمينية من كونتكت، لأننا نقدم لك كل الاختيارات من أفضل شركات التأمين في مصر في مكان واحد! يمكنك أن تجمع ما بين أكثر من خطة مختلفة من أكثر من مقدم خدمات تأمينية بحسب احتياجات شركتك في عرض واحد وتعاقد واحد معنا، مما يجعل اختيار الخطة المناسبة لشركتك أمر سهل مع كونتكت.`,
      description_comp: ` محتاج مكان واحد تقدر تأمن فيه على مشروعك أو شركتك، مع كونتكت تقدر تختار ما بين الباقات التأمينية المختلفة اللي بنوفرهالك من خلال أقوي شركات التأمين في مصر بأقل الأسعار وبأفضل مزايا تأمينية تناسب احتياجات الشركات والمؤسسات المختلفة.`,
    },
    subTitle: "تأمين الأفراد",
    section_a: [
      {
        img: "/family_insurance.svg",
        title: "تأمين عيلتك",
        points: [
          "تأمين طبي",
          "تأمين حياة",
          " حوادث شخصية",
          "كارت المزايا الطبية",
        ],
      },
      {
        img: "/home_insurance.svg",
        title: "تأمين بيتك",
        points: ["تأمين المنزل", "عطل الأجهزة وامتداد الضمان", "استبدال مفتاح"],
      },
      {
        img: "/car_insurance.svg",
        title: "تأمين عربيتك",
        points: [
          "تأمين سيارة",
          "تأمين الهلاك الكلي للسيارات (ملاكي / نقل)",
          "تأمين سيارات النقل",
          "تأمين أخطار الطريق",
          "تغطية استبدال المفتاح",
        ],
      },
      {
        img: "/travel_insurance.svg",
        title: "تأمين مشروعك",
        points: ["تأمين المشروعات الصغيرة"],
      },
    ],
  },
  products_watercraft: {
    cover: {
      img: "/pages/watercraft-cover.png",
      color: "#27A9E1",
      title1: "تمويل مركبات ومعدات الرياضات المائية",
      title2: "عيش الرفاهية",
      description:
        'لو بتحب الرياضات والأنشطة المائية، كونتكت هتساعدك وتقدملك تمويل المركب اللى أنت تتمناه مع خدمة "تمويل مركبات ومعدات الرياضات المائية" من كونتكت. عيش رفاهية الحياة على البحر وجرب متعة وفرحة متتنسيش. كونتكت هتساعدك تشتري أي مركب زى اليخوت، اللنشات، الجيت سكي، والمعدات الخاصة بالغطس أو Rafting، Kayaking، Kitesurfing، Water skiing، Parasailing، وغيرها كتير.',
    },
    outro:
      "اتصل بينا وكونتكت هتساعدك في تمويل المركبات ومعدات الرياضات المائية اللي بتحبها وتبدأ المغامرة.",
  },
  products_motorcycle: {
    cover: {
      img: "/pages/motorcycle-cover.png",
      color: "#DD6F5A",
      title1: "تمويل الدراجـــات النـــارية",
      title2: "استعد للمغامرة",
      description: `استمتع بحُرية الطرق المفتوحة واهرب من الزحمة واكتشف أماكن جديدة! لو كنت مُهتم بامتلاك دراجة نارية، أو سكوتر، أو جولف كار، أو بيتش باجي ، دلوقتي تقدر تستفيد من حلول تمويلية مُختلفة من كونتكت لكل أنواع المركبات، بما فيها الدراجات النارية وإكسسواراتها. سواء كنت عايز مركبة بعجلتين، أو بتلات عجلات، أو بأربع عجلات، كونتكت تقدر تساعدك تمتلكها بأفضل خطط التقسيط.`,
    },
    outro:
      "كونتكت بتوفرلك طريقة سهلة ومريحة عشان تمتلك دراجة نارية أو سكوتر أو جولف كار أو بيتش باجي اللي بتحلم بيهم، وكمان بتوفرلك كل الملحقات اللي ممكن تحتاجها. اتصل بينا وهنوفرلك أكبر مبلغ تمويل وأسهل الإجراءات عشان تمتلك دراجـــتك في أسرع وقت.",
  },
  our_brand_page: {
    title1: "شركات المجموعة",
    title2: "منصاتنا الرقمية",
    Contactfinancialholding: "كونتكت المالية القابضة",
    body: [
      {
        id: 1,
        img: "/our-brands/contact.jpg",
        link1: "",
        heading: "أول وأكبر شركة تمويل في مصر",
        content:
          "تأسست كونتكت عام 2001 لتكون شركة رائدة في مجال التمويل الاستهلاكي في مصر كأول شركة مستقلة في هذا المجال. تحت قيادة ادارة مكونة من أفضل القادة والخبراء في مجال المال والأعمال، نجحت كونتكت باستمرار في الحصول على تمويل متنوع من البنوك وشركات الاستثمار المباشر والمستثمرين الأفراد، مما أدى بطبيعة الحال إلى نمو كونتكت وتوسعها، وعزز مكانتها كشركة رائدة للحلول المالية المصممة خصيصًا للمستهلكين.توسّعت كونتكت في خدماتها بمصر لتغطية مجموعة واسعة من الخدمات حيث يمكن للعملاء الشراء الآن والدفع لاحقًا على أقساط لمعظم الأشياء تقريبًا؛ بدءًا من الأجهزة الإلكترونية والسلع الاستهلاكية، إلى الدراجات النارية، اليخوت، السيارات الخاصة والتجارية وسيارات النقل، المصروفات الدراسية وحتى التصميم والتشطيب والفرش والصيانة وعضويات الأندية  والتمويل العقاري بالإضافة الي تمويل الشركات التجارية من خلال خدمات التخصيم والتأجير التمويلي.",
        supervision:
          "ترخيص الهيئة العامة للرقابة المالية رقم 1 بتاريخ 2020/04/16",
      },
      {
        id: 2,
        img: "/our-brands/c-bro.jpg",
        link1: "",
        heading: "شريك موثوق به، لتغطية تأمينية شاملة ومتميزة",
        content:
          "تقدم كونتكت للوساطة التأمينية خبرة تأمينة متنوعة ومتميزة للأفراد والشركات تحت سقف واحد، نساعدك على الاختياروالجمع بين وثائق التأمين وشركات التأمين المختلفة بدون تعقيدات، ونضمن لك اختيار التغطية المناسبة ومنتجات التأمين الصحيحة لبيتك وعائلتك وسيارتك أو مشروعك. سواء كنت عميلاً فرديا أو مؤسسة، فإن كونتكت للوساطة التأمينية تتعاون مع شركات تأمين رائدة لتقديم باقات مُصممة خصيصًا لتلبية احتياجاتك وميزانيتك المحددة.من خلال فريقنا المتخصص من خبراء التأمين الذين يعملون بشكل وثيق معك لفهم ملف المخاطر وأهدافك الفريدة، نتمكن من ترجمة الوثائق التأمينية المعقدة إلى مميزات  واختيارات واضحة، لنساعدك على اختيار الخطة التي تلائم ميزانيتك ومتطلباتك بثقة ونجاح.",
        supervision:
          "ترخيص الهيئة العامة للرقابة المالية رقم 45 بتاريخ 2015/03/03",
      },
      {
        id: 3,
        img: "/images/insurance-logo-ar.svg",
        link1: "https://sarwa.insurance/sarwa-insurance?lang=ar",
        heading: "نغير فكرتك عن التأمين",
        content:
          "تعد ثروة للتأمين من أكثر الشركات ديناميكية وسرعة في النمو بسوق التامين المصري من خلال تقديم مجموعة واسعة من حلول التأمين للأفراد والشركات. ينصب تركيزنا الأساسي على تقديم خدمات متميزة وقيمة عالية الجودة للعملاء. لقد اخترنا أفضل الكوادر التأمينية في مختلف مجالات التأمين لضمان جاهزيتنا لمواجهة المخاطر المتزايدة واحتياجات التأمين المختلفة لعملائنا. إن خبرتنا الواسعة في العمل بالمعايير الدولية وفهم احتياجات السوق يضمن لنا القدرة على تقديم الحلول الاقتصادية الأكثر فعالية للعملاء. كما تحرص الشركة دائماً على بناء الثقة وخلق والمصداقية كأحد الركائز الأساسية في جميع أعمالها.",
        supervision:
          "ترخيص الهيئة العامة للرقابة المالية رقم 40 بتاريخ 2019/03/03",
      },
      {
        id: 4,
        img: "/images/life-logo-ar.svg",
        link1: "https://sarwa.insurance/sarwa-Life?lang=ar",
        heading: "ثروة حياة، الحياة ثروة",
        content:
          "كشركة رائدة في مجال تأمينات الحياة في مصر، تُقدم ثروة حياة للأفراد والشركات تجربة تأمين مختلفة من خلال تجربة رقمية سلسة ومبتكرة. نحن لا نتوقف عند التأمين التقليدي، بل نصنع حلولًا مالية شاملة مصممة خصيصًا لحياتك الفريدة. تخيل مكاناً واحدًا يمكنك من خلاله تلبية احتياجاتك الطبية والاستثمارية والتقاعدية بسهولة، كل ذلك متاح بالفعل من خلال منصتنا المتطورة.تجعل ثروة حياة من الممكن إدارة وثائق التأمين، والوصول إلى الاهداف الادخارية، وتقديم المطالبات في أي وقت ومن أي مكان، باستخدام أدوات رقمية سريعة وآمنة من ثروة حياة. سواء كنت فردًا أو شركة، فإن ثروة حياة تُبسط الاجراءات، وتوفر خدمات متميزة ومبتكرة تلبي احتياجاتك المحددة.ثروة حياة هي شريكك الموثوق به في طريقك نحو مستقبل أكثر صحة وإشراقًا.",
        supervision:
          "ترخيص الهيئة العامة للرقابة المالية رقم 39 بتاريخ 2019/03/03",
      },
      // {
      //   id: 3,
      //   img: "/our-brands/contact-cars.png",
      //   link: "https://www.contactcars.com/ar",
      //   content:
      //     "كونتكت كارز منصة رائدة في مجال السيارات بمصر من خلال موقع الانترنت وتطبيق الهاتف المحمول. منذ عام ٢٠٠٤، ونحن نقـــود التقدم الرقمي في قطاع السيارات من خلال اعادة تشكيل طريقة شراء وبيع السيارات في مصر، حيث نوفر لهم أدوات وخدمات سهلة الاستخدام تبسط العملية برمتها للبائع والمشتري، بدءاً من عرض السيارة بتفاصيلها للبيع وحتى تمويل السيارات الجديدة والمستعملة والتأمين والخدمات الأخرى.في عام ٢٠٢١، بدأت كونتكت كارز في رحلة جديدة من الابتكار، وأعادت إطلاق الموقع الإلكتروني والتطبيق بشكل جديد أكثر تطورا. وقد تم دمج خدمات جديدة مصممة لكل من المستهلكين وتجار السيارات، مما عزز من تجربة البيع والشراء  لدى كل الأطراف الموجودة في سوق السيارات المصري.من خلال التكنولوجيا المتطورة، تواصل كونتكت كارز تشكيل مستقبل امتلاك السيارات في مصر، مما يمكّن الأفراد والشركات على حد سواء من الإبحار في عالم السيارات بثقة وسهولة، مقدمة حلول جديدة وشراكات جديدة في مجال السيارات في مصر.",
      // },
      {
        id: 5,
        img: "/our-brands/sarwa.png",
        link3: "/sarwa-capital",
        heading: "رواد إدارة رأس مال الدين",
        content:
          "رسخت ثروة مكانتها كشريك موثوق به في مجال إدارة رأس مال الدين (DCM) في مصر. خبرتها الواسعة وإنجازاتها الاستثنائية تجعلها الخيار الأمثل للشركات التي تسعى إلى تحقيق أهدافها المالية.خدماتنا في ادارة رأس مال الدين عديدة وتشمل التوريق، وإصدار الصكوك. منذ عام 2005 قمنا بترتيب وإصدار أكثر من 26 مليار جنيه مصري كأدوات دين، بما في ذلك أول إصدار للتوريق بالسوق المصري. كما أن ثروة هي أول مصدر مرخص للصكوك في السوق المصرية.",
        supervision: null,
      },
      {
        id: 6,
        img: "/our-brands/c-contact-now.png",
        link1: "",
        link2: userAgent(
          "https://apps.apple.com/us/app/contactnow-%D9%83%D9%88%D9%86%D8%AA%D9%83%D8%AA/id1544159088",
          "https://play.google.com/store/apps/details?id=eg.contact"
        ),
        heading: "تجربة تمويلية أسهل",
        content:
          "تم تطوير تطبيق ContactNow  لتبسيط إدارة تمويلاتك المالية و العمليات الشرائية حيث يوفر لك تطبيق الموبايل موافقات سريعة على خطط التمويل من خلال أكبر شبكة من التجار في مصر.تطبيقContactNow  أكثر من مجرد تجربة تمويل تقليدي، فهو منصة سهلة الاستخدام تلبي احتياجات متنوعة لتمويل المنتجات والخدمات بالإضافة إلى تقديم العروض المختلفة. يتم تحديث تطبيق ContactNow دائما لضمان البساطة والوضوح ومنحك تجربة مميزة، حمل التطبيق الآن لتكتشف فرص التمويل المتاحة وتتمكن من اتخاذ قراراتك المالية بسرعة وثقة.",
        supervision:
          "كونتكت كريدي تك ترخيص الهيئة العامة للرقابة المالية رقم 33 بتاريخ 2022/04/28",
      },
      {
        id: 7,
        img: "/our-brands/wasla.png",
        link1: "https://waslabrowser.com/ar",
        heading: "معنى جديد للتسوق",
        content:
          "وصلة هو متصفح ويب رائد على الهاتف المحمول وملحق بمتصفح الكمبيوتر مصمم لتحسين تجربة التسوق عبر الإنترنت في مصر وخارجها.من خلال شبكتنا الواسعة التي تضم عدد كبير من المتاجر الإلكترونية المحلية والاقليمية، نساعدك على اكتشاف أفضل العروض والخصومات والتوفير. سواءً كنت تتصفح متاجر الأزياء المفضلة لديك، أو تبحث عن أجهزة الكترونية مميزة، أو غير ذلك، تمكنك وصلة من توفير المال مع كل عملية شراء أو تسوق الكتروني.",
        supervision: null,
      },
      {
        id: 8,
        // img: "/our-brands/contact-cars.png",
        img: "/our-brands/contact-cars.png",
        link1: "https://www.contactcars.com/ar",
        link2: userAgent(
          "https://apps.apple.com/eg/app/contactcars/id390158823",
          "https://play.google.com/store/apps/details?id=net.sarmady.contactcarswithtabs&hl=en&gl=US"
        ),
        heading: "قيادة التحول الرقمي لقطاع السيارات في مصر",
        content:
          "انطلقت منصة كونتكت كارز دوت كوم في عام 2002 لتكون الخطوة الأولى في طليعة التحول الرقمي لقطاع السيارات في مصر، ومنذ ذلك الحين كان التزامنا وإيماننا العميق بأهمية التطوير والابتكار النواة التي مكنت كونتكت كارز من لعب الدور الأبرز في تشكيل تعاملات بيع وشراء وصيانة المركبات رقمياً في السوق المصري. نركز في كونتكت كارز على تقديم تجربة مستخدم متميزة لنكون منصة شاملة ومتكاملة للخدمات والمنتجات الرقمية للبائعين والمشترين من الأفراد والتجار، ومراكز خدمات السيارات، والوكلاء والموزعين وأصحاب المعارض. أياً ما كان الدور الذي تمثله في هذا القطاع، كونتكت كارز لديها الحل المناسب. حازت كونتكت كارز شهرتها كمرجع هام لأسعار ومواصفات السيارات في مصر، وكسوق رقمي للسيارات والدراجات البخارية، وتوسعت خدماتنا الموجهة للأفراد لتشمل طلبات تقسيط المركبات، حلول متعددة للتأمين الرقمي على السيارات، التجارة الالكترونية للدراجات البخارية، وعدة خدمات مبتكرة لمالكي السيارات. ومن أهم ما نقدمه لشركائنا من أصحاب الأعمال هي خدمات المعارض الرقمية ذات الاشتراكات الشهرية للوكلاء والموزعين وأصحاب المعارض، بالإضافة لحلول المزادات الالكترونية، وأدوات التسعير المبنية على الذكاء الاصطناعي، والإعلانات الرقمية، وتطوير المحتوى الرقمي بأشكاله المتنوعة. في كونتكت كارز دوت كوم نعمل لمزج التكنولوجيا الحديثة والذكاء الاصطناعي مع خبرة تمتد لأكثر من 20 عاماً من قيادة التحول الرقمي لقطاع السيارات بالسوق المصري من أجل هدف واحد، وهو مساعدة الأفراد وأصحاب الأعمال في قطاع السيارات في التغلب على التحديات التي تواجههم والاستفادة من فرص السوق بأفضل شكل ممكن.",
        supervision: null,
      },
      {
        id: 9,
        img: "/our-brands/co-bro-logo-ar.png",
        link2: userAgent(
          "https://apps.apple.com/eg/app/insurance-brokerage/id6445921286",
          "https://play.google.com/store/apps/details?id=com.insuranceBrokerage&hl=ar"
        ),
        heading: "كل احتياجاتك التأمينية في مكان واحد.",
        content:
          "منصة رقمية سهلة الاستخدام تلبي جميع احتياجاتك التأمينية حيث يساعدك تطبيق كونتكت للوساطة التأمينية على معرفة واختيار خطط التأمين الفردية والعائلية وحتى التجارية بالإضافة إلى تقديم العديد من الخدمات التي تسهل حياتك اليومية وتجعلها أكثر جودة. يمكنك من خلال التطبيق تقديم مطالبات التأمين الطبي وحوادث السيارات مباشرة بالاضافة الي الاجابة على استفساراتك الطبية من خلال خدمة استشارات الأطباء وتنظيم الأدوية وتلقي تذكيرات بأوقات تناولها للمساعدة على الالتزام بخطة العلاج الخاصة بك. كما يمكنك الإطلاع على معلومات صحية وطبية عديدة. حمل تطبيق كونتكت للوساطة التأمينية الآن واستمتع بهذه الخدمات والعديد من المميزات الآخرى التي يوفرها لك التطبيق.",
        supervision: null,
      },
    ],
    link1: "لزيارة الموقع الإلكتروني",
    link2: "تنزيل التطبيق",
    link3: "اقرا المزيد",
  },

  rewards: {
    heading: "نقاط برنامج ترشيح العملاء",
    subHeading: "في حالة ترشيح عميل حالي لعميل جديد تحسب النقاط كالاتي",
    title: "كيفية احتساب النقاط",
    note: "ملحوظة: ",
    noteText: "الحد الأدنى لسعر الوثيقة لاحتساب النقاط 5,000 جم",
    pointsCard: [
      {
        id: "1",
        title: "كونتكت تسوق",
        headingKey: "نوع المعاملة",
        headingVal: "عدد النقاط",
        subTitle:
          "تمنح نقاط لكل “جنيه مصري” في المشتريات، وذلك طبقاً لقيمة المعاملة الشرائية الجارية بواسطة الحساب ويتم تقريبها لأقرب نقطة",
        purchaseKey: "المشتريات	",
        purchaseVal: "1 نقطة لكل 1 جم",
        firstTreatmentKey:
          "أول معاملة شرائية خلال أول شهرين من الاشتراك او أول شهرين من اطلاق البرنامج",
        firstTreatmentSubKey: "*بحد ادنى 10000 الاف جنيه مصرى	",
        firstTreatmentVal: "3000 نقطة",
        lastTreatmentKey:
          "خامس معاملة شرائية بعد الإشتراك (ليست مربوطة بمدة محددة)",
        lastTreatmentSubKey: "*بحد ادنى 10000 الاف جنيه مصرى",
        lastTreatmentVal: "2000 نقطة",
      },
      {
        id: "2",
        title: "كونتكت تمويل التشطيب",
        headingKey: "نوع المعاملة",
        headingVal: "عدد النقاط",
        subTitle:
          "تمنح العميل نقاط لكل “جنيه مصري” من المشتريات، وذلك طبقاً لقيمة المعاملة الشرائية الجارية بواسطة الحساب ويتم تقريبها لأقرب نقطة.",
        purchaseKey: "المشتريات	",
        purchaseVal: "0.5 نقطة لكل 1 جم",
        firstTreatmentKey:
          "أول معاملة شرائية خلال أول شهرين من الإشتراك او أول شهرين من إطلاق البرنامج",
        firstTreatmentSubKey: "*بحد ادنى 20000 الاف جنيه مصرى	",
        firstTreatmentVal: "3000 نقطة",
        lastTreatmentKey:
          "خامس معاملة شرائية بعد الإشتراك (ليست مربوطة بمدة محددة)",
        lastTreatmentSubKey: "*بحد ادنى 20000 الاف جنيه مصرى",
        lastTreatmentVal: "2000 نقطة",
      },
    ],
    card: [
      { title: "كونتكت تمويل السيارات ", count: 40000 },
      { title: "كونتكت تمويل النقل ", count: 30000 },
      { title: "كونتكت تسوق عقاري", count: 25000 },
      { title: "كونتكت تمويل التشطيب", count: 20000 },
      { title: "كونتكت تمويل عقاري", count: 20000 },
    ],
    products_finishing: {
      cover: {
        img: "/pages/finishing-cover.png",
        color: "#5E7EB5",
        title1: "تمويل فرش البيت",
        title2: "جدد شكل بيتك",
        description: `تخيل بيتك مليان بفرش وأثاث جديد وشيك يخليك تستمتع بالأناقة والراحة، وتختاره من أي مكان نفسك فيه. مع تمويل فرش البيت من كونتكت، الحلم ده هيقرب كتير وهتقدر تختار كل الفرش والديكور اللي بيتك محتاجه من خلال أكبر محلات الاثاث والديكور اللي بتناسب كل الأذواق.`,
      },
    },

    our_brand_page: {
      title: "شركات المجموعة",
      body: [
        {
          id: 1,
          img: "https://contact.eg/wp-content/uploads/2020/10/logo-3.png",
          link: "/",
          content:
            "بدأت كونتكت في عام 2001 كأول شركة مصرية متخصصة في خدمات التمويل الاستهلاكي. وقد تأسست الشركة باعتبارها كيان مستقل بقيادة إدارة وفريق عمل على أعلى مستوى من الخبرة، ونجحت في جذب الاستثمارات من مصادر متنوعة تشمل البنوك والمؤسسات المالية وشركات الاستثمار المباشر والمستثمرين الأفراد",
        },
        {
          id: 2,
          img: "https://contact.eg/wp-content/uploads/2021/02/Sarwa-Insurance-01.png",
          link: "https://sarwa.insurance/sarwa-insurance?lang=ar",
          content:
            "تعد ثروة للتأمين من أكثر الشركات ديناميكية وسرعة في النمو بسوق التامين المصري من خلال تقديم مجموعة واسعة من حلول التأمين للأفراد والشركات. ينصب تركيزنا الأساسي على تقديم خدمات متميزة وقيمة عالية الجودة للعملاء. لقد اخترنا أفضل الكوادرالتأمينية في مختلف مجالات التأمين لضمان جاهزيتنا لمواجهة المخاطر المتزايدة واحتياجات التأمين المختلفة لعملائنا. إن خبرتنا الواسعة في العمل بالمعايير الدولية وفهم احتياجات السوق يضمن لنا القدرة على تقديم الحلول الاقتصادية الأكثر فعالية للعملاء. كما تحرص الشركة دائماً على بناء الثقة وخلق والمصداقية كأحد الركائز الأساسية في جميع أعمالها.",
        },
        {
          id: 3,
          img: "https://contact.eg/wp-content/uploads/2021/02/Sarwa-Life-EN-1.jpg",
          link: "https://sarwa.insurance/sarwa-Life?lang=ar",
          content:
            "ثروة حياة هي نموذج شامل ونافذة الكترونية واحدة هدفها تغطية الاحتياجات المالية اليومية للعملاء خلال رحلة الحياة كما توفر لهم التغطية الصحية الشاملة، وغيرها من الحلول والخدمات. وقد تم تأسيس ثروة حياة برأس مال مدفوع 100 مليون جنيه لتقديم خدمات متميزة ومبتكرة للعملاء من خلال حلول رقمية سريعة تمكن العملاء من إدارة جميع المتطلبات الكترونياً سواء كان فرد أو شركة في أي وقت وفي أي مكان. بناء على نموذج رقمي وشمولي موحد يدعم احتياجات العمليات المالية اليومية، عن طريق حلول رقمية حديثة ومبتكرة تناسب احتياجات الحياة، والاحتياجات الطبية وغيرها من احتياجات عملائنا. ت تأسيس ثروة لتأمينات الحياة برأس مال يقدر ب 100 مليون جنيه مصري. حيث توفر الشركة خدمات متميزة ومبتكرة لخدمة العملاء سواء كانوا من الأفراد أو الشركات ، من خلال حلول رقمية سهلة وسريعة تساعدهم في إدارة جميع احتياجاتهم رقمياً في أي وقت وفي أي مكان.",
        },
        {
          id: 4,
          img: "https://contact.eg/wp-content/uploads/2021/03/Logo2.png",
          link: "https://www.contactcars.com/ar",
          content:
            "كونتكت كارز منصة رائدة في مجال السيارات بمصر من خلال موقع الانترنت وتطبيق الهاتف المحمول. منذ عام ٢٠٠٤، ونحن نقـــود التقدم الرقمي في قطاع السيارات من خلال اعادة تشكيل طريقة شراء وبيع السيارات في مصر، حيث نوفر لهم أدوات وخدمات سهلة الاستخدام تبسط العملية برمتها للبائع والمشتري، بدءاً من عرض السيارة بتفاصيلها للبيع وحتى تمويل السيارات الجديدة والمستعملة والتأمين والخدمات الأخرى.في عام ٢٠٢١، بدأت كونتكت كارز في رحلة جديدة من الابتكار، وأعادت إطلاق الموقع الإلكتروني والتطبيق بشكل جديد أكثر تطورا. وقد تم دمج خدمات جديدة مصممة لكل من المستهلكين وتجار السيارات، مما عزز من تجربة البيع والشراء  لدى كل الأطراف الموجودة في سوق السيارات المصري.من خلال التكنولوجيا المتطورة، تواصل كونتكت كارز تشكيل مستقبل امتلاك السيارات في مصر، مما يمكّن الأفراد والشركات على حد سواء من الإبحار في عالم السيارات بثقة وسهولة، مقدمة حلول جديدة وشراكات جديدة في مجال السيارات في مصر.",
        },
        {
          id: 5,
          img: "https://contact.eg/wp-content/uploads/2021/03/file-2-e1614693894411.png",
          link: "/",
          content:
            "لطالما كان الاستثمار في أسواق رأس مال الدين (DCM) محورا مركزيا لنموذج أعمال ثروة حيث سمح لنا بتنوع قاعدة تمويلنا وإعادة هيكلة عملياتنا بنجاح.  ومن خلال خبراتنا من هذه التجربة العميقة الجذور في مجال ادارة أسواق الدين ، قمنا بتسويق مجموعة من خدمات التمويل التي دفعتنا إلى أن نصبح أكبر لاعب في مصر في هذا القطاع. وقد قامت ثروة بترتيب وإصدار أكثر من 26 مليار جنيه من إصدارات الديون منذ عام  2005، بما في ذلك أول طرح من نوعه لسندات التوريق في السوق المصري. كما أن ثروة هي أول مصدر للصكوك المرخصة في السوق المصرية.",
        },
      ],
      link: "لزيارة الموقع",
    },
  },

  featureSection: [
    {
      id: "1",
      delay: "0",
      img: "/home-services/finance.svg",
      title: "تمويل",
      text: " خدمات تمويلية متعددة تناسب جميع احتياجاتك",
    },
    {
      id: "2",
      delay: "150",
      img: "/home-services/insurance.svg",
      title: "تأمين",
      text: "مكان واحد لكل الخدمات التأمينية",
    },
    {
      id: "3",
      delay: "300",
      img: "/home-services/invetment-new.svg",
      title: "استثمار وادخار",
      text: "شريك استثمارك اليومي ",
    },
    {
      id: "4",
      delay: "350",
      img: "/home-services/payment.svg",
      title: "مدفوعات الكترونية",
      text: "أدفع فواتيرك وأقساطك وانت في مكانك",
    },
  ],
  stepsFeature: [
    {
      id: "1",
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/step-1-ar.png",
      title: "موافقة فورية",
      subTitle: "ميزة",
      text: "موافقه فورية على الحد الائتماني",
    },
    {
      id: "2",
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/step-2-ar.png",
      title: "زيادة الحد الائتماني",
      subTitle: "ميزة",
      text: "طلب زيادة الحد الائتماني",
    },
    {
      id: "3",
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/step-3-ar.png",
      title: "ادفع فواتيرك",
      subTitle: "ميزة",
      text: "دفع الأقساط والفواتير",
    },
    {
      id: "4",
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/step-4-ar.png",
      title: "العروض والمنتجات",
      subTitle: "ميزة",
      text: "متابعة أحدث العروض والمنتجات",
    },
    {
      id: "5",
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/step-5-ar.png",
      title: "شبكة التجار والخدمات",
      subTitle: "ميزة",
      text: "التعرف على شبكة التجار والخدمات",
    },
  ],
  stepsFeature_business: [
    {
      id: "1",
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/1-ar.png",
      title: "إستشارات طبية",
      subTitle: "ميزة",
      text: "استشارات طبية فورية، وايضاً الإستفادة من توجيهات الأطباء في الحلات الطارئة من خلال التطبيق.",
    },
    {
      id: "2",
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/2-ar.png",
      title: "مواعيد أدويتك",
      subTitle: "ميزة",
      text: "تذكيرك بمواعيد أدويتك في الاوقات والجرعات المحددة بتنبيهات على التطبيق لتجنب نسيان أوقات تناول الدواء ولتحسين صحتك العامة.",
    },
    {
      id: "3",
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/3-ar.png",
      title: "الصحة البدنية",
      subTitle: "feature",
      text: "مقالات متنوعة عن الصحة البدنية تساعدك على تبني نمط حياه صحي وتجنب عادات يومية خاطئة لحياه صحية أفضل.",
    },
    {
      id: "4",
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/4-ar.png",
      title: "تقديم المطالبات",
      subTitle: "feature",
      text: "سرعة وسهولة في تقديم المطالبات من خلال التطبيق ومتابعتها لتوفير عملية تقديم بسيطة.",
    },
  ],
  map: {
    title: "شبكة فروعنا",
    subTitle:
      "بنقربلك في كل  محافظة في مصر من خلال أكتر من ٧٥ فرع في جميع أنحاء الجمهورية",
    placeholderGovernate: "المحافظة",
    placeholderBranch: "الفروع بداخل المحافظات",
    noOption: "لا توجد محافظات",
  },

  contact_homes: {
    cover: {
      img: "/contact-homes.svg",
      color: "#2D9A8F",
      title1: "كونتكت هومز",
      title2: "بداية جديدة لحياة متكاملة",
      description: `الان من خلال الشراكة بين شركة كونتكت, شركة التمويل الأولى في مصر، و شركة كولدويل بانكر رائدة التسويق العقاري، اصبح بإمكانك الاستفادة من عالم لا نهائي من المزايا و العروض التي توفر لك الحياة المتكاملة التي تحلم بها بخصومات كبيرة و أسعار خاصة. بداية جديدة لحياة متكاملة`,
    },
    section_a: {
      img: "/pages/without-advance.png",
      title: "الشروط الخاصة ببرنامج “كونتكت هومز",
      body: `أن يكون عميل حالي لدى كولدول بنكر`,
    },
    section_b: {
      img: "/pages/without-advance.png",
      title:
        "استمتع بعالم من المزايا الحصرية عند انضمامك إلى “Coldwell Banker Star Club”",
      body: [
        "نموذج تصميم ثلاثي الأبعاد مجاناً لغرفة المعيشة أو غرفة النوم أو أحد أقسام غرفة الاستقبال",
        "50% خصم على نموذج التصميم ثنائي الأبعاد وثلاثي الأبعاد عند التعاقد مقدمة من RD Design",
        "تمويل عقاري يصل الى 5 ملايين جنيه من كونتكت",
        "تمويل استهلاكي يصل الى 500 الف جنيه من كونتكت",
        "عروض حصرية وخصومات خاصة على دهانات جوتن، ايكيا و تكييفات كاريير",
      ],
    },
    section_c: {
      img: "/pages/without-advance.png",
      title:
        "مزايا وخصومات حصرية لعملاء”Coldwell Banker Star Club” مقدمة من كونتكت على",
      body: [
        "التمويل عقاري",
        "التسوق",
        "تمويل التشطيب",
        "تمويل السيارات",
        "الوساطة تأمينية",
      ],
    },
    section_d: {
      img: "/pages/without-advance.png",
      title:
        "استمتع بعالم من المزايا الحصرية عند انضمامك إلى “Coldwell Banker Star Club”",
      body: [
        "تأمين منزل مجانى لمدة عام",
        "وثيقة استبدال مفتاح",
        "تأمين على الهاتف المحمول، آيباد و التلفزيون",
        "خصم 50% على قيمة تأمين المنزل الثاني (الساحل الشمالي أو العين السخنة)",
      ],
    },
  },
  inistance: {
    Tittle: "احصل على موافقة فورية على الحد الائتماني",
    Tittle2:
      "رصيد يصل إلى 50,000 جنيه مصري يمكنك الحصول عليه على الفور! فقط اتبع هذه الخطوات",
    Start: "البدء",
  },
  Login: {
    Next: "التالى",
    Login: "تسجيل دخول",
    // PhoneTitle:
    //   "   أدخل رقم هاتفك أدناه ، ستتلقى كلمة مرور لمرة واحدة (OTP)    لتسجيل الدخول فى حسابك   ",
    PhoneTitle: "  أدخل رقم هاتفك    لتسجيل الدخول فى حسابك   ",
    // PhoneLabel: "052-09153 (010) 2+ ",
    PhoneLabel: "011xxxxxxxx ",
    PhoneError:
      " رقم الموبايل يجب أن يكون 11 رقم و يبدا بـ (010/011/012/015) مباشرة",
    ErrorMessPass:
      "رقم الهاتف أو كلمة المرور التي أدخلتها غير صحيحة. يرجى المحاولة مرة أخرى.",
    ErrorMessPhone: "لا يوجد حساب لهذا الرقم",

    ErrorLabel: "خطأ",
    PassTitle: "يرجى ادخال كلمة المرور",
    PassLabel: "كلمة المرور",
    ResetPassword: "هل نسيت كلمة المرور ؟",
    CheckUserExistence: "المستخدم غير موجود",
    OTPTitle:
      "تم ارسال كلمة المرور لمرة واحدة الى رقم هاتف ينتهى بالرقم  ، الرجاء ادخاله ادناه",
    UpdatePassword: "تعين كلمة السر ",
    ConfirmLabel: "تاكيد كلمة المرور",
    ErrorConFirmPass: "كلمات المرور غير متطابقة",
    // SuccsessUpdatePAss:
    //   "تم تغيير كلمة المرور ،سيتم تحويلك الى صفحة تسجيل الدخول ، يرجى تسجيل الدخول للوصول إلى السجل الخاص بك",
    SuccsessUpdatePAss:
      "تم تغيير كلمة المرور ، يرجى تسجيل الدخول للوصول إلى  حسابك",
    ResendOtp: "اعاده الارسال",
    OTPNotVerfy: "كلمة المرور لمرة واحدة غير صالحة",
    VerificationToken: "حدث خطأ برجاءالمحاولة مرة اخري",
    resetError: "الرجاء إدخال رقم هاتفك لإعادة تعيين كلمة المرور",
  },
  user_installements: {
    RemaniningAmounts: {
      title: "المتبقي لك",
      amount: "٢٠.٠٠٠",
      currency: "جنية مصري",
      totalAmountText: "المبلغ الكلي",
      paymentBtn: "تسديد القسط",
    },
    UpComingInstallement: {
      title: "الأقساط القادمة",
      paymentBtn: "تسديد الكل",
      UpComingDetails: [
        {
          id: "1",
          payTo: "تريدلاين إستور",
          payFor: "Macbook M1 Pro",
          totalAmountText: "المبلغ الكلي",
          totalAmount: "٦٤,٤٥٠",
          currency: "جنية مصري",
          whatPaid: "٢,٦٨٦",
          total_number_installments: "٢٤",
          number_paid_installments: "١٨",
          paymentBtn: "تسديد القسط",
        },
        {
          id: "2",
          payTo: "تريدلاين إستور",
          payFor: "Macbook M1 Pro",
          totalAmountText: "المبلغ الكلي",
          totalAmount: "٦٤,٤٥٠",
          currency: "جنية مصري",
          whatPaid: "٢,٦٨٦",
          total_number_installments: "٢٤",
          number_paid_installments: "١٨",
          paymentBtn: "تسديد القسط",
        },
        {
          id: "3",
          payTo: "تريدلاين إستور",
          payFor: "Macbook M1 Pro",
          totalAmountText: "المبلغ الكلي",
          totalAmount: "٦٤,٤٥٠",
          currency: "جنية مصري",
          whatPaid: "٢,٦٨٦",
          total_number_installments: "٢٤",
          number_paid_installments: "١٨",
          paymentBtn: "تسديد القسط",
        },
        {
          id: "4",
          payTo: "تريدلاين إستور",
          payFor: "Macbook M1 Pro",
          totalAmountText: "المبلغ الكلي",
          totalAmount: "٦٤,٤٥٠",
          currency: "جنية مصري",
          whatPaid: "٢,٦٨٦",
          total_number_installments: "٢٤",
          number_paid_installments: "١٨",
          paymentBtn: "تسديد القسط",
        },
      ],
    },
    PreviousDealing: {
      title: "التعاملات السابقة",
      nodataerr: "لا توجد بيانات حاليا يرجى المحاولة لاحقا ......",
      PreDealingHead: {
        product: "المنتج",
        seller: "البائع",
        date: "التاريخ",
        amount: "المبلغ",
        payMethod: "طريقة الدفع",
      },
    },
  },
  customer_services: {
    title: "للتحدث لخدمة عملاء كونتكت",
    whatsappCall: {
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/whatsapp-2.png",
      title: "التحدث من خلال الواتس اب",
      subTitle: "للتحدث من خلال خدمة رسائل الواتساب للإستجابة السريعة",
      arrow: "../images/next-arrow.png",
    },
    hotLineCall: {
      img: "../images/call.png",
      title1: "التحدث من خلال ",
      title2: " الخط الساخن",
      subTitle: "١٦١٧٧",
    },
    ourLocation: {
      img: "../images/location.png",
      title: "زور أحد فروعنا",
      arrow: "../images/next-arrow.png",
    },
  },
  profile: {
    title: "الملف الشخصي",
    img: "../images/userProfile",
    imgBtn: "تغير الصورة",
    email_title: "البريد الإلكتروني",
    extraInfo_title: "معلومات إضافية",
    editBtn: "تعديل",
  },
  userNav: {
    your_installement: "أقساطي",
    call_center: "تواصل معنا",
    profile: "الملف الشخصي",
    logout: "تسجيل خروج",
    welcome: "أهلا",
    // loyaltyPoints: "نقطة ولاء",
    loyaltyPoints: "نقاطك الحاليه",
  },
  sarwa: {
    sarwa_life_individual: {
      logo: "/images/life-logo-ar.svg",
      title: "ثروة لتأمينات الحياة",
      hyperlink: "موقع ثروة لتأمينات الحياة",
      paragraph:
        "ثروة حياة هي إحدى شركات التأمين الرائدة في مصر تهدف خِطَط التأمين لدينا إلى حماية جودة حياتك من خلال خطط تأمين متنوعة، منها التأمين الطبي وتأمين المدخرات وخطط استثمار التقاعد والحماية الفردية والجماعية. نقدم لك مجموعة متنوعة وشاملة من الاختيارات مع خدمة مميزة  توازن بين المرونة والاستجابة السريعة مع تبني المعايير الدولية في الإجراءات التأمينية، يمكننا تقديم أفضل تجربة لعملائنا وتقديم خدمات شاملة ومبتكرة.",
      list_title: "تأمينات الأفراد",
      list: [
        {
          title: "الحياة ثروة (تأمين مؤقت محدد المدة).",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar#reqP",
        },
        {
          title: "ثروة أمان (تجديد تلقائي بدون دراسة).",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar#reqP",
        },
        {
          title: "ثروة لايف (ادخار).",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar#reqP",
        },
        {
          title: "الحماية ضد أخطار السرطان للرجال.",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar#reqP",
        },
        {
          title: "الحماية ضد أخطار السرطان للإناث.",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar#reqP",
        },
        {
          title: "الحماية ضد أخطار التدخين.",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar#reqP",
        },
      ],
      for_details: "للمزيد من التفاصيل قم بزيارة",
      link: "https://sarwa.insurance/sarwa-Life?lang=ar",
      img: "/images/sarwaLife.png",
    },
    sarwa_life_companies: {
      logo: "/images/life-logo-ar.svg",
      title: "ثروة لتأمينات الحياة",
      sub_title: "ثروة حياة، الحياة ثروة",
      hyperlink: "موقع ثروة لتأمينات الحياة",
      paragraph:
        "ثروة لتأمينات الحياه هي شركة رائدة في مجال التأمين في مصر. نمكن الأفراد والمؤسسات من الحصول على خدمات تأمين طبي متميزة بالإضافة إلى خدمات أخرى من خلال مجموعة متنوعة من حلول التأمين على الحياة والاستثمار المبتكرة والشاملة. نقدم خيارات متنوعة لحماية صحة ورفاهية الأفراد والمجموعات في الشركات بمختلف طبيعتها وحجمها في مختلف القطاعات. خدماتنا تشمل خطط التأمين الطبي الفردي والجماعي، خطط التأمين على الحياة، خطط الاستثمار، خطط التقاعد، و خطط الحماية والادخار. نعمل كل يوم على تقديم أفضل خدمات التأمين للشركات في مصر. بصفتنا شريكًا لك، نقدم خيارات متنوعة لحماية صحة ورفاهية الأفراد والمجموعات في شركتك. نحقق ذلك من خلال إدارة استثمارات احترافية توفر لك ولأفراد شركتك منتجات مختلفة وفرص لا حصر لها للاستفادة منها يوميًا.",
      list_title: "تأمينات الشركات",
      list: [
        {
          title: "وثيقة تأمين جماعي – حماية",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar",
        },
        {
          title: "وثيقة تأمين جماعي – ائتمان",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar",
        },
        {
          title: "وثيقة تأمين جماعي - استثمار",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar",
        },
        {
          title: "وثيقة تأمين جماعي - حوادث شخصية",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar",
        },
        {
          title: "وثيقة تأمين طبي جماعي",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar",
        },
        {
          title: "(SME’S) الشركات المتوسطة والصغيرة",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar",
        },
        {
          title: "وثيقة تأمين جماعي - حوادث شخصية اختياري",
          link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar",
        },
      ],
      for_details: "للمزيد من التفاصيل قم بزيارة",
      link: "https://sarwa.insurance/sarwa-Life/product/retail/?lang=ar#reqP",
      img: "/images/sarwaLife.png",
    },
    sarwa_insurance_individual: {
      logo: "/images/insurance-logo-ar.svg",
      title: "ثروة للتأمين",
      sub_title: "هنغير فكرتك عن الـتأمين",
      hyperlink: "موقع ثروة للتأمين",
      paragraph:
        "في ثروة هنغير فكرتك عن التأمين عن طريق بناء الثقة والشفافية في جميع أعمالنا والتي تمتد من تأمينات الأفراد الى تأمين الشركات. نسعى دائماً لتقديم خدمة متميزة ومتطورة تناسب احتياجات كل عميل حيث يقوم فريقنا من الخبراء بمساعدتك على فهم احتياجاتك التأمينية وإيجاد التغطية المناسبة لك مدعوماً بأحدث التكنولوجيا الرقمية لتصميم خطة تلبي احتياجاتك وتقديم الدعم وقتما تحتاج إليه. تؤمن ثروة للتأمين أن أصولك هي أهم ما لديك، ونحن هنا لمساعدتك على حمايتها من أي أحداث غير متوقعة مع تقديم عملية تأمين سريعة.",
      list_title: "تأمينات الأفراد",
      list: [
        {
          title: "تأمين السيارات.",
          link: "https://sarwa.insurance/sarwa-insurance/product/motorInsurance/?lang=ar",
        },
        {
          title: "تأمين المنزل.",
          link: "https://sarwa.insurance/sarwa-insurance/product/homeInsurance/?lang=ar",
        },
        {
          title: "تأمين الحوادث الشخصية ونمط الحياة.",
          link: "https://sarwa.insurance/sarwa-insurance/product/personalAccidents/?lang=ar",
        },
      ],
      for_details: "للمزيد من التفاصيل قم بزيارة",
      link: "https://sarwa.insurance/sarwa-insurance/product/retail/?lang=ar",
      img: "/images/sarwaInsurance.png",
    },
    sarwa_insurance_companies: {
      logo: "/images/insurance-logo-ar.svg",
      title: "ثروة للتأمين",
      sub_title: "نغير فكرتك عن الـتأمين",
      hyperlink: "موقع ثروة للتأمين",
      paragraph:
        "ثروة للتأمين، إحدى شركات التأمين الرائدة في مصر، تتطلع لتغيير النظرة المجتمعية تجاه التأمين من خلال تعزيز الثقة والالتزام بالشفافية في جميع خدماتنا التي تشمل خطط التأمين الفردية، وتأمين الشركات الصغيرة والمتوسطة والشركات متناهية الصغر، بالإضافة إلى حلول التأمين المؤسسي والتجاري في مصر.يحرص فريقنا من الخبراء على فهم احتياجاتك الفريدة وصياغة خطط تأمين مصممة خصيصًا لحماية أصولك وأعمالك وممتلكاتك بشكل فعال. نهتم ببناء علاقات دائمة مع شركائنا، ونضمن  تجربة تأمين سلسة تلبي كافة احتياجاتك من البداية إلى النهاية.",
      list_title: "تأمينات الشركات",
      list: [
        {
          title: "تأمين الممتلكات",
          link: "https://sarwa.insurance/sarwa-insurance/product/propertyInsurance/?lang=ar",
        },
        {
          title: "التأمينات الهندسية",
          link: "https://sarwa.insurance/sarwa-insurance/product/engineeringInsurance/?lang=ar",
        },
        {
          title: "تأمين أساطيل السيارات",
          link: "https://sarwa.insurance/sarwa-insurance/product/motorFleetInsurance/?lang=ar",
        },
        {
          title: "التأمين البحري والبري بضائع",
          link: "https://sarwa.insurance/sarwa-insurance/product/marineInsurance/?lang=ar",
        },
        {
          title: "تأمين المسؤوليات والتأمينات المالية",
          link: "https://sarwa.insurance/sarwa-insurance/product/publicLiabilityInsurance/?lang=ar",
        },
        {
          title: "تأمين طبي",
          link: "https://sarwa.insurance/sarwa-insurance/product/medicalInsurance/?lang=ar",
        },
      ],
      for_details: "للمزيد من التفاصيل قم بزيارة",
      link: "https://sarwa.insurance/sarwa-insurance/product/retail/?lang=ar",
      img: "/images/sarwaInsurance.png",
    },
  },
  referral_program: {
    title: "برنامج ترشيح العملاء",
    sub_title: "يمكنك ترشيح أصدقاءك والحصول على نقاط مجانية وخصومات حصرية",
    conditions: {
      title: "الشروط و الأحكام الخاصة بالبرنامج",
      conditions_list: [
        "لابد أن يكون من قام بالترشيح عميل مسجل لدى كونتكت",
        "لكي يستطيع عملاء كونتكت الحاليين الحصول على نقاط المكافآت لابد من أن يقوم العملاء الجدد بالقيام بعملية تعاقد على إحدى منتجات كونتكت",
        "لكونتكت تسوق وكونتكت تشطيب فقط لابد من العملاء المرشحين أن يقوموا بإتمام عملية شراء واحدة علي الاقل بعد الموافقة الائتمانية والتعاقد حتي يتمكن العملاء الحاليين الحصول على نقاط المكافآت تلقائياً",
        "يمكن لعملاء كونتكت الحاليين ترشيح معارفهم من خلال الموقع الإلكتروني، تطبيق كونتكت للموبايل، الاستمارات داخل الفروع، مراكز خدمة العملاء او من خلال منصات التواصل الاجتماعي الرسمية لكونتكت",
        "الحد الأقصى لعملاء كونتكت الحاليين ترشيح 10 عملاء جدد في الشهر الواحد",
      ],
    },
    program_benefits: "مميزات البرنامج",
    benefites_list: [
      "عملاء كونتكت الحاليين يتم مكافئتهم عن طريق الحصول علي نقاط المكافآت حيث يتم تحديد عدد النقاط طبقاً لمنتجات كونتكت المختلفة.",
      "يمكن استخدام نقاط المكافآت للشراء من شركاء برنامج المكافآت.",
      "يمكن استخدام النقاط في دفع الأقساط أو المصاريف الإدارية لكونتكت.",
    ],
  },
  jobs: {
    title: "وظائف",
    content:
      "مع النمو المستمر للشركة، نتطلع دائماً لإضافة المزيد من الكوادر البراقة لفريقنا الذي يضم أكثر من 2500 موظف. نتميز بمعدل مرتفع لاستمرارية موظفينا في العمل لفترات طويلة. حيث نؤمن بأهمية تنمية وتطوير كوادرنا البشرية من أجل تحقيق نمونا المنشود كأفراد وكفريق عمل وكمؤسسة. إن كنت ترغب في الانضمام إلينا يرجى ملء نموذج التقديم المرفق.",

    jobs_categories: [
      "الكل",
      "تكنولوجيا المعلومات",
      "التسويق",
      "المبيعات",
      "القطاع المالي",
    ],
  },
  application: {
    job_title: "مهندس برمجيات",
    job_desc:
      "نبحث عن مبرمج متميز للانضمام إلى فريقنا في تطوير وصيانة برامج الحاسوب. يجب أن يكون لديه خبرة سابقة في تطوير البرامج والتعامل مع لغات البرمجة المختلفة. سيعمل المبرمج في بيئة عمل مرنة ويجب أن يكون لديه القدرة على تحمل ضغط العمل والعمل بشكل فردي وفي فريق.",
    to_apply: "إن كنت ترغب في الانضمام إلينا يرجى ملء النموذج.",
    resume_upload: {
      title: "انقر أو اسحب الملف إلى هذه المنطقة للتحميل",
      sub_title:
        "دعم التحميل الفردي أو المجمع. يمنع منعا باتا تحميل بيانات الشركة أو ملفات الفرقة الأخرى",
    },
  },
  news: {
    title: "أخبارنا",
    minutes: " دقائق قراءة",
    read_more: "إقرأ المزيد",
    share: "شارك",
    news_list: [
      {
        id: 1,
        //  date: mm/dd/yyyy
        date: "04/03/2023",
        city: "القاهرة",
        title:
          "كونتكت المالية القابضة تغلق الإصدار الأربعون لسندات التوریق بقیمة 1,893 مليار جنيه لمحفظة التمويل الاستهلاكي المملوكة لشركاتها التابعة",
        urlTitle:
          "كونتكت المالية القابضة تغلق الإصدار الأربعون لسندات التوریق بقیمة 1,893 مليار جنيه لمحفظة التمويل الاستهلاكي المملوكة لشركاتها التابعة",

        subTitle: "",
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/defult-news-image.png",
        sections: [
          `أعلنت شركة كونتكت المالية القابضة، الشركة المصرية الرائدة في الخدمات المالية الغير مصرفية، عن إغلاقها للإصدار الأربعون لسندات التوريق المصدرة من شركة ثروة للتوريق، وذلك لمحفظة التمويل الاستهلاكي المحالة من شركتي كونتكت للتمويل  وكونتكت كريدي تك للتمويل الاستهلاكي وذلك بقيمة إجمالية للإصدار بلغت 1,893 مليار جنيه مقسمة على ٣ شرائح بآجال مختلفة تتراوح بين ١٣ وحتى60 شهر، ومن الجدير بالذكر أن هذا الإصدار يأتي الثاني ضمن برنامج إصدارات بحوالي ١٠ مليار جنيها مصريا  تعتزم الشركة إصدارها خلال الفترة  المقبلة  لتمويل شركاتها التابعة والشقيقة.`,
          `وتم تغطية الإصدار من قبل المستثمرين من المؤسسات مالية بنكية وغير بنكية، وهو ما يعكس المكانة التي تتمتع بها إصدارات سندات التوريق الخاصة بشركة ثروة للتوريق التي كان ولا يزال لها الريادة كونها أول وأكبر مصدر لسندات التوریق في لمختلف القطاعات بالسوق المصري وأكبر مصدر لأدوات سوق المال طويلة الأجل بمختلف أنواعها. `,
          `ويذكر أن شركة كونتكت المالية القابضة قد قامت بدور مدير الإصدار ومروج الاكتتاب وضامن التغطية، كما قام كل من بنك مصر والبنك الأهلي المصري والبنك التجاري الدولي – مصر والبنك العربي الأفريقي الدولي والأهلي فاروس لضمان وتغطية الاكتتابات  وسي آي كابيتال لترويج وتغطية الاكتتابات في الأوراق المالية بترويج وضمان التغطية  وقد قام مكتب علي الدين وشاحي (ALC) بدور المستشار القانوني لعملية التوریق. `,
          `وقد حازت الشرائح المكونة لهذا الإصدار من قبل شركة الشرق الأوسط للتصنيف الائتماني وخدمة المستثمرين  MERIS على تصنيف ائتماني AA+. و AA. وA ،وقد بلغت المحفظة الضامنة للإصدار حوالي 2,9 مليار جنيه مصري وحصلت على تصنيف ائتماني (A-) وهو أعلى تصنيف ائتماني لمحافظ تمويل استهلاكي ضامنة لسندات توريق في السوق المصري حتى الآن بما يعكس جودة محافظ المجموعة وتميزها.`,
          `وبهذا الإصدار وصلت قيمة الإصدارات التي صدرت في السوق المصري  بضمان محافظ محالة من مجموعة شركات كونتكت إلى ما يقرب من 22,6 مليار جنيه بعدد 24 إصدار. قد تم سداد ما يقرب من 18,9 مليار جنيها من قيمة تلك الإصدارات في مواعيدها بخلاف العوائد.`,
          ,
          `وعبر السيد سعيد زعتر ،الرئيس التنفيذي لشركة كونتكت المالية القابضة، عن فخره بالإصدار قائلاً "نحن سعداء وفخورون بقدرة كونتكت المالية القابضة على تنفيذ الإصدار وكذلك بإقبال المؤسسات المالية الكبيرة والبنوك المصرية على الاكتتاب في هذا الإصدار في هذه الظروف الحالية على الاقتصادين المصري والعالمي، والذي يؤكد ثقة المؤسسات المالية والمستثمرين في مجموعة كونتكت وشركاتها التابعة مثل ثروة للتوريق وكونتكت للتمويل على مدار اكثر من 20 سنة، وكما اعتدنا حاز الإصدار على التصنيف الائتماني الأعلى في مصر للسندات الغير سيادية ما يعكس ثقة مؤسسات التصنيف الائتماني في جودة وفعالية عمليات كونتكت التمويلية والائتمانية"`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 2,
        date: "06/25/2023",
        city: "القاهرة",
        title:
          "كونتكت المالية القابضة تغلق الإصدار الحادي والأربعون لسندات التوریق بقیمة 1,859 مليار جنيه لمحفظة التمويل الاستهلاكي المملوكة لشركاتها التابعة",
        urlTitle:
          "كونتكت المالية القابضة تغلق الإصدار الحادي والأربعون لسندات التوریق بقیمة 1,859 مليار جنيه لمحفظة التمويل الاستهلاكي المملوكة لشركاتها التابعة",

        subTitle: "",
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/mr%20said.jpg",
        sections: [
          `أعلنت شركة كونتكت المالية القابضة، الشركة المصرية الرائدة في الخدمات المالية غير مصرفية، عن إغلاقها للإصدار الحادي والأربعون لسندات التوريق المصدرة من شركة ثروة للتوريق، وذلك لمحفظة التمويل الاستهلاكي المحالة من شركة كونتكت للتمويل وشركاتها التابعة و الشقيقة وذلك بقيمة إجمالية للإصدار بلغت 1,859 مليار جنيه مقسمة على ٣ شرائح بآجال مختلفة تتراوح بين ١٣ وحتى 61 شهر، ومن الجدير بالذكر أن هذا الإصدار يأتي ضمن برنامج إصدارات بحوالي ١٠ مليار جنيها مصريا  تعتزم الشركة إصدارها خلال العام الحالي  لتمويل شركاتها التابعة والشقيقة.`,
          `وتم تغطية الإصدار من قبل المستثمرين من المؤسسات المالية المصرفية وغير المصرفية، وهو ما يعكس المكانة التي تتمتع بها إصدارات سندات التوريق الخاصة بشركة ثروة للتوريق التي كان ولا يزال لها الريادة كونها أول وأكبر مصدر لسندات التوریق في لمختلف القطاعات بالسوق المصري وأكبر مصدر لأدوات سوق المال طويلة الأجل بمختلف أنواعها. `,
          `  وقد بلغت المحفظة الضامنة للإصدار حوالي 3 مليار جنيه مصري وقد حازت تلك المحفظة على أحد أعلى التصنيفات الائتمانية لمحافظ التمويل الاستهلاكي الضامنة لسندات توريق في السوق المصري حتى الآن بما يعكس جودة محافظ المجموعة وتميزها AA+. وAA. وA على تصنيف ائتماني MERIS وقد حازت الشرائح المكونة لهذا الإصدار من قبل شركة الشرق الأوسط للتصنيف الائتماني وخدمة المستثمرين`,
          `وبهذا الإصدار وصلت قيمة الإصدارات التي صدرت في السوق المصري  بضمان محافظ محالة من مجموعة شركات كونتكت إلى ما يقرب من 	24.5 مليار جنيه بعدد 25 إصدار. قد تم سداد ما يقرب من 19.3 مليار جنيها من قيمة تلك الإصدارات في مواعيدها بخلاف العوائد.`,
          `وصرح السيد سعيد زعتر ،الرئيس التنفيذي لشركة كونتكت المالية القابضة، تعليقا على الإصدار قائلاً "منذ إصدار سندات التوريق الأول في مصر والذي قامت به كونتكت في 2005 ومازالت كونتكت في صدارة سوق سندات التوريق في مصر، فإن ثقة المستثمرين والقطاع المالي في سندات توريق وصكوك كونتكت وكذلك حصولنا على أعلى تصنيف ائتماني لمحافظ تمويل استهلاكي ضامنة لسندات توريق في السوق المصري يؤكدان على جودة المحافظ التمويلية لشركات كونتكت وكفاءة عملياتنا المستمرة منذ اكثر من 20 عاماً".`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 3,
        date: "02/19/2023",
        city: "القاهرة",
        title: `"كونتكت" توقع اتفاقية جديدة لدفع الفواتير من خلال "إي-خالص"`,
        urlTitle: `"كونتكت" توقع اتفاقية جديدة لدفع الفواتير من خلال "إي-خالص"`,

        subTitle: "",
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Contact%20and%20E%20khales.jpg",
        sections: [
          `   لدفع الأقساط الأمر الذي سهل على عملاء المجموعة عملية التحصيل ولتضيف وسيلة تحصيل جديدة بجانب التحصيل من خلال البنوك وكذلك نقاط بيع فوري ومصاري  (Contact Pay)  والذي تم إطلاقه في شهر يناير الماضي. وذكرت " كونتكت " في بيان لها أن توقيع هذه الاتفاقية يأتي استكمالاً للتطور التكنولوجي والتحول الرقمي الذي تقوم به مجموعة كونتكت المالية القابضة، حيث تم تأسيس شركة "كونتكت للمدفوعات الإلكترونية " لمواكبة التطور الحديث في كافة قطاعات التمويل، بعد أن بدأت "كونتكت " بتقديم خدمة كونتكت للمدفوعات الإلكترونية  Contact Now وقعت شركة كونتكت للمدفوعات الإلكترونية، إحدى شركات كونتكت المالية القابضة، اتفاقية شراكة مع منصة مدفوعات التجزئة الرقمية "إي-خالص  احدى شركات «إي فاينانس» لتكنولوجيا تشغيل المنشآت المالية لتقديم حلول المدفوعات الرقمية، وذلك لعملاء كونتكت في كل مكان وبموجب هذه الاتفاقية سيتمكن عملاء كونتكت من دفع كافة فواتيرهم الخدمية والاشتراكات الخاصة بهم من خلال الخدمات التي ستقدمها " إي-خالص " في كل فروع كونتكت وكذلك من خلال التطبيق الذكي `,
          ` وأضاف البيان أن شركة كونتكت المالية القابضة أطلقت خدمة كونتكت للمدفوعات الإلكترونية "أحد أساليب الدفع المبتكرة" لتوفير عدد كبير من خدمات الدفع بالشراكة مع شركة " إي- خالص " مثل دفع مصاريف المدارس والجامعات، فواتير المرافق، فواتير التليفون الأرضي، فواتير وشحن المحمول، اشتراك الإنترنت، تذاكر وسائل النقل، اشتراك القنوات التلفزيونية، الأقساط التأمينية والتبرعات الخيرية واشتراكات الأندية.`,
          ` .لتنافس كونتكت في توفير خدمات الدفع الإلكتروني المتطورة لكل المواطنين من خلال فروع كونتكت وذلك مع الحفاظ التام على سرية بيانات العملاء باستخدام أحدث التقنيات وأعلى معايير أمن البيانات المطبقة عالميا.`,
          `. ووصف السيد سعيد زعتر، الرئيس التنفيذي لشركة كونتكت المالية القابضة، هذه الشراكة بأنها المرحلة الجديدة لتنفيذ استراتيجية التحول الرقمي التي تم إطلاقها بالمجموعة عام 2020، والتي تستهدف رقمنة جميع المعاملات المالية والتمويلية للمجموعة، مؤكداً على ضرورة التركيز على السعي للتطور لمواكبة التحديات الحالية في عالم المال والتكنولوجيا، مشيراً إلي أن " كونتكت" تستطيع من خلال حجم عملائها الضخم و قدرات موظفيها اللامتناهية مواكبة التطور التكنولوجي`,
          `.ومن جانبه قال المهندس أحمد عبد الحكيم، العضو المنتدب لكونتكت للمدفوعات الإلكترونية أننا نعمل بكل جهد لتقديم كل جديد لعملائنا، ليستطيعوا سداد التزاماتهم الشهرية وجميع فواتيرهم من خلالنا، وعبر العضو المنتدب لكونتكت للمدفوعات الإلكترونية عن فخره بالتعاون مع "إي-خالص " صاحبة الباع الطويل في مجال التكنولوجيا المالية وإدارة المدفوعات وعلى وجه الخصوص الحكومية، واصفاً الاتفاقية بأنها ستحقق التعاون المطلوب لتقديم افضل خدمة لعملاء الشركتين `,
          ` .وقال السيد إبراهيم سرحان ،رئيس مجلس الإدارة والعضو المنتدب لاي فاينانس للاستثمارات المالية والرقمية، "إن المجموعة تفتخر بأنها مزود للمدفوعات الإلكترونية في مصر بما لديها من شبكات مدفوعات إلكترونية على مستوى الجمهورية لقطاعات عديدة وتخدم ملايين المتعاملين مع البنوك المصرية والبنك المركزي المصري والحكومة المصرية من بنية تحتية قوية قادرة على استيعاب كافة أنواع وأشكال المدفوعات الإلكترونية للقطاعين العام والخاص وبما يخدم جميع المواطنين في مختلف أنحاء الجمهورية لدعم التحول الرقمي ضمن رؤية مصر 2030، وبدعم رئيسي من مختلف شركاء النجاح في مجالات الدفع الإلكتروني، ولا سيما شركة كونتكت للمدفوعات الإلكترونية صاحبة التاريخ الكبير في المعاملات المالية`,
          ` .كما أكد السيد أحمد الطنطاوي، العضو المنتدب لشركة " إي خالص " لخدمات المدفوعات الرقمية، على أن التعاون مع شركة كونتكت للمدفوعات الإلكترونية سوف يمثل إضافة قوية لكلا الجانبين حيث يتيح لعملاء كونتكت قائمة كبيرة من الخدمات التي ستوفر الكثير من المزايا والخيارات الأقرب والأكثر سهولة لعملاء المدفوعات الإلكترونية من أي مكان مع توفير أعلى درجات الجودة والثقة لجميع المتعاملين، باعتبار شركة "إي خالص" هي المزود الوطني الأول لخدمات المدفوعات الإلكترونية في مصر`,
          ` PCI.والجدير بالذكر إن شركه كونتكت قامت بإطلاق خدمه كونتكت للمدفوعات الإلكترونية عام 2021 وتم التحصيل لصالح شركات كونتكت بنجاح من أقساط والانتهاء من إنشاء كامل البنية التحتية التكنولوجية مع كبري شركات الاستضافة في مصر والحاصلة على رخصة`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 4,
        date: "02/15/2023",
        city: "القاهرة",
        title: `زعتر: واثقون ومتفائلون بعام 2023`,
        urlTitle: `زعتر: واثقون ومتفائلون بعام 2023`,

        subTitle: `ارتفاع الدخل التشغيلي لقطاعي التمويل والتأمين بنسب سنوية ٣٣ و٤٤% على التوالي ليبلغ إجمالي ١,٦ مليار جنيه
          • نشاط التمويل: نمو إجمالي حجم التمويلات الجديدة بنسبة سنوية ٦١% إلى ١١,٤ مليار جنيه
    •	ارتفاع إجمالي الأقساط التأمينية بنسبة سنوية ٨٣% ليبلغ ٩٤٨ خلال ٢٠٢٢، ونمو صافي الأرباح لقطاع التأمين بمعدل سنوي٥٠% إلى ٥٤ مليون جنيه
    `,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Eraning%20release%20pic.jpg",
        sections: [
          `تعليق السيد/ سعيد زعتر -الرئيس التنفيذي لكونتكت المالية القابضة- على نتائج أعمال الشركة لعام 2022`,
          `بينما حققت الشركة صافي أرباح سنوية وصل إلى 511 مليون جنيه خلال عام 2022 بالمقارنة بـ 465 خلال عام 2021، فقد وصل صافي الربح المعدل إلى ٦٠٩ مليون جنيه بنسبة نمو سنوية 21% خلال عام 2022، وصافي الربح المعدل هو صافي الربح بعد استثناء تأثير المعيار المحاسبي الجديد الخاص بالإيجار والاستثمارات في التكنولوجيا وتأثير خصم المخصصات على ضريبة الدخل ومخصص الخسائر الائتمانية المحتملة وتأثير أحد المخصصات المتعلقة بأنشطة التأمين على الحياة. `,
          ` ".وعلّق السيد سعيد زعتر، الرئيس التنفيذي لكونتكت المالية القابضة، على أداء المجموعة في 2022 قائلاً: "أنا فخور بأدائنا في 2022 رغم الرياح المعاكسة ونحن واثقون ومتفائلون بعام 2023، فقدرة الأعمال على الاستمرارية والمناورة في الأوقات العصيبة هي المقياس الحقيقي لصحة ووضوح رؤيتها وحسن إدارتها `,
          ,
          `نشاط التمويل: نمو إجمالي حجم التمويلات الجديدة بنسبة سنوية ٦١% إلى ١١,٤ مليار جنيه
    وكان هذا النمو الكبير مدعوماً بالأداء القوي لمنتجات التمويل الاستهلاكي وتمويل رأس المال العامل (التخصيم) وتمويل شاحنات النقل والتمويل العقاري. ونتج عن ذلك ارتفاع الدخل التشغيلي للقطاع بمعدل سنوي 33% ليسجل 1.4 مليار جنيه خلال عام 2022، وتعليقاً على هذا قال السيد سعيد زعتر "إن الأداء المميز لقطاع التمويل هو نتيجة دراسة مستمرة للسوق واستخدام احدث وسائل تحليل البيانات والذي قادنا لتطوير منتجات جديدة على الدوام مثل منتج التمويل الأخضر وتمويل التعليم والأثاث على صعيد التمويل الاستهلاكي، وأيضا تطوير حلول مالية مبتكرة لتساعد في تمويل رأس المال العامل مثل تعاون شركة التخصيم مع "توثبيك" لخدمة أطباء الأسنان أو مع "وان أوردر" لخدمة قطاع الأغذية والمشروبات، وكل هذا لم يكن ممكنا لولا أيماننا بكفاءات أبناء المجموعة واستثمارنا في رأس المال البشري منذ البداية
    `,
          `ارتفاع الدخل التشغيلي لقطاعي التمويل والتأمين بنسب سنوية ٣٣ و٤٤% على التوالي ليبلغ إجمالي ١,٦ مليار جنيه 
    وأضاف زعتر في تعليقه على ارتفاع الدخل التشغيلي لقطاعي التمويل والتأمين بنسب سنوية ٣٣ و٤٤% على التوالي ليبلغ إجمالي ١,٦ مليار جنيه: "إن كونتكت تقدم حلول مالية وتأمينية متنوعة وكبيرة تلبي الاحتياجات المالية لمختلف للأفراد من مختلف الطبقات وكذلك الأنشطة الإنتاجية، فتضم محفظة كونتكت أنماط مختلفة من التمويل الغير مصرفي مثل التمويل الاستهلاكي والتمويل العقاري والتأجير التمويلي والتخصيم بجانب منتجات التأمين المتنوعة والني تنمح العميل الطمأنينة والثقة في اتخاذ خياراته المستقبلية وبتعدد منتجات كونتكت يتوفر للعميل الحرية المالية مما يؤكد على ريادة كونتكت في مجال الخدمات المالية غير المصرفية في مصر".
    `,
          `ارتفاع إجمالي الأقساط التأمينية بنسبة سنوية ٨٣% ليبلغ ٩٤٨ خلال ٢٠٢٢، نمو صافي الأرباح لقطاع التأمين بمعدل سنوي ٥٠% إلى ٥٤ مليون جنيه
    أما في نشاط التامين الحديث نسبيا في المجموعة، فقد حققت شركتا ثروة للتأمين وثروة لتأمينات الحياة أداءً باهراً بارتفاع إجمالي أقساط الشركتين بنسبة سنوية ٨٣% ليبلغ  ٩٤٨ مليون جنيه خلال ٢٠٢٢ وصافي ربح 54 مليون جنيه بزيادة 50% عن العام السابق، ومشيرا إلى سعادته بأداء قطاع التأمين بالمجموعة قال زعتر: "أظهرت شركتا التأمين التابعتان للمجموعة قدرة عالية على مواكبة التحديات التي يشهدها السوق والمنافسة بقوة وثبات بمواجهة شركات عالمية ومحلية عريقة في المجال عن طريق ابتكار منتجات متطورة تواكب احتياجات السوق، فتنوعت الوثائق التي تقدمها الشركتان لتغطي التأمين الفردي والجماعي واستثمرنا في تغيير المفهوم السائد عن التأمين ونشر الوعي بثقافة التأمين لأنها ما زالت غير منتشرة بمصر، وتتنوع الوثائق التي تقدمها الشركتان مثل: حماية المسكن والتأمين على المشروعات الصغيرة والتأمين الطبي وتأمينات الحياة ووثيقة ثروة للاستثمار في أدوات الدخل الثابت فهذا الصندوق يهدف بصفه خاصه إلى تقديم وعاء ادخاري واستثماري يوفر السيولة النقدية اليومية عن طريق احتساب عائد يومي تراكمي على الأموال المستثمرة فيه يتم إضافته في حساب العميل".
    `,
        ],

        bodyImages: ["", "", ""],
      },
      {
        id: 5,
        date: "05/29/2023",
        city: "القاهرة",
        title: `كونتكت المالية تعلن نتائج أعمالها لفترة الربع الأول من عام 2023`,
        urlTitle: `كونتكت المالية تعلن نتائج أعمالها لفترة الربع الأول من عام 2023`,

        subTitle:
          "الشركة تنجح في بدء عام 2023 بتحقيق نتائج مالية وتشغيلية قوية، مستفيدةً من إنجازاتها المحققة خلال العام السابق",
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/defult-news-image.png",
        sections: [
          `أعلنت اليوم شركة كونتكت المالية القابضة ش.م.م. (كود البورصة المصرية CNFN.CA)، أكبر مقدم للخدمات المالية غير المصرفية في مصر، عن نتائج الأعمال المجمعة للعام المالي المنتهي في 31 مارس 2023، حيث ارتفع الدخل التشغيلي لقطاعي التمويل والتأمين بنسب سنوية 28% و43% على التوالي. وانخفض صافي أرباح قطاع التمويل بنسبة سنوية 14% خلال الربع الأول من العام الجاري، بينما ارتفع صافي ربح قطاع التأمين بمعدل سنوي 35% خلال نفس الفترة. وقد ارتفع صافي الربح المعدل  بنسبة سنوية 3% ليسجل 178 مليون جنيه خلال الربع الأول من عام 2023.`,
          ,
          {
            img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/contact-earning.png",
          },
          `فعلى صعيد نشاط التمويل، شهدت الشركة نمو إجمالي حجم التمويلات الجديدة بنسبة سنوية 66% إلى 4.1 مليار جنيه خلال الربع الأول من عام 2023، مدعومًا بالأداء القوي لمنتجات التمويل الاستهلاكي وتمويل السيارات وشاحنات النقل وتمويل رأس المال العامل. ونتج عن ذلك ارتفاع الدخل التشغيلي للقطاع بمعدل سنوي 28% ليسجل 462 مليون جنيه خلال الربع الأول من عام 2023، في حين انخفض صافي أرباح القطاع بنسبة سنوية 14% ليسجل 121 مليون جنيه خلال الربع الأول من عام 2023 على خلفية زيادة المخصصات التي سجلتها الشركة للتحوط من مخاطر الائتمان الناتجة عن اضطراب الأوضاع الاقتصادية الحالية. وعلى صعيد قطاع التأمين، ارتفع إجمالي الأقساط التأمينية بنسبة سنوية 73% ليبلغ 437 مليون جنيه خلال الربع الأول من عام 2023 بفضل النتائج القوية التي حققتها شركتيّ ثروة حياة وثروة للتأمين. وارتفاع الدخل التشغيلي للقطاع بنسبة سنوية 43% إلى 81 مليون جنيه خلال الربع الأول من العام الجاري، مما أثمر عن نمو صافي ربح القطاع بمعدل سنوي 35% إلى 25 مليون جنيه خلال نفس الفترة.`,
          ,
          `وفي هذا السياق، أعربت الإدارة عن اعتزازها بالنتائج المالية والتشغيلية المحققة خلال الربع الأول من عام 2023، والتي هيأت الشركة لتحقيق مزيد من النمو خلال بقية العام. فقد تمكنت الإدارة من استكمال مسيرتها الناجحة خلال عام 2022 بمواصلة تنمية أعمال قطاعي التمويل والتأمين، بالإضافة إلى المضي قدمًا في تنفيذ استراتيجية النمو وتعظيم القيمة التي تتبناها على المدى البعيد. وقد تمكنت الإدارة من تحقيق تلك النتائج القوية وسط العديد من التحديات الاقتصادية المحلية والعالمية بفضل مرونة الشركة وكفاءة استراتيجيات الاستثمار وخفض المخاطر التي تتبناها`,
          ,
          `تعكس النتائج التي حققتها الشركة نمو سوقيّ تمويل السيارات وشاحنات النقل بالتزامن مع بدء تعافي تلك الأسواق بعد تخفيف القيود المفروضة على الاستيراد في بداية العام. كما شهد قطاع التمويل الاستهلاكي نموًا ملحوظًا بفضل التوسع بشبكة المتاجر التابعة والشرائح الاستهلاكية التي تقوم بخدمتها مع إطلاق منتجات جديدة. وعلى صعيد شبكة المتاجر التابعة، يسر الشركة أن تعلن الدخول في عدد من الشراكات الاستراتيجية مع مجموعة من العلامات التجارية الكبرى منذ بداية العام. كما واصلت الإدارة اهتمامها بتطبيق "ContactNow" الذي تم إطلاقه مؤخرًا، حيث مثل التطبيق 15% من حجم التمويلات الجديدة التي تم تقديمها عبر شركة "Contact Creditech". جدير بالذكر أن عدد تحميلات التطبيق تضاعفت بواقع خمس مرات خلال الربع الأول من عام 2023، وهو ما مكن للشركة من التوسع بقاعدة عملاءها وزيادة مشاركتهم والحفاظ على عملائها، فضلًا عن إتاحة تجربة استخدام تلائم احتياجات جميع العملاء الجدد والحاليين. وعلى مستوى قطاع التأمين، فقد واصلت الشركة تحقيق معدلات نمو قوية، مدعومةً بزيادة تواجدها في السوق ونمو المبيعات بين عملاء مختلف قطاعات الشركة، فضلاً عن المنتجات الجديدة التي تم إطلاقها خلال العام الماضي.`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 7,
        date: "08/22/2023",
        city: "القاهرة",
        title: `كونتكت تشارك في معرض أجري بيزنس ومهرجان العلمين لدعم التنمية المستدامة والابتكار`,
        urlTitle: `كونتكت تشارك في معرض أجري بيزنس ومهرجان العلمين لدعم التنمية المستدامة والابتكار`,

        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/b67aa5ea-da3c-41be-86f4-a5edd3d4580f.jpg",
        sections: [
          `شاركت مجموعة كونتكت المالية، الرائدة في مجال الخدمات المالية غير المصرفية، في فعاليات بطولة مصر الدولية لرياضة المحركات في مدينة العلمين والتي استمرت لمدة أربعة أيام من 17 إلى 20 أغسطس كجزء من مهرجان العلمين 2023. والذي يعد من أبرز الأحداث الترفيهية في الشرق الأوسط، حيث يجمع بين الفعاليات الترفيهية والرياضية ليقدم تجربة صيفية استثنائية على ساحل البحر الأبيض المتوسط.`,
          `بالإضافة إلى ذلك، شاركت كونتكت المالية في معرض "اجري بيزنس"، الذي أقيم في مركز القاهرة الدولي للمؤتمرات والمعارض في مدينة نصر ، وهو أول معرض مصري يهتم بالزراعة والري والطاقة الشمسية، وتُعد هذه المشاركة جزءًا من جهود كونتكت في دعم التنمية وتعزيز الاقتصاد القومي.`,
          `وأكد السيد سعيد زعتر، الرئيس التنفيذي لمجموعة كونتكت المالية، على أهمية هذه الفعالية كفرصة ثمينة لتوسيع شبكة العلاقات التجارية وتعزيز التواصل مع الأطراف المعنية، مما يعكس رؤية مجموعة كونتكت المالية للتنمية المستدامة والابتكار. فالشركة تتفانى في تقديم حلول مستدامة وفعّالة في مجالات توليد الطاقة النظيفة والزراعة عبر منتج التمويل الأخضر الذي تقدمه كونتكت، بالإضافة إلى دعم جهود المجتمع العلمي والصناعي لتحقيق توازن مثمر بين الاستدامة البيئية والتنمية الاقتصادية.`,

          `وتعليقا على مشاركة كونتكت في مهرجات العلمين قال السيد سعيد زعتر "إننا نشعر بسعادة كبيرة للمشاركة في بطولة مصر الدولية لرياضة المحركات 2023 في مدينة العلمين، والتي كانت جزءًا من فعاليات مهرجان العلمين ذا النجاح المبهر والمستقبل الواعد. فنحن في كونتكت لنا علاقة مميزة مع رياضة المحركات تمتد عبر العقود، حيث قمنا بتمويل وتأمين السيارات لأكثر من 20 عامًا، وكان لنا دور كبير في دعم عشاق هذه الرياضة. فهذا الحدث لم يكن مجرد تجربة رياضية، بل كانت فرصة لنا للتواصل مع الجمهور والتفاعل معهم بشكل مباشر. ونحن فخورون بأننا شاركنا في هذا الجو المليء بالحماس".`,
          `ثم أضاف "وكما تطورت رياضة المحركات، تطورت خدماتنا أيضًا. فنحن نسعى لتلبية احتياجات عملائنا بأفضل طريقة ممكنة، ولهذا قمنا بتوسيع نطاق تمويل السيارات ليشمل الآن تمويل صيانة السيارات وتعديلاتها، ذلك بخلاف منتجاتنا الجديدة مثل تمويل الدراجات النارية وتمويل المركبات المائية، وهذا يمنح عشاق رياضات المحركات والسرعة فرصة جديدة لتحقيق أحلامهم. ونحن نتطلع إلى المزيد من التعاون والمشاركة في فعاليات مثل هذه في المستقبل."`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 8,
        date: "03/07/2023",
        city: "القاهرة",
        title:
          '"كونتكت" و"بهية" يوقعان بروتوكول تعاون لدعم محاربات سرطان الثدي "كونتكت" تدعم محاربات سرطان الثدي من خلال "مؤسسة بهية" إيمانا بمسؤوليتها الاجتماعية: "كونتكت" توقع بروتوكول تعاون مع "مؤسسة بهية"',
        urlTitle:
          '"كونتكت" و"بهية" يوقعان بروتوكول تعاون لدعم محاربات سرطان الثدي "كونتكت" تدعم محاربات سرطان الثدي من خلال "مؤسسة بهية" إيمانا بمسؤوليتها الاجتماعية: "كونتكت" توقع بروتوكول تعاون مع "مؤسسة بهية"',
        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/%D8%A8%D9%87%D9%8A%D8%A9.jpg",
        sections: [
          `وقعت شركة كونتكت المالية القابضة بروتوكول تعاون مع مؤسسة بهية للاكتشاف المبكر وعلاج سرطان الثدي بالمجان، جاء ذلك في إطار الاهتمام بالمسئولية الاجتماعية ودعم المرأة، لتقديم خدمة أفضل لكل سيدة مصرية مصابة بسرطان الثدي وتقديم الدعم المادي والمعنوي والوصول إلى أعلي درجات التشجيع لمحاربات بهية ولتقديم ندوات التوعية وتقديم خدمة الكشف المبكر للموظفات. `,
          `وعلى هامش فعاليات توقيع البروتوكول، صرحت الدكتورة هايدي المصري، نائب مدير قطاع الموارد البشرية والتطوير المؤسسي بشركة كونتكت المالية القابضة، قائلة: "نحن سعداء باستمرار دعمنا لمستشفى بهية لمتابعة مسيرتها في علاج الآلاف من السيدات بالمجان، وطمأنة الآلاف منهن على صحتهن."`,
          `وأضافت: "إن هذا البروتوكول الجديد يأتي ضمن مبادرات شركة كونتكت في تعزيز مجالات المسئولية المجتمعية التي تنصب في صالح مجتمعنا المصري ليحظى بحياة أفضل، وتتمحور مساهمتنا هذه المرة لدعم أمهاتنا وسيدات مصر، وحرصا منا أيضا على صحة الموظفات لدي الشركة ومساعدتهم لحماية أنفسهم من أي مرض و مساندتهم للكشف المبكر و التوعية بأهمية ذلك علي صحتهن."`,
          `وأعربت الدكتورة جيلان أحمد، المدير التنفيذي لمؤسسة بهية، عن بالغ سعادتها واعتزازها بوجود شركات مصرية رائدة مثل شركة كونتكت تهتم بالعمل المجتمعي وتضعه على قائمة أولوياتها، لدعم الحياة الكريمة للمواطن المصري في مختلف المجالات خاصة بصحة المرأة المصرية ومحاربة سرطان الثدي،`,
          ` وأضافت، "إننا في مستشفى بهية نعتز بما نقوم به من دور كبير في دعم صحة المرأة المصرية، والكشف المبكر وعلاج سرطان الثدي بالمجان وفقًا لأفضل المستويات العالمية."`,
          `وأشاد السيد سعيد زعتر، الرئيس التنفيذي لشركة كونتكت المالية القابضة، بجهود مؤسسة بهية في دعم المرأة و مساندتها و الحفاظ علي صحتهن من الأمراض، فلعبت المرأة دورًا رئيسيًا في المساهمة والتأثير في مجتمعنا على المستويين الاقتصادي والاجتماعي، وتبلغ نسبة القيادة النسائية في كونتكت 25% من إجمالي المجلس التنفيذي، وتتنوع مناصبهن من رئيس مجلس إدارة وعضو منتدب إلى مديرين تنفيذيين وأعضاء معينين للمديرين التنفيذيين ومديري إدارات في مختلف الشركات والقطاعات التابعة للمجموعة، ،يأتي ذلك إيمانا من كونتكت بدور المرأة و أهميته في المجتمع وبمساهمة المرأة في التنمية المستدامة، تقدر الشركة دور المرأة بشكل كبير ولدعم ذلك اتخذت الشركة خطوه ايجابيه من خطوات المسئولية الاجتماعية، بتوقيع هذا البروتوكول مع مؤسسه بهيه، حرصا منا على سلامه وصحة المرأة كونها أحد الأعمدة الرئيسية في الوطن.`,
          ``,
          ``,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 9,
        date: "01/22/2023",
        city: "القاهرة",
        title: `شراكة بين "جوميا باي" و"كونتكت كريدي تك" لإطلاق خدمات مالية جديدة في مجال الخدمات المالية في مصر.`,
        urlTitle: `شراكة بين "جوميا باي" و"كونتكت كريدي تك" لإطلاق خدمات مالية جديدة في مجال الخدمات المالية في مصر.`,
        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Ahmed%20Samir%20Kamel.jpg",
        sections: [
          `أعلنت كل من جوميا، منصة التجارة الإلكترونية الرائدة في إفريقيا، وجوميا باى عن توقيع مذكرة تفاهم مشتركة مع كونتكت كريدي تك - ذراع التمويل الاستهلاكي الرقمي التابع لمجموعة كونتكت المالية – ، لإطلاق خدمات جديدة في مجال الخدمات المالية وخاصة التمويل الاستهلاكي على منصات جوميا المختلفة.`,
          `وتتيح هذه الشراكة لـ "جوميا" توفير طرق دفع مختلفة لتسهيل عملية الشراء وخلق حلول مالية متنوعة لعملاء جوميا وكونتكت ، حيث تولي مجموعة كونتكت بصفة عامة وكونتكت كريدي تك على وجه الخصوص اهتماما كبيرا بالتحول الرقمي وفقا لرؤية الدولة المصرية 2030  والسعي نحو توسيع قاعدة الخدمات الرقمية المقدمة للسوق المصرية واستخدام أحدث التقنيات في مجال التكنولوجيا المالية.`,
          `وأشار السيد أحمد سمير كامل ،العضو المنتدب لـكونتكت كريدي تك إلى أن  الشركة تسعى دائما نحو إيجاد حلول تمويلية مبتكرة تنفرد بها  كونتكت وتكون نابعة من دراسة جيدة لاحتياجات العميل المالية لتمكنه من تقسيط احتياجاته لمواكبة نمط الحياة العصري دون زيادة في الأعباء المالية على موارده مشيراً إلي أن هذه الشراكة سنتيح لجميع عملاء جوميا حلول مالية تهدف إلى تمكين العملاء من استكمال عملية الشراء بكل سهولة من خلال أحدث الحلول التكنولوجية في مجال التمويل الاستهلاكي مما سيساعد على زيادة القوة الشرائية.`,
          `"أننا نفخر بريادتنا في السوق المصرية حيث تسعى جوميا وجوميا باي دائما لتقديم خدمات غير مسبوقة لعملائها سواء الحاليين أو الجدد ومن خلال شراكتنا الاستراتيجية مع شركة كونتكت كريدي تك ستساعد عملائنا على تجربة جديدة للشراء بشكل أفضل ، خاصة  وأن خدمات كونتكت التمويلية ستكون متاحة لجميع عملاء جوميا والذين لا يشترط أن يكونوا عملاء سابقين لدى كونتكت ، مشيرا إلي أن جوميا تسعى دائما لتلبية كل احتياجات عملائها من منصة واحدة وكان من الضروري تطوير الخدمات المتاحة طوال الوقت لضمان تجربة فريدة للعملاء لذلك جاءت اتفاقيتنا اليوم مع كونتكت" JumiaPay   ومن جانبه صرح السيد / عبد اللطيف عُلما، نائب رئيس   `,
          `ومن جانبه قال سعيد زعتر، الرئيس التنفيذي لكونتكت المالية القابضة، أن الشراكة مع جوميا وجوميا باي جاءت تحت عنوان وهو أن العميل أولاً، مشيراً إلي أنه من خلال هذه الشراكة سيتم تلبية احتياجات مستخدمي المنصة سواء من المتعاملين مع المنظومة البنكية أو من ليس لديهم تعامل مع البنوك  .`,
          `وكشف زعتر ، عن أن أهم ما يميز كونتكت هو السرعة في الاستجابة لكل ما يخص احتياجات العميل المالية وإتاحة الخدمات بطرق بسيطة مما يسهم في تيسير حركة العمل وخدمة العميل على أكمل وجه ويأتي هذا من خبرتنا الواسعة في مجال التمويل في مصر التي بدأت منذ أكثر من 20 سنة ".`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 10,
        date: "03/27/2023",
        city: "القاهرة",
        title: `"في يومها العالمي: كونتكت تدعم المرأة باحتفالية مختلفة"`,
        urlTitle: `"في يومها العالمي: كونتكت تدعم المرأة باحتفالية مختلفة"`,
        subTitle: `وزعتر يعلق: اهتمامنا بالمرأة هو جزء من استراتيجيتنا فهي تشكل عمود هام تستند علية المجموعة
    " المساواة بين الجنسين اليوم من أجل غد مستدام: شعار جديد ترفعه كونتكت في يوم المرأة المصرية"
    `,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/defult-news-image.png",
        sections: [
          `نظمت شركة كونتكت المالية القابضة – الرائدة في مجال الخدمات غير المصرفية – احتفالية بيوم المرأة العالمي، تقديرا للإنجازات الني تقوم بها سيدات كونتكت وتحقيق اهدافهن وأهداف الشركة، وجاءت هذه الاحتفالية بمثابة شكر لكل سيدة في المجموعة قامت ببذل مجهود واستطاعت ان تصل لمكانة كبيرة في الشركة واثبات ذاتها وسط العديد من المسئوليات التي تنطوي تحت كل سيدة، بالإضافة الي انه تقديرا لكل امرأة عاملة ورسالة هامة على أهمية المرأة في المجتمع وأنها من أهم عناصر الحياة.`,
          `ونحن في مارس «شهر المرأة»، حيث الاحتفال في مارس بـ«يوم المرأة المصرية»، و بـ«عيد الأم»، تبقى المرأة المصرية نموذجا متفردا في العطاء والنجاح، وأيقونة في التحدي والصمود وإثبات الذات. فقامت كونتكت بالاحتفال على طريقتها الخاصة، فقامت الشركة بعمل احتفالية، وقام بالانضمام 70 سيدة من سيدات كونتكت، وقاموا بأنشطة متعددة ومن ضمن هذه الأنشطة تكريم الشركة ل أ/ هديل ماجد، وهي مغنية من ذوي الهمم التي قامت بالعديد من المشاركات الفنية في الغناء والتمثيل في عروض مختلفة، و تضمن الاحتفال أيضا مؤسسة خيرية، حيث انضمت مؤسسة "كاريزما أرتس" الخيرية للمشاركة، فهي مؤسسة خيرية غير هادفة للربح حاصلة علي تقديرات دولية مشهرة تحت وزارة التضامن الاجتماعي، تسعي الي النهوض بالمجتمع و ذلك باستخدام الفن و المبادرات الانسانية، وهدف الانضمام هو تشجيع المرأة العاملة و بيع منتجات مثل: الاكسسوارات، حقائب و أدوات مطابخ و غيرهم، ليكون الربح من نصيب الأسر العاملة البسيطة و السيدات العاملات و أصحاب الصناعات اليدوية منهن.`,
          `وعلي هامش الاحتفال قالت الدكتورة هايدي المصري، رئيس قطاع الموارد البشرية والتطوير المؤسسي بالمجموعة، ان المجموعة تقوم بتقدير المرأة وتشجيعها بشكل كبير وذلك أستطيع لمسة بسبب انني امرأة عاملة في تلك المؤسسة، ونحن نريد النهوض بفكر المجتمع من جانب المرأة من خلال تقديرها وتشجيعها، فالشركة تضمن أكثر من 25% من الإدارات والمجلس التنفيذي ومختلف المجالات من السيدات، و ذلك يعكس ثقة و اهتمام المجموعة بالمرأة العاملة`,
          `كما أضافت قائلة، "لن نستطيع المضي قدمًا نحو تحقيق السلام والازدهار للجميع إلا بالحد من أوجه عدم المساواة، التي تشمل الإجحاف القائم على النوع الاجتماعي. وتمكين النساء والفتيات هو الضمانة لمستقبل أفضل وأكثر استدامة".`,
          `كما قال السيد سعيد زعتر، الرئيس التنفيذي لمجموعة كونتكت المالية، تدعو رؤيتنا 2023 أن المرأة هي عمود الفقري الذي يستند اليه المجموعة، وأن نتقدُّم لبلوغ أهداف التنمية المستدامة المتعلقة بالتطور المؤسسي، فمن دون مشاركة قوية للمرأة في المجالات الاقتصادية والسياسية والعامة، سيظل العالم بعيدًا عن تحقيق أهدافه، وينبغي أن تسير الاستدامة والجهود المبذولة لتحقيق المساواة بين الجنسين جنبًا إلى جنب، فالنمو الاقتصادي والتنمية يعتمدان اعتمادًا حاسمًا على تمكين النساء والفتيات، و أن للعنصر النسائي دورا هاما في المجموعة تقوم به علي أكمل وجه و دليلا علي ذلك بلوغ الكثير من السيدات و الفتيات الي مناصب متعددة بكونتكت في مختلف المجالات.`,
          ``,
          ``,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 11,
        date: "07/09/2023",
        city: "القاهرة",
        title: `Fintech لأول مرة في سوق التمويل الاستهلاكي ومجال ال`,
        urlTitle: `Fintech لأول مرة في سوق التمويل الاستهلاكي ومجال ال`,
        subTitle: `لإتاحة حد ائتماني فوري للعملاء Lending as a Service إتفاقية تعاون بين  "كونتكت "و"تيلدا " بهدف تقديم `,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Ahmed%20El%20sabbah%20CEO%20Telda.jpg",
        sections: [
          `أعلنت شركتا "كونتكت كريدي تك"، ذراع التمويل الاستهلاكي الرقمي التابع لمجموعة " كونتكت المالية القابضة"  ، وشركة " تيلدا" ؛ عن إبرام اتفاقية تعاون ينفرد فيها الطرفان بتقديم خدمات التمويل الاستهلاكي لكل عملاء" تيلدا" .`,
          ` والتي تستهدف تمكين عملاء " تيلدا "  من التقديم والتعاقد على خدمة التمويل الاستهلاكي لشركة "كونتكت" وذلك لخدمه اكبر قاعدة من عملاء " تيلدا " هذا بالإضافة لإتاحة الخدمة المعتادة للعملاء الحاليين لشركة "كونتكت" وذلك للاستفادة من تمويل مشترياتهم التي تتم بالبطاقة وسدادها على أقساط حتى 60 شهراً مما يزيد من القوة الشرائية ويتيح إمكانية التحكم في ميزانية المصروفات Lending-as-a-Service وقالت " كونتكت " في بيان لها اليوم أن الإتفاقية شملت التعاون على تقديم خدمات مختلفة ولم تقتصر علي التقسيط فقط حيث سيتم إتاحة خدمة `,
          `وأوضح أحمد سمير كامل، العضو المنتدب لشركة "كونتكت كريدي تك " ، أن حجر الأساس هو  إعتمادنا دائما على التحول الرقمي واستخدام أحدث التقنيات في تصميم الحلول التمويلية المبتكرة. `,
          `وتطبيقات مختلفة لدى الشركاء الاستراتيجيين الذىن نتعاون معهم use cases في سوق التمويل الاستهلاكي لضمان شمول اكبر قاعدة من شرائح العملاء المختلفة بالإضافة إلي خدمة  Lending-as-a-Service ووصف سمير ؛ توقيع عقد الشراكة مع "تيلدا " بأنه خطوة أخرى في تقديم أحدث الخدمات التمويلية الاستثنائية، مشيراً إلي تفرد " كونتكت" بتقديم خدمة`,
          `وأضاف العضو المنتدب  لشركة " كونتكت كريدي تك " : أنه من الطبيعي إتاحة "كونتكت"  وغيرها كوسيلة تقسيط لدى الشركاء ولكن الانفراد الحقيقي هو كيفية خدمة جميع العملاء سواء كان لديهم حد ائتماني أم لا. `,
          `لخلق قيمة مضافة لكل من العملاء وشركائنا LaaS  وتابع سمير : بخبرتنا الواسعة في هذا المجال وحرصنا على تقديم كل ما هو مبتكر ومختلف نجحنا في تسخير الخدمات التمويلية الحديثة مثل `,
          `ومن جانبه قال احمد الصباح، الرئيس التنفيذي لشركة 'تيلدا " سعداء بالتعاون مع "كونتكت" لتقديم حلول التمويل الاستهلاكي لعملائنا ؛ حيث يتيح لنا هذا التعاون اطلاق نظام الموافقات الفورية وفترات تقسيط مختلفة حتى 60 شهر لعملاء شركتنا مما يمنحهم القدرة على زيادة قوتهم الشرائية وإدارة مصاريفهم. موضحاً أن هذه الشراكة تتماشي مع مهمتنا حيث أننا في "تيلدا' ملتزمون بالابتكار وتقديم حلول مالية قيمة لعملائنا.`,
          `وأعرب سعيد زعتر الرئيس التنفيذي والعضو المنتدب لمجموعة "كونتكت المالية القابضة " عن فخره بأستمرار شركات المجموعة في تحقيق الإنجازات الواحدة تلو الأخرى.`,

          ` وقال زعتر : سنظل نستخدم خبرتنا الواسعة في مجال التمويل الإستهلاكي لسد الثغرات وتقديم أفضل المنتجات والخدمات التي يحتاجها المستهلك. `,
          ` هو أكبر دليل علي أن تركيزنا يتجه إلي توفير حلول تمويلية مبتكرة لا يوفرها أي لاعب أخر في سوق التمويل الإستهلاكي  Lending-as-a-Service وأكد الرئيس التنفيذي لمجموعة " كونتكت المالية القابضة " ؛ علي أنه من خلال التعاون مع شركة  " تيلدا " سيتم توسيع نطاق خدماتنا إلى قاعدة عملاء شركائنا باستخدام أحدث التقنيات،لما لنا من ريادة في سوق التمويل الإستهلاكي مضيفاً: أن انفرادنا بتقديم `,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 12,
        date: "01/10/2023",
        city: "القاهرة",
        title: `كونتكت تطلق منصة ContactNow الرقمية ذات خدمات متعددة الأوجه محققة انطلاقة جديدة في عالم تكنولوجيا الأسواق المالية.`,
        urlTitle: `كونتكت تطلق منصة ContactNow الرقمية ذات خدمات متعددة الأوجه محققة انطلاقة جديدة في عالم تكنولوجيا الأسواق المالية.`,
        subTitle: `انطلاقة جديدة في عالم تكنولوجيا الأسواق المالية: كونتكت تطلق منصة ContactNow الرقمية بخدمات متعددة الأوجه `,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/12.jpeg",
        sections: [
          `أطلقت شركة كونتكت كريدي تك، الذراع الرقمي للتمويل الاستهلاكي التابع لمجموعة كونتكت المالية، منصة ContactNow الرقمية التي تعد أول تطبيق مالي شامل في الأسواق المالية يتيح تجربة مختلفة للعملاء من حيث التصميم وخطوات الاستخدام ويوفر خدمات عديدة تلبي احتياجات العميل داخل وخارج مصر. وتعد الأول من نوعها في سوق التمويل الاستهلاكي التي توفر جميع الاحتياجات المالية  لتلبية متطلبات مراحل الحياة المختلفة، وبوابة مجموعة كونتكت المالية القابضة التي تقدم من خلالها جميع خدماتها المالية عبر نافذة واحدة.`,
          `ويتضمن التطبيق التقديم على حد ائتماني لحظي من خلال خطوات محددة والاعتماد على برامج الذكاء الاصطناعي لتحديد القدرة الائتمانية مع استخدام I-Score وسجل الأحوال المدنية في نفس الوقت من خلال الربط التكنولوجي، مع الأخذ في الاعتبار أن إبداء الرأي اللحظي في طلب العميل يتبع سياسة ائتمانية داخلية محددة تراعي كافة القواعد والقوانين المنظمة لمنح التمويل. واستخدام الحلول التكنولوجية الحديثة للتأكد من شخصية المتقدم ومقارنة الصورة الشخصية وصورة الرقم القومي للعميل وتسجيل الدخول برقم الهاتف المسجل لدى قاعدة البيانات، تأتي في إطار ضمان حصول المستخدم على تجربة آمنة عبر التطبيق.`,
          `والتطبيق لا يقتصر على سداد الأقساط فقط بل يتضمن إتاحة خدمات مالية متنوعة للاستفادة من إمكانيات المجموعة بالكامل من حيث منتجات التمويل بكافة الأنواع وأدوات الدفع بما في ذلك الفواتير كدفع الفواتير الخاصة مثل الغاز والكهرباء والتليفون المحمول اذا كانت فواتير شهريه أو شحن والتبرعات والاستثمار بالإضافة إلى إمكانية متابعة المعاملات، معرفة قائمة التجار المتعاقد معها، أحدث العروض وتفاصيل برنامج الولاء ، طلب زيادة الرصيد، طلب تقسيط فاتورة إلى آخره، ويمكن ذلك من خلال التطبيق أو داخل فروع كونتكت بجميع المحافظات و يتيح أيضا خاصية الدخول السريع من خلال Face ID/Fingerprint`,
          `وقد أعرب السيد أحمد سمير كامل، العضو المنتدب لشركة كونتكت كريدي تك، عن سعادته بإطلاق  منصة ContactNow الرقمية حيث تسعى الشركة منذ فتره كبيرة إلى توفير خدمات جديدة ومتعددة  في منصة واحده استجابةً لمتطلبات العملاء لتمكينهم من الوصول لكل الخدمات المالية للمجموعة و مميزات مختلفة توفيراً للوقت والمجهود على العملاء، ، مضيفاً "وقد تم الاعتماد على أحدث التقنيات التكنولوجية وبرامج الذكاء الاصطناعي وأدوات تواصل حديثة تعمل على التواصل الشخصي بما يتناسب مع اهتمامات كل عميل على حدة، وأيضا توفير كل الأدوات لعمل مختلف التقارير والتحاليل لمعرفة وفهم سلوك المستخدمين، وإتاحة خدمات مالية متنوعة للاستفادة من إمكانيات المجموعة بالكامل و إتاحة خدمات أخرى تتناسب مع احتياجات الحياة اليومية."`,
          `وعلق السيد سعيد زعتر، الرئيس التنفيذي لمجموعة كونتكت المالية، "إن التحول الرقمي واستخدام التكنولوجيا وتحليل البيانات ليس بجديد على كونتكت، فقد اطلقنا أول موقع لمجتمع السيارات في مصر في 2004، واطلقنا لاحقا التطبيق الخاص به في 2013 ومن ثم تطبيق كونتكت الشامل الأول في 2021 وفي نفس العام اطلقنا كونتكت واتساب شات بوت المعتمد على تكنولوجيا الذكاء الاصطناعي والمطور بالكامل بمهارات أبناء كونتكت الداخلية، وما إطلاق التطبيق السوبر اليوم ContactNow إلا خطوة جديدة في مشوار كونتكت التكنولوجي نحو تحول رقمي كامل معتمد على احدث تقنيات العصر في تحليل البيانات، حيث حقق استخدام الخدمات الرقمية قبولاً كبيراً من العملاء واصبح استخدام احدث التقنيات دائماً محور أساسي في استراتيجية المجموعة" وأضاف: "نحن سعداء أننا تمكنا من اطلاق هذه المنصة بشكل منفرد في السوق لتشمل إمكانيات المجموعة وفى نفس الوقت تستخدم أحدث التقنيات التكنولوجية لتحقيق أفضل تجربة وتعد هذه المنصة تتويجاً لمجهودات المجموعة للتحول نحو الرقمنة لتحقيق الأهداف الاستراتيجية المختلفة من التنمية المستدامة و نشر الوعى المالي مما ينعكس على الشمول المالي وهو ما اتجهت إليه المجموعة وأدخلته ضمن استراتيجيتها التنموية في وقتٍ مبكر مستهدفةً منظومة الدفع والتحصيل الإلكتروني”.`,
          `نبذه عن كونتكت:
                كونتكت المالية القابضة ش.م.م (كود البورصة المصرية CNFN.CA) هي مجموعة رائدة في تقديم الحلول والخدمات المالية غير المصرفية، حيث تتولى إدارة مجموعة من الشركات التي تقدم من خلالها مجموعة متكاملة من المنتجات والخدمات التمويلية والتأمينية. وتتبنى كونتكت منهجًا مبتكرًا لضمان تقديم خدماتها بأعلى جودة في مجالات التمويل والتأمين، وذلك بأسهل إجراءات وصولاً إلى قطاع عريض من السوق. فعن طريق شركة كونتكت للتمويل، تقدم كونتكت برامج تمويلية متنوعة لتمويل شراء السيارات والمركبات الجديدة والمستعملة، وعن طريق كونتكت كريدي تك تقدم برامج تمويل السلع الاستهلاكية والخدمات، إضافة إلى برامج التمويل العقاري والتشطيب من خلال كونتكت للتمويل العقاري، وبرامج التمويل التجاري من خلال شركاتها الشقيقة كونتكت للتأجير التمويلي وكونتكت للتخصيم. كما تقدم كونتكت خدمات التأمين من خلال شركتي ثروة للتأمين وثروة لتأمينات الحياة. كما تعد الشركة أول وأكبر مصدر لسندات التوريق في مختلف المجالات بالسوق المصري. شركة كونتكت المالية القابضة ش.م.م. مرخصة وخاضعة للهيئة العامة للرقابة المالية.
                `,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 13,
        date: "05/11/2023",
        city: "القاهرة",
        title: `"كونتكت توسع نطاق خدمات تمويل التعليم لكافة المدارس والجامعات بجميع المحافظات"`,
        urlTitle: `"كونتكت توسع نطاق خدمات تمويل التعليم لكافة المدارس والجامعات بجميع المحافظات"`,
        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/defult-news-image.png",
        sections: [
          `قامت شركة كونتكت للتمويل، ذراع التمويل الاستهلاكي التابع لكونتكت المالية القابضة، مسبقاً بالإعلان عن توفير خدمات تمويل طلاب المدارس والجامعات ودارسي الماجيستير والدكتوراه والدورات التدريبية والشهادات المهنية، فتقدم شركة "كونتكت" خيارات تمويل متعددة لتمويل التعليم بأسعار فائدة تنافسية وفترات سداد مرنة تصل إلى 12 شهراً بالنسبة للمدارس والجامعات، والآن ترفع كونتكت مدة التمويل إلى 3 سنوات للماجيستير و5 سنوات للدكتوراه، بحجم تمويل يصل إلى مليون جنيه، لكل المدارس والجامعات المصرية والأجنبية في مصر.`,
          ` كذلك عززت "كونتكت" منتج تمويل التعليم بتوقيع بروتوكولات مع العديد من المدارس والجامعات المتميزة، ومن ضمن التعاقدات الهامة هي توقيع بروتوكول تعاون مع مجموعة مدارس جيمس مصر للتعليم، التابعة لشركة جيمس العالمية أكبر شركة تعليم خاص في العالم والمتواجد فروعها بالكثير من الدول، والمدرسة الكندية الدولية في مصر المعتمدة من قبل وزارة التعليم في أونتاريو (وزارة التعليم الكندية) وتتبع نظام التعليم الكندي، والجامعة الأوروبية EUE)) التي تقدم برامجَ تعليمية باللغة الإنجليزية. والأكاديمية العربية للعلوم الإدارية والمالية والمصرفية (AAMBFS) والتي أضحت "أكاديمية كل العرب". على مر السنين، وأصبحت مركزًا يلهم جميع المهنيين العرب في قطاعي المال والأعمال، ويزودهم بالمعرفة العلمية والأكاديمية.`,
          `وقال السيد تامر سمير، العضو المنتدب لشركة كونتكت للتمويل، "نحن لا نقتصر على جامعات او مدارس محددة، بل ننتشر في جميع المحافظات وكافة المدارس والجامعات، وقمنا بعقد بروتوكولات مع عدد من المدارس والجامعات الدولية، للتشعب ولتقديم خدمات التمويل الأكاديمي للطلاب في هذه المؤسسات. وسنعمل بشكل وثيق مع هذه المؤسسات لتحقيق أفضل النتائج وتلبية احتياجات الطلاب، وتمثل خدمات تمويل التعليم جزءًا من التزامنا الدائم بتقديم خدمات مالية متميزة وذات جودة عالية. ونحن نسعى جاهدين لتوسيع نطاق خدماتنا وتوفير خيارات تمويل متعددة، بما في ذلك القروض التعليمية والماجيستير والدكتوراه".`,
          `وقال السيد تامر سمير، العضو المنتدب لشركة كونتكت للتمويل، "نحن لا نقتصر على جامعات او مدارس محددة، بل ننتشر في جميع المحافظات وكافة المدارس والجامعات، وقمنا بعقد بروتوكولات مع عدد من المدارس والجامعات الدولية، للتشعب ولتقديم خدمات التمويل الأكاديمي للطلاب في هذه المؤسسات. وسنعمل بشكل وثيق مع هذه المؤسسات لتحقيق أفضل النتائج وتلبية احتياجات الطلاب، وتمثل خدمات تمويل التعليم جزءًا من التزامنا الدائم بتقديم خدمات مالية متميزة وذات جودة عالية. ونحن نسعى جاهدين لتوسيع نطاق خدماتنا وتوفير خيارات تمويل متعددة، بما في ذلك القروض التعليمية والماجيستير والدكتوراه".`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 14,
        date: "05/17/2023",
        city: "القاهرة",
        title: `" كونتكت " تمول مركبات ومعدات الرياضات المائية وصيانتها بتمويلات تصل إلي 3 ملايين جنية وفترات سداد تصل إلي 60 شهر`,
        urlTitle: `" كونتكت " تمول مركبات ومعدات الرياضات المائية وصيانتها بتمويلات تصل إلي 3 ملايين جنية وفترات سداد تصل إلي 60 شهر`,
        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/defult-news-image.png",
        sections: [
          `انفردت شركة " كونتكت للتمويل " ، ذراع التمويل الاستهلاكي لـ " مجموعة كونتكت المالية القابضة "، الرائدة في مجال الخدمات المالية غير المصرفية، بتوفير حلول تمويلية جديدة لعملائها الراغبين في تملك المركبات ومعدات الرياضات المائية مثل ،"  اليخوت والمراكب الشراعية ، واللانشات والجيت سكي والقوارب بجميع أنواعها ومعدات الغوص وغيرها " ، بالإضافة إلي إتاحةإمكانية تمويل مصاريف الصيانة والإصلاح، وتتيح هذه الحلول التمويلية للعملاء الحصول على تمويل يصل إلى 100% من قيمة التمويل الذي يصل إلى 3 ملايين جنية .`,
          `وأوضحت " كونتكت "  في بيان صحفي لها أن هذه الحلول التمويلية تشمل تسهيلات في السداد تبدأ من 6 أشهر وتمتد حتى 60 شهراً بسعر فائدة تنافسي ،حيث تتيح هذه التسهيلات للعملاء تحقيق حلمهم في الحصول على يخت فاخر للاستمتاع بالرحلات البحرية بكل راحة ورفاهية وذلك بهدف تدعيم السياحة والرياضات والأنشطة البحرية في مصر. `,
          `وأشاربيان " كونتكت " إلي أنها تقدم خدمات التمويل المصممة خصيصاً لتناسب طبيعة الأصل الممول واحتياجات ومخططات العميل المالية وذلك من خلال جميع فروع " كونتكت "  التي تزيد عن 75 فرع والممتدة في معظم محافظات مصر بما في ذلك المتواجد منها بمناطق ممارسة سياحة اليخوت والأنشطة والرياضات البحرية، مثل فروع الجونة والغردقة وشرم الشيخ والساحل الشمالي والإسكندرية.`,
          `ومن جانبه كشف تامر سمير،العضو المنتدب لشركة " كونتكت للتمويل " : عن تقديم هذه الخدمة الفريدة من نوعها في السوق، فالشركة بهدف تلبية طلبات العملاء الذين يبحثون عن طرق ميسرة وسهلة لتمويل شراء وصيانة المركبات ومعدات الرياضات المائية .`,
          `وأوضح العضو المنتدب لـ " كونتكت للتمويل " ، أن تمويل مركبات ومعدات الرياضات المائية وصيانتها يعد مجالًا واعداً، ويمثل فرصة للاستمتاع بالأنشطة البحرية والتمتع بالحياة الفاخرة التي يبحث عنها أصحاب الذوق الرفيع ومحبي الأنشطة البحرية مثل ، الإبحار والغوص والصيد،مؤكداً علي تقديم هذا المنتج في السوق،" خدمات تمويل المركبات ومعدات الرياضات المائية " بأعلى مستويات الجودة والاحترافية وبأسهل وأسرع الإجراءات .`,
          `وأشار سعيد زعتر، الرئيس التنفيذي لـ " مجموعة كونتكت المالية القابضة " ، إلي تفرد " كونتكت " بتوفير هذا المنتج الفريد من نوعه في السوق المصري. من منطلق إدراكنا بأن المركبات ومعدات الرياضات المائية تمثل استثمارًا كبيرًا وأن العملاء يحتاجون إلى شريك تمويلي يثقوا به ويمكنهم الاعتماد عليه لتلبية جميع احتياجاتهم. `,
          `وأضاف الرئيس التنفيذي لـ " مجموعة كونتكت المالية القابضة " إلي أن طرح ذلك المنتج جاء بفضل المتابعة المستمرة لاحتياجات السوق، مؤكداً علي الاستمرار في توفير حلول مبتكرة ومتفردة لعملاء المجموعة .`,
          ` وأعتبر زعتر: تمويل مركبات ومعدات الرياضات المائية مثال ممتاز على الفرص المتاحة في السوق المصري وتلاقي رؤى القطاع الخاص والاقتصاد الوطني حيث يدعم هذا المنتج السياحة والأنشطة البحرية ونأمل أن يسبب رواجاً في الأنشطة السياحية المتعلقة بالرياضات البحرية".`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 15,
        date: "06/14/2023",
        city: "القاهرة",
        title: `فوربس الشرق الأوسط تضع كونتكت المالية القابضة على قائمة أقوى 50 شركة في مصر لعام 2023 للعام الثاني علي التوالي`,
        urlTitle: `فوربس الشرق الأوسط تضع كونتكت المالية القابضة على قائمة أقوى 50 شركة في مصر لعام 2023 للعام الثاني علي التوالي`,
        subTitle: `فوربس الشرق الأوسط: كونتكت المالية القابضة في قائمة أقوى الشركات في مصر لعام 2023
        للعام الثاني علي التوالي: شركة كونتكت تفوز بمكان في قائمة فوربس الشرق الأوسط لأقوي الشركات في مصر
        `,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/15.jpg",
        sections: [
          `قامت مؤسسة فوربس الشرق الأوسط والتي تصدر وفق ترخيص من علامة فوربس التجارية العالمية،باختيار مجموعة شركات كونتكت المالية القابضة ،الرائدة في مجال الخدمات المالية الغير مصرفية، ضمن أقوى 50 شركة في مصر لعام 2023 مدرجة بالبورصة المصرية وذلك للعام الثاني على التوالي.`,
          `ويعكس إختيار "كونتكت" في قوائم فوربس المعروفة عالمياً بمصداقيتها، جودة أعمال شركات المجموعة وتفرد نموذج  أعمالها وإنجازاتها المتميزة في مجال الخدمات المالية الغير مصرفية، حيث تعد كونتكت هي اللاعب الأكبر في سوق التمويل الاستهلاكي في مصر بحسب هيئة الرقابة المالية المنظمة للقطاع وكذلك كانت هي الشركة الحاصلة على الرخصة رقم 1 لنشاط التمويل الاستهلاكي في مصر.`,
          `وأعرب  سعيد زعتر، الرئيس التنفيذي لمجموعة شركات كونتكت المالية القابضة، عن فخره بتصنيف المجموعة كواحدة من أقوى الشركات في مصر لهذا العام، مؤكدا علي مواصلة تطوير الخدمات وتقديم الحلول التمويلية الفعالة والمبتكرة للعملاء.`,
          ` وتابع زعتر : فهمنا العميق لاحتياجات عملائنا ووصولنا لهم بكل الوسائل المتاحة هو طريقنا للوصول للنجاح، وتحليل البيانات والتكنولوجيا الحديثة هما الركائز الأساسية لهذا الفهم. `,
          `وأوضح الرئيس التنفيذي لمجموعة كونتكت المالية القابضة : عملنا بجهد كبير للتوسع في مصر من خلال تقديم منتجات تمويلية تناسب جميع الفئات في جميع محافظات الجمهورية، ذلك بجانب جهود التحول الرقمي التي كان لها دور كبير أيضاً في هذا النجاح بالإضافة إلى تركيزنا في العمل مع الشركات الناشئة وتطوير حلول تمويلية تساهم في نمو تلك الشركات في السوق المصري.`,
          `والجدير بالذكر أن  فوربس الشرق الأوسط المعلومات والبيانات المالية قد إعتمدت من القوائم المجمعة للشركات المدرجة في البورصة المصرية. وصّنفت الشركات وفقًا للمبيعات وإجمالي الأصول وصافي الأرباح لعام 2022، بالإضافة للقيمة السوقية التي حُسبت بناء على إغلاقات السوق في 30 أبريل 2023. واستبعدت الشركات التي لم تفصح عن القوائم المالية المجمعة والمدققة لعام 2022، حتى 25 أبريل 2023. كما اعُتمدت أسعار صرف العملات الأجنبية في 30 أبريل 2023.`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 16,
        date: "02/07/2023",
        city: "القاهرة",
        title: `تُوقِّيع اتفاقية تعاون بين "جلوبال أوتو" و "كونتكت" لتوفير خدمات تمويل وتأمين السيارات حصرياً لعملاء BMW وMINI`,
        urlTitle: `تُوقِّيع اتفاقية تعاون بين "جلوبال أوتو" و "كونتكت" لتوفير خدمات تمويل وتأمين السيارات حصرياً لعملاء BMW وMINI`,
        subTitle: `حزمة اتفاقيات تعاون مشتركة بين مجموعة كونتكت المالية القابضة وجلوبال اوتو`,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/16.jpeg",
        sections: [
          `أعلنت مجموعة جلوبال أوتو للسيارات، الوكيل الرسمي لسيارات BMW وMINI في مصرَ، توقيع اتفاقية تعاون وشراكة استراتيجية مع شركة "كونتكت المالية القابضة"، لتوفير خدمات التمويل والتأمين على السيارات ليستفيد مِنها حصريًّا عملاء BMW وMINI في جمهورية مصر العربية، ضمن الاستراتيجية الجديدة التي تنتهجها جلوبال أوتو في تلبية كافة احتياجات عملائها وتوفير كافة الخدمات تحت سقف واحد.`,
          `ويُمْكِنُ لعملاء مجموعة جلوبال أوتو حصريًّا الاستفادةُ مِن برامج وخدمات التأمين الشاملة التي توفِّرها شركة "كونتكت للوساطة التأمينية "، بأسعار تنافسية وبخطوات بسيطة، مع تواجد مندوبي شركة "كونتكت " في كافة صالات عرض ومراكز خدمة "جلوبال أوتو" لتيسير إجراءات الحصول على البرامج التأمينية المختلفة لعملاء BMW وMINI وتلبيةِ جميع احتياجاتهم والردِّ أيضًا على استفساراتهم، بالإضافة إلى توافر الخدمات ذاتها في أكثر مِن ٧٥ فرعًا لشركة "كونتكت" في جميع أنحاء الجمهورية.`,
          `وسيتمكَّن ملاك سيارات BMW وMINI القُدامى كذلك مِن الاستفادة مِن الحلول والبرامج التأمينية الجديدة التي توفِّرها جلوبال أوتو بالتعاون مع كونتكت، ما دامت سياراتهم تتمتعُ بتغطية تأمينية سارية مِن أيِّ شركة تأمين أخرى، كما أن خدماتِ التأمينِ الجديدةَ هي الأولى مِن نوعها التي تُتيح للعملاء التمتُّع بنظام المحاسبة وتسوية المطالبات مباشرة بين شركة كونتكت ومراكز خدمة جلوبال أوتو، مما يوفِّر قيمة حقيقية وراحة بال مطلقة لعملاء BMW وMINI المميَّزين.`,
          `مِن جانبه، علَّق السيد محمد قنديل، الرئيس التنفيذي لمجموعة جلوبال أوتو للسيارات، بقوله: "يُسعدني اليومَ الإعلانُ عن الشَّراكة الجديدة بين جلوبال أوتو وكونتكت لتوفير كافة خدمات التمويل والتأمين الشاملة على السيارات لعملائنا الأوفياء، وهي جزء مِن استراتيجية مجموعتنا التي تتضمَّن توفير كافة الخدمات المتعلِّقة بالسيارات لعملائنا تحت سقف واحد، مع تواجد مندوبي كونتكت داخل صالات العرض ومراكز الخدمة الموزَّعة في جميع أنحاء الجمهورية، الأمر الذي يُتَرْجَمُ إلى تقديم تجربة امتلاك راقية ومميَّزة دون مشقَّة تُعزِّز مِن ولاء العملاء لعلامتينا الفاخرتين BMW وMINI".`,
          `وفي سياق متَّصل، قال السيد سعيد زعتر، الرئيس التنفيذي لشركة كونتكت المالية القابضة: "نحن فخورون بهذه الشَّراكة الاستراتيجية مع مجموعة جلوبال أوتو للسيارات، التي تَعكِسُ الثقةَ فيما نوفِّره مِن حلول تأمينية وتمويلية عالية الجودة على السيارات في السوق المصرية. ويُسعدنا للغاية تولي كافة الأنشطة التأمينية لمجموعة جلوبال أوتو، تلبيةً لجميع احتياجات عملاء BMW وMINI التأمينية في أسرع وقت وبأسعار تنافسية تَضمن لهم الاستمتاع بقيادة سياراتهم دون خوف أو قلق؛ لأن هناك شريكَ تأمينٍ يستطيعون الوثوق به والاعتماد عليه. وقريبًا، سنعلن عن خطوة جديدة تُعزِّز مِن شراكتنا مع جلوبال أوتو مِن خلال تقديم حلولٍ تمويليةٍ حصرية ومُيَسَّرةٍ لعملاء العلامتين الفخمتين، ستضمَن دون شك الاستمتاع بتجربة امتلاك خالية من التعقيدات تُناسب احتياجاتِ قطاعٍ عريضٍ مِن العملاء."`,
          `نبذه عن كونتكت:
            كونتكت المالية القابضة ش.م.م (كود البورصة المصرية CNFN.CA) هي مجموعة رائدة في تقديم الحلول والخدمات المالية غير المصرفية، حيث تتولى إدارة مجموعة من الشركات التي تقدم من خلالها مجموعة متكاملة من المنتجات والخدمات التمويلية والتأمينية. وتتبنى كونتكت منهجًا مبتكرًا لضمان تقديم خدماتها بأعلى جودة في مجالات التمويل والتأمين، وذلك بأسهل إجراءات وصولاً إلى قطاع عريض من السوق. فعن طريق شركة كونتكت للتمويل، تقدم كونتكت برامج تمويلية متنوعة لتمويل شراء السيارات والمركبات الجديدة والمستعملة، وعن طريق كونتكت كريدي تك تقدم برامج تمويل السلع الاستهلاكية والخدمات، إضافة إلى برامج التمويل العقاري والتشطيب من خلال كونتكت للتمويل العقاري، وبرامج التمويل التجاري من خلال شركاتها الشقيقة كونتكت للتأجير التمويلي وكونتكت للتخصيم. كما تقدم كونتكت خدمات التأمين من خلال شركتي ثروة للتأمين وثروة لتأمينات الحياة. كما تعد الشركة أول وأكبر مصدر لسندات التوريق في مختلف المجالات بالسوق المصري. شركة كونتكت المالية القابضة ش.م.م. مرخصة وخاضعة للهيئة العامة للرقابة المالية.
            `,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 17,
        date: "03/07/2023",
        city: "القاهرة",
        title: `كونتكت: تتيح وثيقة تأمين جديدة تساعد علي الادخار بـ " 600 جنية سنوياً" من ثروة لتأمينات الحياة`,
        urlTitle: `كونتكت: تتيح وثيقة تأمين جديدة تساعد علي الادخار بـ " 600 جنية سنوياً" من ثروة لتأمينات الحياة`,
        subTitle: `" ثروة لتأمينات الحياة " و" كونتكت للوساطة التأمينية" يعلنان عن وثيقة تأمين علي الحياة بـ " 600 جنية"  سنويا`,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/defult-news-image.png",
        sections: [
          `اطلقت شركتا ثروة لتأمينات الحياة وكونتكت للوساطة التأمينية، التابعتين لمجموعة كونتكت المالية الرائدة في مجال الخدمات المالية الغير مصرفية، منتج التأمين الادخاري الفردي  من خلال فروع كونتكت للتمويل  الـ75 الممتدة في مختلف محافظات الجمهورية والذي تم تصميمه بعناية  من قبل خبراء التأمين بالشركتين ليناسب احتياجات العملاء. `,
          `وكشفت نيهال بريك، العضو المنتدب لشركة كونتكت للوساطة التأمينية ، عن أن هناك أكثر من باقة لعمل هذه الوثيقة تنقسم إلى: 600 جنية، 900 جنية، 1200 جنية سنوياً، ويحدد مبلغ التأمين بناء على تاريخ ميلاد المؤمن عليه وباقة الاشتراك السنوي بحد أدنى 25 ألف جنيه مصري ومضاعفاتها، مشيرة إلى أن المستفيد سيحصل على مبلغ التأمين ومبلغ الاستثمار في حالة وافته المنية لا قدر الله، أما في حاله اكتمال التعاقد فيحصل العميل على مبلغ حساب الاستثمار بالكامل، وتابعت بريك: "أصبحت ظروف الحياة أكثر صعوبة مما يقلق عائل أي أسرة على مستقبل أولاده إذا وافته المنية، وإمكانية تعرض أبناؤه لهزة مالية عنيفة لذا فالإذخار أفضل استثمار لهم وهذه الوثيقة تقدم ذلك بشكل أفضل من وسائل الادخار التقليدية ".`,
          `ومن جانبه أوضح رمِاح أسعد، العضو المنتدب لشركة ثروة لتأمينات الحياة، إن دور "ثروة لتأمينات الحياة " يأتي في مساعدة العملاء لتوفير احتياجاتهم وحماية مدخراتهم ،لاسيما عند التقاعد، ومن بين الامتيازات التي تمنحها الوثيقة لأبناء المؤمن عليه هو التمتع بوجود مبلغ مالي مضمون يحصلون عليه من شركة التأمين يساعدهم في التخطيط لمستقبلهم.`,
          `وقال أسعد  أن هذا النوع من الوثائق يعتبر أهم أنواع عقود التأمين على الحياة، حيث يفضل الكثير من الأفراد شراء هذه الوثائق بسبب انخفاض تكلفتها، وتعتبر أرخص أنواع تأمينات الحياة من حيث مقدار القسط السنوي، وقد زادت أهميتها خاصة بعد الظروف الاقتصادية الحالية، فجميعنا نريد حماية أنفسنا وأولادنا من فواجع الأقدار.`,
          `وأشار السيد سعيد زعتر، الرئيس التنفيذي لشركة كونتكت المالية القابضة، إلى أن هذه الخطوة جاءت تنفيذا لاحتياجات العميل ونظرا للظروف الاقتصادية الحالية التي تستدعي التركيز على منتجات لحمايته وحماية أسرته، وأكد زعتر، "أن المجموعة تبذل قصارى جهدها للاستمرار في تقديم حلول وخدمات تأمينية مبتكرة ذات قيمه مضافة عالية معتمدة في ذلك على تنوع خدمات شركات المجموعة والتكامل الذي يقدمه ذلك التنوع، والذي يجعلنا دائما ما نقدم افضل قيمة مقابل سعر جيد لعملائنا الكرام".`,
          `نبذه عن كونتكت:
          كونتكت المالية القابضة ش.م.م (كود البورصة المصرية CNFN.CA) هي مجموعة رائدة في تقديم الحلول والخدمات المالية غير المصرفية، حيث تتولى إدارة مجموعة من الشركات التي تقدم من خلالها مجموعة متكاملة من المنتجات والخدمات التمويلية والتأمينية. وتتبنى كونتكت منهجًا مبتكرًا لضمان تقديم خدماتها بأعلى جودة في مجالات التمويل والتأمين، وذلك بأسهل إجراءات وصولاً إلى قطاع عريض من السوق. فعن طريق شركة كونتكت للتمويل، تقدم كونتكت برامج تمويلية متنوعة لتمويل شراء السيارات والمركبات الجديدة والمستعملة، وعن طريق كونتكت كريدي تك تقدم برامج تمويل السلع الاستهلاكية والخدمات، إضافة إلى برامج التمويل العقاري والتشطيب من خلال كونتكت للتمويل العقاري، وبرامج التمويل التجاري من خلال شركاتها الشقيقة كونتكت للتأجير التمويلي وكونتكت للتخصيم. كما تقدم كونتكت خدمات التأمين من خلال شركتي ثروة للتأمين وثروة لتأمينات الحياة. كما تعد الشركة أول وأكبر مصدر لسندات التوريق في مختلف المجالات بالسوق المصري. شركة كونتكت المالية القابضة ش.م.م. مرخصة وخاضعة للهيئة العامة للرقابة المالية.
          `,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 18,
        date: "02/28/2023",
        city: "القاهرة",
        title: `"كونتكت تطرح خدمات تمويلية جديدة بالأسواق"`,
        urlTitle: `"كونتكت تطرح خدمات تمويلية جديدة بالأسواق"`,
        subTitle: `"تمويل الصيانة والأثاث من خلال كونتكت"`,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/defult-news-image.png",
        sections: [
          `أضافت شركة كونتكت للتمويل، التابعة لشركة كونتكت المالية القابضة الرائدة في مجال الخدمات المالية الغير مصرفية، منتجين في محفظة التمويل الاستهلاكي الخاصة بها، ضمن إطار سعيها المتواصل لإثراء التجربة الغير مصرفية للعملاء من خلال تقديم خيارات واسعة من المنتجات والخدمات المتوافقة مع احتياجاتهم.`,
          `وأعلنت كونتكت عن إصدار منتجين جديدين، وهما تمويل الأثاث وتمويل الصيانة، فكثيرًا ما تقلق فكرة تجهيز وتأثيث المنزل باعتبارها خطوة تتطلب الكثير من الاستعدادات وادخار الأموال اللازمة للشراء، ولكن الوضع يختلف بخدمتي تمويل الأثاث و تمويل الصيانة من كونتكت.`,
          `وقالت  كونتكت في بيان لها اليوم أن خدمة تقسيط الأثاث ستكون من خلال جميع تجار الأثاث والأجهزة المنزلية التي سيختارها  وما يريده من الأثاث والأجهزة المنزلية من أي عدد من التجار وتقديمها للشركة للحصول على موافقة للتمويل، وتتراوح مدة السداد بين ٦ أشهر حتى ٦٠ شهراً، ويصل مبلغ التقسيط إلى 2 مليون جنية بدون مقدم ، مع إمكانية السداد المعجل بعد مرور ستة أشهر.`,
          `وأشار بيان كونتكت إلي منتج تمويل الصيانة فهو منتج جديد طور خصيصا لسد حاجة عملاء كونتكت لتمويل كافة أنواع الصيانة والتي ازدادت تكلفتها في الآونة الأخيرة نتيجة للزيادة الكبيرة في أسعار المواد الخام والخدمات المتعلقة بالصيانة، .`,
          `وأشار البيان إلي أن المنتج الجديد بشمل  تمويل الصيانة المنزلية والسيارات واي صيانات أخرى على مدة 6 أشهر وحتى 24 شهرا بدون مقدم، وبقيمة تصل إلى 1.5 مليون جنية، ويمكن أيضا للعملاء من ملاك الوحدات داخل المجمعات السكنية (الكومباوندز) أو القرى السياحية أن يستعينوا بنفس المنتج لتمويل وديعة الصيانة، حيث يشترط معظم المطورين العقاريين على العملاء سداد قيمة وديعة الصيانة بالكامل قبل تسليم الوحدة، وهكذا تسهل كونتكت على العملاء تسلم وحداتهم والاستمتاع باستثماراتهم.`,
          `ومن جانبه قال السيد تامر سمير، العضو المنتدب لشركة كونتكت للتمويل، "إن إضافة منتجي تمويل الأثاث وتمويل الصيانة سوف يسهم بشكل كبير في تخفيف الأعباء على العملاء، وبموجب هذا سيتمكن عملاء كونتكت من الحصول على أسلوب الحياة المتطور ومساندتهم في جميع احتياجاتهم الحياتية".`,
          `ومن جانبه قال السيد سعيد زعتر، الرئيس التنفيذي لشركة كونتكت المالية القابضة، " أننا نسعى لتقديم خدمات استثنائية لعملائنا وإتاحة حرية الاختيار للعميل للحصول على أكثر برنامج مريح له للتقسيط، سواء الأثاث أو الصيانة ، يأتي هذا كجزء من جهودنا المركزة لتقديم خيارات التمويل الميسرة لعملائنا في كل مكان، وسنستمر في إطلاق المنتجات التي توفر حاجة العملاء والسوق لنمكنهم من الحصول على المنتجات المناسبة لاحتياجاتهم والتي يرغبون في شرائها باستخدام حلول تمويلية مرنة من خلال كونتكت".`,
          `نبذه عن كونتكت:
         كونتكت المالية القابضة ش.م.م (كود البورصة المصرية CNFN.CA) هي مجموعة رائدة في تقديم الحلول والخدمات المالية غير المصرفية، حيث تتولى إدارة مجموعة من الشركات التي تقدم من خلالها مجموعة متكاملة من المنتجات والخدمات التمويلية والتأمينية. وتتبنى كونتكت منهجًا مبتكرًا لضمان تقديم خدماتها بأعلى جودة في مجالات التمويل والتأمين، وذلك بأسهل إجراءات وصولاً إلى قطاع عريض من السوق. فعن طريق شركة كونتكت للتمويل، تقدم كونتكت برامج تمويلية متنوعة لتمويل شراء السيارات والمركبات الجديدة والمستعملة، وعن طريق كونتكت كريدي تك تقدم برامج تمويل السلع الاستهلاكية والخدمات، إضافة إلى برامج التمويل العقاري والتشطيب من خلال كونتكت للتمويل العقاري، وبرامج التمويل التجاري من خلال شركاتها الشقيقة كونتكت للتأجير التمويلي وكونتكت للتخصيم. كما تقدم كونتكت خدمات التأمين من خلال شركتي ثروة للتأمين وثروة لتأمينات الحياة. كما تعد الشركة أول وأكبر مصدر لسندات التوريق في مختلف المجالات بالسوق المصري. شركة كونتكت المالية القابضة ش.م.م. مرخصة وخاضعة للهيئة العامة للرقابة المالية.
         `,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 19,
        date: "08/15/2023",
        city: "القاهرة",
        title:
          "تعليق السيد/ سعيد زعتر -الرئيس التنفيذي لكونتكت المالية القابضة- على نتائج اعمال النصف الأول من ارباح الشركة لعام 2023",
        urlTitle:
          "تعليق السيد/ سعيد زعتر -الرئيس التنفيذي لكونتكت المالية القابضة- على نتائج اعمال النصف الأول من ارباح الشركة لعام 2023",
        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/defult-news-image.png",
        sections: [
          `نشاط التمويل: نمو إجمالي صافي أرباح التمويل ليصل الي نسبة 71% خلال الربع الثاني من عام 2023 
          وفي هذا السياق علق السيد سعيد زعتر قائلا:" أود أن أعرب عن فخري وامتناني لفريقنا المتميز على الأداء الرائع بالنصف الأول من عام 2023 الذي حققناه في ظل الظروف الاقتصادية الصعبة وارتفاع نسب الأرباح يعكس الجهود الجادة والاستراتيجية الفعالة التي تم تنفيذها لتحقيق هذا النجاح. في هذه الظروف الاقتصادية الصعبة، وأن هذا التفوق المالي يعزز مكانتنا في السوق كما حقق قطاعي تمويل السيارات وشاحنات النقل نموًا قويًا ولاسيما تمويل السيارات في ضوء استفادة القطاعين من التعافي التدريجي لسوقي السيارات وشاحنات النقل بعد تخفيف القيود المفروضة على الاستيراد في بداية العام. كما واصل قطاع التمويل الاستهلاكي أداءه القوي بفضل التوسع بشبكة المتاجر التابعة وزيادة تواجده في السوق مع إطلاق منتجات جديدة، ويعكس ذلك ثقة عملائنا وشركاءنا في قدرتنا على تحقيق التطور ومواكبة الظروف الراهنة. ونعد بالاستمرار في العمل بجدية وتفانٍ لتحقيق المزيد من النجاح."
          `,
          `ارتفاع الدخل التشغيلي لقطاعي التمويل والتأمين بنسب %47 و53% على التوالي خلال الربع الثاني من عام 2023
          وأضاف زعتر في تعليقه على ارتفاع الدخل التشغيلي لقطاعي التمويل والتأمين بنسب سنوية %47 و53% على التوالي: "إن كونتكت تقدم حلول مالية وتأمينية متنوعة وكبيرة تلبي الاحتياجات المالية لمختلف للأفراد من مختلف الطبقات وكذلك الأنشطة الإنتاجية، حيث ان بلغت محفظة كونتكت التمويلية 18.1 مليار جنية، حيث ان هذا الرقم يعكس التفاني والتفوق الذي يتمتع به فريقنا في إدارة وتنمية استثماراتنا. ويدعم ذلك انتشارنا في 94 فرعا في جميع انحاء البلاد مكون من 79 فرعا، 15 نقطة بيع في مواقع استراتيجية، ونؤكد مكانتنا كشركة قوية وموثوقة في سوق الاستثمارات. نظرًا للتحديات المستمرة في السوق المالية، فإن الوصول إلى محفظة بهذا الحجم يعكس استراتيجيتنا القوية والفعالة في اختيار الاستثمارات وإدارتها بحكمة، واؤكد على التزامنا بتحقيق أهداف الشركة على المديين القريب والبعيد طوال العام، على الرغم من التحديات الاقتصادية المتوقع استمرارها خلال النصف الثاني من العام. كما نؤكد استمرار نمو أنشطة قطاع التمويل الاستهلاكي من خلال تطبيق "ContactNow"حيث حصلنا علي إقبالً قويًا على التطبيق خلال النصف الأول من عام 2023 في ضوء ما يوفره من خدمات رقمية متنوعة تلبي مختلف الاحتياجات المالية للعملاء، مدعومًا بباقة المنتجات المتنوعة التي نقدمها والمنتجات الجديدة التي أطلقناها مؤخراً، حيث اننا أطلقنا منتجات جديدة خلال النصف الأول من العام الجاري لتمويل المناسبات الاجتماعية والدراجات البخارية والمراكب المائية الشخصية، ونعتزم بإطلاق منتجات جديدة أخرى على مدار العام."
          `,
          `•	ارتفاع إجمالي الأقساط التأمينية بنسبة 65%عن العام السابق ليبلغ 832 مليون خلال النصف الأول من عام 2023.
    
          أما في نشاط التامين في المجموعة، فقد حققت شركتا ثروة للتأمين وثروة لتأمينات الحياة أداءً قوياً بارتفاع إجمالي الأقساط لشركة ثروة لتأمينات الحياة بنسبة 92% ليبلغ 471 مليون جنيه خلال النصف الأول من عام 2023، كما بلغت نسبة النمو بشركة ثروة للتأمين الي 39% بقيمة 361 مليون جنية خلال النصف الأول من عام 2023.
          وقال السيد سعيد زعتر تعليقا على ارتفاع الأقساط التأمينية، ان هذا النجاح يعكس زيادة تواجد الشركتين بالسوق واتاحة خدماتهم عبر قنوات تجارية مختلفة، كما أظهرت شركتا التأمين التابعتان للمجموعة قدرة عالية على مواكبة التحديات التي يشهدها السوق والمنافسة بقوة وثبات بمواجهة شركات عالمية ومحلية عريقة في المجال عن طريق ابتكار منتجات متطورة تواكب احتياجات السوق، فتنوعت الوثائق التي تقدمها الشركتان لتغطي التأمين الفردي والجماعي واستثمرنا في تغيير المفهوم السائد، حيث يتميز الشركتين بالتركيز علي العميل، الخبرة، السرعة و فاعلية و الخدمة الفائقة و المصداقية، الذين يعتبروا هم حجر الأساس للتطور و التميز و النجاح و الوصول الي هذا التصاعد الدائم."  
          `,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 20,
        date: "09/07/2023",
        city: "القاهرة",
        title: `كونتكت تحصد جائزة أفضل شركة مالية في تكنولوجيا التحول الرقمي في مصر لعام 2022`,
        urlTitle: `كونتكت تحصد جائزة أفضل شركة مالية في تكنولوجيا التحول الرقمي في مصر لعام 2022`,
        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/defult-news-image.png",
        sections: [
          `تسعى كونتكت دائما لتوسيع قاعدة عملائها من منطلق الشمول المالي سعيًا لتغطية جميع شرائح المجتمع، فكان توسعها الجغرافي في 25 من محافظات الجمهورية المصرية بشبكة فروع تمتد إلى العديد من المراكز، وقوامها حتى الآن 60 فرعًا مرشحة للزيادة؛ فكانت كونتكت المؤسسة المالية الأسرع نموًا في مصر في عام 2021 بشهادة مجلة The Global Economics البريطانية المتخصصة في الشئون الاقتصادية. ويأتي هذا التوسع ملبيًا لاحتياجات قطاع عريض من المستهلكين في الأقاليم المصرية، توفر لهم كونتكت تمويلًا ميسرًا وآمنًا لمختلف احتياجاتهم الأساسية من سلعٍ وخدمات، بناءً على دراسة خاصة للتركيبة السكانية والاجتماعية والسلوك الاستهلاكي في كل منطقة. `,
          `ووفقًا لرؤية كونتكت القائمة على الريادة والتطوير المستمر والمستدام، تمكنت مجموعة كونتكت المالية – على التوازي من توسعها الجغرافي – من إتمام عملية التحول الرقمي لخدماتها بنجاح لتحصل على جائزة أفضل شركة مالية في تكنولوجيا التحول الرقمي في مصر لعام 2022 بشهادة نفس المجلة The Global Economics. فقد بنت كونتكت على تاريخ ممارساتها الائتمانية الناجحة لأكثر من عقدين من الزمان نظامًا متطورًا يعتمد على تكنولوجيا الذكاء الاصطناعي بهدف التقييم الائتماني الفوري للعملاء الأفراد، لتجمع بين كفاءة الخدمة الإلكترونية وسرعتها وبين تطبيق مبدأ "الائتمان العادل" في نفس الوقت، هذا المبدأ الذي لا يحمي فقط جهة التمويل من المخاطر الائتمانية، بل يراعي أيضًا التوازن في العبء الدَيْني الذي يتحمله العميل.`,
          `وهكذا يتميز نموذج كونتكت - كمجموعة مالية رائدة في الخدمات المالية الغير مصرفية - بتعدد القنوات الإلكترونية وغير الإلكترونية لتصل خدماتها التمويلية والتأمينية إلى كل مواطن مصري بمختلف الوسائل. كما تستهدف كونتكت تحقيق التحول الرقمي على مستوى العملاء بحثهم على استخدام تطبيقاتها الإلكترونية، وإن كان إقبالهم الأول على الخدمة قد تم عبر القنوات الاعتيادية، مساهمةً منها في تحقيق التحول الرقمي على مستوى المجتمع على التوازي من تحقيق الشمول المالي، وفي إطار من التنمية المستدامة. `,
          `معرباً عن سعادته بالحصول على الجائزة، صرح السيد سعيد زعتر، الرئيس التنفيذي لمجموعة كونتكت المالية والعضو المنتدب للشركة القابضة : "إن منح مؤسسة الاقتصاد العالمي  The Global Economicsجائزة أفضل شركة مالية في تكنولوجيا التحول الرقمي في مصر لعام 2022 لكونتكت ليعكس الإنجازات القوية التي أحرزتها الشركة على صعيد التوسع بنطاق خدماتها، وابتكار الخدمات الجديدة، وتنمية شبكة التجار، وإقامة المزيد من الشراكات الاستراتيجية المثمرة".`,
          `جدير بالذكر، أن كونتكت المالية القابضة، قد اختيرت ضمن قائمة أقوى50 شركة في مصر لعام 2022 من مجلة فوربس ميدل إيست Forbes Middle East والتي تصدر وفق ترخيص من علامة فوربس التجارية العالمية.`,
          `عن شركة كونتكت المالية
         كونتكت المالية القابضة ش.م.م (كود البورصة المصرية CNFN.CA) هي مجموعة رائدة في تقديم الحلول والخدمات المالية غير المصرفية، حيث تتولى إدارة مجموعة من الشركات التي تقدم من خلالها مجموعة متكاملة من المنتجات والخدمات التمويلية والتأمينية. وتتبنى كونتكت منهجًا مبتكرًا لضمان تقديم خدماتها بأعلى جودة في مجالات التمويل والتأمين، وذلك بأسهل إجراءات وصولاً إلى قطاع عريض من السوق. فعن طريق شركة كونتكت للتمويل، تقدم ثروة برامج تمويلية متنوعة لتمويل شراء السيارات والمركبات الجديدة والمستعملة وبرامج تمويل السلع المعمرة، إضافة إلى برامج التمويل العقاري والتشطيب من خلال كونتكت للتمويل العقاري، وبرامج التمويل التجاري من خلال شركاتها الشقيقة كونتكت التأجير التمويلي وكونتكت التخصيم. كما تقدم ثروة خدمات التأمين من خلال شركتي ثروة للتأمين وثروة لتأمينات الحياة. كما تعد الشركة أول وأكبر مصدر لسندات التوريق في مختلف المجالات بالسوق المصري. شركة كونتكت المالية القابضة ش.م.م. مرخصة وخاضعة للهيئة العامة للرقابة المالية.
         `,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 21,
        date: "04/09/2023",
        city: "القاهرة",
        title: `" كونتكت تشارك في مؤتمر الصعيد الزراعي وتدعم الاقتصاد الأخضر "`,
        urlTitle: `" كونتكت تشارك في مؤتمر الصعيد الزراعي وتدعم الاقتصاد الأخضر "`,
        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/21.jpg",
        sections: [
          `شاركت شركة كونتكت المالية - الرائدة في مجال الخدمات المالية غير المصرفية -، في مؤتمر الصعيد الزراعي الذي أقيم في مارس الماضي، الذي يعد أحد أهم المؤتمرات الزراعية في منطقة الصعيد بمصر. وتأتي هذه المشاركة في إطار دور الشركة الريادي في دعم الاقتصاد الأخضر وتعزيز الثقافة الزراعية المستدامة وباعتبارها أول شركة تمويل في مصر تدعم التمويل الأخضر.`,
          `وضم أكبر تجمع لشركات المعدات والمنتجات الزراعية وشبكات الري والتقاوي والأسمدة والبذور، إضافة إلى الأسمدة العضوية ومعدات توليد الطاقة النظيفة وغيرها. ويعتبر مؤتمر الصعيد الزراعي منصة مهمة للتواصل بين الخبراء والمهنيين في مجال الزراعة، ويهدف إلى تحسين وتطوير الزراعة في منطقة الصعيد، وتوفير فرص العمل وتعزيز الاقتصاد المحلي. ومن خلال مشاركتها في هذا المؤتمر، تسعى شركة كونتكت إلى تعزيز الثقافة الزراعية المستدامة ودعم الاقتصاد الأخضر في مصر. وانفردت كونتكت بالرعاية الذهبية للمعرض، وقد أطلقت كونتكت منذ أشهر قليلة منتجها للتمويل الأخضر.`,
          `وتتيح كونتكت تقسيط أصول متعددة من خلال منتج التمويل الأخضر مثل: تمويل وتطوير نظم الري وتمويل الصوب الزراعية و تطوير وتجهيز مشروعات الزراعات الخندقية والأغطية البلاستيكية للأنفاق والصوب الزراعية و الاحواض ومعدات الثروة السمكية و عنابر ومعدات الثروة الداجنة والحيوانية، ذلك بجانب وحدات توليد الطاقة النظيفة، فترة تقسيط تصل إلى خمس سنوات بدون مقدم و تمويل يصل إلى مليون و نصف، ويتميز منتج التمويل الأخضر بنظامي سداد أحدهم شهري والآخر ربع سنوي، مما يعكس تفهم كونتكت لطبيعة النشاط الزراعي ودورة التدفقات النقدية الخاصة به.`,
          `ومن جانبه قال السيد تامر سمير، العضو المنتدب لشركة كونتكت للتمويل، إن التنوع في إصدار المنتجات والتطور في جميع المجالات المستدامة، أعطت لكونتكت الصدارة في وللأهمية الكبرى بمشاركة المجموعة في مثل هذه المعارض لمساعدة تمويل صغار المزارعين، وأن الشركة تتناغم مع الاتجاهات العالمية للبحث عن بدائل جديدة للطاقة وتوجهها نحو إيجاد بيئة نظيفة وصحية عبر الاعتماد المتزايد على مصادر الطاقة الجديدة من شمس ورياح.`,
          `وقال السيد سعيد زعتر، الرئيس التنفيذي لمجموعة كونتكت المالية، بجانب أن كونتكت تقوم بالتنوع في المنتجات التي يتم إطلاقها حسب احتياج السوق فمن اللازم الاهتمام أيضاً بالمشروعات الخضراء التي تراعي العنصر البيئي بالمجتمع، وإرساء قواعد التمويل المستدام بالقطاع غير المصرفي، مشيدا بالجهد الذي يبذله موظفي المجموعة لمراقبة السوق لمعرفة متطلباته، وأن الشركة تلعب دوراً مهماً في الخوض في مجالات متعددة من ضمنها مجالات المحافظة على البيئة.`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 22,
        date: "06/01/2023",
        city: "القاهرة",
        title: `«كونتكت» تعلن عن شراكة جديدة مع «فودافون مصر» لإتاحة خدمة التمويل الاستهلاكي بالإضافة إلى خدمة Lending as a service`,
        urlTitle: `«كونتكت» تعلن عن شراكة جديدة مع «فودافون مصر» لإتاحة خدمة التمويل الاستهلاكي بالإضافة إلى خدمة Lending as a service`,
        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/defult-news-image.png",
        sections: [
          `أعلنت شركة كونتكت كريدي تك -ذراع التمويل الاستهلاكي الرقمي التابع لمجموعة كونتكت المالية القابضة عن توقيع اتفاقية مع شركة فودافون مصر، تهدف إلى إطلاق خدمات التمويل الاستهلاكي لعملاء فودافون بالإضافة إلى إتاحة نظام الموافقات الفورية فيما يعرف بـ Lending as a service، وذلك لتمكين العملاء من التقديم على حد ائتماني لحظي بأسهل الإجراءات.`,
          `يأتي هذا التعاون في إطار استراتيجية " كونتكت "  التي تعتمد على التحول الرقمي، وإتاحة أحدث الخدمات التمويلية المختلفة لشركائها الاستراتيجيين ولأكبر فئة من العملاء، حيث سيتم استهداف شرائح متواجدة في أماكن جغرافية مختلفة، ستشمل القرى والمراكز بهدف تحديث الهواتف المحمولة الخاصة بالعملاء، لتشمل أحدث وسائل تكنولوجيا الاتصالات. `,
          ` وقال  أحمد سمير كامل، العضو المنتدب لشركة كونتكت كريدي تك ؛ أن حجر الأساس الذي نعتمد عليه في تواجدنا بالسوق هو التحول الرقمي واستخدام أحدث التقنيات في تصميم المنتجات والخدمات المبتكرة، مع إتاحة هذه الخدمات للشركاء الاستراتيجيين، لتخدم أهداف مختلفة طبقاً للاحتياج في كل إطار تعاون".`,
          ` وأعرب كامل ؛ عن فخره بالتعاون مع فودافون مصر كشريك استراتيجي، حيث تم التركيز في الفترة الأخيرة على التوسع من خلال تكوين شراكات جديدة في مختلف المجالات باستخدام أحدث الخدمات التكنولوجية، وإتاحة خدمة  Lending as a service  ضمن باقة خدمات التمويل الاستهلاكي  التي تنفرد بها "كونتكت"  في السوق المصري حصرياً حتى الآن حيث ساعدتنا في خلق مفهوم جديد يظهر القيمة المضافة لكل من العملاء والشركاء الاستراتيجيين في نفس الوقت لخدمتهم في تطبيقات مختلفة تخدم نطاق عملهم."`,
          `كما قال الدكتور زكريا نبيل رئيس قطاع مبيعات الأفراد في “فودافون مصر": "نفخر بدورنا في دعم التحول الرقمي والاستدامة في مصر، وبالتعاون مع " كونتكت" يمكن لعملائنا الاستمتاع بتقسيط شراء الأجهزة من متاجرنا بطريقة سهلة ومريحة، في إطار التزامنا بتوفير حلول مبتكرة وملائمة للعملاء.`,
          `وتابع رئيس قطاع مبيعات الأفراد في “فودافون مصر"نسعى جاهدين لتوفير تجربة مميزة للعملاء الذين ما زالوا على شبكتي 2Gو G3، وتقديم إمكانية الحصول على موافقة فورية من كونتكت لشراء هواتف 4G من متاجرنا،  في إطار التزامنا بالمساهمة في تحقيق التنمية المستدامة وتعزيز الاقتصاد الرقمي، ونتطلع إلى مزيد من الابتكارات والخدمات المبتكرة في المستقبل."`,
          `ومن جانبه، أكد سعيد زعتر الرئيس التنفيذي لمجموعة كونتكت المالية القابضة ؛ أن " كونتكت" تشهد  هذه الفترة توسع ملحوظ في مجال التمويل القائم على التطور التكنولوجي والتقني،مشيرا إلي أولوية اهتمام المجموعة مراعاة إحتياجات السوق والاطلاع عليها ؛ لتقديم خدمة استثنائية لأكبر قاعدة من العملاء،.`,
          `وأوضح زعتر ؛أنه بالرغم من الظروف الحالية لدينا إيمان قوى بقدرتنا على تسخير قوتنا في هذا المجال لتخطى أي عقبات قد تطرأ علينا في السوق؛ معربا عن إعتزازه بالتعاقد مع "فودافون مصر " لما تتيحه هذه الشراكة من تعزيز الوصول إلى قاعدة عملاء جديدة وتلبية احتياجاتها، انطلاقًا من خبرة شركتنا الواسعة في مجال التمويل التي بدأت في مصر منذ أكثر من 20 سنة".`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 23,
        date: "06/22/2023",
        city: "القاهرة",
        title: `" ثروة للتأمين " تحتفل بمرور 5 سنوات من الإنجازات وتوسع نطاق عملها في سوق التأمين المصري`,
        urlTitle: `" ثروة للتأمين " تحتفل بمرور 5 سنوات من الإنجازات وتوسع نطاق عملها في سوق التأمين المصري`,
        subTitle: `في وسط أجواء احتفالية كبيرة " ثروة للتأمين " تعرب عن فخرها بنجاحاتها وتلتزم بتقديم أفضل الخدمات لعملائها " وخليفة " يعد بالمزيد من النجاحات والابتكار في المستقبل `,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/defult-news-image.png",
        sections: [
          `احتفلت شركة ثروة للتأمين، ذراع التأمينات العامة لمجموعة " كونتكت المالية القابضة " ، بمناسبة مرور خمس سنوات على تأسيسها وتواجدها في سوق التأمين المصري بإقامة احتفالية كبيرة في Le lac du Caire (بحيرة القاهرة) الواقعة في أحضان المتحف القومي للحضارة المصرية في قلب مدينة الفسطاط عاصمة القاهرة الإسلامية القديمة وعلى ضفاف بحيرة عين الصيرة، وحضر الحفل العديد من الشخصيات البارزة بسوق التأمين المصري ووسطاء التأمين الذين يعدوا شركاء النجاح الأساسيين وتعتبرهم " ثروة للتأمين " من اهم أسباب الوصول لما هي عليه اليوم من نجاحات وتقدم، وأحيا الحفل المطربة ياسمين علي التي أمتعت الحاضرين بصوتها العذب، والفنان يوسف فوزي الذي قام بعزف موسيقي رائعة ومختلفة بالساكسفون وسط أجواء من البهجة والسعادة.`,
          `وتقدم " ثروة للتأمين "  مجموعة واسعة من خدمات التأمين الشاملة والمتنوعة للشركات مثل ( تأمين النقل البحري، التأمينات الهندسية، تأمين أساطيل السيارات وتأمين المسؤوليات والتأمينات المالية وغيرها من المنتجات ).`,
          ` كما تقدم خدمات تأمينية للأفراد مثل ( تأمين الحوادث الشخصية ونمط الحياة، تأمين المنازل، وتأمين السيارات ) .وتتميز الشركة بالابتكار والتطوير المستمر لمنتجاتها وخدماتها.`,
          ` وحققت " ثروة " إنجازات متعددة، وذلك بفضل الاختلاف والتنوع في المنتجات التي تقدمها للعملاء والمصداقية والسرعة، من خلال فريق قوي من الموظفين لتحقيق الأهداف بالتعاقد مع أكبر معيدي التأمين، ومجلس الإدارة الذي منح كل الإمكانيات التقنية والعملية التي يحتاجها الموظفين، حيث وصلت " ثروة للتأمين " لأكثر من 50,000 عميل مع مجموعة مكونة من اكثر من 130 موظف طموحًا وناجحًا تميزوا بقوة التصميم والتركيز والمرونة، خلال رحلة نجاحهم التي بدأت بسيطة ووصلت إلي أن تكون " ثروة " واحدة من أكبر الشركات في صناعة التأمين.`,
          `وأوضح احمد خليفة، العضو المنتدب لشركة " ثروة للتأمين ، أن الشركة تهتم بالتركيز علي العميل والخبرة والسرعة والفاعلية والخدمة الفائقة منذ بداية تأسيسها، مشيراً إلي خطة التوسع وافتتاح 6 فروع في عدد من مدن المحافظات       ( الإسكندرية وبورسعيد والدقي ومصر الجديدة ووسط القاهرة وطنطا وغيرهم ) ، مؤكداً علي العمل بشكل متواصل على تحسين الخدمات وتوسيع نطاق عمل الشركة بالسوق.`,
          ` وكشف خليفة ، أنه بفضل الجهود المتواصلة لفريق العمل الذي يعمل كخلية النحل ومجلس الإدارة الذي يوفر كل الإمكانيات التي نحتاجها لتحقيق الأهداف، استطعنا تحقيق أرقاماً قياسية حيث كانت بدايتنا في 2019 بتحقيق أقساط وصلت إلي 91 مليون جنية حتي حققنا أقساط وصلت إلي  517 مليون جنية في عام 2022.ويسعدنا أن نرى أن هذه الجهود تؤتي ثمارها، ونتعهد بالمزيد من الابتكار والتطوير المستمر لتلبية كافة احتياجات العملاء .`,
          `ومن جانبه قال سعيد زعتر، الرئيس التنفيذي لمجموعة شركات " كونتكت المالية القابضة " ، نحتفل اليوم بمرور خمس سنوات على تأسيس شركة " ثروة للتأمين " ذراع التأمينات العامة للمجموعة، الأمر الذي يشعرنا بالفخر والاعتزاز بما حققته الشركة خلال هذه الفترة.`,
          ` وتابع زعتر : تمكنا من الأستمرار في تحقيق نمواً في حصتنا السوقية، كما نجحنا في تقديم منتجات تأمينية متميزة وخدمات عالية الجودة.`,
          `وقدم الرئيس التنفيذي لمجموعة " كونتكت المالية القابضة " شكره لكل من عمل ودعم رحلة " ثروة للتأمين " خلال الخمس سنوات الماضية، بما في ذلك عملائنا الكرام وشركاؤنا وفريقنا المتميز ، ونتطلع إلى مواصلة العمل معهم وتحقيق المزيد من النجاحات في المستقبل .`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 24,
        date: "06/05/2023",
        city: "القاهرة",
        title: `" كونتكت " تعلن عن إطلاق برنامج تمويل الدراجات النارية بتمويل يصل إلى 2 مليون جنية`,
        urlTitle: `" كونتكت " تعلن عن إطلاق برنامج تمويل الدراجات النارية بتمويل يصل إلى 2 مليون جنية`,
        subTitle: ` إطلاق برنامج استثنائي جديد لتمويل الدراجات النارية من " كونتكت "`,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/24.jpg",
        sections: [
          `أعلنت شركة " كونتكت للتمويل "، إحدي شركات " مجموعة كونتكت المالية القابضة " الرائدة في مجال الخدمات المالية الغير مصرفية،عن إطلاق منتج تقسيط الدراجات النارية، ويأتي هذا البرنامج كجزء من خطة الشركة وسعيها المستمر لتقديم مجموعة واسعة من خدمات التمويل الاستهلاكي، حيث أن إمتلاك الدراجة النارية يمكن أن يوفر تجربة رائعة من المغامرة والحرية في الحركة، ويمكن أيضًا أن يكون وسَيلة مريحة وفعالة من حيث التكلفة للتنقل بالمدن والمناطق المختلفة مع الإحساس بروح المغامرة والانطلاق والاستمتاع بالتجربة.`,
          `وجاء اطلاق المنتج الجديد بالتزامن مع المشاركة المتميزة لـ " كونتكت " في معرض" Motorsports hub " السنوي الجمعة الماضي والذي يعد أحد أهم تجمعات ملاك ومحبي الدرجات النارية في مصر، وشهد حضور "كونتكت" في Motorsport hub" " إقبالاً كبيراً من الحضور الذين أبدوا إعجابهم الشديد بما تقدمه الشركة من منتجات وتسهيلات لكل محبي ركوب الدراجات النارية في مصر.`,
          `وكشفت " كونتكت " في بيان لها أن برنامج تمويل الدراجات النارية يتيح لجميع العملاء تقسيط كافة أنواع ( الدراجات النارية الجديدة أو المستعملة وكذلك الدراجات الكهربائية ،السكوتر الكهربائي ، وسيارات الجولف ، والبيتش باجي وجميع معدات رياضة ركوب الدراجات النارية ) .`,
          `وأشارت " كونتكت " في بيانها أن البرنامج يقدم للعملاء فرصة الحصول على تمويل يصل قيمته إلى 2 مليون جنية على فترات سداد تصل إلى 5 سنوات دون الحاجة إلى التأمين الإجباري، وتمويل جميع أنواع الدرجات النارية بإجراءات سهلة وسريعة وخطط سداد مرنة تناسب جميع الاحتياجات وبأسعار فائدة منافسة وتسهيلات في السداد مع خدمة العملاء المميزة التي تشتهر بها الشركة .`,
          `وأوضح تامر سمير، العضو المنتدب لشركة " كونتكت للتمويل " ، أن الشركة صممت برنامج تقسيط الدراجات النارية لتلبية الحاجة المتزايدة للاستمتاع بأجواء المغامرة والرفاهية وكذلك الاستمتاع بالتحرك بسهولة ، مؤكداً ،علي أن شروط وإجراءات التقسيط تتميز بالسهولة والمرونة لجميع العملاء الذين يبحثون عن الانفراد والتميز والانطلاق، في ظل تزايد الطلب على الدراجات النارية والاتجاه إلى تحسين الخدمات المالية المتاحة للعملاء .`,
          `وتابع العضو المنتدب لـ "كونتكت للتمويل "متحمسون جدًا للعمل مع عملائنا وتوفير الحلول المالية المناسبة لهم، ونتوقع ردود فعل إيجابية من مجتمع الدراجات النارية المصري بشأن هذا المنتج الجديد."`,
          `ومن جانبة قال سعيد زعتر،الرئيس التنفيذي لـ "مجموعة كونتكت المالية القابضة ": وضعنا عدداً من الأهداف وعازمين على تحقيقها منذ بداية العام ومن أهمها، مواصلة النمو في كافة القطاعات التي تؤكد على قوة ومكانة المجموعة  في سوق التمويل المصري خصوصاً في مجال التمويل الاستهلاكي . `,
          `وأضاف زعتر:أن " كونتكت " أطلقت مؤخراً منتج تمويل المركبات المائية وبإطلاق منتج تمويل الدراجات النارية إستطعنا أن نحقق جزء من أهدافنا لتوسيع وتطوير خدماتنا لتلبية إحتياجات جميع الفئات ، مشيراً إلي أن هذا يعكس القيم الأساسية التي نؤمن بها وهي السهولة ، والمصداقية والنزاهة ، والعميل أولًا".`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 25,
        date: "08/02/2023",
        city: "القاهرة",
        title: `" كونتكت " تقدم حزمة منتجات تمويلية جديدة لتمويل مناسبات الأفراح وأعياد الميلاد والتعليم واشتراكات الأندية`,
        urlTitle: `" كونتكت " تقدم حزمة منتجات تمويلية جديدة لتمويل مناسبات الأفراح وأعياد الميلاد والتعليم واشتراكات الأندية`,
        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/25.jpg",
        sections: [
          `أعلنت مجموعة " كونتكت المالية القابضة " الرائدة في الخدمات المالية غير المصرفية عن توفير حزمة حلول تمويلية مبتكرة، تضمنت  تمويل الاحتفال بالمناسبات الخاصة، وتمويل الأفراح ، وحفلات الزفاف والخطوبة وأعياد الميلاد والتخرج وغيرها ، وذلك بهدف تمكين العملاء من الحصول على تمويل يساعدهم على تحقيق ما يحلمون به في أي مناسبة خاصة بهم.`,
          `وأكدت مجموعة " كونتكت المالية القابضة " علي مد يد العون لمساعدة الشباب خلال هذه المرحلة العمرية لإقامة حفل زفاف مشرف يناسب مظهرهم الاجتماعي ويتم تمويل المنتج لمدة تصل إلى 36 شهر .`,
          ` والجدير بالذكر أن ، مجموعة " كونتكت " تقدم العديد من الخدمات التي تشكل أهمية كبرى بالنسبة لجميع الأسر والأفراد، وتقوم المجموعة بتقديم الحل الأمثل لكل مراحل الحياة بدءا من الزواج، وصولا لتعليم الأبناء والحفاظ على لياقتهم البدنية بإشراكهم في أفضل الأندية، وقد وفرت المجموعة علي مر تاريخها طوال 21 عام منتجات متنوعة وخطط تمويلية تناسب جميع العملاء وأصبحت مصدر ثقة للجميع .`,
          `وقال بيان " كونتكت " أن تمويل التعليم وتغطية جميع مراحل الحياة يعد أمرًا حيويًا لتحقيق التنمية الشاملة والاستدامة الاجتماعية والاقتصادية، وهذا يتطلب توافر فرص تمويلية مناسبة ،مثل التي تقدمها المجموعة لتوفير الفرص التعليمية للجميع وتحقيق التقدم الشخصي والمهني للأفراد بالمجتمع، وذلك من منطلق الاهتمام بتعليم الأبناء لضمان مستقبل ناجح لهم ، على مدار جميع مراحل تعليمهم ، بدءًا من التعليم الأساسي كالمدارس والتعليم العالي لمدة تصل إلى سنة وصولاً إلى الدراسات العليا حتى 5 سنوات في جميع المدارس والجامعات المصرية والأجنبية في مصر وبقيمة تمويل تصل إلى مليون جنيه ، وفي مرحلة لاحقة من الحياة العميل، أتاحت كونتكت حلول تمويلية لاشتراكات الأندية، حيث يمكن الحصول على تمويل لمدة تصل إلى60 شهراً لكي يساعدهم على الاستمتاع بالحياة مع العائلة والأصدقاء ومساعدة الأطفال للمشاركة اجتماعيا مع الآخرين وتطور مهاراتهم البدنية والذهنية من خلال تكوين الصداقات والقيام بالعديد من المهارات.`,
          `ومن جانبه أكد تامر سمير، العضو المنتدب لشركة " كونتكت للتمويل " ، علي الإهتمام بمشاركة العملاء في جميع مراحل حياتهم ويتمثل دور الشركة في مساعدتهم بمختلف جوانب حياتهم ، بدءًا من حلم السيارة في بداية المشوار من الزواج ووصولاً للتعليم واشتراكات الأندية لعائلاتهم .`,
          ` وأوضح سمير أن الزواج هو بداية مرحلة جديدة في الحياة، تحتاج إلى دعم مالي لتغطية تكاليفه والحياة الجديدة التي ستبدأ بعده. مشيراً إلي أن التعليم، من أهم الأمور التي يحتاجها الأفراد لتحسين مستقبلهم وزيادة فرصهم في العمل والازدهار المالي. وإشتراكات وإشتراكات النوادي، تعد استثمار في تطوير الأبناء وتنمية مهاراتهم وتوسيع شبكة علاقاتهم الاجتماعية.`,
          `وأشار سعيد زعتر، الرئيس التنفيذي لـ "مجموعة كونتكت المالية القابضة " إلي سعى المجموعة لتوفير الخدمات المالية والتمويلية المبتكرة التي يحتاجها العملاء لتحقيق كافة أهدافهم بإجراءات ميسرة ، موضحاً أن شركات المجموعة تعمل على تقديم الاستشارات المالية والإرشادات اللازمة للعملاء لاتخاذ القرارات المالية الصائبة. بالإضافة إلي تقديم الدعم لهم في جميع مراحل حياتهم، حتي نكون دائماً إختيارهم الأول.`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 26,
        date: "05/11/2023",
        city: "القاهرة",
        title: `" كونتكت " توسع نطاق خدمات تمويل التعليم لكافة المدارس والجامعات بجميع المحافظات وترفع مدة التمويل لدارسي الماجيستير إلى 3 سنوات والدكتوراه إلي 5 سنوات`,
        urlTitle: `" كونتكت " توسع نطاق خدمات تمويل التعليم لكافة المدارس والجامعات بجميع المحافظات وترفع مدة التمويل لدارسي الماجيستير إلى 3 سنوات والدكتوراه إلي 5 سنوات`,
        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/defult-news-image.png",
        sections: [
          `أعلنت شركة " كونتكت للتمويل " ، ذراع التمويل الاستهلاكي لـ " مجموعة كونتكت المالية القابضة " ، عن رفع مدة التمويل لدارسي الماجيستير إلى 3 سنوات و5 سنوات للدكتوراه، بحجم تمويل يصل إلى مليون جنيه، لكل المدارس والجامعات المصرية والأجنبية في مصر ، وذلك بهدف توفير خدمات تمويل طلاب المدارس والجامعات ودارسي الماجيستير والدكتوراه والدورات التدريبية والشهادات المهنية،التي كانت قد أعلنت عنها منذ مدة ، وقدمت "كونتكت" من خلالها خيارات تمويل متعددة لتمويل التعليم بأسعار فائدة تنافسية وفترات سداد مرنة تصل إلى12 شهراً بالنسبة للمدارس والجامعات .`,
          `وأوضحت " كونتكت " أنها عززت منتج تمويل التعليم بتوقيع بروتوكولات مع العديد من المدارس والجامعات المتميزة، التي من  ضمنها توقيع بروتوكول تعاون مع مجموعة "مدارس جيمس مصر للتعليم "، التابعة لشركة جيمس العالمية أكبر شركة تعليم خاص في العالم والتي تنتشر فروعها بالكثير من الدول، و" المدرسة الكندية الدولية " في مصر المعتمدة من قبل وزارة التعليم في أونتاريو (وزارة التعليم الكندية) وتتبع نظام التعليم الكندي، و" الجامعة الأوروبية EUE)) " التي تقدم برامجَ تعليمية باللغة الإنجليزية و" الأكاديمية العربية للعلوم الإدارية والمالية والمصرفية(AAMBFS) " والتي أصبحت " أكاديمية كل العرب " على مر السنين، وتحولت إلي مركز يلهم جميع المهنيين العرب في قطاعي المال والأعمال، ويزودهم بالمعرفة العلمية والأكاديمية.`,
          `وأشار تامر سمير، العضو المنتدب لشركة " كونتكت للتمويل " إلي أن خدمات التمويل لا تقتصر على  جامعات او مدارس محددة ، بل أنها تمتد لتغطي المدارس والجامعات بكافة المحافظات ، كاشفاً : عن عقد بروتوكولات مع عدد من المدارس والجامعات الدولية ، لتقديم خدمات التمويل الأكاديمي للطلاب في هذه المؤسسات.`,
          ` وأكد العضو المنتدب لـ " كونتكت للتمويل " علي أن الشركة ستعمل بشكل وثيق مع هذه المؤسسات لتحقيق أفضل النتائج وتلبية احتياجات الطلاب،موضحاً أن تقديم خدمات تمويل التعليم تمثل جزءًا هاماً من التزام " كونتكت" الدائم بتقديم خدمات مالية متميزة ذات جودة عالية ، وهو ما نسعى جاهدين إليه لتوسيع نطاق خدماتنا وتوفير خيارات تمويل متعددة، بما في ذلك القروض التعليمية والماجيستير والدكتوراه .`,
          `ومن جانبه قال سعيد زعتر، الرئيس التنفيذي لمجموعة" كونتكت " المالية القابضة، إن التعليم يمثل حجر الأساس لبناء مجتمعات مزدهرة ومستقرة وتقليص الاستثمار في التعليم يهدد بحدوث أزمات أكثر خطورة في المستقبل .`,
          ` وكشف زعتر:أن التعليم من أكثر المنتجات التي يقبل عليها المستهلك لذلك نحرص علي تقليل قيمة الفائدة الخاصة بهذا المنتج خصوصاً لأنه يندرج تحت المسئولية الاجتماعية الخاصة بشركات المجموعة، مشيراً إلي إعتزام " كونتكت للتمويل " توفير خدمات تمويل التعليم لكل المصريين في جميع المحافظات و بكافة المدارس و الجامعات .`,
          `وأعرب الرئيس التنفيذي لمجموعة كونتكت المالية القابضة عن أمله في أن تسهم هذه الخدمات في تحقيق أحلام المصريين الأكاديمية والمهنية، وتمكن الجميع من الحصول على التعليم الجيد واللازم لبناء مستقبل مهني ناجح ومستقر.`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 27,
        date: "07/18/2023",
        city: "القاهرة",
        title: `"الصافي" و"كونتكت" يقدمان التأمين المجاني لأجهزة "موبايلاتي" ضد الغرق والكسر والحرق`,
        urlTitle: `"الصافي" و"كونتكت" يقدمان التأمين المجاني لأجهزة "موبايلاتي" ضد الغرق والكسر والحرق`,
        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/defult-news-image.png",
        sections: [
          `وقّعت كل من شركة كونتكت للوساطة التأمينية إحدي شركات مجموعة كونتكت المالية القابضة وشركة موبايلاتي التابعة لمجموعة "الصافي" للاستيراد والتصدير والتوكيلات التجارية، اتفاقية شراكة هي الأولى من نوعها في السوق المصري لتقديم التأمين المجاني لأجهزة وهواتف عملاء شركة "موبايلاتي" لمدة عام، بما يشمل تغطية شاملة للأضرار الخارجية مثل الكسر والحريق والغرق.`,
          `وبموجب هذه الاتفاقية يتم تفعيل وثيقة تأمين مجانية لمدة عام كامل لكل مشترٍ للهواتف والأجهزة الإلكترونية من فروع "موبايلاتي" البالغة 20 فرعاً في جميع أنحاء مصر، فضلاً عن منصة التسوق الإلكتروني لشركة "موبايلاتي" وما توفره من مجموعة ضخمة لكافة المنتجات والهواتف الذكية والإلكترونيات وملحقاتها لأشهر العلامات التجارية العالمية الأكثر مبيعاً حول العالم.`,
          `وانفردت شركة "كونتكت للوساطة التأمينية" بالتعامل في كل ما يخص التأمين للعملاء التابعين لشركة "موبايلاتي"، بالإضافة للتأمين على أصول وممتلكات مجموعة "الصافي" ومشروعاتها في مجالات التوزيع والتجارة والإلكترونيات وتجارة التجزئة والأغذية والمشروبات والاتصالات والخدمات اللوجستية، والنفط والغاز، والتطوير العقاري.`,
          `وكشف خالد فهمي المدير التنفيذي لشركة "موبايلاتي" التابعة لمجموعة "الصافي"، إن هذه الاتفاقية وما تقدمه من خدمات فريدة من نوعها لعملاء "موبايلاتي"، تؤكد حرص الشركة على تقديم أفضل الحلول والخدمات لعملائها، بما يدعم المبيعات لتتصدر السوق بلا منازع، ويأتي ذلك تماشياً مع توسعات الشركة واعتزامها افتتاح فرعين جديدين لتصل بفروعها إلى 22 فرعاً بنهاية 2023.`,
          `ومن جانبها أعربت  نهال بريك رئيس مجلس الإدارة والعضو المنتدب لشركة كونتكت للوساطة التأمينية، عن سعادتها بتلك الشراكة التي تعتبرها فرصة ناجحة لجميع الأطراف.`,
          `وقالت بريك أن هذا التعاون مع مجموعة "الصافي " جاء في إطار خطة شركة "كونتكت للوساطة التأمينية" المتواصلة على توسيع نطاق أعمالها وخدماتها في السوق المصري، وحرصها على التعامل مع كبري الشركات في جميع المجالات، مضيفة: أن  الشركة  تسعي لمساعدة عملائها في الحصول على تغطيات تأمينية تتعلق بكافة موضوعات وشئون حياتهم، في نفس الوقت الذي تسعى فيه "الصافي جروب" لتأكيد التزامها نحو عملائها وتوفير أفضل الخدمات غير المسبوقة لهم".`,
          `ومن جانبها قالت ريم صافي الرئيس التنفيذي لمجموعة "الصافي"، إن التعاون مع شركة "كونتكت للوساطة التأمينية" إحدى كبرى الشركات الرائدة والمتميزة في قطاع التأمين، يعكس حرص المجموعة على تقديم أفضل الخدمات لعملائها، ولا سيما خدمات ما بعد البيع حيث الانفراد بتقديم التأمين المجاني لأجهزة عملاء "موبايلاتي"، لتصبح الاختيار الأفضل في مصر على الإطلاق.`,
          `وأكدت ريم صافي علي أن القوة والثقة التي تتمتع بها شركة "كونتكت" سوف تنعكس على منتجات وأجهزة "موبايلاتي" لتصبح الأولى في السوق المصري بلا منافس، كما حرصت مجموعة "الصافي" على الاستفادة أيضاً من الخدمات التأمينية لشركة "كونتكت" حيث التأمين على أصول وممتلكات مجموعة "الصافي" بما يضمن مواصلة النمو والتوسع بكل ثقة وأمان لمختلف مشروعاتها.`,
          `ووصف  سعيد زعتر الرئيس التنفيذي لمجموعة "كونتكت المالية القابضة"  هذه الشراكة بأنها تعكس ما تقدمه الشركة لعملائها من خدمات متميزة، مشيرا إلي أن "كونتكت" منذ اليوم الأول لوجودها في السوق المصري وهي تلتزم باستراتيجية طموحة هدفها الأول هو عملائنا، وتنعكس تلك الاستراتيجية على ما نقدمه من منتجات فريدة، وكذلك على التوسعات التي نستهدفها لنكون الأقرب لعملائنا، وهو ما مكننا من بناء قاعدة عملاء ضخمه يستفيدون من خدماتنا ومنتجاتنا عبر قنواتنا البيعية المتنوعة، والأهم من ذلك منحهم الاطمئنان والسكينة، خاصة مع علمهم بوجود شبكة حماية وأمان لمنتجاتهم مجاناً ولمدة عام".`,
          `عن مجموعة الصافي
          تأسست "موبيلاتي" التابعة لمجموعة "الصافي" عام 2020، وهي سلسلة محلات رائدة لبيع علامات تجارية متعددة من خلال 20 منفذ في جميع أنحاء الجمهورية، بالإضافة إلى منصتها الإلكترونية التي تقدم مجموعة كبيرة من الأجهزة المنزلية والهواتف المحمولة وأجهزة اللاب توب والألعاب والإكسسوارات ومعدات إنترنت الأشياء وتقنيات المنزل الذكي لتلبية كافة الاحتياجات التكنولوجية لجميع العملاء. 
          تأسست مجموعة الصافي عام 1985 برؤية وطنية لتصبح رائدة صناعية في إدارة المحافظ الاستثمارية المتنوعة في مصر.  حققت المجموعة انتشارا واسعا في نطاق تغطية شاملة لعملائها في اكثر من 5 دول منهم مصر والصين وهونج كونج والإمارات العربية المتحدة وأمريكا والسودان وجنوب كوريا.  رسخت مجموعة الصافي أقدامها في العديد من القطاعات المتنوعة على مر السنوات الماضية كما سعت لتحقيق فرص استثمارية جاذبة ومشاركات استراتيجية لتحمل اليوم المسئولية من أجل عملائنا وشركائنا والمجتمع المصري بأكمله برؤية قومية تعتز بحب الوطن وتسعى أن تساهم في الازدهار الاجتماعي والاقتصادي والبيئي كمساهم رئيسي في تنشيط وازدهار الاقتصاد المصري.
          `,
          `عن شركة كونتكت المالية
          كونتكت المالية القابضة ش.م.م (كود البورصة المصرية CNFN.CA) هي أكبر مقدم للخدمات المالية غير المصرفية في مصر، حيث تقود التحول في وسائل تقديم خدمات التمويل والتأمين للأفراد والشركات. ومنذ تأسيسها عام 2001، تتبنى كونتكت منهجًا مبتكرًا لضمان تقديم خدماتها بأعلى جودة في مجالات التمويل والتأمين، وذلك بأسهل إجراءات وصولاً إلى قطاع عريض من السوق من خلال شركاتها التابعة وشركائها الاستراتيجيين. فعن طريق شركة كونتكت للتمويل، تقدم باقة من البرامج التمويلية المتنوعة لتمويل شراء السيارات والمركبات الجديدة والمستعملة وبرامج تمويل السلع المعمرة عن طريق كونتكت للخدمات الائتمانية، إضافة إلى برامج التمويل العقاري والتشطيب من خلال كونتكت للتمويل العقاري، وبرامج التمويل التجاري من خلال شركاتها الشقيقة كونتكت التأجير التمويلي وكونتكت التخصيم. كما تقدم ثروة خدمات التأمين من خلال شركتي ثروة للتأمين وثروة لتأمينات الحياة. كما تقدم الشركة باقة واسعة من خدمات التمويل للشركات بما في ذلك إصدار سندات التوريق وإدارة الديون المُهيكلة وإدارة استثمار الديون. شركة كونتكت المالية القابضة ش.م.م. مرخصة وخاضعة للهيئة العامة للرقابة المالية.
          `,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 28,
        date: "05/21/2023",
        city: "القاهرة",
        title: `كونتكت للوساطة التأمينية وثروة للتأمين وثروة لتأمينات الحياة يشاركون في الماراثون الأخضر`,
        urlTitle: `كونتكت للوساطة التأمينية وثروة للتأمين وثروة لتأمينات الحياة يشاركون في الماراثون الأخضر`,
        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/28.jpg",
        sections: [
          `شاركت مجموعة " كونتكت المالية القابضة " من خلال شركات التأمين التابعة لها،( ثروة للتأمين وثروة لتأمينات الحياة وكونتكت للوساطة التأمينية ) ، في " الماراثون الأخضر الرابع " برعاية الاتحاد المصري للتأمين الذي اقيم تحت شعار (معاً لمحاربة السرطان)، وتأتي المشاركة لتأكيد دور المجموعة في عالم التأمين والمسؤولية المجتمعيةوبمشاركة مجموعة من موظفي قطاع التأمين بمجموعة كونتكت، وقد قامت كل من ثروة للتامين وثروة لتأمينات الحياة بالرعاية الفضية فيما كانت كونتكت للوساطة التأمينية شريك الماراثون.`,
          `وكان الاتحاد المصري للتأمين نظم الماراثون الأخضر السنوي الرابع تحت رعاية وزارة الشباب والرياضة والهيئة العامة للرقابة المالية ، بمركز شباب الجزيرة بحضور الدكتور أشرف صبحي وزير الشباب والرياضة والدكتور محمد فريد، ر ئيس الهيئة العامة للرقابة المالية، والدكتور إسلام عزام، نائب رئيس الهيئة العامة الرقابة المالية ،علاء الزهيري، رئيس الاتحاد المصري للتأمين، والدكتور طارق سيف، أمين عام الاتحاد المصري للتأمين تحت عنوان "معًا لمحاربة السرطان"،خيث شارك ما يقرب من 1500 مشارك هذا العام من كافة الفئات والأعمار، من بينهم الكثير من العاملين بشركات التأمين وشركات الوساطة التأمينية وأسرهم وغيرها من الكيانات والمؤسسات التي تعمل ضمن منظومة التأمين المصري.`,
          `ويأتي تنظيم الماراثون كجزء من مساهمات الاتحاد في مجال المسؤولية المجتمعية ،حسث إستهدف هذا العام الوقاية والتوعية من مرض سرطان الأطفال، وتشجيع كافة فئات المجتمع على أهمية ممارسة الرياضة. كما شهد الماراثون مشاركة خاصة لذوي الهمم الأمر الذي يعد ترجمة حقيقية للأهتمام الكبير والجهود التي تقوم بها الدولة المصرية في تجاه رعاية وتأهيل ذوي الهمم .`,
          `وأكد السيد سعيد زعتر، الرئيس التنفيذي لـ " مجموعة كونتكت المالية القابضة " ، على أهمية المشاركة في هذه الفعاليات التي تدعم المبادرات الصحية والاجتماعية، وتعزز الوعي الصحي وتساهم في حماية صحة المجتمع  . `,
          `وأوضح زعتر حرص " كونتكت" على المشاركة في كل ما يعزز وينمي مبادئ الإستدامة والمشاركة في الفعاليات الرياضية، لأنها تساهم في زيادة الوعي والثقافة الرياضية للوقاية من الأمراض  ، مشيراً ، إلى مواصلة الجهود في هذا المجال، لتحقيق تأثير إيجابي على المجتمع والصحة العامة من خلال تلك المشاركة .`,
          ` وأشاد الرئيس التنفيذي لـ " مجموعة كونتكت المالية القابضة " بتنظيم  الإتحاد المصري للتأمين لمثل هذه الفعاليات والمبادرات الهامة التي تعزز العلاقة التبادلية بين الشركات والمجتمع، كما عبر عن سعادته بتشجيع الدولة متمثلة في وزارة الشباب وكذلك الهيئة العامة للرقابة المالية وحضور وزير الشباب والرياضة ورئيس الهيئة العامة للرقابة المالية ونائبه.`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 29,
        date: "06/11/2023",
        city: "القاهرة",
        title: `كونتكت تشارك في مؤتمر Africa Health Excon لتقديم حلول تمويل مبتكرة`,
        urlTitle: `كونتكت تشارك في مؤتمر Africa Health Excon لتقديم حلول تمويل مبتكرة`,
        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/29.jpg",
        sections: [
          `شاركت شركة كونتكت للتأجير التمويلي، إحدي شركات مجموعة كونتكت المالية القابضة الرائدة في مجال الخدمات المالية الغير مصرفية، في المؤتمر والمعرض الطبي الأفريقي الثاني "صحة أفريقيا Africa Health ExCon في دورته الثانية، الذي استمرت فعالياته خلال الفترة من 6إلى 9 يونيو 2023بمركز مصر للمعارض الدولية، وتضمنت فعاليات المؤتمر  جلسات متنوعة تستعرض خطوات زيادة قدرة أفريقيا نحو تصنيع اللقاحات والعلاجات المختلفة، بالإضافة إلى مناقشة أحدث التقنيات الطبية للنهوض بصحة المرأة في أفريقيا`,
          `وأكدت " كونتكت المالية القابضة " في بيان لها اليوم علي أن مشاركة "كونتكت للتأجير التمويلي" في المعرض يبرهن على التزامها بتوفير حلول تمويلية مبتكرة وملائمة لاحتياجات العملاء في القطاع الطبي بتمويل الأجهزة الطبية بكافة أشكالها وأنواعها، وتعزيز الشراكات الاستراتيجية مع الشركات والمؤسسات العاملة في قطاع الرعاية الصحية، بهدف تحسين جودة الخدمات وتعزيز الرعاية الصحية بالمجتمع.`,
          ` وقال البيان أن نشاط " كونتكت للتأجير التمويلي " يقوم على تمويل الأصول الثابتة في قطاعات متنوعة ويندرج تحت مظلتها برامج تمويلية متعددة وشاملة، من أهمها تمويل المعدات الطبية مثل أجهزة مراكز وعيادات التجميل والأسنان ومعامل التحاليل والعيادات، والمستشفيات عموماً كغرف العمليات والعناية المركزة والإنعاش ، كما  تنفرد بتمويل تجديد الأجهزة الطبية. وتمويل وسائل النقل لجميع الأنشطة التجارية الأخرى مثل الشركات والمدارس والمولات التجارية وشركات قطاع السياحة والنوادي مثل سيارات الملاكي والنقل والأوتوبيسات والخلاطات وكذلك وسائل توزيع البضائع وتوصيلها مثل الموتوسيكل والتروسيكل وغيرهم، وتميزت الشركة بسرعة التنفيذ وسهولة الإجراءات.`,
          `وأكد إسماعيل سمير، العضو المنتدب لشركة " كونتكت للتأجير التمويلي " علي أن الشركة تؤمن بأهمية العميل وان كل عملائنا بمثابة شركاء نجاح لنا، ولذلك وفرنا مؤخراً خدمة تمويل جميع أنواع الأصول الثابتة من غير المعدات الطبية ووسائل النقل التي يحتاجونها لتطوير أعمالهم وتحقيق أهدافهم، بما في ذلك المعدات الثقيلة والزراعية والوحدات الطبية والإدارية .`,
          `وكشف العضو المنتدب لشركة " كونتكت للتأجير التمويلي " أنه تم إضافة تمويل الطاقة الشمسية إيمانا منا بأهمية الاستدامة ومواكبة التطور بالمجتمع. مشيراً إلي إنفراد " كونتكت "  في سوق التأجير التمويلي بتثبيت سعر الفائدة وعدم زيادتها علي العميل علي مدار فترة التعاقد بغض النظر عن سعر الكوريدور، مؤكداً علي السعي الدائم لتلبية احتياجات العملاء وتقديم الحلول التمويلية الأمثل التي تتناسب مع متطلباتهم الفريدة`,
          `ومن جانبه أوضح  سعيد زعتر، الرئيس التنفيذي لمجموعة " كونتكت المالية القابضة " ، "أن شركات " كونتكت " تعتبر نفسها شريك حقيقيي لعملائها، حيث نسعى جاهدين لتقديم خدمات التمويل المختلفة وبفضل فريق عملنا المؤهل والمتخصص، نحن قادرون على تقديم حلول تمويلية مبتكرة وميسرة لعملائنا، بما في ذلك تمويل جميع أنواع الأصول الثابتة. `,
          `وأشار الرئيس التنفيذي لمجموعة " كونتكت المالية القابضة " إلي أن كونتكت للتأجير التمويلي تلعب دورًا حيويًا في مجموعة شركاتنا، مع الإلتزام بتقديم خدمات التأجير التمويلي الأمثل والميسرة لعملائنا بالسهولة والسرعة التي اعتاد عليها عميل كونتكت دائماً، .`,
          `وأكد زعتر ، علي سعى شركات المجموعة دائمًا لتحقيق أعلى مستويات الجودة والكفاءة في كل ما تقوم به لمواكبة تطورات السوق واحتياجاته`,
          `والجدير بالذكر أن " كونتكت للتأجير التمويلي " هي أحد أذرع قطاع التمويل بمجموعة " كونتكت المالية القابضة " والتي انضمت لها عام 2015، من أجل توفير مجموعة متكاملة من المنتجات المالية والحلول التمويلية البديلة والغير تقليدية لمواكبة التطور المستمر في سوق الخدمات المالية الغير مصرفية، ولتلبية احتياجات العملاء المتنوعة من الشركات خصوصاً أصحاب الأعمال الصغيرة والمتوسطة كالأطباء والصيادلة وغيرهم.`,
          `وتتميز خدمة التأجير التمويلي بالعديد من المزايا، مثل توفير رأس المال اللازم للإستثمار في الأصول والتجهيزات اللازمة للنجاح في العمل، وتخفيف العبء المالي على المشتري عند الحاجة إلى شراء المعدات بأسعار عالية.`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 30,
        date: " 08/30/2023",
        city: "القاهرة",
        title: `استكمالاً لدورها الرائد في تحقيق المسئولية الاجتماعية: " كونتكت " تكرم أوائل الثانوية العامة في احتفالية خاصة ومتميزة`,
        urlTitle: `استكمالاً لدورها الرائد في تحقيق المسئولية الاجتماعية: " كونتكت " تكرم أوائل الثانوية العامة في احتفالية خاصة ومتميزة`,
        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/defult-news-image.png",
        sections: [
          `نظمت مجموعة " كونتكت المالية القابضة " ، الرائدة في مجال الخدمات المالية غير المصرفية، إحتفالية متميزة لتكريم الطلاب المتفوقين من أوائل الثانوية العامة بالتعاون مع جريدة الجمهورية. وأقيمت الإحتفالية بالمقر الرئيسي للمجموعة  بوسط البلد بمحافظة القاهرة بحضور العديد من الطلاب وأولياء أمورهم  ونخبة من مديري شركات المجموعة وموظفيها وسط أجواء سودها البهجة والسعادة .`,
          `وأقيمت الاحتفالية بحضور السيد سعيد زعتر، الرئيس التنفيذي لمجموعة كونتكت المالية، الذي كرم الطلاب الذين حققوا نتائج متميزة  في امتحاناتهم النهائية وتفوقوا في الدراسة حتى أصبحوا من الأوائل المجتهدين. `,
          `وقالت " كونتكت" في بيان لها صباح اليوم أن هذه المبادرة تأتي في ضوء التزامها بدعم التعليم وتشجيع الطلاب على تحقيق النجاح الأكاديمي ، مبينه أن هذه المناسبة بمثابة  فرصة للاحتفال بجهود الطلاب وتفانيهم في الدراسة والتحصيل العلمي.`,
          ` وكشف البيان أن تكريم أوائل الثانوية العامة شمل ، كل من " الشعبة العلمية - علوم، الشعبة العلمية – رياضيات،والشعبة الأدبية، وشعبة العلوم - الدمج التعليمي،وشعبة الرياضيات الدمج التعليمي، الشعبة الأدبية - الدمج التعليمي، والشعبة العلمية - علوم STEM،والشعبة العلمية - رياضيات STEM.`,
          `وخلال الحفل قام مديري الشركة في مجال الموارد البشرية وإدارة الاستدامة، بتقديم خطابات تشجيعية وتحفيزية وتعريف بالمجموعة وما تقوم به ومجالاتها لجميع الحضور.`,
          `وأشار البيان إلي أن إدارة الموارد البشرية قامت بتحليل شخصية للطلاب بهدف تقديم المشورة المهنية لهم و تعريفهم بالمهارات العملية اللازمة لحياتهم الوظيفية مستقبلاً ، ووزعت " كونتكت " الجوائز والشهادات التقديرية للطلاب المكرمين ، وتم تسليط الضوء على إنجازات الطلاب والدور الذي يلعبونه كنماذج إلهام للأجيال القادمة.`,
          `وعبر السيد سعيد زعتر، الرئيس التنفيذي لمجموعةشركات "  كونتكت المالية القابضة " ،عن  فخره وامتناننه للطلاب المتفوقين الذين إحتفلت بهم " كونتكت "  اليوم. مؤكداً علي أن تحقيق النجاح الأكاديمي في الثانوية العامة يعد إنجازًا كبيرًا يستحق التقدير والتكريم. `,
          `ووجه زعتر كلمة للطلاب المتفوقين وصف فيها الشباب أنهم أمل مستقبلنا، مشيداً بتفانيهم وتفوقهم الدراسي ، موضحاً أن  مجموعة " كونتكت المالية القابضة " تؤمن بقوة ، أن التعليم هو أساس بناء المجتمعات القوية والمستدامة. ومشيراً إلي أنه من خلال هذا التكريم، نسعى لتشجيعكم على الاستمرار في التفوق والسعي لتحقيق طموحاتكم الأكاديمية والمهنية.`,
          `ووجه الرئيس النفيذي لمجموعة " كونتكت المالية القابضة الشكر لأسرهم وللمعلمين الذين ساهموا في رحلتهم التعليمية. مقدمين الدعم والتوجيه اللازمين للطلاب ، مؤكداً انهم جزء لا يتجزأ من هذا النجاح . `,
          `وتابع زعتر : ، أود أن أوجه لكم التهنئة الحارة والتقدير العميق على هذا التحصيل الرائع ، أنتم نماذج مشرفة للإلهام والتفوق، ونحن مقتنعون بأن لديكم القدرة على تحقيق أهدافكم الكبيرة في المستقبل.وأتمنى لكم جميعًا مستقبلًا مشرقًا ونجاحًا مستمرًا في حياتكم الأكاديمية والمهنية ،  ونأمل في حياتكم القادمة وأن تستمتعوا باللحظات المتميزة التي ستبقى في ذاكرتكم الدائمة.`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 31,
        date: " 08/08/2023",
        city: "القاهرة",
        title: `كونتكت توفر الحلول المتكاملة لتغطية السيارات من التأمين والإصلاح والصيانة`,
        urlTitle: `كونتكت توفر الحلول المتكاملة لتغطية السيارات من التأمين والإصلاح والصيانة`,
        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/defult-news-image.png",
        sections: [
          `تقدم شركة كونتكت المالية القابضة خدمة تمويل الصيانة للسيارات وذلك في إطار التزامها بتلبية احتياجات عملائها وتوفير حلول مالية جديدة. والصيانة من المصاريف الطارئة التي تطرأ على العملاء دون الترتيب لها من قبل، وتعد هذه الخدمة مميزة حيث انها توفر على العملاء الوقت والمجهود. وصيانة السيارات تطلب مصاريف كثيرة في مراكز الخدمة والتوكيلات في حين ان يمكن تمويلها بكل سهولة من خلال شركة كونتكت.`,
          `توفر كونتكت خدمة التأمين على السيارات، حيث تقوم بتغطية شاملة للمركبات الخاصة بالعملاء وذلك سواء من خلال ذراع التأمينات العامة التابع لها، ثروة للتأمين، او من خلال شركة الوساطة التأمينية التابعة لها كونتكت للوساطة التأمينية، مما يحميهم من المخاطر المحتملة مثل الحوادث والسرقة والأعطال والأضرار الأخرى.  تتوفر خدمة التأمين من خلال شبكة واسعة من الشركاء الموثوقين ويتم اتاحة تلك الخدمة من خلال فروع الشركة المنتشرة في جميع أنحاء الجمهورية، مما يضمن توافر الخدمات في مختلف المناطق والمدن. ويمكن التواصل بسهولة عبر المنصات الإلكترونية أو الاتصال بمركز خدمة العملاء لدي الشركة للحصول على مزيد من المعلومات وطلب الخدمات. فتقدم الشركة خيارات تأمين متعددة تتناسب مع احتياجات كل عميل، كما توفر خدمة تمويل الصيانة الدورية وحدها دون الحاجة الي التأمين الشامل على السيارات وتعتبر تلك الخدمة ميزة لكل عميل لتوفير الصيانة لدية دون الحاجة الي دفع مبلغ مالي كبير. وتتميز الشركة بمرونة في التعامل وسرعة في تقديم الاستجابة للعملاء، مما يسهل عليهم الحصول على التمويل المطلوب بأسرع وقت ممكن.`,
          `ومن جانبه قال السيد تامر سمير، العضو المنتدب لشركة كونتكت للتمويل، ان تقديم خدمات تمويل الصيانة يعد خيارًا جيدًا للأشخاص الذين يرغبون في الحفاظ على ممتلكاتهم واستمرارية عملها بدون تحمل أعباء مالية كبيرة في البداية. وأننا نعمل على تلبية احتياجات العملاء من خلال توفير خدمات التمويل المختلفة، وهذا يعني أن العملاء يمكنهم الاستفادة من الصيانة اللازمة لسياراتهم دون الحاجة إلى دفع مبالغ كبيرة مقدمًا. هذا يساعد الناس على تخطي العقبات المالية ويضمن لهم الوصول إلى الخدمات اللازمة بسهولة.`,
          `وقال السيد سعيد زعتر، الرئيس التنفيذي لمجموعة كونتكت المالية، نحن في شركة كونتكت المالية القابضة نفخر بتقديم هذه الخدمة المبتكرة والتي تعكس التزامنا بتلبية احتياجات عملائنا وتوفير حلول مالية مرنة ومناسبة. نحن ملتزمون بتقديم تجربة عملاء مميزة والعمل على تحقيق رضاهم التام، وأننا نضمن تجربة خدمة عملاء استثنائية. ومن ضمن الجوانب الإيجابية لتمويل الصيانة، أنه يساهم في تعزيز الاقتصاد المحلي ودعم الشركات المتخصصة في مجال الصيانة فيمكن للأشخاص الحصول على الصيانة اللازمة بشكل منتظم، مما يؤدي إلى زيادة الطلب على الخدمات وبالتالي خلق فرص عمل ودعم النمو الاقتصادي.`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 32,
        date: "03/12/2023",
        city: "القاهرة",
        title: `بمشاركة كونتكت: اختتام فعاليات معرض وسط الصعيد الزراعي بمحافظة اسيوط`,
        urlTitle: `بمشاركة كونتكت: اختتام فعاليات معرض وسط الصعيد الزراعي بمحافظة اسيوط`,
        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/32.jpg",
        sections: [
          `شاركت مجموعة كونتكت المالية، الرائدة في مجال الخدمات المالية الغير مصرفية، في معرض ومؤتمر «وسط الصعيد الزراعي»، الذي أقيم يومي 7 و8 شهر مارس الجاري بمحافظة أسيوط، وضم أكبر تجمع لشركات المعدات والمنتجات الزراعية وشبكات الري والتقاوي والأسمدة والبذور، وعرضت الشركات أحدث المنتجات والمحاصيل الزراعية، والأسمدة والمبيدات وشبكات الري، والتقاوي والبذور المختلفة للمحاصيل الزراعية، إضافة إلى الأسمدة العضوية ومشاتل الفواكه والخضروات المختلفة، ومنتجات الطاقة الشمسية، كما شهد المعرض عقد عدة ندوات لتوعية وارشاد المزارعين والفلاحين.`,
          `وقد افتتح المعرض محافظ أسيوط السيد اللواء/ عصام سعد ، وعقب الافتتاح تفقد المحافظ ومرافقوه أقسام المعرض والخاصة بالمعدات والجرارات الزراعية ومعدات التقاوي ومنتجات الأسمدة، واستمع إلى شرح لأهم منتجات المصانع وأسعارها وأحدث المنتجات التي تقدمها الشركات للمزارعين من أسمدة وتقاوي، وكانت كونتكت هي الراعي الذهبي للمعرض فمن أهداف كونتكت الاهتمام بتمويل العملاء من المزارعين أو أصحاب المشروعات وحثهم على استخدام الطاقة النظيفة في كل القطاعات الزراعية والخدمية والصناعية بدلًا الطاقة الغير متجددة، وكذلك تتعاون مع عدد من الشركات العاملة في بناء محطات الطاقة الشمسية وحفر الآبار في الأراضي الصحراوية.`,
          `ومن جانبه قال السيد تامر سمير، العضو المنتدب لشركة كونتكت للتمويل، إن التنوع في إصدار المنتجات والتطور في جميع المجالات المستدامة، أعطت لكونتكت الصدارة في وللأهمية الكبرى بمشاركة المجموعة في مثل هذه المعارض لمساعدة تمويل صغار المزارعين، وأن الشركة تتناغم مع توجهات الدولة الرامية للبحث عن بدائل جديدة للطاقة وتوجهها نحو إيجاد بيئة نظيفة وصحية عبر الاعتماد المتزايد على مصادر الطاقة الجديدة من شمس ورياح.`,
          `وقال السيد سعيد زعتر، الرئيس التنفيذي لمجموعة كونتكت المالية، بجانب أن كونتكت تقوم بالتنوع في المنتجات التي يتم اطلاقها حسب احتياج السوق فمن اللازم الاهتمام أيضاً بالمشرعات الخضراء التي تراعي العنصر البيئي بالمجتمع، وإرساء قواعد التمويل المستدام بالقطاع غير المصرفي، مشيدا بالجهد الذي يبذله موظفي المجموعة لمراقبة السوق لمعرفة متطلباته، وأن الشركة تلعب دوراً مهماً في الخوض في مجالات متعددة من ضمنها مجالات المحافظة على البيئة. `,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 33,
        date: "04/26/2023",
        city: "القاهرة",
        title: `من خلال التمويل العقاري: كونتكت تعزز الاستقرار الاقتصادي والاجتماعي`,
        urlTitle: `من خلال التمويل العقاري: كونتكت تعزز الاستقرار الاقتصادي والاجتماعي`,
        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/defult-news-image.png",
        sections: [
          `تعلن شركة كونتكت المالية القابضة – الرائدة في مجال الخدمات المالية غير المصرفية - عن زيادة تمويلاتها العقارية لتصل إلى 6 ملايين جنيه مصري وذلك لفترة سداد تصل الي 10 سنوات. وتأتي هذه الخطوة في إطار سعي الشركة لتلبية احتياجات العملاء وتوفير حلول مالية مبتكرة وملائمة لهم.`,
          `وتوفر شركة كونتكت المالية القابضة خدمات التمويل العقاري للأفراد ومن خلال الشركات ايضا، وتهدف إلى تسهيل عملية الحصول على التمويل اللازم لشراء العقارات وتمويل مشروعات البناء والتطوير العقاري. وتتميز خدمات الشركة بالمرونة والسرعة في إصدار القروض، بالإضافة إلى توفير فترات سداد مرنة ومتنوعة تتناسب مع احتياجات العملاء. وشهدت الشركة نمو حجم التمويلات الجديدة بمعدل سنوي 88 %خلال عام 2022، مدفوعاً بتحسن عمليات التقديم وزيادة الإقبال على منتج التمويل العقاري طويل الأجل والممتد على عشر سنوات. واحتلت كونتكت للتمويل العقاري مركز الصدارة في مبادرة التمويل العقاري بنهاية مارس 2023 بحصة 1.5% بقيمة 838.361 مليون جنية.`,
          `ومن جانب اخر، يعتبر سوق التمويل العقاري والتقسيط في الساحل والسخنة وأماكن المصايف أحد الأسواق النابضة بالحياة، ويشهد هذا السوق نمواً كبيراً في السنوات الأخيرة. ولتلبية الحاجة المتزايدة للتمويل العقاري والتقسيط في هذه المناطق، تقدم كونتكت حلول تمويلية مبتكرة. ومن المتوقع أن تحظى هذه الحلول المبتكرة بإقبال كبير من قبل المستثمرين في الساحل والسخنة وأماكن المصايف، فستسهم في تسهيل الحصول على التمويل العقاري والتقسيط، وتوفير الوقت والجهد اللازمين للبحث عن الحلول المالية المناسبة.`,
          `وفي هذا السياق، أعلن السيد ايمن حليم، العضو المنتدب لشركة كونتكت للتمويل العقاري، اننا ندرس في الفترة القادمة دخول التمويل العقاري للوحدات التجارية للأفراد لكي نصل الي كل ما يحتاجه السوق والتوسع والتنوع لخدمة العميل وان هناك طلب على تمويل الوحدات التجارية ونقوم بدراسة السوق أيضا والأدوات التي يمكن ان نحتاجها للدخول في هذا النوع من التمويل. فنحن في شركة كونتكت للتمويل العقاري نولي أهمية كبيرة لتوظيف الكفاءات العالية والمتميزة في هذا المجال، وذلك لتقديم أفضل الخدمات لعملائنا. نحن نفخر بأن لدينا فريق عمل مؤهل وذو خبرة عالية في هذا المجال، ويسعدنا دائماً خدمتكم بأفضل ما لدينا.`,
          `وعلي هذا النحو أشار السيد سعيد زعتر، الرئيس التنفيذي لشركة كونتكت المالية القابضة، إلى أن هذه الخطوة تأتي في إطار استراتيجية كونتكت لتعزيز مكانتها في سوق التمويل العقاري وزيادة حصتها السوقية، وتعزيز قدرتنها على تلبية احتياجات العملاء بشكل أفضل. ونؤكد على استمرارنا في تقديم خدمات متميزة وملائمة لعملائنا، وتلبية تحديات سوق التمويل العقاري في مصر. وأوضح أن هذه الحلول المبتكرة تهدف إلى تلبية احتياجات الجميع، وتوفير أفضل الخيارات المتاحة لهم. وتعمل الشركة على توفير خدماتها الرائدة في هذا المجال من خلال شبكة واسعة من المتخصصين في التمويل العقاري والتقسيط، وذلك لضمان تلبية احتياجات عملائنا بأسرع وقت ممكن.`,
          `نبذه عن كونتكت:
          كونتكت المالية القابضة ش.م.م (كود البورصة المصرية CNFN.CA) هي مجموعة رائدة في تقديم الحلول والخدمات المالية غير المصرفية، حيث تتولى إدارة مجموعة من الشركات التي تقدم من خلالها مجموعة متكاملة من المنتجات والخدمات التمويلية والتأمينية. وتتبنى كونتكت منهجًا مبتكرًا لضمان تقديم خدماتها بأعلى جودة في مجالات التمويل والتأمين، وذلك بأسهل إجراءات وصولاً إلى قطاع عريض من السوق. فعن طريق شركة كونتكت للتمويل، تقدم كونتكت برامج تمويلية متنوعة لتمويل شراء السيارات والمركبات الجديدة والمستعملة، وعن طريق كونتكت كريدي تك تقدم برامج تمويل السلع الاستهلاكية والخدمات، إضافة إلى برامج التمويل العقاري والتشطيب من خلال كونتكت للتمويل العقاري، وبرامج التمويل التجاري من خلال شركاتها الشقيقة كونتكت للتأجير التمويلي وكونتكت للتخصيم. كما تقدم كونتكت خدمات التأمين من خلال شركتي ثروة للتأمين وثروة لتأمينات الحياة. كما تعد الشركة أول وأكبر مصدر لسندات التوريق في مختلف المجالات بالسوق المصري. شركة كونتكت المالية القابضة ش.م.م. مرخصة وخاضعة للهيئة العامة للرقابة المالية.
          `,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 40,
        date: "02/12/2024",
        city: "القاهرة",
        title: `شراكة استراتيجية بين كونتكت والأهلي ممكن لتحسين خدمات الدفع في مصر`,
        urlTitle: `شراكة استراتيجية بين كونتكت والأهلي ممكن لتحسين خدمات الدفع في مصر`,
        subTitle: ``,
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/AhlyMomken%20photo.jpg",
        sections: [
          `أعلنت اليوم شركة كونتكت لخدمات الدفع الإلكتروني "Contact Pay"، الشركة الرائدة في حلول الدفع وإحدى شركات مجموعة كونتكت الرائدة في مجال الخدمات المالية غير المصرفية، عن توقيع اتفاقية تعاون استراتيجية مع شركة  "الأهلي ممكن"، الرائدة في مجال المدفوعات الإلكترونية والتكنولوجيا المالية، لتيسير عمليات الدفع لعملاء كونتكت في مصر عبر توفير خيار دفع أقساط كونتكت في قنوات الدفع التابعة للأهلي ممكن. وقع من جانب كونتكت المهندس أحمد عبدالحكيم، العضو المنتدب لـ كونتكت لخدمات الدفع الإلكتروني، عن الاتفاقية، فيما وقع من جانب الأهلي ممكن المهندس أحمد عنايت، العضو المنتدب والرئيس التنفيذي. للأهلي ممكن `,
          `تعكس هذه الشراكة رؤية مشتركة بين الشركتين لتيسير عمليات الدفع للعملاء، وذلك من خلال فروع ونقاط البيع التابعة لـ "الأهلي ممكن" المتواجدة في جميع أنحاء مصر بأكثر من 90 ألف نقطة بيع وأكثر من 5 ملايين مستخدم. يُشير إلى أن "كونتكت" لها وجود جغرافي في معظم محافظات مصر ، وتقدم خدماتها في المناطق الريفية بتغطية كاملة واحترافية كما تقدمها في المدن في كل محافظات مصر. كما تمثل هذه الشراكة تكاملًا استراتيجيًا بين كونتكت لخدمات الدفع الإلكتروني كشركة متخصصة في حلول الدفع، وبين "الأهلي ممكن" كمقدمي حلول دفع إلكتروني ونقاط بيع في جميع أنحاء مصر، خاصة في المناطق الريفية، ويعزز هذا التعاون من سهولة وسرعة وصول العملاء إلى خدمات "كونتكت" عبر التغطية  الواسعة لـ "الأهلي ممكن". `,
          `وفي تصريحه بخصوص الاتفاقية، أكد المهندس أحمد عبدالحكيم، العضو المنتدب لـ كونتكت لخدمات الدفع الإلكتروني: "نحن متحمسون لهذه الشراكة الاستراتيجية مع 'الأهلي ممكن'، حيث تأتي في إطار التزامنا بتقديم خدمات الدفع بأعلى معايير الأمان والفعالية. هذه الاتفاقية تفتح أفقًا جديدًا للعملاء لإتمام معاملاتهم المالية بكل يسر وسهولة في جميع أنحاء البلاد". `,
          `من جهته، أشار السيد  مهاب جمال، نائب الرئيس التنفيذي بالأهلي ممكن : "تعكس هذه الشراكة تفانينا في تقديم تجارب دفع سلسة ومبتكرة . نحن واثقون من أن هذه الخطوة ستعزز من قدرة عملائنا على الوصول إلى خدمات كونتكت بشكل أسهل وأسرع من خلال فروعنا ونقاط البيع المنتشرة في جميع أنحاء البلاد". `,
          `كما أضاف المهندس احمد عنايت العضو المنتدب و الرئيس التنفيذي لشركة الأهلي ممكن أن التعاون مع شركة كونتكت ، يأتي استكمالا لاستراتيجية التوسع  وتقديم خدمات متنوعة و تعزيز خدمات دفع آمنة و سهلة و سريعة للمستهلكين في السوق المصري. `,
          `وختامًا، أعرب السيد سعيد زعتر، الرئيس التنفيذي لمجموعة كونتكت المالية، عن رؤيته للمستقبل، قائلاً: "تأتي هذه الخطوة في إطار رؤيتنا لتحقيق مجتمع مالي غير نقدي، حيث نسعى دائمًا لتقديم حلاً مبتكرًا ومستدامًا لاحتياجات عملائنا. نحن نؤمن بأهمية تكامل الخدمات المالية مع تقنيات الدفع الحديثة لتلبية احتياجات العملاء بشكل أفضل وأسهل". `,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 41,
        date: "02/27/2024",
        city: "القاهرة",
        title: `«رئيس كونتكت المالية القابضة» يشارك في فعاليات النسخة الثامنة لقمة أسواق المال`,
        urlTitle: `«رئيس كونتكت المالية القابضة» يشارك في فعاليات النسخة الثامنة لقمة أسواق المال`,
        subTitle: (
          <>
            <p>توحيد سعر الصرف هو الحل لمشكلات التمويل الاستهلاكي </p>
            <p>التمويل الاستهلاكي يدعم النمو الاقتصادي </p>
          </>
        ),
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Capital%20MArkets%20photo.jpg",
        sections: [
          `شارك السيد سعيد زعتر الرئيس التنفيذي لشركة كونتكت المالية القابضة ورئيس الاتحاد المصري للتمويل الاستهلاكي في فعاليات النسخة الثامنة للقمة السنوية لأسواق المال، تحت عنوان "الإصلاحات الهيكلية.. استدامة التنمية"؛ وتحت رعاية وزارتي المالية، والتخطيط والتنمية الاقتصادية، والهيئة العامة للرقابة المالية وجهات أخرى، لمناقشة الإصلاحات الهيكلية التي تجريها الدولة المصرية على جميع القطاعات الاقتصادية من حيث الاستثمار والاستدامة.  `,
          `وفي الجلسة الحوارية الثانية بعنوان "الشركات وتحديات إدارة تكاليف التمويل"، ، صرّح السيد سعيد زعتر: " أن التمويل الاستهلاكي يعد أحد أهم القطاعات الاقتصادية في مصر، حيث يمسّ حياة جميع المواطنين، ويُساهم في تحفيز الاستهلاك ودعم النمو الاقتصادي وهو المستقبل الذي سنتواجد فيه، حيث تم في 2020 إصدار قانون تنظيم التمويل الاستهلاكي وهو ما فتح مجالًا كبيرًا للشركات للدخول والقيام بدور كبير خاصةً في ظل أزمات كورونا وتغير سعر الصرف وغيره". وأضاف: " يختلف التمويل الاستهلاكي عن أنواع التمويل الأخرى مثل التأجير التمويلي مثلا حيث إنه لا يمكن فرض فائدة متغيرة على العميل" `,
          `وتحدث زعتر عن الثقافة الاستهلاكية للمواطنين، حيث أن العميل قد يستخدم التمويل الاستهلاكي في شراء سلع قد لا يحتاجها خوفاً من زيادة سعرها في المستقبل وقد يستخدم التمويل الاستهلاكي لغرض الادخار بسبب التضخم، وذلك يؤدي إلى صعوبة في سداد الأقساط المطالب بها.  `,
          `وقال زعتر إن "كونتكت" بدأت في 2001 كأول شركة تمويل في مصر، وبدأت في إصدار سندات التوريق في 2005 كأول مصدر لسندات التوريق في مصر ولاحقًا أصدرت الصكوك، حتى أصبحت من أكبر مصدري السندات والصكوك في مصر، مضيفًا أن الشركة تحتاج إلى سيولة كبيرة لتمويل عملياتها، لذا تلجأ لكل أدوات التمويل، حيث لا يمكن الاعتماد على البنوك وحدها، لذا نبحث الاحتياجات التمويلية للتوصل إلى السيولة المطلوبة. `,
          `وعن مشروع رأس الحكمة، توقع زعتر أن استقرار سعر الصرف سيجذب المستثمرين، مضيفًا أنه يجب السعي لاستقرار سعر الصرف وتوظيف الموارد، للاستمرار في سوق صحي يُمكّن الشركات من النظر بتفاؤل للاقتصاد المصري. `,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 42,
        date: "01/23/2024",
        city: "القاهرة",
        title: `كونتكت تتوسع في التمويل الأخضر: إطلاق برنامج تمويل السيارات الكهربائية`,
        urlTitle: `كونتكت تتوسع في التمويل الأخضر: إطلاق برنامج تمويل السيارات الكهربائية`,
        subTitle: (
          <>
            <p>
              تمويل السيارات الكهربائية من كونتكت: خطوة نحو مستقبل أخضر ونظيف{" "}
            </p>
            <p>
              تمويل السيارات الكهربائية من كونتكت: دعم للتحول إلى الطاقة النظيفة
              والمساهمة في الاستدامة{" "}
            </p>
          </>
        ),
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/electric%20Cars%20Photo.jpeg",
        sections: [
          `أعلنت شركة كونتكت المالية القابضة، الشركة الرائدة في مجال الخدمات المالية غير المصرفية، عن إطلاق نظام تمويل جديد مبتكر يهدف إلى تمويل السيارات الكهربائية. يأتي هذا المنتج الجديد كجزء من التزام الشركة بالاستدامة البيئية ودعم الانتقال إلى المستقبل الأخضر حيث يعيش العالم حاليًا تحديات بيئية هائلة نتيجة لتأثيرات تلوث الهواء وتغير المناخ، ومن بين الحلول الرئيسية لهذه التحديات هي تشجيع استخدام السيارات الكهربائية. فالسيارات الكهربائية تعد بديلاً مستدامًا ونظيفًا للسيارات التقليدية التي تعمل بالوقود. فهي تعمل بالكامل بالطاقة الكهربائية المستدامة، مما يقلل من انبعاثات ثاني أكسيد الكربون وتلوث الهواء. وبالتالي، يساهم استخدام السيارات الكهربائية في تحقيق أهداف الاستدامة البيئية وتقليل الأثر البيئي السلبي. `,
          `يتميز المنتج الجديد بمجموعة واسعة من الميزات المصممة خصيصًا لتلبية احتياجات العملاء وتسهيل عملية شراء السيارات الكهربائية، بمقدم يبدأ من ٢٠ ٪، كما أن التأمين اختياري، وفترات سداد تصل إلى 5 سنوات، وإمكانية السداد المبكر الكلي أو الجزئي بداية من أول شهر بدون رسوم سداد معجل. كما أن الشركة تقوم حاليًا بدراسة إمكانية تمويل سيارات النقل الكهربائية والدراجات الكهربائية، في ظل التحول العالمي نحو الاهتمام بالبيئة والحد من الخطر البيئي، حيث تعد وسائل النقل الكهربائية حلاً مبتكرًا وواعدًا في تخفيض انبعاثات الكربون وتحسين جودة الهواء في المدن. `,
          `في هذا السياق، صرح السيد تامر سمير، العضو المنتدب لشركة كونتكت للتمويل، قائلاً: "نحن فخورون بإطلاق منتج تمويل السيارات الكهربائية الجديد. حيث يمكن لهذا المنتج أن يلعب دورًا حاسمًا في تحسين تجربة العملاء، فهذا المنتج يعد استثمارًا مستقبليًا وفرصة لزيادة العملاء. كما أن تمويل السيارات الكهربائية يعتبر فرصة جيدة للنمو والتوسع في سوق السيارات. `,
          `كما أكد سمير، إننا نحرص على تلبية احتياجات العملاء وتوفير الخيارات المالية الملائمة لهم لتسهيل عملية التمويل. ونحن ملتزمون بتقديم تجربة عملاء ممتازة وتلبية توقعاتهم واحتياجاتهم، ونوفر معلومات شاملة عن السيارات الكهربائية وميزاتها، ونضمن دعمًا ما بعد البيع متميزًا وفعالًا. `,
          `كما أضاف السيد سعيد زعتر الرئيس التنفيذي لكونتكت المالية القابضة، نحن نؤمن جيدًا بالقيمة البيئية والاقتصادية للاستدامة. ومن خلال منتج تمويل السيارات الكهربائية، نسعى لتمكين الأفراد والمجتمعات من تحقيق رؤيتهم لمستقبل مستدام ونظيف. وندرك أن الاستدامة ليست مجرد مسؤولية الأفراد، ولكنها أيضًا مسؤولية الشركات. ولذلك، نعلن بفخر عن تبنينا لمجموعة من المبادرات التي تهدف إلى دعم الاستدامة البيئية وأطلقنا منتج تمويل السيارات الكهربائية بجانب منتج التمويل الأخضر الذي أطلقناه في نهاية عام 2022. كما نقوم نحن في كونتكت بتقديم مجموعة متنوعة من الخيارات المالية التي تناسب جميع متطلبات العملاء، ويتم ذلك من خلال فروع كونتكت المنتشرة في جميع أنحاء الجمهورية، ونبذل قصارى جهدنا كي نضع أنظمة تمويل متكاملة، مع الحفاظ على المرونة والسهولة. `,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 43,
        date: "03/14/2024",
        city: "القاهرة",
        title: `"كونتكت " و"OPay" تتعاونان لتقديم حلول دفع مبتكرة وتحسين تجربة العملاء`,
        urlTitle: `"كونتكت " و"OPay" تتعاونان لتقديم حلول دفع مبتكرة وتحسين تجربة العملاء`,
        subTitle: (
          <>
            <p>"كونتكت" و"OPay" تتعاونان لتقديم حلول دفع رقمية شاملة </p>
            <p>
              "كونتكت" تُوسّع من نطاق تواجدها في السوق المصرية من خلال شراكة مع
              OPay{" "}
            </p>
          </>
        ),
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/OPay%20photo.jpg",
        sections: [
          `في إطار سعيها المتواصل لتقديم حلول دفع مبتكرة وفعالة لعملائها، أعلنت شركة "كونتكت لخدمات الدفع الإلكتروني" (Contact Pay)، الرائدة في مجال حلول الدفع وإحدى شركات مجموعة كونتكت الرائدة في مجال الخدمات المالية غير المصرفية ، عن توقيع اتفاقية تعاون استراتيجية مع شركة "OPay"، الشركة الرائدة في مجال المدفوعات عبر الهاتف المحمول. تهدف هذه الاتفاقية إلى تعزيز التعاون بين الشركتين لتقديم حلول دفع رقمية شاملة تلبي احتياجات العملاء المتنوعة وتُحسّن من تجربتهم بشكل كبير. `,
          `بموجب هذه الاتفاقية، ستعمل "OPay" كذراع تحصيل جديد لـ "كونتكت" على الأرض، مما سيُوسّع من نطاق تواجدها ووصولها إلى العملاء في مختلف أنحاء مصر. ستُتيح هذه الشراكة لـ "كونتكت" الاستفادة من شبكة " OPay " الواسعة من نقاط البيع وأكشاك الدفع، والتي تُقدّر بأكثر من 90 ألف نقطة موزعة جغرافياً في جميع أنحاء الجمهورية. `,
          ` وتعليقًا على الاتفاقية، صرح عمرو جوهر، رئيس قطاع تطوير الأعمال في OPay ، قائلاً: "تمثل الشراكة معContact Pay خطوة استراتيجية هامة لتعزيز تجربة الدفع الرقمية للمستهلكين والشركات على حد سواء. تؤكد هذه الشراكة على التزام "OPay"بدفع الابتكار في مجال التكنولوجيا المالية في مصر وتعاونها مع كل أطراف القطاع المالي في مصر. فإن "OPay" تقدم مجموعة واسعة من حلول الدفع الرقمية المبتكرة، مثل الدفع بدون اتصال، والدفع عبر الإنترنت، وخدمة المحفظة الرقمية المدعومة بالذكاء الاصطناعي. ستُتيح هذه الحلول لعملاء "كونتكت" الاستمتاع بتجربة دفع سلسة وسهلة وآمنة، دون الحاجة إلى حمل النقود أو البطاقات البنكية." `,
          `بدوره، أعرب أحمد عبد الحكيم، العضو المنتدب لـ "كونتكت لخدمات الدفع الإلكتروني"، عن سعادته بتوقيع هذه الشراكة الاستراتيجية مع "OPay"، قائلاً: "نحن سعداء بتوقيع هذه الشراكة الاستراتيجية مع "OPay"، التي ستساهم بشكل كبير في تعزيز خدمات الدفع المقدمة للعملاء وتحسين تجربتهم، وتسهيل تحصيل مدفوعاتهم عبر إضافة وسيلة دفع جديدة تنضم لمحفظة وسائل تحصيل كونتكت، التي حرصت دائما على راحة عمليها وتسهيل معاملاتها المالية." `,
          `محمود خضر، الرئيس التنفيذي لشركة "OPay"، أعرب عن حماسه لتوقيع هذه الشراكة الاستراتيجية مع Contact Pay، حيث تمثل هذه الخطوة خطوة استراتيجية هامة في رحلة تطوير الدفع الرقمي في مصر. وأكد "أن "OPay"ملتزمة بتقديم أحدث وأفضل التقنيات والحلول في مجال التكنولوجيا المالية، وهذه الشراكة تعكس تفانيهم في توفير تجربة دفع سلسة ومبتكرة للعملاء. وأن هذه الشراكة ستفتح أبوابًا جديدة للابتكار والنمو في قطاع الدفع الرقمي، حيث ستجمع القوتين والخبرات لتطوير حلول دفع متقدمة تلبي احتياجات العملاء وتحسن تجربتهم بشكل ملحوظ. `,
          `وفي النهاية، أضاف السيد سعيد زعتر، الرئيس التنفيذي لشركة كونتكت المالية القابضة: "إن هذه الشراكة تمثل خطوة استراتيجية هامة نحو تحقيق رؤيتنا في تحسين تجربة الدفع الإلكتروني في مصر وتقديم حلول دفع مبتكرة تلبي تطلعات عملائنا. نحن واثقون من أن هذه الشراكة ستعزز مكانة الشركة كرائدة في قطاع الخدمات المالية غير المصرفية وستساهم في تعزيز التكنولوجيا المالية في السوق المصرية." `,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 44,
        date: "04/7/2024",
        city: "القاهرة",
        title: `الابتكار المالي يقود "كونتكت" للتميز في "أقوى 50 شركة تكنولوجيا مالية في الشرق الأوسط لعام 2024`,
        urlTitle: `الابتكار المالي يقود "كونتكت" للتميز في "أقوى 50 شركة تكنولوجيا مالية في الشرق الأوسط لعام 2024`,
        subTitle: (
          <>
            <p>"كونتكت": ريادة في التكنولوجيا المالية وتقدير عالمي </p>
          </>
        ),
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/Fintech.jpg",
        sections: [
          `حققت "كونتكت المالية القابضة" إنجازًا لافتًا بتصنيفها ضمن قائمة "أقوى 50 شركة تكنولوجيا مالية في الشرق الأوسط لعام 2024"، وفقًا لتصنيف مجلة "فوربس الشرق الأوسط". يُعد هذا التصنيف شهادة على الدور البارز الذي تقوم به الشركة في تقديم حلول مالية مبتكرة وغير تقليدية. `,
          `منذ تأسيسها في عام 2001، نمت "كونتكت المالية القابضة" لتصبح علامة بارزة في السوق المصري، مع توسع شبكة فروعها لتشمل 75 فرعًا و13 نقطة بيع، مما يعزز وصول خدماتها لشريحة أوسع من العملاء. وقد أظهرت الشركة قدرة فائقة على الابتكار من خلال إطلاق تطبيق "كونتكت ناو"، الذي يستخدم الذكاء الاصطناعي لتوفير الموافقات الائتمانية الفورية وإدارة المعاملات المالية بكفاءة، فبحلول نهاية ديسمبر 2023، بلغ عدد المستخدمين المسجلين في التطبيق أكثر من 600 ألف مستخدم، مع تسجيل 296 ألف مستخدم جديد في عام 2023 وحده. كما تلقى التطبيق أكثر من 271 ألف طلب للحصول على تمويل فوري، مما يعكس الثقة العميقة التي يحظى بها بين العملاء. `,
          `كما أسست“Contact Pay”  والتي تعد ذراع المدفوعات الإلكترونية تحت مظلة “كونتكت المالية القابضة”، وهي رائدة في تقديم حلول الدفع الرقمية المبتكرة، وتمثل التزام “كونتكت” بالابتكار وتحسين الخدمات المالية، مما يعكس رؤيتها لتكون الخيار الأول للخدمات المالية الرقمية المبتكرة. تسعى الشركة دائمًا لتقديم تجارب دفع سلسة وآمنة، مما يجعل النقد والبطاقات المادية أمرًا من الماضي، ويدفع بالمعاملات المالية نحو مستقبل رقمي متكامل. `,
          `وتعليقاً على الخبر صرح السيد سعيد زعتر الرئيس التنفيذي لشركة كونتكت المالية القابضة "إن الابتكار هو قلب نجاحنا والتزامنا بالتميز هو روح شركتنا. تصنيفنا ضمن أفضل 50 شركة تكنولوجيا مالية في الشرق الأوسط لعام 2024' ليس مجرد إنجاز، بل هو دليل على ثقة عملائنا وتفاني فريقنا. نحن نبني مستقبل التكنولوجيا المالية، وكل خطوة نتقدم بها تقربنا أكثر من تحقيق رؤيتنا لتمكين الأفراد والشركات من خلال حلول مالية مبتكرة وموثوقة." `,
          `جدير بالذكر أن هذه ليست المرة الأولى التي تتضمن قوائم فوربس الشرق الأوسط إنجازات شركة كونتكت، فكونتكت قد صنفت لعامين على التوالي من اقوى 50 شركة مدرجة بالبورصة المصرية كما تم تكريم كونتكت كأحد قادة الاستدامة في الشرق الأوسط ذلك بخلاف تصنيف السيد سعيد زعتر رئيسها التنفيذي كأحد أقوى الرؤساء التنفيذيين في الشرق الأوسط للعام 2023. `,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 45,
        date: "06/29/2024",
        city: "القاهرة",
        title: `"جوميا" و "كونتكت " تعلنان عن توسيع الشراكة الاستراتيجية  
`,
        urlTitle: `"جوميا" و "كونتكت " تعلنان عن توسيع الشراكة الاستراتيجية`,
        subTitle: (
          <>
            <p>جوميا تتعاون مع كونتكت لتسهيل عملية الشراء عبر الإنترنت</p>
          </>
        ),
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/9d6d94a7-263d-4689-ae3f-7062f4f8ff40.jfif",
        sections: [
          `أعلنت كل من جوميا منصة التجارة الإلكترونية الرائدة في السوق المصرية عن توسيع الشراكة الاستراتيجية بين جوميا باي و كونتكت كريدي تك - ذراع التمويل الاستهلاكي الرقمي التابع لمجموعة كونتكت المالية – لتقديم خدمات أفضل لعملائهما، وذلك استكمالً للنجاح الذي حققته هذه الشراكة والتي بدأت في يناير 2023، لتشمل توفير طرق دفع متنوعة لتيسير عملية الشراء عبر الإنترنت وخلق حلول مالية متنوعة لعملاء جوميا و كونتكت.`,
          `ويشمل التعاون بين جوميا و كونتكت توفير طرق دفع مختلفة لتسهيل عملية الشراء وخلق حلول مالية متنوعة لعملاء جوميا و كونتكت، حيث تولي مجموعة كونتكت بصفة عامة و كونتكت كريدي تك على وجه الخصوص اهتماما كبيرا بالتحول الرقمي وفقا لرؤية الدولة المصرية 2030 والسعي نحو توسيع قاعدة الخدمات الرقمية المقدمة للسوق المصرية واستخدام أحدث التقنيات في مجال التكنولوجيا المالية.`,
          `وتعقيبا على هذه الخطوة، أعرب عبد اللطيف عٌلما، الرئيس التنفيذي لشركة جوميا مصر عن بالغ سعادته باستمرار التعاون بين الشركتين لمصلحة العملاء، حيث تعتبر هذه الخطوة جزءًا من التزام جوميا باي و كونتكت لتقديم أفضل تجربة تسوق عبر الإنترنت للمستهلكين في السوق، وتعزز الثقة بين الشركتين كشركاء استراتيجيين تعملان جنبًا إلى جنب لتحقيق أهداف مشتركة وتلبية احتياجات العملاء بشكل أفضل.`,
          `وتابع عٌلما "نتطلع إلى مستقبل مشرق من النجاح والتطور في هذه الشراكة المثمرة بين الشركتين". `,
          `وأوضح عمر الفقي، العضو المنتدب لكونتكت كريدي تك أنه من خلال توسيع نطاق شراكتنا وتقديم عروض بدون رسوم إدارية وبدون فوائد وبدون مقدم، نسعى إلى تحقيق مزيد من المزايا لعملائنا المشتركين. نحن متحمسون للغاية لمستقبل هذه الشراكة ونتطلع إلى تحقيق نجاحات جديدة معًا، وتقديم تجارب تسوق متميزة تلبي تطلعات واحتياجات العملاء في السوق".`,
          `ومن جانبه، قال سعيد زعتر، الرئيس التنفيذي لكونتكت المالية القابضة "نحن في كونتكت نعتز بالتعاون الوثيق والشراكة الاستراتيجية التي نمتلكها مع جوميا. هذه الشراكة ليست مجرد اتفاقية تجارية وحسب، بل هي رؤية مشتركة لتحسين تجربة التسوق عبر الإنترنت لعملائنا، نحن نؤمن بأهمية توفير حلول مالية مبتكرة ومريحة للعملاء، وهذا يتطلب شراكات استراتيجية قوية مع أطراف مثل جوميا، التي تتمتع بخبرة واسعة في مجال التجارة الإلكترونية والتكنولوجيا".`,
          `وفي إطار احتفالات جوميا بعيد ميلادها الـ 12 في السوق المصرية في الفترة من 27 مايو إلى 9 يونيو من العام الحالي، يمكن للعملاء الشراء والتسوق من خلال جوميا و تقسيط المشتريات من خلال كونتكت بدون رسوم إدارية وبدون فوائد وأيضا بدون مقدم لمدة تصل إلى ستة أشهر حيث يمكن للعملاء الاستفادة من هذه الفرصة للتسوق بمرونة وراحة تامة.`,
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 46,
        date: "05/12/2024",
        city: "القاهرة",
        title: `كونتكت وضامن تتعاونان لتقديم حلول دفع مبتكرة وتحسين تجربة العملاء `,
        urlTitle: `كونتكت وضامن تتعاونان لتقديم حلول دفع مبتكرة وتحسين تجربة العملاء`,
        subTitle: (
          <>
            <p>
              كونتكت وضامن تتعاونان لتقديم حلول دفع مبتكرة وتحسين تجربة العملاء
            </p>
          </>
        ),
        img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/3c2928b6-0291-4681-9994-a74d01f503cc.jfif",
        sections: [
          ` أعلنت شركة "كونتكت لخدمات الدفع الإلكتروني" (Contact Pay)، الرائدة في مجال حلول الدفع وإحدى شركات مجموعة كونتكت الرائدة في مجال الخدمات المالية غير المصرفية، عن توقيع اتفاقية تعاون استراتيجية مع شركة "ضامن" للمدفوعات الإلكترونية، الشركة المصرية الناشئة المتخصصة في تقديم حلول دفع إلكتروني مبتكرة للأفراد والمؤسسات. تهدف هذه الاتفاقية إلى تعزيز التعاون بين الشركتين لتقديم حلول دفع رقمية شاملة تلبي احتياجات العملاء المتنوعة وتُحسّن من تجربتهم بشكل كبير.`,
          `تهدف هذه الشراكة إلى الجمع بين خبرات كلتا الشركتين الواسعة لتقديم منظومة دفع رقمية شاملة تلبي احتياجات العملاء المتنوعة وتُبسّط تجربتهم بشكل ملحوظ.`,
          `بموجب بنود الاتفاقية، ستعمل "ضامن" كذراع تحصيل جديد لـ "كونتكت" على الأرض، مما سيُتيح لها تعزيز تواجدها الجغرافي ووصولها إلى قاعدة عملاء أوسع بكثير في مختلف أنحاء الجمهورية. ستستفيد "كونتكت" من شبكة "ضامن" الواسعة التي تضم أكثر من 100 ألف نقطة بيع وأكشاك دفع موزعة جغرافياً في جميع أنحاء مصر، وهو ما يُعدّ إضافة قوية لمحفظة قنوات التحصيل التي تقدمها "كونتكت" لعملائها.`,
          `صرح أحمد عبد الحكيم، العضو المنتدب لـ "كونتكت لخدمات الدفع الإلكتروني"،  قائلاً: "إنّ توقيع هذه الشراكة الاستراتيجية مع "ضامن"، يمثل خطوة مهمة بالنسبة لنا. نحن على يقين بأنّ هذه الشراكة ستُساهم بشكل كبير في تعزيز خدمات الدفع التي نقدمها لعملائنا، وتبسّط عملية تحصيل المدفوعات عليهم، وتمنحهم خيارات دفع أكثر تنوعاً. نؤمن بأنّ هذه الخطوة ستصب في مصلحة عملائنا وستعزز مكانة "كونتكت" كرائدة في مجال توفير حلول الدفع المبتكرة."`,
          `من جانبه، أعرب سامح الملاّح، الرئيس التنفيذي لشركة "ضامن" للمدفوعات الإلكترونية، عن حماسه بهذه الشراكة، حيث صرح: "يسعدنا للغاية إبرام هذه الشراكة الاستراتيجية مع "كونتكت"، الشركة الرائدة في مجال حلول الدفع الإلكتروني بمصر. ستتيح لنا هذه الشراكة الاستفادة من تاريخ "كونتكت" العريق وخبرتها الواسعة في هذا المجال، وهو ما سيساعدنا على توسيع نطاق خدماتنا لتلبية احتياجات عدد أكبر من العملاء. نحن على ثقة بأنّ هذه الشراكة ستُحدث نقلة نوعية في مجال التكنولوجيا المالية في مصر، وستساهم في دفع عجلة الشمول المالي الذي نسعى إليه جميعاً."`,
          `كما أضاف السيد سعيد زعتر، الرئيس التنفيذي لشركة كونتكت المالية القابضة، تعليقاً على الاتفاقية: "تمثل هذه الشراكة الاستراتيجية مع "ضامن" خطوة استراتيجية هامة نحو تحقيق رؤيتنا المتمثلة في الارتقاء بتجربة الدفع الإلكتروني في مصر وتوفير حلول دفع مبتكرة تلبي تطلعات عملائنا. نحن على ثقة بأنّ تعاوننا مع "ضامن" سيعزز ريادتنا في قطاع الخدمات المالية غير المصرفية وسيعود بالنفع على السوق المصرية برمتها من خلال تعزيز مشهد التكنولوجيا المالية."`,
        ],
        bodyImages: ["", "", ""],
      },
    ],
  },
  errorPage: {
    title: "لم يتم العثور ع الصفحة ",
    Home: "العودة الى الصفحة الرئسيه",
  },
  internetConnectionPage: {
    title: "عذراً!!",
    subTitle: "لا يوجد إتصال بالإنترنت. تحقق من إتصالك وحاول مرة اخرى",
    Home: "إعادة التحميل",
  },
  paymentSucsess: {
    title: "لقد تم الدفع بنجاح",
    Home: "العودة الى الصفحة الرئسيه",
    Sucsess: "نجاح",
  },
  paymentFail: {
    title: "",
    Home: " المحاولة مرة اخري ",
    error: "خطأ",
  },
  blogs: {
    title: "المدونات",
    minutes: " دقائق قراءة",
    read_more: "إقرأ المزيد",
    share: "شارك",
    blogs_list: [
      {
        id: 1,
        //  date: mm/dd/yyyy
        date: "04/03/2023",
        city: "القاهرة",
        title: `متتنازلش عن فرح أحلامك: الفرحة بتتضاعف مع كونتكت!`,
        urlTitle: `متتنازلش عن فرح أحلامك: الفرحة بتتضاعف مع كونتكت!`,
        subTitleA: `الأفراح بتحتاج تخطيط ومصاريف كتير عشان تحقق حلم العروسين وطلباتهم والتفاصيل اللي نفسهم يعملوها ، من الفستان والبدلة للمكان، والأكل، DJ، وغيرها من التفاصيل.
بس أغلب العرسان مش بيكون عندهم توفر مبلغ كافي  عشان يمولوا فرحهم، فبيستخدموا كروت الائتمان بتاعتهم أو ياخدوا قروض من البنك عشان يغطوا مصاريف الفرح، وغيرها من الحلول اللي أحياناً بتكون متعبة.
`,
        subTitleB: `الأفراح بتحتاج تخطيط ومصاريف كتير عشان تحقق حلم العروسين وطلباتهم والتفاصيل اللي نفسهم يعملوها ، من الفستان والبدلة للمكان، والأكل، DJ، وغيرها من التفاصيل.
بس أغلب العرسان مش بيكون عندهم توفر مبلغ كافي  عشان يمولوا فرحهم، فبيستخدموا كروت الائتمان بتاعتهم أو ياخدوا قروض من البنك عشان يغطوا مصاريف الفرح، وغيرها من الحلول اللي أحياناً بتكون متعبة.
`,
        img: "/blogs/6.png",
        sections: [
          {
            head: "عيش فرح أحلامك مع كونتكت. ",
            body: "إحنا عارفين إن يوم فرحك هو واحد من أهم أيام حياتك، عشان كده إحنا هنساعدك تعمله من غير أي ضغط مالي، علشان كده بنقدملك برنامج كونتكت تمويل أفراح!",
          },
          {
            head: "مميزات تمويل فرحك مع كونتكت ",
            body: (
              <>
                <p style={{ fontWeight: "bold" }}>
                  مع كونتكت، خلي فرح أحلامك يبقى حقيقة لأن إحنا بنقدملك:
                </p>
                <ul style={{ paddingRight: "1.5rem" }}>
                  <li style={{ marginBottom: "5px" }}>
                    {" "}
                    خطط تقسيط مناسبة: إحنا بنقدم خطط تقسيط مختلفة تناسب
                    ميزانيتك. تقدر تختار خطة تناسب دفعاتك الشهرية وشروط السداد
                    المبكر.
                  </li>
                  <li style={{ marginBottom: "5px" }}>
                    اجراءات سهلة: عملية التقديم سريعة وسهلة. تقدر تتقدم أونلاين
                    أو شخصيًا في واحد من فروعنا.
                  </li>
                  <li style={{ marginBottom: "5px" }}>
                    أسعار فائدة تنافسية: إحنا بنقدم أسعار فائدة تنافسية على
                    تمويل الأفراح والحفلات.
                  </li>
                  <li style={{ marginBottom: "5px" }}>
                    خدمة عملاء مضمونة: فريقنا ممكن يجاوب على اسئلتك ويساعدك في
                    عملية التمويل.
                  </li>
                  <li style={{ marginBottom: "5px" }}>مقدم يبدأ من 20%</li>
                  <li style={{ marginBottom: "5px" }}>
                    ميزانية تمويل لغاية مليون جنيه عشان تعيش فرح أحلامك.
                  </li>
                </ul>
              </>
            ),
          },
          {
            head: "هل محتاج حساب بنكي أو تقييم ائتماني عشان تمول فرحك مع كونتكت؟ ",
            body: "لا، مش محتاج حساب بنكي أو تقييم ائتماني عشان تقدم على تمويل فرحك معانا.",
          },
          {
            head: "إيه  الأوراق اللي محتاجها عشان تقدم على تمويل فرحك مع كونتكت؟ ",
            body: (
              <>
                <p style={{ fontWeight: "bold" }}>
                  عشان تقدم لتمويل الأفراح مع كونتكت، هتحتاج تقدم البيانات دي:
                </p>
                <ul style={{ paddingRight: "1.5rem" }}>
                  <li style={{ marginBottom: "5px" }}>اسمك الكامل</li>
                  <li style={{ marginBottom: "5px" }}>تاريخ ميلادك</li>
                  <li style={{ marginBottom: "5px" }}>رقم بطاقتك الشخصية</li>
                  <li style={{ marginBottom: "5px" }}> بيانات الدخل </li>
                  <li style={{ marginBottom: "5px" }}>
                    المبلغ المطلوب للتمويــل
                  </li>
                  <li style={{ marginBottom: "5px" }}>نظام السداد المناسب </li>
                </ul>
                <p>
                  لما تبعت طلبك، فريقنا هيراجعه ويرد عليك، ويبعتلك عقد التمويل.
                  بعد كده تقدر تبدأ تخطط لفرحك براحتك ومتشلش هم المصاريف .
                </p>
              </>
            ),
          },
          {
            head: "بعض النصائح لتمويل فرحك: ",
            body: (
              <>
                <ul style={{ paddingRight: "1.5rem" }}>
                  <li style={{ marginBottom: "5px" }}>
                    {" "}
                    ابدأ التخطيط بدري. كل ما تبدأ تخطط بدري، هيكون عندك وقت أكتر
                    عشان توفر فلوس وتلاقي أحسن اختيارات تمويل.
                  </li>
                  <li style={{ marginBottom: "5px" }}>
                    {" "}
                    حدد ميزانية تلتزم بيها. مهم جدًا إن يكون عندك ميزانية واقعية
                    لفرحك عشان تصرف فلوسك بحكمة.
                  </li>
                  <li style={{ marginBottom: "5px" }}>
                    {" "}
                    فكر في كل أساليب التمويل المتاحة. فيه طرق كتيرة مختلفة عشان
                    تمول فرحك، فاحرص إنك تقارن بين خياراتك قبل ما تقرر.
                  </li>
                </ul>
              </>
            ),
          },
          {
            head: `احسب أقساطك الشهرية مع كونتكت`,
            body: (
              <p>
                ريحناك من التخمين، دلوقتي تقدر تحسب أقساطك الشهرية باستخدام {""}
                <a href="/products/events" target="blank">
                  {" "}
                  أداة حساب القسط{" "}
                </a>
                مع كونتكت
              </p>
            ),
          },
          ,
          {
            head: "تواصل معنا:",
            body: (
              <p>
                لمعرفة المزيد عن تمويل حفلات الزفاف مع كونتكت. اتصل بنا للإجابة
                على أسئلتك ومساعدتك أن
                <a href="/contact-us/" target="blank">
                  {" "}
                  تبدأ
                </a>
                .
              </p>
            ),
          },
        ],
        bodyImages: ["", "", ""],
      },
      {
        id: 2,
        //  date: mm/dd/yyyy
        date: "04/03/2023",
        title: "الموتوسيكل، السكوتر، أو دراجتك النارية أقرب مما تتصور!",
        urlTitle: "الموتوسيكل، السكوتر، أو دراجتك النارية أقرب مما تتصور!",
        subTitleA: `كونتكت بتقدملك أسهل برنامج تمويل يساعدك تشتري الموتوسيكل، السكوتر، أو الدراجة النارية اللي بتحلم بيها  من خلال أكبر مبلغ تمويل متاح، عشان تقدر تشتري اللي نفسك فيه. قدم دلوقتي وابدأ رحلتك على طول!`,
        subTitleB: `كونتكت بتقدملك أسهل برنامج تمويل يساعدك تشتري الموتوسيكل، السكوتر، أو الدراجة النارية اللي بتحلم بيها  من خلال أكبر مبلغ تمويل متاح، عشان تقدر تشتري اللي نفسك فيه. قدم دلوقتي وابدأ رحلتك على طول!`,
        img: "/blogs/8.png",
        sections: [
          {
            head: `زيادة الطلب على الدراجات النارية في مصر `,
            body: (
              <>
                <p>
                  الدراجات النارية في مصر بتزيد شعبيتها. وهي واحدة من أسرع وأكثر
                  وسائل النقل المتاحة من ناحية الاعتمادية والاقتصادية. من
                  السكوترات والدراجات النارية والدراجات الهوائية والجبلية.
                  وبالتالي مصر جذبت كتير من العلامات التجارية لسوقها اللي بيكبر
                  في الفترة الأخيرة.
                </p>
                <p>
                  سبب آخر لتفضيل المصريين للدراجات النارية والسكوترات عن
                  السيارات هو سعرها وفارق السعر حالياً مع السيارات؛ فالدراجات
                  النارية اقتصادية أكتر ومش بتحتاج مصاريف بنزين وصيانة زي
                  السيارات، وده بيخليها أفضل وسيله مواصلات للشباب.
                </p>
              </>
            ),
          },
          {
            head: `تقسيط الدراجات النارية مع كونتكت:`,
            body: (
              <>
                <p>
                  لو لقيت الموتوسيكل، السكوتر، أو الدراجة النارية اللي بتحلم
                  بيها، ومش عارف تدفع كاش ولا تقسيط، كل طريقه دفع ليها مزايا
                  وعيوب. إذا دفعت كاش، مدخراتك هتقل وهتأثر على استقرارك المالي
                  لفترة علشان تقدر تحوش من تاني.
                </p>

                <p>
                  {""} إذا دفعت بالأقساط، مش هتأثر على مدخراتك لأن مش مطلوب منك
                  تدفع مبلغ كبير مره واحدة. ولو بتفكر في سعر الفايدة أو المصاريف
                  الإدارية ، كونتكت حلتهالك! من خلال أقل سعر فايدة على القسط
                  ومصاريف ادارية بسيطة جداً وفي متناول
                  <span style={{ fontWeight: "bold" }}>
                    {""} الجميع {""}
                  </span>
                  علشان نخلي قرارك أسهل.
                </p>
              </>
            ),
          },
          {
            head: `كونتكت بتقدملك أسهل برنامج تمويل عشان تشتري الموتوسيكل، السكوتر، أو الدراجة النارية اللي بتحلم بيها:`,
            body: (
              <>
                <ul style={{ paddingRight: "2rem" }}>
                  <li style={{ marginBottom: "5px" }}>
                    {" "}
                    التقديم للبرنامج سهل وسريع، وممكن تستلم الموافقة في خلال ٢٤
                    ساعة فقط.
                  </li>
                  <li style={{ marginBottom: "5px" }}>
                    {" "}
                    كونتكت بتقدملك اكبر مبلغ تمويل متاح للموتوسيكل، السكوتر، أو
                    الدراجة النارية يصل إلى ٢ مليون جنيه، عشان تقدر تشتري اللي
                    نفسك فيه بدون تردد.
                  </li>
                  <li style={{ marginBottom: "5px" }}>
                    {" "}
                    كونتكت بتقدملك خيارات تمويل مختلفة، عشان تختار الخطة اللي
                    تناسب ميزانيتك.
                  </li>
                  <li style={{ marginBottom: "5px" }}> مقدم يبدأ من 20%.</li>
                  <li style={{ marginBottom: "5px" }}>
                    {" "}
                    هتقدر تأمن على الموتوسيكل، السكوتر، أو الدراجة النارية.
                  </li>
                  <li style={{ marginBottom: "5px" }}>
                    {" "}
                    برامج التمويل بتاعتنا متاحة لجميع أنواع الدراجات (عجلتين،
                    ثلاث عجلات، أو أربع عجلات)، سواء كانت جديدة أو مستعملة أو
                    مستوردة.
                  </li>
                </ul>
              </>
            ),
          },
          {
            head: `هل محتاج حساب بنكي أو تقييم ائتماني عشان تمول الموتوسيكل، السكوتر، أو الدراجة النارية مع كونتكت؟  `,
            body: `لا، مش محتاج حساب بنكي أو تقييم ائتماني عشان تقدم على تمويل مع كونتكت.`,
          },
          {
            head: `عشان تقدم لتمويل الموتوسيكل، السكوتر، أو الدراجة النارية مع كونتكت، هتحتاج تقدم البيانات دي:`,
            body: (
              <>
                <ul style={{ paddingRight: "2rem" }}>
                  <li style={{ marginBottom: "5px" }}>اسمك الكامل</li>
                  <li style={{ marginBottom: "5px" }}>تاريخ ميلادك</li>
                  <li style={{ marginBottom: "5px" }}>رقم بطاقتك الشخصية</li>
                  <li style={{ marginBottom: "5px" }}>بيانات الدخل</li>
                  <li style={{ marginBottom: "5px" }}>
                    مبلغ التمويل اللى محتاجه
                  </li>
                  <li style={{ marginBottom: "5px" }}>نظام السداد المناسب</li>
                </ul>
                <p>
                  لما تبعت طلبك، هنراجعه ونبعتلك عقد تمويل لو طلبك اتوافق عليه.
                  بعد توقيع عقد التمويل، تقدر تبدأ تستخدم فلوس التمويل وتشتري
                  الموتوسيكل اللي بتحلم بيه!
                </p>
              </>
            ),
          },
          {
            head: `احسب أقساطك الشهرية مع كونتكت `,
            body: (
              <p>
                من غير حيره وتفكير، احسب أقساطك الشهرية باستخدام طريقة {""}
                <a
                  href="https://contact.eg/ar/products/motorcycles"
                  target="blank"
                >
                  حساب الأقساط {""}
                </a>
                مع كونتكت
              </p>
            ),
          },

          {
            head: `تواصل معنا`,
            body: (
              <p>
                عشان تعرف كل التفاصيل عن تمويل الموتوسيكلات مع كونتكت، اتصل بنا
                وهنجاوب على أسئلتك ونساعدك{" "}
                <a href="https://contact.eg/ar/contact-us" target="blank">
                  تبدأ
                </a>
                .
              </p>
            ),
          },
        ],
      },
      {
        id: 3,
        date: "08/16/2023",
        title: `تمويل التعليم مع كونتكت: مستقبل أفضل للجميع`,
        urlTitle: `تمويل التعليم مع كونتكت: مستقبل أفضل للجميع`,
        subTitleA: `في كونتكت، إحنا مؤمنين إن التعليم هو حجر الأساس لمستقبل أفضل. عشان كده إحنا بنقدم برنامج تمويل التعليم اللى بيساعد كل الناس فى الحصول على مستوى التعليم المناسب واللى هيساعدهم يحققوا احلامهم.
برنامجنا بيغطي كل مراحل البرامج التعليمية الوطنية (الحكومية) والدولية في مصر، لحد مليون جنيه. سواء كنت محتاج  تمويل لتعليم أولادك في المدرسة أو الجامعة أو التعليم العالي، إحنا ممكن نساعدك تحقق `,
        subTitleB: (
          <>
            <p>
              في{" "}
              <a href="/" target="blank">
                كونتكت
              </a>
              ، إحنا مؤمنين إن التعليم هو حجر الأساس لمستقبل أفضل. عشان كده إحنا
              بنقدم برنامج تمويل التعليم اللى بيساعد كل الناس فى الحصول على
              مستوى التعليم المناسب واللى هيساعدهم يحققوا احلامهم.
            </p>
            <p>
              برنامجنا بيغطي كل مراحل البرامج التعليمية الوطنية (الحكومية)
              والدولية في مصر، لحد مليون جنيه.
            </p>
            <p>
              سواء كنت محتاج تمويل لتعليم أولادك في المدرسة أو الجامعة أو
              التعليم العالي، إحنا نقدر نساعدك تحقق أهدافك.
            </p>
            <p>
              كونتكت بتقدملك طرق دفع مختلفة ومرنة تناسب ميزانيتك، بتقسيط لحد 12
              شهر للمدارس والجامعات، 36 شهر للماجستير، و60 شهر للدكتوراه.
            </p>
          </>
        ),
        img: "/blogs/1.png",
        sections: [
          // {
          //   head: ``,
          //   body: `كونتكت بتقدملك طرق دفع مختلفة ومرنة تناسب ميزانيتك، بتقسيط لحد 12 شهر للمدارس والجامعات، 36 شهر للماجستير، و60 شهر للدكتوراه.`,
          // },
          {
            head: `كمان إحنا بنقدم مميزات إضافية تانية كتير: `,
            body: (
              <>
                <ul style={{ paddingRight: "2rem" }}>
                  <li style={{ marginBottom: "5px" }}>
                    بدون دفعة أولى أو مقدم
                  </li>
                  <li style={{ marginBottom: "5px" }}>
                    مفيش غرامات للسداد المبكر
                  </li>
                  <li style={{ marginBottom: "5px" }}>
                    عملية طلب سهلة أونلاين
                  </li>
                  <li style={{ marginBottom: "5px" }}>موافقة سريعة</li>
                </ul>
              </>
            ),
          },
          {
            head: `تفاصيل البرنامج: `,
            body: (
              <>
                <ul style={{ paddingRight: "2rem" }}>
                  <li style={{ marginBottom: "5px" }}>
                    البرنامج متاح لكل المصريين، مهما كان تقييمهم الائتماني.
                  </li>
                  <li style={{ marginBottom: "5px" }}>
                    مفيش حد أدنى أو أقصى لسن المتقدم.
                  </li>
                  <li style={{ marginBottom: "5px" }}>
                    البرنامج بيغطي كل أنواع التعليم، زي المدارس الحكومية،
                    والخاصة، والجامعات، والمعاهد.
                  </li>
                  <li style={{ marginBottom: "5px" }}>
                    البرنامج كمان بيغطي المؤسسات التعليمية الدولية، داخل مصر.
                  </li>
                </ul>
              </>
            ),
          },
          {
            head: ``,
            body: (
              <p>
                عشان تقدم طلب التمويل {""}
                <a href="/products/education" target="blank">
                  ارسل بياناتك{" "}
                </a>
                ممثل من كونتكت هيكلمك عشان يتأكد من البيانات ويجاوب على أي أسئلة
                ممكن تكون عندك.
              </p>
            ),
          },
          {
            head: ``,
            body: `بعد ما تستلم الموافقة التمويلية ، تقدر تختار من بين خطط دفع مختلفة تناسب ميزانيتك. كمان تقدر تدفع دفعة أولى لو عايز.`,
          },
          {
            head: ``,
            body: `تمويل التعليم من كونتكت هو الطريقة المثالية عشان تحقق أحلامك التعليمية. مع خطط سداد مرنة، من غير دفعة أولى، مع كونتكت هتقدر تدفع مصاريف التعليم اللي محتاجه عشان تحقق أحلامك.`,
          },
          {
            head: ``,
            body: (
              <p>
                <a href="/products/education" target="blank">
                  قدم دلوقتي{" "}
                </a>
                وابدأ رحلتك لمستقبل أفضل.
              </p>
            ),
          },
        ],
      },
      {
        id: 4,
        //  date: mm/dd/yyyy
        date: "08/15/2023",
        title:
          "اشتري عربيتك اللي بتحلم بيها دلوقتي مع تمويل السيارات من كونتكت",
        urlTitle:
          "اشتري عربيتك اللي بتحلم بيها دلوقتي مع تمويل السيارات من كونتكت",
        subTitleA: `شراء عربية ممكن يكون تحدي لناس كتير، لكن مع برامج كونتكت لتمويل السيارات القرار بقى أسهل!
كونتكت هتساعدكعلى تحقيق حلمك! 

            `,
        subTitleB: `شراء عربية ممكن يكون تحدي لناس كتير، لكن مع برامج كونتكت لتمويل السيارات القرار بقى أسهل!
كونتكت هتساعدكعلى تحقيق حلمك! 
            
            `,
        img: "/blogs/11.png",
        sections: [
          {
            head: `اشترى عربيتك من خلال تمويل السيارات مع كونتكت`,
            body: (
              <>
                <p>
                  كونتكت هي الشركة الرائدة في تمويل السيارات في مصر. بشراكة مع
                  أكبر عدد من معارض السيارات في كل مصر، كونتكت بتقدم حلول تمويل
                  للعربيات الجديدة والمستعملة، العادية أو الكهربائية.
                </p>
                <p>
                  حلول تمويل السيارات من كونتكت مرنة ومناسبة، مع خطط تقسيط لحد 5
                  سنين. تقدر بسهولة تجيب العربية اللي بتحبها، حتى لو مش عندك
                  المبلغ الكامل نقداً.
                </p>
                <p>
                  بالإضافة لشروط التمويل المرنة، تمويل السيارات من كونتكت بيقدم
                  خطط سداد مختلفة بتمويل لحد 5,000,000 جنيه، متاحة لأي حد في مصر
                  بين سن 21-70، بالإضافة إلى خدمات تسجيل العربية اللي تشمل
                  الترخيص والفحص سواء بالتأمين أو من غير.
                </p>
              </>
            ),
          },
          {
            head: `مزايا إضافية لتمويل السيارات مع كونتكت `,
            body: (
              <>
                <ul style={{ paddingRight: "2rem" }}>
                  <li style={{ marginBottom: "5px" }}>أقساط شهرية مرنة</li>
                  <li style={{ marginBottom: "5px" }}>
                    عملية طلب سهلة وموافقة سريعة
                  </li>
                </ul>
                <p>
                  لو بتدور على طريقة مضمونة ومناسبة عشان تمول عربيتك، يبقى تمويل
                  السيارات من كونتكت هو الحل المثالي.
                </p>
              </>
            ),
          },
          {
            head: `خطط تمويل السيارات من كونتكت `,
            body: (
              <>
                <p>
                  <strong> السيارات الكهربائية </strong>

                  <ul
                    style={{
                      marginLeft: "5px",
                      marginTop: "5px",
                      paddingRight: "2rem",
                    }}
                  >
                    <li style={{ marginBottom: "5px" }}>مقدم يبدأ من ٢٠ ٪ </li>
                    <li style={{ marginBottom: "5px" }}>التأمين اختياري</li>
                    <li style={{ marginBottom: "5px" }}>
                      فترات سداد تصل إلى 5 سنوات
                    </li>
                    <li style={{ marginBottom: "5px" }}>
                      إمكانية السداد المبكر الكلي أو الجزئي
                    </li>
                  </ul>
                </p>
                <p>
                  <strong> الاقتصادي </strong>
                  <ul
                    style={{
                      marginLeft: "5px",
                      marginTop: "5px",
                      paddingRight: "2rem",
                    }}
                  >
                    <li style={{ marginBottom: "5px" }}> مقدم يبدأ من ٢٠ ٪</li>
                    <li style={{ marginBottom: "5px" }}> التأمين إجباري</li>
                    <li style={{ marginBottom: "5px" }}>
                      فترات سداد تصل إلى ٣ سنوات
                    </li>
                  </ul>
                </p>

                <p>
                  <strong>الاقتصادي بلس</strong>
                  <ul
                    style={{
                      marginLeft: "5px",
                      marginTop: "5px",
                      paddingRight: "2rem",
                    }}
                  >
                    <li> مقدم يبدأ من ٢٠ ٪</li>
                    <li> التأمين إجباري</li>
                    <li> فترات سداد تصل إلى ٥ سنوات</li>
                    <li> إمكانية السداد المبكر بعد سنة من التعاقد</li>
                  </ul>
                </p>
                <p>
                  <strong>المرن </strong>
                  <ul
                    style={{
                      marginLeft: "5px",
                      marginTop: "5px",
                      paddingRight: "2rem",
                    }}
                  >
                    <li style={{ marginBottom: "5px" }}>مقدم يبدأ من ٢٠ ٪</li>
                    <li style={{ marginBottom: "5px" }}>التأمين إجباري</li>
                    <li style={{ marginBottom: "5px" }}>
                      فترات سداد من ٣ إلى ٥ سنوات
                    </li>
                    <li style={{ marginBottom: "5px" }}>
                      إمكانية السداد المبكر بعد سنة من التعاقد
                    </li>
                    <li style={{ marginBottom: "5px" }}>
                      إمكانية تأجيل جزء من المقدم
                    </li>
                  </ul>
                </p>

                <p>
                  <strong>المرن بلس</strong>
                  <ul
                    style={{
                      marginLeft: "5px",
                      marginTop: "5px",
                      paddingRight: "2rem",
                    }}
                  >
                    <li style={{ marginBottom: "5px" }}>مقدم يبدأ من ٢٠ ٪</li>
                    <li style={{ marginBottom: "5px" }}>التأمين اختياري</li>
                    <li style={{ marginBottom: "5px" }}>
                      فترات سداد تصل إلى ٥ سنوات
                    </li>
                    <li style={{ marginBottom: "5px" }}>
                      إمكانية السداد المبكر الكلي أو الجزئي
                    </li>
                    <li style={{ marginBottom: "5px" }}>
                      إمكانية تأجيل جزء من المقدم
                    </li>
                  </ul>
                </p>

                <p>
                  <strong>الشركات</strong>
                  <ul
                    style={{
                      marginLeft: "5px",
                      marginTop: "5px",
                      paddingRight: "2rem",
                    }}
                  >
                    <li style={{ marginBottom: "5px" }}>مقدم يبدأ من ١٠ ٪</li>
                    <li style={{ marginBottom: "5px" }}>التأمين إجباري</li>
                    <li style={{ marginBottom: "5px" }}>
                      فترات سداد من 2 إلى ٥ سنوات
                    </li>
                    <li style={{ marginBottom: "5px" }}>
                      إمكانية السداد المبكر بعد سنة من التعاقد
                    </li>
                  </ul>
                </p>
                <p>
                  <strong>السيارات المستعملة</strong>
                  <ul
                    style={{
                      marginLeft: "5px",
                      marginTop: "5px",
                      paddingRight: "2rem",
                    }}
                  >
                    <li style={{ marginBottom: "5px" }}>مقدم يبدأ من ٢٠ ٪</li>
                    <li style={{ marginBottom: "5px" }}>التأمين اختياري</li>

                    <li style={{ marginBottom: "5px" }}>
                      فترات سداد تصل إلى ٥ سنوات
                    </li>
                  </ul>
                </p>
              </>
            ),
          },
          {
            head: `محتاج حساب بنكي أو تقييم ائتماني عشان تمول عربيتك مع كونتكت؟  `,
            body: ` لا، مش محتاج حساب بنكي أو تقييم ائتماني عشان تقدر تمول عربيتك معانا.    `,
          },
          {
            head: `ايه الأوراق اللي محتاجها عشان تستحق تمويل عربيتك مع كونتكت؟ `,
            body: (
              <>
                <ul style={{ paddingRight: "2rem" }}>
                  <li style={{ marginBottom: "5px" }}>اسمك الكامل</li>
                  <li style={{ marginBottom: "5px" }}>تاريخ ميلادك</li>
                  <li style={{ marginBottom: "5px" }}>رقم بطاقتك الشخصية</li>
                  <li style={{ marginBottom: "5px" }}> رخصة القيادة بتاعتك </li>
                  <li style={{ marginBottom: "5px" }}>بيانات الدخل</li>
                  <li style={{ marginBottom: "5px" }}>
                    مبلغ التمويل اللى محتاجه
                  </li>
                  <li style={{ marginBottom: "5px" }}>
                    خطة التقسيط اللي بتفضلها
                  </li>
                </ul>
                <p>
                  اول ما تبعت طلبك، هنبعتلك عقد تمويل لو طلبك اتوافق عليه. لما
                  توقع على عقد التمويل، تقدر تشتري العربية اللي بتحلم بيها.
                </p>
              </>
            ),
          },
          {
            head: `احسب أقساطك الشهرية مع كونتكت `,
            body: (
              <p>
                ريحناك من التخمين، ودلوقتي تقدر تحسب أقساطك باستخدام وسيلة{" "}
                <a href="/products/auto" target="blank">
                  حساب الأقساط {""}
                </a>
                من كونتكت
              </p>
            ),
          },

          {
            head: `تواصل معنا  `,
            body: (
              <p>
                عشان تعرف كل التفاصيل عن تمويل السيارات مع كونتكت، اتصل بنا
                وهنجاوب على أسئلتك ونساعدك{" "}
                <a href="/contact-us/" target="blank">
                  تبدأ{" "}
                </a>
                .
              </p>
            ),
          },
        ],
      },
      {
        id: 5,
        //  date: mm/dd/yyyy
        date: "08/16/2023",
        title: `كونتكت باي مدفوعاتك بقت أسهل!`,

        urlTitle: `كونتكت باي مدفوعاتك بقت أسهل!`,
        subTitleA: `"كونتكت باي—حل جديد للمدفوعات من كونتكت. بيسهل وبيأمن دفع فواتير الموبايل، الكهرباء، الغاز، المياه، والعديد من الخدمات الأخرى عن طريق تطبيق "ContactNow" أو فروع كونتكت في جميع أنحاء مصر.
            `,
        subTitleB: `"كونتكت باي—حل جديد للمدفوعات من كونتكت. بيسهل وبيأمن دفع فواتير الموبايل، الكهرباء، الغاز، المياه، والعديد من الخدمات الأخرى عن طريق تطبيق "ContactNow" أو فروع كونتكت في جميع أنحاء مصر.
            `,
        img: "/blogs/10.png",
        sections: [
          {
            head: ` يمكن استخدام خدمة كونتكت باي لدفع وسداد: `,
            body: (
              <>
                <ul style={{ paddingRight: "2rem" }}>
                  <li style={{ marginBottom: "5px" }}>
                    رسوم الجامعات والمدارس
                  </li>
                  <li style={{ marginBottom: "5px" }}>فواتير الكهرباء</li>
                  <li style={{ marginBottom: "5px" }}>فواتير الغاز</li>
                  <li style={{ marginBottom: "5px" }}>فواتير المياه</li>
                  <li style={{ marginBottom: "5px" }}>
                    فواتير التليفون الأرضي
                  </li>
                  <li style={{ marginBottom: "5px" }}>فواتير المحمول</li>
                  <li style={{ marginBottom: "5px" }}>اشتراك الإنترنت</li>
                  <li style={{ marginBottom: "5px" }}>تذاكر المواصلات</li>
                  <li style={{ marginBottom: "5px" }}>اشتراك منصات الترفيه</li>
                  <li style={{ marginBottom: "5px" }}>أقساط التأمين</li>
                  <li style={{ marginBottom: "5px" }}>
                    التبرعات والجمعيات الخيرية
                  </li>
                  <li style={{ marginBottom: "5px" }}>اشتراكات الأندية</li>
                </ul>
              </>
            ),
          },
          {
            head: ``,
            body: (
              <>
                <ul style={{ paddingRight: "2rem" }}>
                  <li style={{ marginBottom: "5px" }}>
                    كونتكت باي حل سريع وبسيط جداً في الاستخدام سواء عن طريق
                    تطبيق ContactNow أو فروع كونتكت في جميع أنحاء مصر
                  </li>
                  <li style={{ marginBottom: "5px" }}>
                    خدمة كونتكت باي خدمة آمنة جداً، بياناتك كلها محمية وفي أمان
                    تحت رقابة هيئة الرقابة المالية
                  </li>
                  <li style={{ marginBottom: "5px" }}>
                    تقدر تستخدم كونتكت باي في أي مكان لكل مدفوعاتك، الخدمة
                    مقبولة في الكثير من الجهات المختلفة
                  </li>
                </ul>
              </>
            ),
          },

          {
            head: `كونتكت باي هو الحل المثالي إذا كنت تبحث عن طريقة بسيطة وآمنة ومريحة لكل مدفوعاتك. `,
            body: ``,
          },
          {
            head: (
              <p>
                <a href="/contact-us/" target="blank">
                  اتصل بنا{" "}
                </a>
                أو زور أحد فروعنا وابدأ في الاستمتاع بفوائد كونتكت باي!.
              </p>
            ),
            body: ``,
          },
        ],
      },
      {
        id: 6,
        //  date: mm/dd/yyyy
        date: "08/01/2024",
        title: `بتفكر تشتري عربية كهربائية؟ 
عندنا أسهل تمويل لعربيتك الكهربائية الجديدة في مصر
`,

        urlTitle: `بتفكر تشتري عربية كهربائية؟ 
عندنا أسهل تمويل لعربيتك الكهربائية الجديدة في مصر
`,
        subTitleA: `مع التحول العالمي للطاقة النظيفة والمستدامة، العربيات الكهربائية بقت اختيار شائع بين ملاك السيارات في مصر. بس عملية شراء عربية كهربائية ممكن تبقى صعبة، خصوصًا بسبب التكلفة العالية اللي أحياناً بتحتاج للتمويل. هنا بييجي دور كونتكت، إحنا موجودين علشان نسهل عليك عملية تمويل وتقسيط شراء عربيتك الكهربائية في مصر، وبنقدم حلول تمويل مخصصة تخلي امتلاك عربية كهربائية أسهل من أي وقت فات.`,
        subTitleB: (
          <>
            <p>
              مع التحول العالمي للطاقة النظيفة والمستدامة، العربيات الكهربائية
              بقت اختيار شائع بين ملاك السيارات في مصر. بس عملية شراء عربية
              كهربائية ممكن تبقى صعبة، خصوصًا بسبب التكلفة العالية اللي أحياناً
              بتحتاج للتمويل. هنا بييجي دور كونتكت، إحنا موجودين علشان نسهل عليك
              عملية تمويل وتقسيط شراء عربيتك الكهربائية في مصر، وبنقدم حلول
              تمويل مخصصة تخلي امتلاك عربية كهربائية أسهل من أي وقت فات.
            </p>
          </>
        ),
        img: "/blogs/3.png",
        sections: [
          {
            head: `تمويل السيارات من كونتكت: مصمم خصيصًا للعربيات الكهربائية`,
            body: (
              <>
                <p>
                  برنامج تمويل السيارات من كونتكت مصمم علشان الناس اللي بيفكروا
                  يشتروا عربية كهربائية. إحنا فاهمين إن التحول للعربية
                  الكهربائية مش مجرد شراء عربية، ده استثمار في مستقبل أفضل. عشان
                  كده كونتكت بتقدم حلول تمويل بتراعي احتياجات المقبلين على شراء
                  العربيات الكهربائية. مع كونتكت، تقدر تمول عربيتك الكهربائية
                  بكل سهولة، وانت مطمن إنك بتاخد أفضل خدمات التمويل في مصر اللي
                  تتماشى مع نمط حياتك.
                </p>
              </>
            ),
          },
          {
            head: `خطط سداد مرنة: امتلك العربية الكهربائية اللي بتحلم بيها`,
            body: (
              <>
                <p>
                  واحدة من الميزات الرئيسية في برنامج تمويل السيارات من كونتكت
                  هي المرونة اللي بيقدمها. سواء كنت بتشتري عربية كهربائية جديدة
                  أو مستعملة، كونتكت بتوفر خطط سداد تخليك تمتلك العربية اللي
                  بتحلم بيها بكل سهولة. مع خطط سداد لحد 5 سنين وتمويل يصل لحد 7
                  مليون جنيه، تقدر تسوق عربيتك الكهربائية بمقدم بسيط يبدأ من
                  20%. عندنا أداة حساب الأقساط على موقعنا اللي بتخليك تعرف
                  بالضبط الدفعات الشهرية هتكون كام، من غير مفاجآت.
                </p>
              </>
            ),
          },
          {
            head: `مزايا التمويل مع كونتكت: تجربة سلسة من البداية للنهاية`,
            body: (
              <>
                <p>
                  في كونتكت، إحنا مهتمين بتسهيل عملية التمويل والتقسيط لأقصى
                  درجة ممكنة. من أول ما تقرر تشتري عربية كهربائية لحد ما تستلمها
                  من المعرض، كونتكت موجودة تدعمك في كل خطوة. فريقنا المتخصص جاهز
                  يساعدك تختار أفضل خيارات التمويل اللي تناسب احتياجاتك.
                </p>
              </>
            ),
          },
          {
            head: ``,
            body: (
              <>
                <p>
                  لو بتفكر تشتري عربية كهربائية لكن كنت متردد بسبب التكلفة
                  ومحتاج تمويل مرن، دلوقتي الوقت المناسب تاخد الخطوة دي. مع حلول
                  التمويل المتخصصة من كونتكت، امتلاك عربية كهربائية في مصر بقى
                  أسهل من أي وقت فات. اكتشف إمكانيات التمويل والتقسيط النهاردة
                  وامتلك العربية الكهربائية اللي بتحلم بيها مع كونتكت.
                </p>
                <p>
                  ادخل على
                  <a
                    href="https://contact.eg/products/auto"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://contact.eg/products/auto
                  </a>{" "}
                  قدم طلبك واحسب أقساطك دلوقتي.
                </p>
              </>
            ),
          },
        ],
      },
      {
        id: 7,
        //  date: mm/dd/yyyy
        date: "08/01/2024",
        title: `السنة الدراسية 2024-2025 قربت تبدأ: 
إزاي تموّل مصاريف التعليم مع كونتكت بسهولة
`,

        urlTitle: `السنة الدراسية 2024/2025 قربت تبدأ: 
إزاي تموّل مصاريف التعليم مع كونتكت بسهولة
`,
        subTitleA: `مع اقتراب السنة الدراسية الجديدة، الأهالي في مصر بيستعدوا ويقدموا لأولادهم في المدارس والجامعات. ومع زيادة تكاليف التعليم، كتير من العائلات بتدور على طرق دفع مرنة للمصاريف دي من غير ما تضغط على ميزانيتها. وهنا بيجي دور كونتكت. حلول تمويل وتقسيط مصاريف التعليم اللي بنقدمها مصممة علشان تسهل دفع مصاريف تعليم أولادك وتخليها على دفعات تناسب تنظيمك لميزانيتك.`,
        subTitleB: (
          <>
            <p>
              مع اقتراب السنة الدراسية الجديدة، الأهالي في مصر بيستعدوا ويقدموا
              لأولادهم في المدارس والجامعات. ومع زيادة تكاليف التعليم، كتير من
              العائلات بتدور على طرق دفع مرنة للمصاريف دي من غير ما تضغط على
              ميزانيتها. وهنا بيجي دور كونتكت. حلول تمويل وتقسيط مصاريف التعليم
              اللي بنقدمها مصممة علشان تسهل دفع مصاريف تعليم أولادك وتخليها على
              دفعات تناسب تنظيمك لميزانيتك.
            </p>
          </>
        ),
        img: "/blogs/7.png",
        sections: [
          {
            head: `تمويل التعليم مع كونتكت: خطط دفع مرنة`,
            body: (
              <>
                <p>
                  في كونتكت، إحنا فاهمين إن توفير تعليم كويس لأولادك هو واحد من
                  أهم الاستثمارات اللي ممكن تعملها في حياتك. علشان كده بنقدم خطط
                  تمويل وتقسيط تعليم حصرية بخطط دفع تصل لـ 12 شهر للمدارس
                  والجامعات وحتى الدورات المهنية. سواء كنت محتاج تغطي مصاريف
                  الدراسة، تكاليف التسجيل، أو أي مصاريف تعليمية تانية، كونتكت
                  موجودة علشان تساعدك.
                </p>
              </>
            ),
          },
          {
            head: `تمويل يصل لمليون جنيه مصري، من غير مقدم`,
            body: (
              <>
                <p>
                  واحدة من المميزات في تمويل التعليم من كونتكت هي إمكانية
                  التمويل حتى مليون جنيه مصري من غير مقدم. يعني تقدر تغطي
                  المصاريف اللي محتاجها لتعليم أولادك من غير ما تقلق بسبب
                  التكاليف الكبيرة. سواء كنت بتسجل طفلك لأول مرة في مدرسته
                  الجديدة أو عندك مصاريف تعليمية لأكتر من طفل، كونتكت بتقدم
                  المرونة والدعم اللي محتاجه.
                </p>
              </>
            ),
          },

          {
            head: `ادفع بالتقسيط بالطريقة اللي تناسبك`,
            body: (
              <>
                <p>
                  لكتير من الأهالي، فكرة دفع مبلغ كبير دفعة واحدة ممكن تكون
                  مرهقة. تمويل وتقسيط التعليم من كونتكت بيخفف الضغط المتعلق بدفع
                  مصاريف الدراسة عن طريق تقديم خطط تقسيط لغاية 12 شهر للمدارس
                  والجامعات، و3 سنوات للماجستير، و5 سنوات للدكتوراه، تقدر تختار
                  الخطة اللي تناسبك.
                </p>
              </>
            ),
          },
          {
            head: `إمكانية حساب الأقساط متوفرة على موقعنا: خطّط لمدفوعاتك براحتك`,
            body: (
              <>
                <p>
                  علشان نساعدك تخطط أحسن، كونتكت بتقدملك أداة حساب الأقساط على
                  موقعنا. الأداة دي بتخليك تشوف بالظبط إجمالي الأقساط الشهرية
                  علشان تكون عارف هتدفع كام بدون مفاجآت. بحسبة بسيطة، تقدر تحدد
                  أفضل اختيار تمويل لاحتياجاتك وأفضل فترة سداد تناسبك.
                </p>
              </>
            ),
          },
          {
            head: `ركز على مستقبل طفلك، والباقي علينا`,
            body: (
              <>
                <p>
                  باختيارك تمويل التعليم من كونتكت، إنت مش بس بتاخد قرار مالي
                  ذكي، إنت كمان بتستثمر في مستقبل طفلك. حلولنا التمويلية مصممة
                  علشان تديك المرونة اللي محتاجها لإدارة ميزانيتك وفي نفس الوقت
                  تضمن إن طفلك بيحصل على التعليم اللي يستحقه. مع كونتكت، تقدر
                  تركز على الأهم—تعليـــم طفلك ونجاحه الدراسي.
                </p>
              </>
            ),
          },
          {
            head: ``,
            body: (
              <>
                <p>
                  دلوقتي الوقت المناسب تكتشف خطط تمويل التعليم من كونتكت. تقدر
                  تموّل من خلالنا مصاريف التعليم لحد مليون جنيه مصري من غير
                  مقدم، وتدفع مصاريف الدراسة بسهولة وعلى أقساط. ماتخليش
                  الالتزامات المالية تقف في طريق تعليم طفلك—تواصل مع كونتكت
                  النهاردة واضمن مستقبل أفضل لعيلتك بدايةً من التعليم.
                </p>
                <p>
                  زور{" "}
                  <a
                    href="https://contact.eg/products/education"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://contact.eg/products/education
                  </a>{" "}
                  واكتشف حلول تمويل مميزة مع كونتكت!
                </p>
              </>
            ),
          },
        ],
      },
      {
        id: 8,
        //  date: mm/dd/yyyy
        date: "08/01/2024",
        title: "شريك قوي في قراراتك المالية: قوة حلول الأعمال مع كونتكت",

        urlTitle: `شريك قوي في قراراتك المالية: 
قوة حلول الأعمال مع كونتكت
`,
        subTitleA: `في سوق العمل التنافسي النهاردة، وجود الشريك المناسب لشركتك ممكن يفرق كتير. في كونتكت، إحنا فاهمين التحديات اللي بتواجهها الشركات في مصر وبنوفر حلول مصممة خصيصًا علشان تساعدك مش بس على الاستمرار، لكن كمان على النجاح والازدهار. الشراكة مع كونتكت بتفتح لك عالم من الفرص، وبنوفر لك أكتر من مجرد دعم مالي؛ إحنا بنمكن شركتك توصل لمستويات جديدة. عن طريق:`,
        subTitleB: `في سوق العمل التنافسي النهاردة، وجود الشريك المناسب لشركتك ممكن يفرق كتير. في كونتكت، إحنا فاهمين التحديات اللي بتواجهها الشركات في مصر وبنوفر حلول مصممة خصيصًا علشان تساعدك مش بس على الاستمرار، لكن كمان على النجاح والازدهار. الشراكة مع كونتكت بتفتح لك عالم من الفرص، وبنوفر لك أكتر من مجرد دعم مالي؛ إحنا بنمكن شركتك توصل لمستويات جديدة. عن طريق:`,
        img: "/blogs/4.png",
        sections: [
          {
            head: `خدمات التخصيم: عزز التدفق النقدي لشركتك`,
            body: `واحدة من الخدمات الأساسية اللي بنقدمها هي التخصيم، وهو برنامج لأصحاب الأعمال والتجارة من كونتكت هدفه يحسن التدفق النقدي لشركتك بشكل كبير. من خلال تحويل مستحقاتك إلى نقد فوري، التخصيم مع كونتكت يضمن إن عندك رأس المال اللي محتاجه علشان تحافظ على سير أعمالك بسلاسة. سواء كنت عاوز تدير أعمالك في أوقات مختلفة أو توفر سيولة للاستثمار والتوسع، خدمات التخصيم من كونتكت متاحة لمعظم الشركات المصرية وبتوفر المرونة والدعم اللي شركتك محتاجاهم.`,
          },
          {
            head: `خدمات تأجير تمويلي: مرونة لنمو أعمالك`,
            body: (
              <>
                <p>
                  حل آخر بنقدمه هو التأجير التمويلي. سواء كنت محتاج معدات جديدة،
                  عربيات، أو أصول تانية، التأجير التمويلي مع كونتكت بيسمح لك
                  تحصل على اللي محتاجه من غير تكاليف كبيرة في البداية. خيارات
                  التأجير التمويلي من كونتكت مصممة علشان تناسب احتياجات شركتك،
                  وتمكنك من البقاء من المنافسة في صناعتك لأنك هاتمتلك المعدات
                  اللي ممكن تحتاجها. مع كونتكت، تقدر تكون واثق إنك بتحصل على
                  أفضل خدمات التأجير التمويلي في مصر المصممة علشان تناسب أهداف
                  عملك.
                </p>
                <p>
                  بنقدم التأجير التمويلي للمؤسسات الطبية وتشمل تجهيزات العيادات
                  والمنشآت الطبية وسيارات الإسعاف. بنقدم كمان التأجير التمويلي
                  لشركات النقل ويشمل وسائل النقل من السيارات الشخصية إلى
                  السيارات التجارية (نقل خفيف، متوسط وثقيل) بالإضافة إلى
                  الحافلات والڤان.
                </p>
              </>
            ),
          },

          {
            head: `خدمات التأمين: حماية لأعمالك وموظفيك`,
            body: `في كونتكت، إحنا كمان فاهمين أهمية حماية أعمالك وأغلى أصولك—موظفيك. حلول التأمين الشاملة من كونتكت بتغطي مجموعة واسعة من الاحتياجات، من تأمين الأعمال لتأمين الموظفين. سواء كنت عاوز تحمي ممتلكاتك، عربياتك، أو موظفيك، كونتكت بتوفر التغطية اللي محتاجها علشان تضمن راحة بالك واستمرارية أعمالك.`,
          },
          {
            head: `فرص للاستثمار: نمّي رأس مال أعمالك مع كونتكت`,
            body: `بجانب التمويل والتأمين، كونتكت كمان بتوفر فرص استثمارية اللي ممكن تساعد شركتك على النمو. سواء كنت بتدور على الاستثمار في مشاريع جديدة أو توسيع أعمالك، كونتكت بتقدم خدمات استثمارية مصممة خصيصًا علشان تتماشى مع أهدافك طويلة الأجل.`,
          },
          {
            head: ``,
            body: (
              <>
                <p>
                  الشراكة مع كونتكت معناها إنك بتستفيد من مجموعة شاملة من
                  الخدمات المالية المصممة لشركتك. من التخصيم والتأجير التمويلي
                  للتأمين وفرص الاستثمار، كونتكت بتقدم أفضل حلول التمويل
                  والتأمين للشركات وأصحاب الأعمال في مصر. جرب الفرق مع كونتكت
                  واكتشف الإمكانيات الكاملة لشركتك.
                </p>
                <p>
                  كلمنا دلوقتي على 16177 أو زور أقرب فرع لينا علشان تعرف أكتر عن
                  الفرص المتاحة لشركتك مع كونتكت.
                </p>
              </>
            ),
          },
        ],
      },
      {
        id: 9,
        //  date: mm/dd/yyyy
        date: "08/01/2024",
        title:
          "إزاي خطط الدفع والتقسيط من كونتكت ممكن توسع قاعدة عملائك وتكبر تجارتك (للتجار وأصحاب المحلات)",

        urlTitle: `إزاي خطط الدفع والتقسيط من كونتكت ممكن توسع قاعدة عملائك وتكبر تجارتك (للتجار وأصحاب المحلات)`,
        subTitleA: `لو انت تاجر أو صاحب محل في مصر، هدفك الأساسي هو جذب أكبر عدد ممكن من العملاء وزيادة المبيعات. لكن في السوق النهاردة، المنافسة كبيرة، والتميّز بيحتاج أكتر من مجرد تقديم منتجات ممتازة. هنا بييجي دور كونتكت. من خلال التسجيل مع كونتكت وقبول الدفع عن طريق كونتكت كوسيلة دفع في محلك وإضافة محلك أو شركتك كأحد التجار المعتمدين من كونتكت، تقدر توسع قاعدة عملائك بشكل كبير وتعزز مبيعاتك.`,
        subTitleB: `لو انت تاجر أو صاحب محل في مصر، هدفك الأساسي هو جذب أكبر عدد ممكن من العملاء وزيادة المبيعات. لكن في السوق النهاردة، المنافسة كبيرة، والتميّز بيحتاج أكتر من مجرد تقديم منتجات ممتازة. هنا بييجي دور كونتكت. من خلال التسجيل مع كونتكت وقبول الدفع عن طريق كونتكت كوسيلة دفع في محلك وإضافة محلك أو شركتك كأحد التجار المعتمدين من كونتكت، تقدر توسع قاعدة عملائك بشكل كبير وتعزز مبيعاتك.`,
        img: "/blogs/2.png",
        sections: [
          {
            head: `اوصل لعملاء أكتر في مصر: استفيد من شبكة عملاء كونتكت`,
            body: `واحدة من أكبر المزايا في شراكتك مع كونتكت هي الوصول لشبكة عملاء واسعة على مستوى الجمهورية. كأكبر شركة تمويل استهلاكي في مصر، كونتكت أسست خلال السنين اللي فاتت شبكة ضخمة من العملاء والمشترين في مصر اللي بيثقوا فينا لتوفير خيارات دفع مرنة ومريحة. لما تنضم لشبكة تجار كونتكت، انت مش بس بتضيف وسيلة دفع جديدة—انت بتفتح أبواب جديدة لشريحة جديدة من العملاء اللي بيفضّلوا الشراء من الأماكن اللي يقدروا يستخدموا فيها كونتكت كوسيلة دفع وتقسيط.`,
          },
          {
            head: `خطط تقسيط مرنة: خلي الشراء أسهل على عملائك`,
            body: `المستهلكين النهاردة بيدوروا على المرونة في طرق الدفع، خصوصًا لما يتعلق الأمر بقرارت شراء كبيرة. عن طريق تقديم خطط التقسيط من كونتكت في محلك، بتسهل على العملاء يشتروا اللي عاوزينه، في الوقت اللي يناسبهم، مع برنامج "اشتري الآن وادفع بعدين" من كونتكت. خطط التقسيط بتاعتنا بتسمح للعملاء بتوزيع الأقساط على الوقت المناسب ليهم، وده بيخلي قرار شراء منتجاتك أكتر سهولة. المرونة دي مش بس بتجذب عملاء أكتر، لكن كمان بتشجعهم يشتروا أكتر، عارفين إنهم يقدروا يدفعوا على مدار الوقت على دفعات مع خطط تمويل المشتريات من كونتكت.`,
          },
          {
            head: `مزايا للتجار: نمّي مبيعاتك مع كونتكت`,
            body: `الانضمام لشبكة التجار المعتمدين من كونتكت بييجي مع مجموعة كبيرة من المزايا. بجانب توسيع قاعدة عملائك، شراكتك مع كونتكت ممكن تعزز من ولاء ورضا العملاء. حلول الدفع بتاعتنا مصممة لتلبية احتياجات كل من العملاء والتجار، وضمان عملية سلسة وتجربة تسوق مميزة!`,
          },
          {
            head: ``,
            body: (
              <>
                <p>
                  إضافة خطط الدفع والتقسيط من كونتكت في عملك مش بس خطوة ذكية—دي
                  خطوة استراتيجية ممكن تدفع عملك للنمو والنجاح اللي بتدوّر عليه.
                  عن طريق الاستفادة من قاعدة عملاء كونتكت على مستوى الجمهورية
                  وتقديم خيارات دفع مرنة، انت تقدر تجذب عملاء أكتر وتزود
                  مبيعاتك. ما تضيعش الفرصة دي—اشترك مع كونتكت النهاردة.
                </p>
                <p>
                  ادخل على{" "}
                  <a
                    href="https://contact.eg/partnership/contact-now-merchant"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://contact.eg/partnership/contact-now-merchant
                  </a>{" "}
                  وسجل في خطوات بسيطة!
                </p>
              </>
            ),
          },
        ],
      },
      {
        id: 10,
        //  date: mm/dd/yyyy
        date: "09/01/2024",
        title: "حقق حلمك في الحج والعمرة مع كونتكت",

        urlTitle: `حقق حلمك في الحج والعمرة مع كونتكت`,
        subTitleA: `كل مسلم في مصر بيحلم بيوم يكون فيه في بيت الله الحرام، لأداء مناسك الحج أو العمرة. الرحلة دي مش مجرد سفرية، دي تجربة
                    روحانية عظيمة وركن أساسي من أركان الإسلام. لكن ساعات التكاليف بتبقى عائق قدام ناس كتير.
                    علشان كده، كونتكت قدمت لك الحل مع برنامج مناسك لـتقسيط وتمويل الحج والعمرة في مصر. ده برنامج تمويل مريح ومصمم
                    خصيصاً لكل اللي عايزين يحققوا حلمهم بأداء الحج أو العمرة، وكله متوافق مع الشريعة الإسلامية.`,
        subTitleB: (
          <>
            <p>
              كل مسلم في مصر بيحلم بيوم يكون فيه في بيت الله الحرام، لأداء مناسك
              الحج أو العمرة. الرحلة دي مش مجرد سفرية، دي تجربة روحانية عظيمة
              وركن أساسي من أركان الإسلام. لكن ساعات التكاليف بتبقى عائق قدام
              ناس كتير.
            </p>
            <p>
              علشان كده، كونتكت قدمت لك الحل مع برنامج مناسك لـتقسيط وتمويل الحج
              والعمرة في مصر. ده برنامج تمويل مريح ومصمم خصيصاً لكل اللي عايزين
              يحققوا حلمهم بأداء الحج أو العمرة، وكله متوافق مع الشريعة
              الإسلامية.`,
            </p>
          </>
        ),
        img: "/blogs/Manasik-Blog.png",
        sections: [
          {
            head: `مناسك: طريقك لبيت الله الحرام`,
            body: (
              <>
                <p>
                  مع برنامج مناسك من كونتكت، تقدر دلوقتي تحقق حلمك بسهولة وتسدد
                  تكلفة الحج أو العمرة على أقساط مريحة تناسب ظروفك. في كونتكت
                  هانكون جنبك خطوة بخطوة.
                </p>
              </>
            ),
          },
          {
            head: `إيه اللي يميز برنامج مناسك من كونتكت؟`,
            body: (
              <>
                <ol>
                  <li>
                    <strong>خطط سداد مريحة: </strong> سدد على 5 سنين للحج أو 12
                    شهرًا للعمرة، حسب إمكانياتك.
                  </li>
                  <li>
                    <strong>تمويل كبير: </strong> تمويل لحد 3 مليون جنيه يغطي كل
                    تكاليف السفر والإقامة.
                  </li>
                  <li>
                    <strong>مقدم بسيط: </strong> تقدر تدفع مقدم يبدأ من %20 بس!
                  </li>
                  <li>
                    <strong>تمويل متوافق مع الشريعة الإسلامية: </strong> حلول
                    تمويلية على أعلى مستوى وتتماشى مع أحكام الشريعة.
                  </li>
                  <li>
                    <strong>إجراءات سهلة وسريعة: </strong> معانا، مش هتشيل هم
                    الورق والتفاصيل. الإجراءات بسيطة وهتاخد وقت قليل.
                  </li>
                  <li>
                    <strong>حاسبة الأقساط: </strong> استخدم حاسبة الأقساط على
                    موقعنا الإلكتروني علشان تخطط دفعاتك بمنتهى الوضوح والسهولة.
                  </li>
                </ol>
              </>
            ),
          },
          {
            head: `ابدأ حلمك النهارده`,
            body: (
              <>
                <p>
                  مع برنامج مناسك من كونتكت، مفيش حاجة تمنعك من تحقيق حلمك
                  الكبير. ركز على ترتيب تفاصيل رحلتك وسيب علينا التكاليف. ابدأ
                  النهارده وعيش أعظم تجربة في حياتك!
                </p>
              </>
            ),
          },
        ],
      },
    ],
  },
  careers: {
    apply: "التقديم",
    section: "القسم",
    jobBrief: "معلومات الوظيفة",
    requirements: "المتطلبات",
    notHiring: "لا توجد وظائف متاحة في الوقت الحالي",
    jobs: [
      {
        id: 1,
        title: "محاسب موردين",
        section: "القطاع المالي",
        jobBrief: (
          <>
            <ul style={{ paddingRight: "1.5rem" }}>
              <li style={{ marginBottom: "5px" }}>
                إدارة جميع المعاملات المحاسبية
              </li>
              <li style={{ marginBottom: "5px" }}>
                إعداد توقعات الميزانية والقوائم المالية في الوقت المناسب
              </li>
              <li style={{ marginBottom: "5px" }}>
                التعامل مع عمليات إغلاق الميزانية الشهرية والربع سنوية والسنوية
              </li>
              <li style={{ marginBottom: "5px" }}>
                تسوية الحسابات المستحقة للموردين
              </li>
              <li style={{ marginBottom: "5px" }}>
                ضمان المدفوعات المصرفية في الوقت المناسب{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                حساب الضرائب وإعداد الإقرارات الضريبية{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                إدارة الميزانيات العمومية وبيانات الأرباح والخسائر{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                تقرير عن الصحة المالية للشركة وسيولتها{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                المراجعة على البيانات و المعاملات والوثائق المالية{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                المحافظة على سرية البيانات المالية وإجراء نسخ احتياطية من قاعدة
                البيانات عند الضرورة و الامتثال للسياسات والأنظمة المالية{" "}
              </li>
            </ul>
          </>
        ),
        requirements: (
          <>
            <ul style={{ paddingRight: "1.5rem" }}>
              <li style={{ marginBottom: "5px" }}>
                خبرة فى العمل كمحاسب موردين من عامين لخمسة أعوام
              </li>
              <li style={{ marginBottom: "5px" }}>
                معرفة ممتازة بالأنظمة والإجراءات المحاسبية{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                اهتمام قوي بالتفاصيل والمهارات التحليلية الجيدة{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                الحصول على درجة البكالوريوس في المحاسبة أو المالية أو درجة ذات
                صلة{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                الشهادة (CPA أو CMA) هي ميزة إضافية
              </li>
            </ul>
          </>
        ),
      },
      {
        id: 2,
        title: "محاسب عملاء",
        section: "القطاع المالي",
        jobBrief: (
          <>
            <ul style={{ paddingRight: "1.5rem" }}>
              <li style={{ marginBottom: "5px" }}>
                إدارة جميع المعاملات المحاسبية
              </li>
              <li style={{ marginBottom: "5px" }}>
                إعداد توقعات الميزانية والقوائم المالية في الوقت المناسب
              </li>
              <li style={{ marginBottom: "5px" }}>
                التعامل مع عمليات إغلاق الميزانية الشهرية والربع سنوية والسنوية
              </li>
              <li style={{ marginBottom: "5px" }}>
                تسوية الحسابات المستحقة من العملاء
              </li>
              <li style={{ marginBottom: "5px" }}>
                ضمان المدفوعات المصرفية في الوقت المناسب{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                حساب الضرائب وإعداد الإقرارات الضريبية{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                إدارة الميزانيات العمومية وبيانات الأرباح والخسائر{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                تقرير عن الصحة المالية للشركة وسيولتها{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                المراجعة على البيانات و المعاملات والوثائق المالية{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                المحافظة على سرية البيانات المالية وإجراء نسخ احتياطية من قاعدة
                البيانات عند الضرورة و الامتثال للسياسات والأنظمة المالية{" "}
              </li>
            </ul>
          </>
        ),
        requirements: (
          <>
            <ul style={{ paddingRight: "1.5rem" }}>
              <li style={{ marginBottom: "5px" }}>
                خبرة فى العمل كمحاسب عملاء من عامين لخمسة أعوام
              </li>
              <li style={{ marginBottom: "5px" }}>
                معرفة ممتازة بالأنظمة والإجراءات المحاسبية{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                اهتمام قوي بالتفاصيل والمهارات التحليلية الجيدة{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                الحصول على درجة البكالوريوس في المحاسبة أو المالية أو درجة ذات
                صلة{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                الشهادة (CPA أو CMA) هي ميزة إضافية
              </li>
            </ul>
          </>
        ),
      },
      {
        id: 3,
        title: "مسؤول مبيعات",
        section: "المبيعات",
        jobBrief: (
          <>
            <ul style={{ paddingRight: "1.5rem" }}>
              <li style={{ marginBottom: "5px" }}>
                بناء علاقات مع بائعي المنتجات والموردين والمحافظة عليها{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                عرض برامج وأنظمة تقسيط مختلفة للعملاء{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                توفير الدعم للعملاء منذ تقديم الطلب وحتى إتمام العملية البيعية{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>
                ضمان سلاسة تجربة العملاء من خلال التنسيق مع الإدارات ذات الصلة{" "}
              </li>
            </ul>
          </>
        ),
        requirements: (
          <>
            <ul style={{ paddingRight: "1.5rem" }}>
              <li style={{ marginBottom: "5px" }}>مؤهل عالي </li>
              <li style={{ marginBottom: "5px" }}>
                0 - 3 سنوات من الخبرة في مجال المبيعات{" "}
              </li>
              <li style={{ marginBottom: "5px" }}>مهارات التواصل مع الأخرين</li>
              <li style={{ marginBottom: "5px" }}>
                القدرة على العمل تحت الضغط{" "}
              </li>
            </ul>
          </>
        ),
      },
    ],
  },
  contact_uae: {
    banner: {
      title: (
        <>
          <b>تمويل من غير حدود مع كونتكت!</b>
          <br />
          <b>اشتري في مصر، وقسط من الإمارات </b>
        </>
      ),
      description: (
        <>
          <p>
            كونتكت بتقدم أفضل خدمة في مجال التمويل الاستهلاكي في مصر؛ من خلال
            تقديم حلول مبتكرة بتساعد عملائنا يشتروا دلوقتي ويدفعوا بعدين مع
            مزايا وخطط دفع مرنة، قدرنا نساعد عدد كبير من المصريين على تحقيق
            أحلامهم وإدارة مشترياتهم ومصاريفهم بشكل أحسن. على مدار 25 سنة،
            كونتكت بتستمر في وضع معايير جديدة للتميز والابتكار في مجال التمويل
            في مصر.
          </p>
          <>
            دلوقتي بنوسع خدماتنا علشان يستفيد منها المصريين اللي عايشين أو
            بيشتغلوا في الإمارات العربية المتحدة. مع كونتكت تقدر تشتري أي حاجة
            في مصر وتدفع من الإمارات بكل سهولة، سواء كان اللي انت محتاجه خدمة
            تمويل أو تأمين. استمتع بالراحة والمرونة في إدارة احتياجاتك المالية
            مع دعم متواصل من كونتكت.
          </>
        </>
      ),
    },
    second_section: {
      title: "احنا بنموّل كل اللي ممكن تحتاجه!",
      description:
        "كونتكت بتقدم مجموعة واسعة من خدمات التمويل والتأمين لتغطية كل احتياجاتك في مصر، ومنها:",
      list: [
        "تمويل السيارات",
        "تمويل الدراجات النارية",
        "تمويل النقل",
        "تمويل عقاري",
        "تمويل التصميم والتشطيب",
        "تمويل فرش البيت",
        "التمويل الأخضر",
        "تمويل الصيانة",
        "مناسك",
        "تمويل أفراح ومناسبات ",
        "تمويل اشتراكات الأندية ",
        "تمويل التعليم",
        "التسوق",
        "خدمات التأمين",
        "تمويل مركبات ومعدات الرياضات المائيه",
      ],
    },
    third_section: {
      title: "كونتكت جنبك في الإمارات!",
      description:
        "في كونتكت، إحنا فاهمين احتياجات المصريين المقيمين في الإمارات وملتزمين بتوفير خدمات مالية وتأمينية متميزة ليهم. هدفنا هو جعل إدارة مصاريفك واحتياجاتك التمويلية مريحة وبلا ضغوط، سواء كنت في مصر أو الإمارات. بنقدم لك:",
      list: [
        "حلول تمويل وتأمين متنوعة: استمتع بنفس مجموعة الخدمات المتاحة في السوق المصري.",
        "خدمة متكاملة من بيتك: مش محتاج تسافر لمصر. تقدر تقدم على منتجات التمويل أو التأمين من راحة بيتك في الإمارات.",
        "خدمه سريعه وسهله: استفد من الإجراءات السهلة والسريعة بأقل قدر من المتطلبات.",
        "خيارات دفع مرنة: وزع تكلفة مشترياتك مع خطط الدفع المرنة من كونتكت.",
        "خدمة عملاء على مدار الساعة: فريقنا من الخبراء ملتزمين بتقديم دعم احترافي خلال رحلتك التمويلية والتأمينية، سواء كنت في مصر أو الإمارات.",
      ],
    },
    form: {
      title: "إزاي تقدم؟",
      subTitle1: "سجل بياناتك وسيتصل بك أحد ممثلينا",
      subTitle2: "قدم دلوقتي واستمتع بتجربة جديدة من الحلول المالية مع كونتكت!",
      name: "الاسم بالكامل",
      email: "البريد الإلكتروني",
      phone_number: "رقم الهاتف",
      product: "المنتج",
      product_list_name: "اختر المنتج",
      product_list: [
        { id: 1, product_name: "تمويل السيارات", value: "auto" },
        { id: 2, product_name: "تمويل النقل", value: "trucks" },
        { id: 3, product_name: "تسوق", value: "shopping" },
        { id: 4, product_name: "تمويل التعليم", value: "education" },
        { id: 5, product_name: "تمويل اشتراكات الاندية", value: "clubs" },
        { id: 6, product_name: "تمويل الصيانة", value: "maintenance" },
        { id: 7, product_name: "تمويل الدراجات النارية", value: "21" },
        {
          id: 8,
          product_name: "تمويل أفراح و مناسبات",
          value: "wedding",
        },
        { id: 9, product_name: "تمويل عقاري", value: "mortgage" },
        { id: 10, product_name: "التمويل الأخضر", value: "greenFinance" },
        { id: 11, product_name: "تمويل فرش البيت", value: "19" },
        {
          id: 12,
          product_name: "تمويل التصميم و التشطيب",
          value: "homes",
        },
        {
          id: 13,
          product_name: "تمويل مركبات ومعدات الرياضات المائية",
          value: "20",
        },
        { id: 14, product_name: "مناسك", value: "manasik" },
        { id: 15, product_name: "وساطة تأمينية", value: "brokerage" },
      ],
      message: "رسالتك",
      submit: "ارسال",
    },
    last_section: {
      contact_us: "تواصل معنا",
      list: [
        {
          title: "التليفون",
          description: "اتصل بنا للحصول على المساعدة الفورية",
          info: (
            <>
              <>
                <a
                  dir="ltr"
                  href="tel:+971 54 700 4400"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    marginBottom: "10px",
                    display: "block",
                  }}
                >
                  +971 54 700 4400
                </a>
                <a
                  dir="ltr"
                  href="tel:+971 50 865 3388"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  +971 50 865 3388{" "}
                </a>
              </>
            </>
          ),
          img: "/phone icon UAE.png",
        },
        {
          title: "الايميل",
          description:
            "إرسال الاستفسارات عبر البريد الإلكتروني للحصول على الدعم",
          info: "Info@contact.eg",
          img: "/email icon UAE.png",
        },
        {
          title: "الموقع",
          description: "تفضل بزيارة فرعنا في الإمارات",
          info: (
            <a
              target="_blank"
              href="https://maps.app.goo.gl/MKMNyBTxV74EuJ2BA?g_st=ic"
              style={{ textDecoration: "underline", color: "inherit" }}
            >
              داماك برج إكس إل بمنطقة الخليج التجاري – مكتب 905
            </a>
          ),
          img: "/location icon UAE.png",
        },
      ],
    },
  },
  Campaign: {
    Title1: `   شكرا لتواصلك مع كونتكت  !`,
    Title2: `برجاء ادخال بياناتك وسيقوم احد ممثلينا بالتواصل معك في اقرب وقت`,
    financing_title: "اشتري عربيتك BMW دلوقتي بأقل سعر فائدة في مصر",
    financing_pg: (
      <>
        <p>
          0% مصاريف ادارية | فائدة 4.4% فقط | ثلاث سنوات صيانة مجاناً| ضمان لمدة
          5 سنوات
        </p>
        <p>سجل طلب التمويل الآن</p>
      </>
    ),
  },
  // ***********
  navbar_investment: "استثمار",
  investment_dropdown: [
    {
      url: "/investment/cash-management",
      color: colors.ratty,
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/cash-mangement.png",
      title: "ادارة المحافظ",
    },
    {
      url: "/investment/income-trading",
      color: colors.ratty,
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/income-trading.png",
      title: "أدوات الدخل الثابت",
    },
    {
      url: "/investment/investment-fund",
      color: colors.ratty,
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/investment-fund.png",
      title: "صندوق استثمار كل يوم",
    },
  ],
  navbar_partnership: "انضم لشركاؤنا",
  partner_dropdown: [
    {
      url: "/partnership/contact-now-merchant",
      color: colors.ratty,
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/partnership.png",
      title: "شبكة تجار ContactNow",
    },
    {
      url: "/partnership/medical-supplies",
      color: colors.ratty,
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/partnership.png",
      title: "التوريدات الطبية",
    },
    {
      url: "/partnership/vehicles-and-transportation-vendor",
      color: colors.ratty,
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/partnership.png",
      title: "السيارات و وسائل النقل",
    },
    {
      url: "/partnership/other-entities",
      color: colors.ratty,
      img: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/partnership.png",
      title: "هيئات أخرى",
    },
  ],
  business: {
    logo: "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/contact-ar-white.png",
    cover_title: "شريكك التمويلي",
    cover_body:
      "في عالم مليء بالفرص، تلعب كونتكت دورًا رئيسيًا في تحويل أحلامك إلى حقيقة وجسرًا يساعدك في الوصول إلى رأس المال الذي تحتاجه. كشريكك الموثوق به للتمويل نقدم لك مجموعة متنوعة من اختيارات التمويل المصممة لتناسب أهدافك المحددة وطموحاتك المالية.",
    btn1: "Request service",
    btn2: "انضم إلينا",
    sponsor_title: "شركاؤنا",
    sponsors: [
      "/bussiness-brands/1.png",
      "/bussiness-brands/2.png",
      "/bussiness-brands/3.png",
      "/bussiness-brands/4.png",
      "/bussiness-brands/5.png",
      "/bussiness-brands/6.png",
      "/bussiness-brands/7.png",
      "/bussiness-brands/8.png",
      "/bussiness-brands/9.png",
      "/bussiness-brands/10.png",
      "/bussiness-brands/11.png",
      "/bussiness-brands/12.png",
      "/bussiness-brands/13-ar.png", // fawry
      "/bussiness-brands/14.png",
      "/bussiness-brands/15.png",
      "/bussiness-brands/16-ar.png", // basata
      "/bussiness-brands/17-ar.png", // jumia
      "/bussiness-brands/18.png", //raya
      "/bussiness-brands/19.png", //Orange
      "/bussiness-brands/20.png", //Vodafone
    ],
    plans_title: "Quis autem vel eum iure reprehenderit qui",
    plans_subtitle: "Tagline",
    plans_description:
      "diam laoreet consectetur libero, elit sollicitudin. felis, ac ipsum In nisi id ullamcorper felis, efficitur. faucibus elit. orci in Ut urna. massa Cras orci",
    btn11: "More",
    btn22: "Follow",
    card_title: "Quis autem vel eum iure reprehenderit qui",
    card_description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros.",
    testimonial_title: "قصص نجاح من شركائنا",
    testimonial_description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    reviews_business: [
      {
        avatar: "/business/hossam-avatar.jpg",
        name: "السيد / حسام عز",
        role: "رئيس القطاع التجاري، شركة فوري",
        // rating => description
        rating:
          'سعداء للغاية بشراكتنا مع "كونتكت" الممتدة على مدار السنوات الماضية والتي تكللت بالعديد من النجاحات إذ أصبحت قنوات فوري المختلفة تمثل احد اهم قنوات التحصيل التي يسرت علي عملاء كونتكت سداد مستحقاتهم بسهوله ويسر، وتمثل هذه الخطوة توطيدا للتعاون بين الجانبين بهدف تعزيز قيم الشمول المالي ودفع عجلة التحول الرقمي.',
      },
      {
        avatar: "/business/adham-avatar.jpg",
        name: "السيد / ادهم حسني",
        role: "رئيس قطاع التخطيط والمنتجات، شركة كارزامي",
        // rating => description
        rating:
          'لقد لعبت شراكتنا مع "كونتكت" دورًا مهمًا في نجاحنا من خلال تقديم الموافقات السريعة والتعاون المبتكر. ويشرفنا أن يكونوا شركاء لنا، ونحن فخورون للغاية بارتباطنا بهم',
      },
      {
        avatar: "/business/mahmoud.jpg",
        name: "السيد / محمود السيد",
        role: "المؤسس المشارك والرئيس التنفيذي، متصفح وصلة",
        // rating => description
        rating:
          'نحن نؤمن بأن شراكتنا مع شركة "كونتكت" تتيح لنا توسيع عروضنا بشكل مستمر وإدخال طرق جديدة لمساعدة المستهلكين على توفير المال، والدفع بشكل آمن، والاقتراض بمرونة',
      },
    ],
    news_title: "أخبارنا",
    news_description: "Main news",
    btn111: "عرض الكل",
    accordion: [
      {
        title: "كيف تدعم كونتكت الشركات وتساعدها على تجاوز العقبات المالية؟ ",
        description:
          "نحن ندعم مختلف الشركات من خلال دعم الأصول الأساسية والتدفق النقدي الفوري ، حيث توفر كونتكت مجموعة واسعة من الحلول التمويلية من خلال برامج التأجير التمويلي والتخصيم  وحلول  Laas والمزيد!",
      },
      {
        title:
          "كيف تساعد كونتكت الأفراد والشركات على حماية المستقبل الصحى والمالي ؟",
        description:
          "تساهم كونتكت في تمكين الأفراد والشركات على حد سواء في حماية صحتهم ومستقبلهم المالي من خلال تقديم حلول متنوعة تشمل: الخطط التأمينية الصحية الفردية والجماعية، وخطط تأمين على الحياة، وخطط استثمارية، وخطط تقاعد، الحماية والادخار، والمزيد!",
      },
      {
        title: "كيفية تقديم طلب تمويل من كونتكت؟",
        description:
          "يمكنك ان تقدم طلب التمويل الخاص بك من خلال وسائل التواصل المختلفة مثل فروع كونتكت المنتشرة في كل المحافظات، الموقع الالكتروني، تطبيق الهاتف المحمول، الواتساب أو الاتصال التليفوني بمركز خدمة العملاء 16177.",
      },
      {
        title: "لماذا تختار شركات التمويل بدلا من التمويل البنكي؟",
        description:
          "تمنح شركات التمويل اجراءات أسهل وأسرع من الإقراض المصرفي التقليدي بالإضافة الي موافقة أسهل من البنوك.",
      },
    ],
    faqs: "الأسئلة الشائعة",
    faqs_description: "نُمكنك من تحقيق اهدافك المالية",
  },
  //* sustainability
  sus_t1: "الاستدامة",
  sus_b1: `تعد الاستدامة عنصراً هاماً في مواجهة التحديات البيئية والاجتماعية تعمل كونتكت على تعبئة الموارد المالية وتخصيصها لمبادرات التنمية المستدامة وحماية البيئة وتنمية الموارد الطبيعية بالإضافة إلى العدالة الاجتماعية والاقتصادية. 
توفر كونتكت التمويل ورأس المال اللازم لمختلف المشاريع والمبادرات البيئية والحماية المجتمعية مثل مبادرات حماية محدودي الدخل وتمكين المرأة وذوى الهمم. وتأتي الحاجة إلى تمويل الاستدامة من خلال المسئولية المجتمعية للشركة حيث أن النظم المالية التقليدية غالبا ما تعطي الأولوية للمكاسب القصيرة الأجل على حساب مشاريع الاستدامة الطويلة الأجل. ونتيجة لذلك، كان هناك تركيز متزايد لدى كونتكت على دمج اعتبارات الاستدامة في عمليات صنع القرار المالي وتيسير التمويل الأخضر لدعم مشروعات الطاقة النظيفة، حماية البيئة، الحفاظ على الموارد والحرص الدائم على اتباع ومواكبة السياسات الحكومية التي تحفز الاستثمارات في هذا المجال.
`,
  sus_t2: "اهداف التنمية المستدامة",
  sus_st2:
    "تتوافق خطة عملنا للفترة 2023-2025 مع أهداف التنمية المستدامة التالية:",
  sus_b2: [
    "الصحة الجيدة الرفاهية",
    "التعليم الجيد",
    "العمل اللائق والنمو الاقتصادي",
    "الحد من أوجه عدم المساواة",
    "العمل المناخي",
    "عقد الشراكات من أجل تحقيق الأهداف",
  ],
  sus_img2:
    "https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/sus.png",
  sus_report: "اطّلع على تقرير الاستدامة الخاص بنا لعام ٢٠٢٣",
  sarwa_capital: "/our-brands/sarwa.png",
  sarwa_capital2: "/sarwa-2.png",
  sc_title1: "ثروة كابيتال",
  sc_body1: `لطالما كان الاستثمار في أسواق رأس مال الدين (DCM) محورا مركزيا لنموذج أعمال ثروة حيث سمح لنا بتنوع قاعدة تمويلنا وإعادة هيكلة عملياتنا بنجاح.  ومن خلال خبراتنا من هذه التجربة العميقة الجذور في مجال ادارة أسواق الدين ، قمنا بتسويق مجموعة من خدمات التمويل التي دفعتنا إلى أن نصبح أكبر لاعب في مصر في هذا القطاع. وقد قامت ثروة بترتيب وإصدار أكثر من 26 مليار جنيه من إصدارات الديون منذ عام  2005، بما في ذلك أول طرح من نوعه لسندات التوريق في السوق المصري. كما أن ثروة هي أول مصدر للصكوك المرخصة في السوق المصرية.

يتمتع فريقنا بسجل حافل في هيكلة وتسعير وإصدار التعاملات المالية  في ظل تقلبات وظروف السوق الصعبة، بما في ذلك الإصدارات التي تحمل تصنيف AA+ – وهو أعلى تصنيف للكيان غير السيادي في مصر.

ولذلك فإننا نفخر بخبرة طويلة في هذه القطاع وشبكة من العلاقات مع المستثمرين غير المصرفيين والخبراء وهيئات التصنيف وغيرها من المؤسسات المالية. كما نعمل بوتيرة ثابتة مع هيئات التصنيف والبنوك الرائدة من خلال منحها إمكانية الوصول اليومي والاطلاع على عملياتنا وقاعدة بياناتنا وهو امر نفخر به ويدعم الإصدارات التي نطرحها بمزيد من الثقة والشفافية .

بالإضافة الى الخبرة في مجموعة واسعة من فئات الأصول التي تتراوح بين قروض السيارات والمستحقات العقارية فإننا نعمل ايضاً بنشاط على توسيع خبرتنا لزيادة هياكل التمويل الجديدة والمبتكرة.`,
  sc_title2: "المعاملات الهامة التي نفخر بها:",
  sc_subtitle2:
    "روادإدارة أدوات الدين بسجل حافل من المعاملات في ظل تحديات السوق المختلفة لتحقيق السيولة المالية.",
  sc_body2: [
    "أول طرح للسندات بالسوق المصري في عام 2005",
    "أول طرح للسندات بالدعم العقاري في عام 2015.",
    "أول طرح صكوك مضاربة لمؤسسة مالية في 2020",
  ],
  // ************
  other_products: "منتجات أخرى",
  viewOnGoogleMaps: "زورنا علي خرائط جوجل",
  Readmore: "اقرأ المزيد",
  pages_main_tags: {
    home: {
      title: "كونتكت | أول شركة تمويل استهلاكي في مصر ",
      meta_desc:
        "كونتكت تقدم حلول تمويل متنوعة تشمل تمويل السيارات، تمويل النقل، تمويل استهلاكي، تمويل تصميم وتشطيب، تمويل فرش البيت، وتمويل الصيانة.",
      h1: "مرحباً بكم في كونتكت",
      h2: "حلول تمويلية مبتكرة لجميع احتياجاتك المالية",
    },
    products: {
      auto: {
        title: "تمويل السيارات من كونتكت | شروط ميسرة وعروض مميزة",
        meta_desc:
          "احصل على تمويل السيارات من كونتكت بشروط ميسرة وعروض مميزة. اكتشف المزيد عن خدماتنا التمويلية للسيارات.",
        h1: "تمويل السيارات",
        h2: "شروط ميسرة وعروض مميزة",
      },
      trucks: {
        title: "تمويل النقل من كونتكت | حلول تمويلية مرنة",
        meta_desc:
          "كونتكت تقدم تقسيط وتمويل لكل أنواع سيارات النقل الثقيل والشاحنات، من الصغيرة للكبيرة، ومن النص نقل للمقطورة.",
        h1: "تمويل النقل",
        h2: "حلول تمويلية مرنة",
      },
      homeInterior: {
        title: "تمويل تصميم وتشطيب من كونتكت | لبيت مثالي",
        meta_desc:
          "كونتكت بتقدم أفضل خطط تقسيط وتمويل تصميم وتشطيب سواء كنت بتشطب بيت جديد أو بتجدد بيتك القديم.",
        h1: "تمويل تصميم وتشطيب",
        h2: "لبيت مثالي",
      },
      homeFurniture: {
        title: "تمويل فرش البيت من كونتكت | افرش بيتك بالتقسيط",
        meta_desc:
          "كونتكت بتقدملك مجموعة متنوعة من خدمات وبرامج التمويل والتقسيط لفرش البيت مع امكانية إمكانية دمج عروض سعر مختلفة في نفس الطلب.",
        h1: "تمويل فرش البيت",
        h2: "جدد بيتك بأفضل خطط الدفع",
      },
      maintainance: {
        title: "تمويل الصيانة من كونتكت | تقسيط مصاريف الصيانات",
        meta_desc:
          "كونتكت بتقدم تقسيط وتمويل لأي صيانة، من خلال تمويل الصيانة هتقدر تستعين بأحسن عمال الصيانة في مصر، وتقسط بعدين بأقساط مريحة وسهلة.",
        h1: "تمويل الصيانة",
        h2: "تمويل يصل إلى1.5  مليون جنيه",
      },
      mortgage: {
        title: "تمويل عقاري من كونتكت | شراء منزلك بالتقسيط بسهولة",
        meta_desc:
          "احصل على تمويل عقاري من كونتكت لتقسيت بيتك بسهولة. اكتشف خطط تقسيط تصل إلى 10 سنوات.",
        h1: "تمويل عقاري",
        h2: "اشتري بيت بالتقسيط",
      },
      education: {
        title: "تمويل التعليم من كونتكت | دعم مستقبلك",
        meta_desc:
          "تمويل التعليم افضل اختيار يناسب احتياجاتك وميزانيتك، بنقدم تقسيط للتعليم والبرامج الأكاديمية يصل إلى 12 شهر للمدارس والجامعات والكورسات.",
        h1: "دعم مستقبلك",
        h2: "تمويل التعليم",
      },
      events: {
        title: "تمويل أفراح ومناسبات من كونتكت | احتفل بأحلى اللحظات",
        meta_desc:
          "احصل على تمويل أفراح ومناسبات من كونتكت واحتفل بأحلى اللحظات دون قلق. أفضل خطط لتقسيط الأفراح والمناسبات لدى كونتكت.",
        h1: "تمويل أفراح ومناسبات",
        h2: "احتفل بأحلى اللحظات",
      },
      clubs: {
        title: "تمويل اشتراكات الأندية من كونتكت | استمتع برياضاتك المفضلة",
        meta_desc:
          "اشترك في النادي اللي بتحلم بيه مع كونتكت بالتقسيط. تقدر تموّل اشتراك النادي اللي تتمناه بأسهل إجراءات، وأسرع وقت وبفترات سداد مناسبة تصل إلى 5 سنوات وبدون مقدم",
        h1: "تمويل اشتراكات الأندية",
        h2: "استمتع برياضاتك المفضلة",
      },
      greenFinance: {
        title: "التمويل الأخضر من كونتكت | لدعم مشروعاتك",
        meta_desc:
          "احصل على التمويل الأخضر من كونتكت وقسط وحدات الطاقة الشمسية، نظم الري، وكل اللي محتاجه لمشروعك الزراعي",
        h1: "التمويل الأخضر",
        h2: "لدعم مشروعاتك",
      },
      watercraft: {
        title: "تمويل مركبات ومعدات الرياضات المائية | عيش الرفاهية",
        meta_desc:
          "كونتكت هتساعدك تشتري أي مركب زى اليخوت، اللنشات، الجيت سكي، والمعدات الخاصة بالغطس أو Rafting، Kayaking، Kitesurfing، Water skiing، Parasailing، وغيرها كتير بالتقسيط.",
        h1: "تمويل مركبات ومعدات الرياضات المائية",
        h2: "عيش الرفاهية",
      },
      motorcycles: {
        title: "تمويل الدراجات النارية من كونتكت | احصل على دراجتك بسهولة",
        meta_desc:
          "كونتكت بتقدم تمويل وتقسيط دراجة نارية، أو سكوتر، أو جولف كار، أو بيتش باجي ، دلوقتي تقدر تستفيد من حلول تمويلية مُختلفة من كونتكت لكل أنواع المركبات، بما فيها الدراجات النارية وإكسسواراتها.",
        h1: "تمويل الدراجات النارية",
        h2: "استعد للمغامرة",
      },
      contactNow: {
        title: "تمويل التسوق من كونتكت | اشتري اللي انت عايزه بسهولة",
        meta_desc:
          "اشتري وقسط مع كونتكت الشركة رقم واحد للتقسيط في مصر، اشتري من أكبر عدد من المحلات والمعارض ومنافذ البيع والتحصيل. فترات سداد تصل إلى 5 سنوات.",
        h1: "تمويل استهلاكي وتقسيط المشتريات",
        h2: "تحقيق أحلامك بسهولة",
      },
      manasik: {
        title:
          "حج وعمرة بالتقسيط | تمويل الحج والعمرة المتوافق مع الشريعة من كونتكت بأفضل الشروط",
        meta_desc:
          "دلوقتي تقدر تحقق حلمك بأداء الحج أو العمرة بكل سهولة مع كونتكت. تمويل متوافق مع الشريعة، خطط تقسيط مريحة، وإجراءات سهلة وسريعة لتجربة روحانية لا  ُتنسى.",
        h1: "تمويل الحج والعمرة بالتقسيط من كونتكت",
        h2: "خطوات بسيطة لتمويل الحج أو العمرة مع برامج متوافقة مع الشريعة",
        h3: "مزايا وشروط تمويل الحج والعمرة",
      },
      insurance: {
        title: "حلول التأمين - كونتكت",
        meta_desc:
          "استمتع بأفضل خطط التأمين في مصر مع كونتكت. حماية كاملة للحياة، الصحة، والممتلكات بأسعار مناسبة للجميع.",
        h1: "أفضل خطط التأمين في مصر",
        h2: "حلول التأمين",
      },
    },
    epyament: {
      title: "كونتكت-بــاي | حلول دفع مبتكرة وسريعة",
      meta_desc:
        "مع كونتكت باي هتدفع كل فواتيرك بسهولة وفي مكان واحد: فواتير الكهرباء، فواتير الغاز، فواتير المياه، أقساط التأمين، مصاريف المدارس والجامعات، وغيرها.",
      h1: "كونتكت بــاي",
      h2: "حلول دفع مبتكرة وسريعة",
    },
    investment: {
      title: "كونتكت كل يوم للاستثمار والادخار",
      meta_desc: `كونتكت "كل يوم" طريقة بسيطة وآمنة ومليانة بالمكاسب تقدر من خلالها تكتر فلوسك كل يوم.`,
      h1: "كونتكت كل يوم",
      h2: "شريك استثمارك اليومي",
    },
    sarwaInsurance: {
      title: "ثروة للتأمين - كونتكت | حلول شاملة للتأمين في مصر",
      meta_desc:
        "احمي كل ما يهمك مع ثروة للتأمين. نقدم خطط تأمين شاملة مصممة خصيصًا لتلبية للأفراد والشركات في مصر.",
      h1: "ثروة للتأمين",
      h2: "تغطية شاملة لراحة بالك",
    },
    blogs: {
      title: "نصائح تهمك بخصوص تمويل وتقسيط كل شئ - أخبار كونتكت",
      meta_desc:
        "ابقَ على اطلاع بآخر النصائح والمستجدات المالية من كونتكت. تعلم كيفية الحصول على تمويل أفضل مع حلول مرنة.",
      h1: "أخبار كونتكت",
      h2: "",
    },
    contactUs: {
      title: "اتصل بنا - تواصل مع كونتكت",
      meta_desc:
        "تواصل مع كونتكت لأي استفسارات أو دعم. نحن هنا لنساعدك في كل ما يخص خدمات التمويل والتقسيط الأفضل في مصر.",
      h1: "تواصل معنا",
      h2: "مستعدون دائمًا لمساعدتك",
    },
    login: {
      title: "تسجيل الدخول - إدارة حسابك مع كونتكت",
      meta_desc:
        "سجل الدخول لحسابك مع كونتكت لإدارة خدماتك، متابعة مدفوعاتك، اكتشاف فرص تمويل جديدة، وكل ما تحتاجه بسهولة وأمان.",
      h1: "تسجيل الدخول إلى حسابك",
      h2: "إدارة خدماتك أونلاين بكل سهولة",
    },
    sustainability: {
      title: "الاستدامة في كونتكت - التزامنا بمستقبل أفضل",
      meta_desc:
        "اكتشف التزام كونتكت بالاستدامة ودعمنا لمستقبل أخضر وأفضل للجميع.",
      h1: "الاستدامة في كونتكت",
      h2: "التزامنا بمستقبل أخضر ومستدام",
    },
    sarwaLife: {
      title: "ثروة لتأمينات الحياة - كونتكت",
      meta_desc:
        "وفر الأمان لمستقبل عائلتك مع خطط تأمين الحياة من ثروة. احصل على راحة البال مع خدمات التأمين الشاملة.",
      h1: "أمان لعائلتك",
      h2: "ثروة لتأمينات الحياة",
    },
    referralProgram: {
      title: "برنامج ترشيح العملاء - كونتكت",
      meta_desc:
        "شارك خدمات كونتكت مع أصدقائك وعائلتك واربح مكافآت فورية. برنامج ترشيح العملاء سهل ومجزي للجميع!",
      h1: "مكافآت مع كل ترشيح",
      h2: "قول لأصحابك وعائلتك عن كونتكت",
    },
    rewards: {
      title: "برنامج المكافآت - كونتكت",
      meta_desc:
        "استفد من برنامج المكافآت في كونتكت وتمتع بأفضل الخصومات والمزايا الحصرية لعملائنا المميزين في مصر.",
      h1: "استمتع بالمزايا الحصرية",
      h2: "برنامج المكافآت من كونتكت",
    },
    ourBranches: {
      title: "فروع كونتكت - أفضل خدمات التمويل في مصر",
      meta_desc:
        "اعثر على أقرب فرع من فروع كونتكت المنتشرة في جميع أنحاء مصر واحصل على التمويل والتقسيط اللي انت محتاجه بأسهل اجراءات",
      h1: "في كل مكان فرع كونتكت قريب منك",
      h2: "فروعنا",
    },
    productsPage: {
      title: "جميع خدمات كونتكت - أفضل حلول التمويل والتقسيط",
      meta_desc:
        "اكتشف مجموعة خدمات كونتكت الكاملة. من حلول التمويل للأفراد والشركات لأفضل خطط التأمين في مصر.",
      h1: "استمتع بأفضل خدمات التمويل والتقسيط في مصر",
      h2: "جميع منتجات وخدمات كونتكت",
    },
    companies: {
      title: "حلول الشركات - كونتكت",
      meta_desc:
        "احصل على حلول وخدمات التمويل والتأجير التمويلي والتخصيم مصممة خصيصًا لاحتياجات شركتك. تمويل يساعد شركتك على النمو والتوسع في مصر.",
      h1: "تمويل الشركات في مصر",
      h2: "تمويل الشركات من كونتكت",
    },
    partnership: {
      contactNowMerchant: {
        title: "شركاء كونتكت - كونتكت ناو",
        meta_desc:
          "انضم إلينا وحقق النمو لأعمالك من خلال تقديم خيارات تمويل مرنة لعملائك مع كونتكت ناو.",
        h1: "كن شريك كونتكت",
        h2: "برنامج كونتكت للمتاجر",
      },
    },
    media: {
      title: "المركز الإعلامي - كونتكت",
      meta_desc:
        "تابع أحدث الأخبار والبيانات الصحفية من كونتكت، وكل ما هو جديد حول خدمات التمويل والتقسيط في مصر.",
      h1: "آخر الأخبار من كونتكت",
      h2: "أخبار كونتكت",
    },
    careers: {
      title: "وظائف في كونتكت المالية - انضم إلى فريقنا المتنامي في مصر",
      meta_desc:
        "استكشف فرص العمل في كونتكت المالية، الشركة الرائدة في التمويل الاستهلاكي في مصر. انضم إلى فريقنا المتوسع الذي يضم أكثر من 2500 موظف وساهم في نجاحنا. قدم الآن لتعزيز مسارك المهني معنا.",
      h1: "الوظائف",
      h2: "إذا كنت ترغب في الانضمام إلينا.",
    },

    contactUae: {
      title: "كونتكت-الإمارات",
      meta_desc: "اشترِ في مصر وادفع من الإمارات.",
      h1: "كونتكت - الإمارات",
      h2: "اشترِ في مصر، وادفع من الإمارات.",
    },

    productsBusiness: {
      factoring: {
        title: "تخصيم من كونتكت | حلول مالية مبتكرة",
        meta_desc:
          "وفر فلوس وسيولة لاحتياجاتك واحتياجات مشروعك واستفيد من خدمة التخصيم من كونتكت، الحل اللي بيـسـمـحلك تستبدل فواتير مبيعاتك وتاخد فلوسها فـوراً بدون انتظار",
        h1: "كن شريك كونتكت",
        h2: "برنامج كونتكت للمتاجر",
      },
      leasing: {
        title: "تأجير تمويلي من كونتكت | حلول مرنة وميسرة",
        meta_desc:
          "كونتكت هي شركة رائدة في تقديم خدمات التأجير التمويلي لمختلف القطاعات في مصر. خطط سداد متنوعة مصممة لتناسب احتياجاتك.",
        h1: "",
        h2: "",
      },
    },
    whyContact: {
      title: "ليه تختار كونتكت: تمويل وتأمين لكل احتياجاتك",
      meta_desc: "اكتشف ليه كونتكت اختيارك الأول للتمويل والتأمين. بنقدملك خدمات تمويلية وتأمينية تناسب جميع مراحل حياتك، بأسرع وأسهل الإجراءات وأنت في مكانك",
      h1: "ليه تختار كونتكت لاحتياجاتك التمويلية والتأمينية؟",
      h2: "ركائزنا الاستراتيجية",
      h3:["الخبرة والثقة","مكان واحد للتمويل والتأمين","تقدم على التمويل أو التأمين وأنت في مكانك","تمكين طموحاتك"],
      navigation_bar: {
        sections: [
          { id: 1, title: "خبرة و ثقة ", href: "Expertise&Trust" },
          {
            id: 2,
            title: "خدمات متكاملة في مكان واحد",
            href: "One-Stop-Shop",
          },
          {
            id: 3,
            title: "منتجاتنا التمويلية والتأمينية",
            href: "Financing_Insurance_Products",
          },

          { id: 4, title: "بندعم طموحك!", href: "Ambition" },
        ],
        contact_us: "تواصل معنا",
      },
      header: {
        title: (
          <p>
            بنقدم حلولاً{" "}
            <strong style={{ color: colors.orange }}>
              {" "}
              <Box
                sx={{
                  position: "relative",
                  display: "inline-block",
                  padding: "8px 16px",
                  borderRadius: "8px",
                  color: colors.orange,
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    border: `3px dashed ${colors.orange}`,
                    borderImageSource: `repeating-linear-gradient(55deg, ${colors.orange} 5px 20px, transparent 10px 30px)`,
                    borderImageSlice: 2,
                    borderRadius: "8px",
                    transform: "skew(0deg , 2.5deg)",
                  },
                }}
              >
                تمويلية و تأمينية
              </Box>{" "}
            </strong>
            لتمكين أحلامك <br /> و تحقيق طموحاتك.
          </p>
        ),

        btn: "دعنا نستكشف",
        video:
          "https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/Copy+of+Purple+and+Orange+Minimalist+Clean+Animated+Business+Advertising+Mobile+Video.mp4",
      },
      expertise: {
        title: "خبرة و ثقة",
        text: "على مدار أكتر من 20 سنة، كونتكت هي الشركة الرائدة في التمويل الاستهلاكي في مصر، بنقدّم لك حلول مالية تناسب كل مرحلة في حياتك. سواء محتاج تمويل لتحقيق أحلامك الكبيرة، تأمين شامل، أو خدمات دفع إلكترونية سهلة، إحنا معاك بخيارات سريعة، آمنة، ومرنة. وبخبرتنا الطويلة في عالم التمويل والتأمين، هنفضل دايماً جنبك علشان نسهّل عليك رحلتك المالية بكل ثقة وابتكار.",
        btn: "إكتشف منتجاتنا",
        statistic: [
          { id: "1", sufTheous: " ألف", text: "عميل", count: 250 },
          {
            id: "2",
            sufTheous: " ",
            text: "فرع علي مستوي جمهورية مصر العربية",
            count: 78,
          },
          {
            id: "3",
            sufTheous: " ألف",
            text: "أكبر شبكة تجار في مصر",
            count: 18,
          },
        ],
      },

      services: {
        mainTitle: "خدمات متكاملة في مكان واحد",
        title: (
          <p>
            مع <strong>كونتكت</strong> هتلاقي كل اللي محتاجه من{" "}
            <strong>تمويل وتأمين ومدفوعات إلكترونية</strong> بسهولة وسرعة في
            مكان واحد.
          </p>
        ),
        ourServices: [
          {
            id: 1,
            img: "/why-contact/contact-services-ar.png",
            text: "كونتكت للتمويل",
            color: colors.blue,
          },
          {
            id: 2,
            img: "/why-contact/sarwa-life.png",
            text: "ثروة لتأمينات الحياة",
            color: colors.lemon_green,
          },
          {
            id: 3,
            img: "/why-contact/sarwa-insurance.png",
            text: "ثروة للتأمين",
            color: colors.blue,
          },
          {
            id: 4,
            img: "/why-contact/contact-insurance-ar.png",
            text: "كونتكت للوساطة التأمينية",
            color: colors.blue,
          },
          {
            id: 5,
            img: "/why-contact/payment.png",
            text: "مدفوعات إلكترونية",
            color: colors.orange,
          },
        ],
      },

      financingInsuranceProducts: {
        title: (
          <p>
            بكل سهولة وسرعة تقدر تعرف أكتر عن منتجاتنا{" "}
            <strong> التمويلية والتأمينية</strong> وتقدم على طلب التمويل أو
            التأمين وأنت في مكانك
          </p>
        ),
        products: [
          {
            id: 1,
            img: "/why-contact/mockup-block-1.png",
            title: "موقعنا الإلكتروني Contact.eg",
            text: "بنقدملك تجربة مختلفة ومتطورة من حلول وخدمات التمويل والتأمين للأفراد والشركات سواء من موبايلك، لاب توب، تابلت، علشان نكون دايماً إختيارك الأول للتمويل والتأمين",
            services: [
              {
                id: 1,
                img: "/why-contact/online-services.svg",
                text: "تقدر من خلال موقعنا تعرف كل المعلومات إللي محتاجها عن منتجاتنا وخدماتنا التمويلية",
              },
              {
                id: 2,
                img: "/why-contact/installment.svg",
                text: " تقدر تحسب أقساطك بكل سرعة وسهولة",
              },
              {
                id: 3,
                img: "/why-contact/save-money.svg",
                text: "تقدر تقدم على طلب التمويل والتأمين من وأنت في مكانك",
              },
              {
                id: 4,
                img: "/why-contact/repayment-periods.svg",
                text: "تقدر تتابع أقساطك، منتجاتك، نقاطك، عن طريق حسابك الشخصي",
              },
            ],
          },
          {
            id: 2,
            img: "/why-contact/mockup-block-2.png",
            title: "موبايل ابلكيشن كونتكت",
            text: `موبايل ابلكيشن "كونتكت ناو" تقدر من عليه تعرف كل المعلومات إللي محتاجها عن منتجاتنا التمويلية والتأمينية وتقدم على طلب التمويل من وأنت في مكانك، وتقدر ايضاً تستفاد بمجموعة متنوعة من عروض التقسيط إللي تهمك`,
            services: [
              {
                id: 1,
                img: "/why-contact/online-services.svg",
                text: "موافقة فورية على الحد الائتماني",
              },
              {
                id: 2,
                img: "/why-contact/credit-limits.svg",
                text: "طلب زيادة الحد الائتماني",
              },
              {
                id: 3,
                img: "/why-contact/bills.svg",
                text: "دفع فواتيرك وأقساطك",
              },
              {
                id: 4,
                img: "/why-contact/merchants.svg",
                text: "معرفة شبكة التجار",
              },
            ],
          },
          {
            id: 3,
            img: "/why-contact/mockup-block-3.png",
            title: "موبايل ابلكيشن كونتكت للوساطة التأمينية",
            text: " موبايل ابلكيشن كونتكت للوساطة التأمينية هيقدملك كل اللي يخص التأمين، وهيساعدك تفهم وتختار الخطة المناسبة ليك، لعيلتك، أو حتى لشغلك، بالإضافة لخدمات تانيه كتير تخلي حياتك أسهل وأكثر جودة",
            services: [
              {
                id: 1,
                img: "/why-contact/repayment-periods.svg",
                text: "تقدر عن طريق الابلكيشن تقدم المطالبات التأمينية",
              },
              {
                id: 2,
                img: "/why-contact/medical-consultations.svg",
                text: " نصائح تهمك لصحتك البدنية",
              },
              {
                id: 3,
                img: "/why-contact/physical-health.svg",
                text: "طلب استشارات طبية و تذكيرك بمواعيد أدويتك",
              },
              {
                id: 4,
                img: "/why-contact/save-money.svg",
                text: "طلب الخدمات التأمينية الخاصة بك، أو بأسرتك، أو اعمالك",
              },
            ],
          },
          {
            id: 4,
            img: "/why-contact/mockup-block-4.png",
            title: "واتس آب كونتكت",
            text: "واتس آب كونتكت هو مساعدك السريع لكل احتياجاتك، سواء في التمويل أو التأمين! تقدر عن طريقه تعرف أكتر عن منتجاتنا وخدماتنا، وجاهز يساعدك أي وقت خلال الإسبوع. واتس آب كونتكت سريع، سهل، وبضغطة زرار بس!",

            services: [
              {
                id: 1,
                img: "/why-contact/online-services.svg",
                text: "ردود سريعة",
              },
              {
                id: 2,
                img: "/why-contact/availability.svg",
                text: "مُتاح لخدمتك على مدار الإسبوع",
              },
              {
                id: 3,
                img: "/why-contact/repayment-periods.svg",
                text: "تقدر تتابع أقساطك، منتجاتك، نقاطك، عن طريق واتس آب كونتكت",
              },
              {
                id: 4,
                img: "/why-contact/save-money.svg",
                text: "تقدر تقدم طلبات التمويل والتأمين من مكانك وبكل سهولة",
              },
            ],
          },
        ],
      },

      ambition: {
        bgImage: "/why-contact/contatct-ambition.png",
        logo: "/why-contact/contact-logo-ar.png",
        title: "بندعم طموحك!",
        description:
          "كونتكت بتفهم طموحاتك وبتساعدك تحقق أحلامك، وبتقرب منك عشان تقدم لك حلول مبتكرة تناسب احتياجاتك، مش بس تمويل.. لكنها جزء من حياتك اليومية!",
        btn: "تواصل معنا",
      },
    },
  },
  Erroruploadingfile: "حدث خطا فى رفع الملف حاول مره اخري ",
  ErrorNoPhoneNumFile: "برجاء ادخال رقم الهاتف أولاً",
  connectionError:
    "تم الكشف عن مشكلة في الشبكة. يرجى التحقق من الاتصال وإعادة المحاولة.",
};
